import gql from 'graphql-tag';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};



export type AccountIdsOuput = {
  __typename?: 'AccountIdsOuput';
  ID: Scalars['String'];
};

export type ActiveLoanStatusOutput = {
  __typename?: 'ActiveLoanStatusOutput';
  count: Scalars['Float'];
  openCount: Scalars['Float'];
  unreachableCount: Scalars['Float'];
  docsSubmittedCount: Scalars['Float'];
  loanAppealedCount: Scalars['Float'];
  pendingDocsCount: Scalars['Float'];
  loanIssuedCount: Scalars['Float'];
  loanDocSignedCount: Scalars['Float'];
  loanSignedCount: Scalars['Float'];
  assignedCount: Scalars['Float'];
  unassignedCount: Scalars['Float'];
};

export type AddEmailLogSchemeInput = {
  refId: Scalars['String'];
  refType: Scalars['String'];
  content: Scalars['String'];
  subject: Scalars['String'];
  recipientEmail: Scalars['String'];
  ccEmails?: Maybe<Scalars['String']>;
  bccEmails?: Maybe<Scalars['String']>;
  isEmailSent: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
};

export type AddPackageInput = {
  name: Scalars['String'];
  desc: Scalars['String'];
  listPrice: Scalars['Float'];
  marketValue: Scalars['Float'];
  projectId: Scalars['String'];
};

export type AddSalesPackageInput = {
  id?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  name: Scalars['String'];
  desc?: Maybe<Scalars['String']>;
  listPrice: Scalars['Float'];
  marketValue: Scalars['Float'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};

export type AddSiteProgressInput = {
  id?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  publishDate: Scalars['DateTime'];
  attachment?: Maybe<Array<Scalars['Upload']>>;
};

/** JsonType */
export type Address = {
  __typename?: 'Address';
  ID?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  postCodeName?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
};

export type AddressInput = {
  ID?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  siteName?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  postCodeName?: Maybe<Scalars['String']>;
  AddressType?: Maybe<AddressType>;
};

export type AddressJson = {
  __typename?: 'AddressJson';
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  subdistrict?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  postCodeName?: Maybe<Scalars['String']>;
  AddressType?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type AddressJsonInput = {
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  subdistrict?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  postCodeName?: Maybe<Scalars['String']>;
  AddressType?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export enum AddressType {
  Primary = 'PRIMARY',
  Delivery = 'DELIVERY',
  Site = 'SITE'
}

export type AdminAddPanelInput = {
  project_id: Scalars['String'];
  financier_id?: Maybe<Scalars['String']>;
  is_panel: Scalars['Boolean'];
};

export type AdminCampaignInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};

export type AdminCompanyInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  companyCode: Scalars['String'];
  regNo: Scalars['String'];
  regionId?: Maybe<Scalars['String']>;
  desc: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  addr: AddressJsonInput;
  logoFile?: Maybe<Scalars['Upload']>;
  websiteUrl: Scalars['String'];
};

export type AdminEditGalleryInput = {
  picture_id?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['Float']>;
  unit_layout_id?: Maybe<Scalars['String']>;
  seq_no?: Maybe<Scalars['Float']>;
  delete?: Maybe<Scalars['Boolean']>;
  bucket_file_name?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  videoType?: Maybe<Scalars['String']>;
  media_type?: Maybe<Scalars['String']>;
  is_private?: Maybe<Scalars['Boolean']>;
  gallery_type: Scalars['String'];
  project_id: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
};

export type AdminEditGalleryTourInput = {
  url?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
};

export type AdminEditGalleryVideoInput = {
  url?: Maybe<Scalars['String']>;
  videoType?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
};

export type AdminEditLayoutBlockInput = {
  picture_id?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  seq_no?: Maybe<Scalars['Float']>;
  bucket_file_name?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  media_type?: Maybe<Scalars['String']>;
  is_private?: Maybe<Scalars['Boolean']>;
  project_id: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
};

export type AdminEditLayoutFloorInput = {
  picture_id?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  seq_no: Scalars['Float'];
  bucket_file_name?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  media_type?: Maybe<Scalars['String']>;
  is_private?: Maybe<Scalars['Boolean']>;
  project_id: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  block: Scalars['String'];
  floor: Scalars['Float'];
  blockFloor: Scalars['String'];
};

export type AdminEditLayoutUnitInput = {
  picture_id?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
  resource_id?: Maybe<Scalars['String']>;
  seq_no?: Maybe<Scalars['Float']>;
  bucket_file_name?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  media_type?: Maybe<Scalars['String']>;
  is_private?: Maybe<Scalars['Boolean']>;
  caption?: Maybe<Scalars['String']>;
  unit_layout_id?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  unit_type_id?: Maybe<Scalars['String']>;
  no_of_bedroom?: Maybe<Scalars['Float']>;
  no_of_bathroom?: Maybe<Scalars['Float']>;
};

export type AdminEditProjectGalleryInput = {
  picture_id?: Maybe<Scalars['String']>;
  resource_id?: Maybe<Scalars['String']>;
  seq_no?: Maybe<Scalars['Float']>;
  bucket_file_name?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  media_type?: Maybe<Scalars['String']>;
  is_private?: Maybe<Scalars['Boolean']>;
  project_id: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
};

export type AdminEventsInput = {
  id?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  desc?: Maybe<Scalars['String']>;
  website: Scalars['String'];
  location: Scalars['String'];
  startDate?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['DateTime']>;
  budget: Scalars['Float'];
};

export type AdminFinancierPanelInput = {
  projectId: Scalars['String'];
  financierId: Scalars['String'];
  contactIds: Array<Scalars['String']>;
  financialLimit?: Maybe<Scalars['Float']>;
  interestRate?: Maybe<Scalars['Float']>;
};

export type AdminProjectInput = {
  id?: Maybe<Scalars['String']>;
  holdingCompany: Scalars['String'];
  developmentCompany: Scalars['String'];
  name: Scalars['String'];
  townshipName?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  launchDate?: Maybe<Scalars['DateTime']>;
  projectAddress?: Maybe<Scalars['String']>;
  projectGps?: Maybe<Scalars['String']>;
  saleGalleryAddress?: Maybe<Scalars['String']>;
  saleGalleryGps?: Maybe<Scalars['String']>;
  tenure: Scalars['String'];
  landType: Scalars['String'];
  uom: Scalars['String'];
  city: Scalars['String'];
  state: Scalars['String'];
  projectType: Scalars['String'];
  minPrice?: Maybe<Scalars['Float']>;
  maxPrice?: Maybe<Scalars['Float']>;
  amenities?: Maybe<Array<AmenitiesInput>>;
  projectCode: Scalars['String'];
  currency: Scalars['String'];
  country: Scalars['String'];
  isIntegrated?: Maybe<Scalars['Boolean']>;
  integrationType?: Maybe<Scalars['String']>;
};

export type AdminSaveProjectSpecInput = {
  project_id: Scalars['String'];
  booking_fee_mandatory: Scalars['Boolean'];
  booking_form_lang: Scalars['String'];
  min_bookingfee_amount: Scalars['Float'];
  booking_sign_required: Scalars['Boolean'];
  ELetteringSMSRequired?: Maybe<Scalars['Boolean']>;
  min_age_required: Scalars['Boolean'];
  min_age?: Maybe<Scalars['Float']>;
  nric_attachment_required: Scalars['Boolean'];
  ccr_attachment_required: Scalars['Boolean'];
  bookingfee_amount_required: Scalars['Boolean'];
  bookingPDPAconsent_required: Scalars['Boolean'];
  bookingRefundPolicyconsent_required: Scalars['Boolean'];
  statement_refund_policy?: Maybe<Scalars['String']>;
  company_show: Scalars['String'];
  packages_show: Scalars['Boolean'];
  discounts_show: Scalars['Boolean'];
  address_show: Scalars['Boolean'];
  remarks_show: Scalars['Boolean'];
  maritalstatus_show: Scalars['Boolean'];
  loanconsent_required: Scalars['Boolean'];
  loan_screening: Scalars['Boolean'];
  expected_snp_required: Scalars['Boolean'];
  expected_snp_duration?: Maybe<Scalars['Float']>;
  payment_gateway_id?: Maybe<Scalars['String']>;
  payment_gateway_refund_policy?: Maybe<Scalars['String']>;
  auto_assign_lead_activated?: Maybe<Scalars['Boolean']>;
  assign_start_time?: Maybe<Scalars['String']>;
  assign_end_time?: Maybe<Scalars['String']>;
  auto_reassign_lead_activated: Scalars['Boolean'];
  auto_reassign_lead_duration?: Maybe<Scalars['Float']>;
  reassign_start_time?: Maybe<Scalars['String']>;
  reassign_end_time?: Maybe<Scalars['String']>;
  software_code?: Maybe<Array<Scalars['String']>>;
  lead_assign_notification_activated?: Maybe<Scalars['Boolean']>;
  lead_assign_notification_method?: Maybe<Array<Scalars['String']>>;
  leadAging_activated: Scalars['Boolean'];
  leadAging_duration?: Maybe<Scalars['Float']>;
  leadAging_notification_method?: Maybe<Array<Scalars['String']>>;
  lead_idle_one?: Maybe<Scalars['Float']>;
  lead_idle_two?: Maybe<Scalars['Float']>;
  lead_idle_three?: Maybe<Scalars['Float']>;
  lead_aging_manager_handled?: Maybe<Array<Scalars['String']>>;
  purchaser_app_setting?: Maybe<Scalars['String']>;
  sales_chart_sorting: Scalars['String'];
  tr_generation?: Maybe<Scalars['Boolean']>;
  paymentPlanId?: Maybe<Scalars['String']>;
  paymentPlanCode?: Maybe<Scalars['String']>;
  paymentPlanDesc?: Maybe<Scalars['String']>;
  gracePeriod?: Maybe<Scalars['Float']>;
  isPlatform: Scalars['Boolean'];
  reservation_sales?: Maybe<Scalars['Boolean']>;
  reservation_agency?: Maybe<Scalars['Boolean']>;
  auto_release_reservation_day?: Maybe<Scalars['Float']>;
  sale_notification?: Maybe<SaleLeadNotificationInput>;
  loan_notification?: Maybe<LoanLeadNotificationInput>;
  solicitor_notification?: Maybe<SolicitorLeadNotificationInput>;
  agency_notification?: Maybe<AgencyLeadNotificationInput>;
};

export type AdminSolicitorInput = {
  solicitorName: Scalars['String'];
  solicitorEmail: Scalars['String'];
  officeTel: Scalars['String'];
  officeAddress?: Maybe<AddressJsonInput>;
  contactName: Scalars['String'];
  contactEmail: Scalars['String'];
  contactPhoneNo: Scalars['String'];
  logo?: Maybe<Scalars['Upload']>;
  solicitorCode?: Maybe<Scalars['String']>;
};

export type AdminTeamInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  projects: Array<Scalars['String']>;
  users: Array<AdminTeamUserrole>;
};

export type AdminTeamUserrole = {
  user_id: Scalars['String'];
  role: Scalars['String'];
};

export type AdminUnitIntegrationInput = {
  baseUrl: Scalars['String'];
  pxProjectId: Scalars['String'];
  ifcaCompanyID: Scalars['String'];
  ifcaProjectID: Scalars['String'];
  ifcaPhaseID: Scalars['String'];
  ifcaCompanyName?: Maybe<Scalars['String']>;
  ifcaProjectName?: Maybe<Scalars['String']>;
  ifcaPhaseName?: Maybe<Scalars['String']>;
};

export type AdminUnitSalesChartInput = {
  projectid: Scalars['String'];
  block: Scalars['String'];
  floor: Scalars['Float'];
  resourceid: Scalars['String'];
  unitid: Scalars['String'];
  coordinate: Scalars['String'];
};

export type AdminUnitStatusInput = {
  unitid: Scalars['String'];
  status: Scalars['String'];
};

export type AdminUpdateUnitVirtualModelInput = {
  tourId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  block: Scalars['String'];
  unitLayoutId?: Maybe<Scalars['String']>;
  unitTypeId?: Maybe<Scalars['String']>;
  virtualModelLink: Scalars['String'];
};

export type AgencyContractPolicyOutput = {
  __typename?: 'AgencyContractPolicyOutput';
  allow_waiting_list?: Maybe<Scalars['Boolean']>;
  allow_update_loan_status?: Maybe<Scalars['Boolean']>;
};

export type AgencyLeadNotificationInput = {
  loanAssignment?: Maybe<LoanAssignmentInput>;
};

export type AgencyLeadNotificationOutput = {
  __typename?: 'AgencyLeadNotificationOutput';
  loanAssignment?: Maybe<LoanAssignmentOutput>;
};

export type AgencyPermissionOutput = {
  __typename?: 'AgencyPermissionOutput';
  allowWaitingList?: Maybe<Scalars['Boolean']>;
  allowLoanApp?: Maybe<Scalars['Boolean']>;
};

export type AgentTotalUnitSoldOutput = {
  __typename?: 'AgentTotalUnitSoldOutput';
  unitSoldCount?: Maybe<Scalars['Float']>;
  totalPrice?: Maybe<Scalars['Float']>;
};

export type AllStandardCoreBaseEntity = StandardAuditEntity & {
  __typename?: 'AllStandardCoreBaseEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export type Amenities = {
  __typename?: 'Amenities';
  category: Scalars['String'];
  items: Array<Scalars['String']>;
};

export type AmenitiesInput = {
  category: Scalars['String'];
  items: Array<Scalars['String']>;
};

export type AppointmentEntity = {
  __typename?: 'AppointmentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  teamId: Scalars['String'];
  salesPersonId: Scalars['String'];
  salesPersonOrigin: Scalars['String'];
  appointmentDate: Scalars['DateTime'];
  startTime: Scalars['String'];
  endTime: Scalars['String'];
  appointmentTypeId: Scalars['String'];
  contactId: Scalars['String'];
  remarks: Scalars['String'];
  needManagerAssistant: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  modBy: Scalars['String'];
  modTs: Scalars['DateTime'];
  participantLimit: Scalars['Float'];
  leadId: Scalars['String'];
  salePerson: SUserEntity;
  saleTeam: SaleTeamEntity;
  appointmentPurpose: AppointmentTypeEntity;
  lead: LeadContactEntity;
  project: ProjectEntity;
  leadSourceFromLead?: Maybe<LeadEntity>;
};

export type AppointmentTypeEntity = {
  __typename?: 'AppointmentTypeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  seqNo: Scalars['Float'];
  defaulted: Scalars['Boolean'];
  systemUse: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  isDeletable: Scalars['Boolean'];
};

/** JsonType */
export type ApprovalListJson = {
  __typename?: 'ApprovalListJson';
  stepNo: Scalars['Float'];
  roleId: Scalars['String'];
  roleName?: Maybe<Scalars['String']>;
  predicate?: Maybe<Scalars['String']>;
};

export type ApprovalListJsonInput = {
  stepNo: Scalars['Float'];
  roleId: Scalars['String'];
  roleName?: Maybe<Scalars['String']>;
  predicate?: Maybe<Scalars['String']>;
};

export type AssignedBatchDetails = {
  __typename?: 'AssignedBatchDetails';
  batch_id: Scalars['String'];
  batch_title: Scalars['String'];
  record_count: Scalars['Float'];
  isRoundRobinUser?: Maybe<Scalars['Boolean']>;
  projects?: Maybe<Array<AssignedProjectDetails>>;
  createdTs?: Maybe<Scalars['DateTime']>;
  countLeadSource?: Maybe<LeadBatchCountLeadSourceOutput>;
};

export type AssignedProjectDetails = {
  __typename?: 'AssignedProjectDetails';
  assigned_date: Scalars['DateTime'];
  project_name: Scalars['String'];
  batch_id: Scalars['String'];
  lead_count: Scalars['Float'];
};

export type AttachmentOutput = {
  __typename?: 'AttachmentOutput';
  fileName?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  brochureUrl?: Maybe<Scalars['String']>;
};

export type AuditEntity = {
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
};

export type AuditEntity_Temp = {
  recordStatus: Scalars['String'];
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
};

export type AuthorizedAgentOutput = {
  __typename?: 'AuthorizedAgentOutput';
  count?: Maybe<Scalars['Float']>;
  lastAssignedDate?: Maybe<Scalars['DateTime']>;
};

export type BaseInput = {
  ID?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<CommonStatus>;
};

export enum BillAfter {
  SalesRegistrationDate = 'SALES_REGISTRATION_DATE',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export enum BillFrequency {
  Day = 'DAY',
  Month = 'MONTH',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export enum BillType {
  DownPayment = 'DOWN_PAYMENT',
  Installment = 'INSTALLMENT',
  BankLoan = 'BANK_LOAN',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export type BlockByProjectOutput = {
  __typename?: 'BlockByProjectOutput';
  blocks: Array<Scalars['String']>;
  integrated: Scalars['Boolean'];
  isSubProduct: Scalars['Boolean'];
};

export type BlockGalleryOutput = {
  __typename?: 'BlockGalleryOutput';
  resourceid: Scalars['String'];
  url: Scalars['String'];
  pictureid: Scalars['String'];
  seqno: Scalars['Float'];
  block: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
};

export type BlockOutput = {
  __typename?: 'BlockOutput';
  block: Scalars['String'];
  unitTypes: Array<UnitTypeLinkOutput>;
  unitLayouts: Array<UnitLayoutOutput>;
};

export type BookStatusOutput = {
  __typename?: 'BookStatusOutput';
  total?: Maybe<Scalars['Float']>;
  reserveCount?: Maybe<Scalars['Float']>;
  bookedCount?: Maybe<Scalars['Float']>;
  signedCount?: Maybe<Scalars['Float']>;
  cancelledCount?: Maybe<Scalars['Float']>;
  totalSellingPrice?: Maybe<Scalars['Float']>;
};

export type BookedAndFavUnit = {
  __typename?: 'BookedAndFavUnit';
  favouriteUnits: Array<Scalars['String']>;
  bookedUnits: Array<Scalars['String']>;
};

export type BookedUnit = {
  __typename?: 'BookedUnit';
  unitNo: Scalars['String'];
  salesStatus: Scalars['String'];
};

export type BookingCancellationNotificationInput = {
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  purchaserReceive?: Maybe<Scalars['Boolean']>;
};

export type BookingCancellationNotificationOutput = {
  __typename?: 'BookingCancellationNotificationOutput';
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  purchaserReceive?: Maybe<Scalars['Boolean']>;
};

export type BookingConfirmationStatusOutput = {
  __typename?: 'BookingConfirmationStatusOutput';
  total: Scalars['Float'];
  pendingCount?: Maybe<Scalars['Float']>;
  reservationCount: Scalars['Float'];
  purchaserAppCount: Scalars['Float'];
  eLaunchAppCount: Scalars['Float'];
  integrationCount: Scalars['Float'];
  cancelledCount: Scalars['Float'];
};

export type BookingDetailOutput = {
  __typename?: 'BookingDetailOutput';
  salesId: Scalars['String'];
  projectId: Scalars['String'];
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  buyerId: Scalars['String'];
  buyerName: Scalars['String'];
  buyerCompanyName?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isjointBuyerComplete?: Maybe<Scalars['Boolean']>;
  salesNo: Scalars['String'];
  listPrice: Scalars['String'];
  unitLayout?: Maybe<Scalars['String']>;
  builtUp: Scalars['String'];
  buyerNric: Scalars['String'];
  buyerCompanyRegNo?: Maybe<Scalars['String']>;
  buyerPhoneNo?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  cancelledDate?: Maybe<Scalars['DateTime']>;
  cancelledReason?: Maybe<Scalars['String']>;
  cancelledByName?: Maybe<Scalars['String']>;
  teamName?: Maybe<Scalars['String']>;
  personName?: Maybe<Scalars['String']>;
  agencyName?: Maybe<Scalars['String']>;
  agencyUserName?: Maybe<Scalars['String']>;
  salePaymentId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paidAmount?: Maybe<Scalars['Float']>;
  bookingRemark?: Maybe<Scalars['String']>;
  unitLayoutDes?: Maybe<Scalars['String']>;
  landArea?: Maybe<Scalars['String']>;
  extraLandArea?: Maybe<Scalars['Float']>;
  attachmentCount?: Maybe<BookingListAttachmentOutput>;
  joinBuyer: Array<JointBuyerEntity>;
};

export type BookingLeadsOutput = {
  __typename?: 'BookingLeadsOutput';
  lead_id?: Maybe<Scalars['String']>;
  contact_id: Scalars['String'];
  full_name: Scalars['String'];
  phone_no: Scalars['String'];
  email: Scalars['String'];
  military_ic?: Maybe<Scalars['String']>;
  ic_no?: Maybe<Scalars['String']>;
  nationality_id?: Maybe<Scalars['String']>;
  lead_source_id?: Maybe<Scalars['String']>;
};

export type BookingListAttachmentOutput = {
  __typename?: 'BookingListAttachmentOutput';
  bookingFeeAttachment?: Maybe<Scalars['Float']>;
  bookingNricAttachments?: Maybe<Scalars['Float']>;
  bookingCcrAttachments?: Maybe<Scalars['Float']>;
  bookingPdpaAttachments?: Maybe<Scalars['Float']>;
  requiredDocCount?: Maybe<Scalars['Float']>;
  completedDocCount?: Maybe<Scalars['Float']>;
  isAttachmentComplete?: Maybe<Scalars['Boolean']>;
};

export type BookingListDataOutput = {
  __typename?: 'BookingListDataOutput';
  salesId: Scalars['String'];
  projectId: Scalars['String'];
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['String'];
  listPrice: Scalars['String'];
  saleDate: Scalars['DateTime'];
  unitNo: Scalars['String'];
  unitId: Scalars['String'];
  buyerId: Scalars['String'];
  unitLayout?: Maybe<Scalars['String']>;
  builtUp: Scalars['String'];
  buyerName: Scalars['String'];
  buyerNric: Scalars['String'];
  salesNo: Scalars['String'];
  cancelledDate?: Maybe<Scalars['DateTime']>;
  cancelledReason?: Maybe<Scalars['String']>;
  cancelledByName?: Maybe<Scalars['String']>;
  salePaymentId?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paidAmount?: Maybe<Scalars['Float']>;
  salePersonName?: Maybe<Scalars['String']>;
  agentPersonName?: Maybe<Scalars['String']>;
  buyerCompanyName?: Maybe<Scalars['String']>;
  buyerCompanyRegNo?: Maybe<Scalars['String']>;
  buyerPhoneNo?: Maybe<Scalars['String']>;
  buyerEmail?: Maybe<Scalars['String']>;
  salePaymentStatus?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  bookingRemark?: Maybe<Scalars['String']>;
};

export type BookingListJointBuyerOutput = {
  __typename?: 'BookingListJointBuyerOutput';
  isNotCompleteCount?: Maybe<Scalars['Float']>;
};

export type BookingListLoanScreeningOutput = {
  __typename?: 'BookingListLoanScreeningOutput';
  caseCode: Scalars['String'];
  status: Scalars['String'];
  CCRIS?: Maybe<Scalars['String']>;
  CTOS?: Maybe<Scalars['String']>;
};

export type BookingNotificationInput = {
  assignmentSalesUserReceive?: Maybe<Scalars['Boolean']>;
  assignmentAgencyUserReceive?: Maybe<Scalars['Boolean']>;
  assignmentPurchaserReceive?: Maybe<Scalars['Boolean']>;
  attachTr?: Maybe<Scalars['Boolean']>;
  attachBookingAttachment?: Maybe<Scalars['Boolean']>;
};

export type BookingNotificationOutput = {
  __typename?: 'BookingNotificationOutput';
  assignmentSalesUserReceive?: Maybe<Scalars['Boolean']>;
  assignmentAgencyUserReceive?: Maybe<Scalars['Boolean']>;
  assignmentPurchaserReceive?: Maybe<Scalars['Boolean']>;
  attachTr?: Maybe<Scalars['Boolean']>;
  attachBookingAttachment?: Maybe<Scalars['Boolean']>;
};

export type BookingSharedOutput = {
  __typename?: 'BookingSharedOutput';
  salesId: Scalars['String'];
  projectId: Scalars['String'];
  isPurchaserInfoComplete?: Maybe<Scalars['Boolean']>;
  salesStatus: Scalars['String'];
  sellingPrice: Scalars['Float'];
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  buyerId: Scalars['String'];
  buyerName: Scalars['String'];
  buyerCompanyName?: Maybe<Scalars['String']>;
  isCompany?: Maybe<Scalars['Boolean']>;
  isjointBuyerComplete?: Maybe<Scalars['Boolean']>;
};

export type CarPark = {
  carParkId: Array<Scalars['String']>;
  carParkNo: Array<Scalars['String']>;
};

export type CheckOnPremApiModel = {
  __typename?: 'CheckOnPremApiModel';
  onPremVer?: Maybe<Scalars['String']>;
  onPremIntType?: Maybe<Scalars['String']>;
  apiUrl?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['Float']>;
  softwareCode?: Maybe<Scalars['String']>;
  sApiGatewayId?: Maybe<Scalars['String']>;
  getSuccess?: Maybe<Scalars['Boolean']>;
  errno?: Maybe<Scalars['String']>;
  errMsg?: Maybe<Scalars['String']>;
};

export type CityMasterDataOutput = {
  __typename?: 'CityMasterDataOutput';
  ID: Scalars['String'];
  name: Scalars['String'];
  stateID: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type CloseDateIdInput = {
  id: Scalars['String'];
};

export type CloudStorageOutput = {
  __typename?: 'CloudStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  Url: Scalars['String'];
  MediaType: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  PrivateUrl?: Maybe<Scalars['String']>;
};

export type CollectionActivityUserPermEntity = {
  __typename?: 'CollectionActivityUserPermEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  salesPersonId: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type CollectionActivityUserPermissionEntity = {
  __typename?: 'CollectionActivityUserPermissionEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  salesPersonId: Scalars['String'];
  commonStatus: Scalars['String'];
};

export enum CommercialPurpose {
  Commercial = 'COMMERCIAL',
  Residential = 'RESIDENTIAL',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export enum CommonStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Block = 'BLOCK'
}

export enum CompanyTax {
  NoTax = 'NO_TAX',
  SstNo = 'SST_NO',
  GstNo = 'GST_NO'
}

export type Contact = {
  __typename?: 'Contact';
  contactId: Scalars['String'];
  date?: Maybe<Scalars['String']>;
  link: Scalars['String'];
  default?: Maybe<Scalars['Boolean']>;
  contactInfo?: Maybe<FinancierContactEntity>;
};

export type ContactInfo = {
  __typename?: 'ContactInfo';
  name: Scalars['String'];
  phoneNo: Scalars['String'];
  email: Scalars['String'];
};

export type ContactNupInput = {
  name?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  identitytype?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  hometel?: Maybe<Scalars['String']>;
  officetel?: Maybe<Scalars['String']>;
};

/** JsonType */
export type ContactPerson = {
  __typename?: 'ContactPerson';
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  associateID?: Maybe<Scalars['String']>;
  docRefTable?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type ContactPersonInput = {
  ID?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  associateID?: Maybe<Scalars['String']>;
  docRefTable?: Maybe<Scalars['String']>;
  designation?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
};

export type CoreBaseEntity = AuditEntity & {
  __typename?: 'CoreBaseEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export type CountWaitingUnitOutput = {
  __typename?: 'CountWaitingUnitOutput';
  waitList?: Maybe<Scalars['Float']>;
  activeUnits?: Maybe<Scalars['Float']>;
  leaveQueue?: Maybe<Scalars['Float']>;
};

export type CountryMasterDataOutput = {
  __typename?: 'CountryMasterDataOutput';
  ID: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type CreateAuditInput = {
  createdBy?: Maybe<Scalars['String']>;
};

export type DotnetContactDetail = {
  __typename?: 'DOTNETContactDetail';
  ContactInfo: Array<ContactInfo>;
  total: Scalars['Float'];
};

export type DotnetSalesCountAndEmailOutput = {
  __typename?: 'DOTNETSalesCountAndEmailOutput';
  email: Scalars['String'];
  bookedCount: Scalars['Float'];
  signedCount: Scalars['Float'];
};

export type DotnetSalesDetail = {
  __typename?: 'DOTNETSalesDetail';
  id: Scalars['String'];
  buyerName: Scalars['String'];
  price: Scalars['String'];
  projectName: Scalars['String'];
  unitNo: Scalars['String'];
  salesStatus: Scalars['String'];
  currency: Scalars['String'];
};

export type DataSource = {
  __typename?: 'DataSource';
  DataSource: Scalars['String'];
  Columns?: Maybe<Array<Scalars['String']>>;
  DataMember: Scalars['String'];
  IsStoreProcedure?: Maybe<Scalars['Boolean']>;
  IsMainQuery?: Maybe<Scalars['Boolean']>;
  DynamicFilterColumn?: Maybe<Scalars['String']>;
};

export type DataSourceInput = {
  DataSource: Scalars['String'];
  Columns?: Maybe<Array<Scalars['String']>>;
  DataMember: Scalars['String'];
  IsStoreProcedure?: Maybe<Scalars['Boolean']>;
  IsMainQuery?: Maybe<Scalars['Boolean']>;
  DynamicFilterColumn?: Maybe<Scalars['String']>;
};


export enum DeductBookingFee {
  FirstInstallment = 'FIRST_INSTALLMENT',
  Prorated = 'PRORATED',
  None = 'NONE',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export type DirectionInput = {
  name: Scalars['String'];
};

export type DiscountInput = {
  discountTypeId: Scalars['String'];
  title: Scalars['String'];
  formula?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  discountVal?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type DiscountParamaterValueOutput = {
  __typename?: 'DiscountParamaterValueOutput';
  amount: Scalars['Float'];
  type: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type DistinctBlockByProjectOutput = {
  __typename?: 'DistinctBlockByProjectOutput';
  block: Scalars['String'];
};

export type DistinctFloorByProjectOutput = {
  __typename?: 'DistinctFloorByProjectOutput';
  block: Scalars['String'];
  floor: Scalars['Float'];
  blockFloor: Scalars['String'];
};

export type DistinctUnitByProjectOutput = {
  __typename?: 'DistinctUnitByProjectOutput';
  unit_layout_id: Scalars['String'];
  desc: Scalars['String'];
  block?: Maybe<Scalars['String']>;
  unit_type?: Maybe<Scalars['String']>;
};

export type DistinctUnitTypeByProjectOutput = {
  __typename?: 'DistinctUnitTypeByProjectOutput';
  unit_type_id: Scalars['String'];
  unit_type_desc: Scalars['String'];
  unit_block: Scalars['String'];
};

export type DistrictMasterDataOutput = {
  __typename?: 'DistrictMasterDataOutput';
  ID: Scalars['String'];
  name: Scalars['String'];
  stateID: Scalars['String'];
  commonStatus: Scalars['String'];
};

export enum DocumentNumberHeaderTypeIndoEnum {
  BookingNo = 'BOOKING_NO',
  BookingReceipt = 'BOOKING_RECEIPT',
  SalesRegistration = 'SALES_REGISTRATION',
  DepositReceipt = 'DEPOSIT_RECEIPT',
  TemporaryReceipt = 'TEMPORARY_RECEIPT',
  OfficialReceipt = 'OFFICIAL_RECEIPT',
  Allocation = 'ALLOCATION',
  Unallocation = 'UNALLOCATION',
  CreditNote = 'CREDIT_NOTE',
  DebitNote = 'DEBIT_NOTE',
  Refund = 'REFUND',
  RescheduleInstallment = 'RESCHEDULE_INSTALLMENT',
  SalesRebate = 'SALES_REBATE',
  UnitTransfer = 'UNIT_TRANSFER',
  PurchaserNameTransfer = 'PURCHASER_NAME_TRANSFER',
  LoanApproval = 'LOAN_APPROVAL',
  LoanReleaseNotification = 'LOAN_RELEASE_NOTIFICATION',
  LoanPayment = 'LOAN_PAYMENT',
  Refinancing = 'REFINANCING',
  BuyBack = 'BUY_BACK',
  PaymentReminders = 'PAYMENT_REMINDERS',
  Interest = 'INTEREST',
  Misc = 'MISC',
  AreaVariance = 'AREA_VARIANCE',
  Lad = 'LAD',
  Contra = 'CONTRA',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export type DropDownDataSource = {
  __typename?: 'DropDownDataSource';
  DataSource: Scalars['String'];
  DataMember: Scalars['String'];
  parameters: Array<DropDownParamterInterface>;
};

export type DropDownDataSourceInput = {
  DataSource: Scalars['String'];
  DataMember: Scalars['String'];
  parameters: Array<DropDownDataSourceParameterInput>;
};

export type DropDownDataSourceParameterInput = {
  Name: Scalars['String'];
  ParameterName: Scalars['String'];
};

export type DropDownMember = {
  __typename?: 'DropDownMember';
  ValueSource: Scalars['String'];
  DynamicSource?: Maybe<DynamicSource>;
  StaticData?: Maybe<Array<StaticData>>;
};

export type DropDownMemberInput = {
  ValueSource: Scalars['String'];
  DynamicSource?: Maybe<DynamicSourceInput>;
  StaticData?: Maybe<Array<StaticDataInput>>;
};

export type DropDownParamterInterface = {
  __typename?: 'DropDownParamterInterface';
  Name: Scalars['String'];
  ParameterName: Scalars['String'];
};

export type DynamicSource = {
  __typename?: 'DynamicSource';
  DisplayMember: Scalars['String'];
  ValueMember: Scalars['String'];
  DataSource: DropDownDataSource;
};

export type DynamicSourceInput = {
  DisplayMember: Scalars['String'];
  ValueMember: Scalars['String'];
  DataSource: DropDownDataSourceInput;
};

export type ELaunchAllocationInput = {
  e_launch_id: Scalars['String'];
  unitIds: Array<Scalars['String']>;
};

export type ELaunchInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  code: Scalars['String'];
  project_id: Scalars['String'];
  start_date: Scalars['DateTime'];
  end_date: Scalars['DateTime'];
  termination_date: Scalars['DateTime'];
  publish_date: Scalars['DateTime'];
};

export type ELetterOutput = {
  __typename?: 'ELetterOutput';
  fileName: Scalars['String'];
  content: Scalars['String'];
};

export type ESignLetterTemplateAssignmenttOutput = {
  __typename?: 'ESignLetterTemplateAssignmenttOutput';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ESignProjectLetterListingOutput = {
  __typename?: 'ESignProjectLetterListingOutput';
  letterTemplateId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  letterType?: Maybe<Scalars['String']>;
  defaulted?: Maybe<Scalars['Boolean']>;
};

export type EditAppointmentScheduleInput = {
  id: Scalars['String'];
  startTime: Scalars['String'];
  endTime: Scalars['String'];
  participantLimit: Scalars['Float'];
};

export type EditDirectionInput = {
  name: Scalars['String'];
  id: Scalars['String'];
};

export type EditDiscountInput = {
  discountTypeId: Scalars['String'];
  title: Scalars['String'];
  formula?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  discountVal?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
};

export type EditEmailLogSchemeInput = {
  refId: Scalars['String'];
  refType: Scalars['String'];
  content: Scalars['String'];
  subject: Scalars['String'];
  recipientEmail: Scalars['String'];
  ccEmails?: Maybe<Scalars['String']>;
  bccEmails?: Maybe<Scalars['String']>;
  isEmailSent: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
};

export type EditIncomeRangeInput = {
  range: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
};

export type EditLeadSourceInput = {
  name: Scalars['String'];
  id: Scalars['String'];
};

export type EditLetterTemplate = {
  __typename?: 'EditLetterTemplate';
  id: Scalars['String'];
  name: Scalars['String'];
  templateBody: Scalars['String'];
  jointBuyerSignRequired: Scalars['Boolean'];
  letterParameter: Array<LetterParameter>;
};

export type EditLetterTemplateInput = {
  standardLetterId: Scalars['String'];
  name: Scalars['String'];
  text: Scalars['String'];
  jointBuyerSign?: Maybe<Scalars['Boolean']>;
  letterTemplateId: Scalars['String'];
};

export type EditMaritalStatusInput = {
  name: Scalars['String'];
  id: Scalars['String'];
};

export type EditNupReasonInput = {
  id: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type EditNupTypeInput = {
  id: Scalars['String'];
  nupType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  prefix?: Maybe<Scalars['String']>;
  viaMobile?: Maybe<Scalars['Boolean']>;
  viaAgent?: Maybe<Scalars['Boolean']>;
};

export type EditPackageInput = {
  name: Scalars['String'];
  desc: Scalars['String'];
  listPrice: Scalars['Float'];
  marketValue: Scalars['Float'];
  id: Scalars['String'];
};

export type EditPlatformUserInput = {
  userId: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  contactNo: Scalars['String'];
  role: Scalars['Boolean'];
  username: Scalars['String'];
};

export type EditProjectTypeInput = {
  name: Scalars['String'];
  id: Scalars['String'];
};

export type EditPropertyTypeInput = {
  name: Scalars['String'];
  commercialPurpose: CommercialPurpose;
  id: Scalars['String'];
};

export type EditRaceInput = {
  name: Scalars['String'];
  id: Scalars['String'];
};

export type EditReasonCodeInput = {
  name: Scalars['String'];
  type: Scalars['String'];
  id: Scalars['String'];
};

export type EditRegionInput = {
  name: Scalars['String'];
  id: Scalars['String'];
};

export type EditSalesDocInput = {
  id: Scalars['String'];
  docName: Scalars['String'];
  allowSalesTeam: Scalars['Boolean'];
  allowAgency: Scalars['Boolean'];
  projectId: Scalars['String'];
  type: Scalars['String'];
};

export type EditSalesPackageInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  desc?: Maybe<Scalars['String']>;
  listPrice: Scalars['Float'];
  marketValue: Scalars['Float'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
};

export type EditSalutationInput = {
  name: Scalars['String'];
  id: Scalars['String'];
};

export type EditTeamInput = {
  name: Scalars['String'];
  projectId: Scalars['String'];
  id: Scalars['String'];
};

export type EditUnitTypeInput = {
  name: Scalars['String'];
  id: Scalars['String'];
};

export type EditUserInput = {
  userId: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  username: Scalars['String'];
  phoneNo: Scalars['String'];
  superUser: Scalars['Boolean'];
  allowOpenLead: Scalars['Boolean'];
  allowPropertyAgency: Scalars['Boolean'];
  allowGlobalBI?: Maybe<Scalars['Boolean']>;
  allowRoundRobin?: Maybe<Scalars['Boolean']>;
  allowOpenLeadRoundRobin?: Maybe<Scalars['Boolean']>;
};

export type ElaunchUnitAllocation = {
  __typename?: 'ElaunchUnitAllocation';
  unit_id: Scalars['String'];
  unit_no: Scalars['String'];
  unit_status: Scalars['String'];
  unit_type?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  floor?: Maybe<Scalars['Float']>;
  floor_label?: Maybe<Scalars['String']>;
  cell: Scalars['Float'];
  status?: Maybe<Scalars['String']>;
  isBumi?: Maybe<Scalars['Boolean']>;
  unitType: Scalars['String'];
  favouriteCount: Scalars['Float'];
};


export type ElaunchUnitAllocationFavouriteCountArgs = {
  eLaunchId: Scalars['String'];
};

export type ElementTypeOutput = {
  __typename?: 'ElementTypeOutput';
  elementId: Scalars['String'];
  elementName: Scalars['String'];
};

export type EmailLogOutput = {
  __typename?: 'EmailLogOutput';
  id: Scalars['String'];
  accountId: Scalars['String'];
  refId: Scalars['String'];
  refType: Scalars['String'];
  content: Scalars['String'];
  subject: Scalars['String'];
  recipientEmail: Scalars['String'];
  ccEmails?: Maybe<Scalars['String']>;
  bccEmails?: Maybe<Scalars['String']>;
  isEmailSent: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type ExchangeLog = {
  __typename?: 'ExchangeLog';
  exchangeRate?: Maybe<Scalars['Float']>;
  modTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
};

export type ExchangeLogInput = {
  exchangeRate?: Maybe<Scalars['Float']>;
  modTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
};

export type ExistingLeadOutput = {
  __typename?: 'ExistingLeadOutput';
  contact_id: Scalars['String'];
  full_name: Scalars['String'];
  email: Scalars['String'];
  phone_no: Scalars['String'];
  sales_person_name?: Maybe<Scalars['String']>;
  sales_person_id?: Maybe<Scalars['String']>;
};

export type FavouriteUnit = {
  __typename?: 'FavouriteUnit';
  count: Scalars['Float'];
  unitNo: Scalars['String'];
};

export type FavouriteUnitType = {
  __typename?: 'FavouriteUnitType';
  count: Scalars['Float'];
  unitType: Scalars['String'];
};

export type FieldError = {
  __typename?: 'FieldError';
  field: Scalars['String'];
  message: Scalars['String'];
};

export type FinancierContact = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  email: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type FinancierInput = {
  id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
  address?: Maybe<AddressJsonInput>;
  logo?: Maybe<Scalars['Upload']>;
  contacts?: Maybe<Array<FinancierContact>>;
};

export type FinancierProject = {
  __typename?: 'FinancierProject';
  projectId: Scalars['String'];
  invitation: Array<Contact>;
};

export type FloorGalleryOutput = {
  __typename?: 'FloorGalleryOutput';
  resourceid: Scalars['String'];
  url: Scalars['String'];
  pictureid: Scalars['String'];
  seqno: Scalars['Float'];
  caption?: Maybe<Scalars['String']>;
  block: Scalars['String'];
  floor: Scalars['Float'];
  blockFloor: Scalars['String'];
};

export type FloorOutput = {
  __typename?: 'FloorOutput';
  projectid: Scalars['String'];
  block: Scalars['String'];
  floor: Scalars['Float'];
  floorlabel: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
  Unit?: Maybe<Array<UnitEntity>>;
  ActiveUnit?: Maybe<Array<UnitEntity>>;
};

export type GlRevenueMapping = {
  __typename?: 'GLRevenueMapping';
  ExpenseDiv?: Maybe<Scalars['String']>;
  RevenueDiv?: Maybe<Scalars['String']>;
  ReverseDiv?: Maybe<Scalars['String']>;
  ExpenseDept?: Maybe<Scalars['String']>;
  RevenueDept?: Maybe<Scalars['String']>;
  ReverseDept?: Maybe<Scalars['String']>;
  ExpenseDebit?: Maybe<Scalars['String']>;
  RevenueDebit?: Maybe<Scalars['String']>;
  ReverseDebit?: Maybe<Scalars['String']>;
  ExpenseCredit?: Maybe<Scalars['String']>;
  RevenueCredit?: Maybe<Scalars['String']>;
  ReverseCredit?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
};

export type GlRevenueMappingInput = {
  ExpenseDiv?: Maybe<Scalars['String']>;
  RevenueDiv?: Maybe<Scalars['String']>;
  ReverseDiv?: Maybe<Scalars['String']>;
  ExpenseDept?: Maybe<Scalars['String']>;
  RevenueDept?: Maybe<Scalars['String']>;
  ReverseDept?: Maybe<Scalars['String']>;
  ExpenseDebit?: Maybe<Scalars['String']>;
  RevenueDebit?: Maybe<Scalars['String']>;
  ReverseDebit?: Maybe<Scalars['String']>;
  ExpenseCredit?: Maybe<Scalars['String']>;
  RevenueCredit?: Maybe<Scalars['String']>;
  ReverseCredit?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
};

export type HuaweiStorageOutput = {
  __typename?: 'HuaweiStorageOutput';
  BucketFileName: Scalars['String'];
  FileName: Scalars['String'];
  Url: Scalars['String'];
  MediaType: Scalars['String'];
  IsPrivate?: Maybe<Scalars['Boolean']>;
  PrivateUrl?: Maybe<Scalars['String']>;
};

export type IfcaAccountOutput = {
  __typename?: 'IfcaAccountOutput';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ImportLeadDetails = {
  __typename?: 'ImportLeadDetails';
  contact_id?: Maybe<Scalars['String']>;
  full_name: Scalars['String'];
  phone_no: Scalars['String'];
  email: Scalars['String'];
  lead_source_id: Scalars['String'];
  event_id?: Maybe<Scalars['String']>;
  salutation_id?: Maybe<Scalars['String']>;
  nationality_id?: Maybe<Scalars['String']>;
  gender_id?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  race_id?: Maybe<Scalars['String']>;
  marital_id?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  prefer_location?: Maybe<Scalars['String']>;
  prefer_property?: Maybe<Scalars['String']>;
  annual_income?: Maybe<Scalars['String']>;
  isContactExisted: Scalars['Boolean'];
  utm_id?: Maybe<Scalars['String']>;
  utm_source?: Maybe<Scalars['String']>;
  utm_medium?: Maybe<Scalars['String']>;
  utm_campaign?: Maybe<Scalars['String']>;
  utm_term?: Maybe<Scalars['String']>;
  utm_content?: Maybe<Scalars['String']>;
};

export type ImportUnitOptionOutput = {
  __typename?: 'ImportUnitOptionOutput';
  displayImportMethods: Scalars['Boolean'];
  overwrite: Scalars['Boolean'];
  append: Scalars['Boolean'];
  integrated: Scalars['Boolean'];
};

export type IncludeInDetailInput = {
  paymentPlanDetailId?: Maybe<Scalars['String']>;
};

export type IncomeRangeInput = {
  range: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
};

export type IntegrationCalculatedDiscountOutput = {
  __typename?: 'IntegrationCalculatedDiscountOutput';
  DiscountName: Scalars['String'];
  DiscountFormula: Scalars['String'];
  DiscountAmt: Scalars['Float'];
  DiscountId?: Maybe<Scalars['Float']>;
};

export type IntegrationCalculatedRebateDiscountOutput = {
  __typename?: 'IntegrationCalculatedRebateDiscountOutput';
  discountAmt: Scalars['Float'];
  taxAmt: Scalars['Float'];
  enableInputTaxAndDiscount: Scalars['Boolean'];
};

export type IntegrationCompanyOutput = {
  __typename?: 'IntegrationCompanyOutput';
  id: Scalars['Float'];
  name: Scalars['String'];
};

export type IntegrationDiscountsInfoOutput = {
  __typename?: 'IntegrationDiscountsInfoOutput';
  DiscountID: Scalars['Float'];
  DiscountCode?: Maybe<Scalars['String']>;
  Description: Scalars['String'];
  ProjectID?: Maybe<Scalars['String']>;
  DiscountType?: Maybe<Scalars['String']>;
  DiscountAmt?: Maybe<Scalars['Float']>;
  SeqNo?: Maybe<Scalars['Float']>;
  EffectiveDate?: Maybe<Scalars['DateTime']>;
  ExpiryDate?: Maybe<Scalars['DateTime']>;
  AssignType?: Maybe<Scalars['String']>;
};

export type IntegrationForP365Input = {
  UnitNo: Scalars['String'];
  UnitType: Scalars['String'];
  UnitTypeDesc: Scalars['String'];
  Phase: Scalars['String'];
  Block: Scalars['String'];
  Floor: Scalars['String'];
  BuiltUp: Scalars['String'];
  Price: Scalars['Float'];
  BookingStatus: Scalars['String'];
  UnitID: Scalars['Float'];
  BlockID: Scalars['Float'];
  PhaseID: Scalars['Float'];
  ProjectID: Scalars['Float'];
  LandArea: Scalars['Float'];
  CompanyID: Scalars['Float'];
  ExtraLandArea: Scalars['Float'];
  FloorSeq: Scalars['Float'];
  UnitSeq: Scalars['Float'];
  FacingDirection?: Maybe<Scalars['String']>;
  FacingView?: Maybe<Scalars['String']>;
  HSDNo?: Maybe<Scalars['String']>;
  PTDNo?: Maybe<Scalars['String']>;
  IsBumi?: Maybe<Scalars['Boolean']>;
  CommercialPurpose: Scalars['String'];
  PropertyType: Scalars['String'];
  UpdateOnlyUnitStatus?: Maybe<Scalars['Boolean']>;
  UnitLayout?: Maybe<Scalars['String']>;
  CCCDate?: Maybe<Scalars['DateTime']>;
  IsCCCReady?: Maybe<Scalars['Boolean']>;
};

export type IntegrationPackagesInfoOutput = {
  __typename?: 'IntegrationPackagesInfoOutput';
  PackageID: Scalars['Float'];
  Description?: Maybe<Scalars['String']>;
  Price: Scalars['Float'];
  ProjectID?: Maybe<Scalars['Float']>;
  AssignType?: Maybe<Scalars['String']>;
  CostPrice?: Maybe<Scalars['Float']>;
};

export type IntegrationParamOutput = {
  __typename?: 'IntegrationParamOutput';
  baseUrl: Scalars['String'];
  projectIntegrationId?: Maybe<Scalars['String']>;
  ifcaCompanyId?: Maybe<Scalars['Float']>;
  ifcaProjectId?: Maybe<Scalars['Float']>;
  ifcaPhaseId?: Maybe<Scalars['Float']>;
};

export type IntegrationPaymentPlanInfoOutput = {
  __typename?: 'IntegrationPaymentPlanInfoOutput';
  PaymentPlanID: Scalars['Float'];
  PaymentPlanCode: Scalars['String'];
  Description?: Maybe<Scalars['String']>;
  NoOfInstall: Scalars['Float'];
  InterestRate: Scalars['Float'];
};

export type IntegrationProjectDetailsForP365Output = {
  __typename?: 'IntegrationProjectDetailsForP365Output';
  UnitNo: Scalars['String'];
  UnitType: Scalars['String'];
  UnitTypeDesc: Scalars['String'];
  Phase: Scalars['String'];
  Block: Scalars['String'];
  Floor: Scalars['String'];
  BuiltUp: Scalars['String'];
  Price: Scalars['Float'];
  BookingStatus: Scalars['String'];
  UnitID: Scalars['Float'];
  BlockID: Scalars['Float'];
  PhaseID: Scalars['Float'];
  ProjectID: Scalars['Float'];
  LandArea: Scalars['Float'];
  CompanyID: Scalars['Float'];
  ExtraLandArea: Scalars['Float'];
  FloorSeq: Scalars['Float'];
  UnitSeq: Scalars['Float'];
  FacingDirection?: Maybe<Scalars['String']>;
  FacingView?: Maybe<Scalars['String']>;
  HSDNo?: Maybe<Scalars['String']>;
  PTDNo?: Maybe<Scalars['String']>;
  IsBumi?: Maybe<Scalars['Boolean']>;
  CommercialPurpose: Scalars['String'];
  PropertyType: Scalars['String'];
  UpdateOnlyUnitStatus?: Maybe<Scalars['Boolean']>;
  UnitLayout?: Maybe<Scalars['String']>;
  CCCDate?: Maybe<Scalars['DateTime']>;
  IsCCCReady?: Maybe<Scalars['Boolean']>;
};

export type IntegrationProjectDetailsOutput = {
  __typename?: 'IntegrationProjectDetailsOutput';
  ProjectNo: Scalars['String'];
  ProjectName: Scalars['String'];
  ProjectDesc: Scalars['String'];
  rowID: Scalars['String'];
};

export type IntegrationSolicitorInfoOutput = {
  __typename?: 'IntegrationSolicitorInfoOutput';
  SolicitorID: Scalars['Float'];
  SolicitorName: Scalars['String'];
  SolicitorCode: Scalars['String'];
  Fax?: Maybe<Scalars['String']>;
  Phone?: Maybe<Scalars['String']>;
  Email?: Maybe<Scalars['String']>;
  Address?: Maybe<Scalars['String']>;
  StateName?: Maybe<Scalars['String']>;
  CityName?: Maybe<Scalars['String']>;
  CountryName?: Maybe<Scalars['String']>;
  PostCode?: Maybe<Scalars['String']>;
};

export type IntegrationTypeGetFormOutput = {
  __typename?: 'IntegrationTypeGetFormOutput';
  projectDetails: Array<ProjectDetailsOutput>;
  integrationType: Scalars['JSONObject'];
};

export type IntegrationUnitOutput = {
  __typename?: 'IntegrationUnitOutput';
  ifcaUnitId: Scalars['Float'];
  unitNo: Scalars['String'];
  block: Scalars['String'];
  floor: Scalars['Float'];
  floorLabel: Scalars['String'];
  cell: Scalars['Float'];
};

export type IntegrationUnitStatusOutput = {
  __typename?: 'IntegrationUnitStatusOutput';
  crmStatus?: Maybe<Scalars['String']>;
  dotnetPplusStatus: Scalars['String'];
};

export enum InterestBasicRate {
  Daily = 'DAILY',
  Yearly = 'YEARLY',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export type Ipay88PaymentOutput = {
  __typename?: 'Ipay88PaymentOutput';
  refNo: Scalars['String'];
  amount: Scalars['String'];
  currency: Scalars['String'];
  prodDesc: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  contactNo: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  lang: Scalars['String'];
  method: Scalars['String'];
  paymentId: Scalars['String'];
  signature: Scalars['String'];
  signatureType: Scalars['String'];
  paymentUrl: Scalars['String'];
  merchantCode: Scalars['String'];
  redirectUrl: Scalars['String'];
  notifyUrl: Scalars['String'];
};


export type JobPositionListWithRecentModTs = {
  __typename?: 'JobPositionListWithRecentModTs';
  jobPositions: Array<JobPositionEntity>;
  recentModTs?: Maybe<Scalars['DateTime']>;
};

export type JointBuyerInfoForBookingListing = {
  __typename?: 'JointBuyerInfoForBookingListing';
  saleId?: Maybe<Scalars['String']>;
  totalJointBuyer?: Maybe<Scalars['Float']>;
  isJointBuyerInfoRequired?: Maybe<Scalars['Boolean']>;
};

export type JointBuyerParamaterValueOutput = {
  __typename?: 'JointBuyerParamaterValueOutput';
  contact: Scalars['String'];
  nationality: Scalars['String'];
  salutation: Scalars['String'];
  race: Scalars['String'];
  incomeRange: Scalars['String'];
};

export type LanguageNamesOutput = {
  __typename?: 'LanguageNamesOutput';
  langCode?: Maybe<Scalars['String']>;
  langName?: Maybe<Scalars['String']>;
};

export type LanguageOutput = {
  __typename?: 'LanguageOutput';
  obj?: Maybe<Scalars['String']>;
  fileNames?: Maybe<Array<Scalars['String']>>;
};

export type LastEmailSendInput = {
  SendBy: Scalars['String'];
  SendDate: Scalars['DateTime'];
};

export type LastEmailSendOutput = {
  __typename?: 'LastEmailSendOutput';
  SendBy: Scalars['String'];
  SendDate: Scalars['DateTime'];
};

export type LeadActivityDetails = {
  __typename?: 'LeadActivityDetails';
  actiontakenname?: Maybe<Scalars['String']>;
  agencyname?: Maybe<Scalars['String']>;
  lead_id?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  activitytype?: Maybe<Scalars['String']>;
  activitydesc?: Maybe<Scalars['String']>;
  leadStatus: Scalars['String'];
  activitydate: Scalars['DateTime'];
  followupdate?: Maybe<Scalars['DateTime']>;
  followupremark?: Maybe<Scalars['String']>;
  activityAudio?: Maybe<Scalars['String']>;
};

export type LeadBatchContactOutput = {
  __typename?: 'LeadBatchContactOutput';
  contactId: Scalars['String'];
  fullName: Scalars['String'];
  email: Scalars['String'];
  phoneNo: Scalars['String'];
};

export type LeadBatchCountLeadSourceOutput = {
  __typename?: 'LeadBatchCountLeadSourceOutput';
  id: Scalars['String'];
  top1: Array<LeadBatchCountLeadSourceValuesOutput>;
  top2: Array<LeadBatchCountLeadSourceValuesOutput>;
  top3: Array<LeadBatchCountLeadSourceValuesOutput>;
  others: Array<LeadBatchCountLeadSourceValuesOutput>;
};

export type LeadBatchCountLeadSourceValuesOutput = {
  __typename?: 'LeadBatchCountLeadSourceValuesOutput';
  name: Scalars['String'];
  count: Scalars['Float'];
};

export type LeadBatchSummaryPageOutput = {
  __typename?: 'LeadBatchSummaryPageOutput';
  eLaunchId: Scalars['String'];
  eLaunchName: Scalars['String'];
  totalImportedLead?: Maybe<Scalars['Float']>;
  totalRegisteredLead?: Maybe<Scalars['Float']>;
  leadBatchs?: Maybe<Array<Scalars['JSONObject']>>;
  endDate?: Maybe<Scalars['DateTime']>;
};

export type LeadByBatch = {
  __typename?: 'LeadByBatch';
  id?: Maybe<Scalars['String']>;
  lead_id: Scalars['String'];
  contact_id: Scalars['String'];
  project_id?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  full_name: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  lead_source?: Maybe<Scalars['String']>;
  phone_no: Scalars['String'];
  isRegistered?: Maybe<Scalars['Boolean']>;
  project_count: Scalars['Float'];
};

export type LeadByBatchIds = {
  __typename?: 'LeadByBatchIds';
  id?: Maybe<Scalars['String']>;
  batchTitle?: Maybe<Scalars['String']>;
  createdTs?: Maybe<Scalars['DateTime']>;
  recordCount?: Maybe<Scalars['Float']>;
  isRoundRobinUser?: Maybe<Scalars['Boolean']>;
  leadData?: Maybe<Array<LeadDataOutput>>;
  assignedProjectDetails?: Maybe<Array<AssignedProjectDetails>>;
  total?: Maybe<Scalars['Float']>;
  openTotal?: Maybe<Scalars['Float']>;
  hotTotal?: Maybe<Scalars['Float']>;
  coldTotal?: Maybe<Scalars['Float']>;
  dropTotal?: Maybe<Scalars['Float']>;
  warmTotal?: Maybe<Scalars['Float']>;
  isExpired?: Maybe<Scalars['Boolean']>;
};

export type LeadData = {
  __typename?: 'LeadData';
  id?: Maybe<Scalars['String']>;
  contact_id: Scalars['String'];
  project_id?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  full_name: Scalars['String'];
  gender?: Maybe<Scalars['String']>;
  lead_source?: Maybe<Scalars['String']>;
  phone_no: Scalars['String'];
};

export type LeadDataByBatch = {
  __typename?: 'LeadDataByBatch';
  totalCount?: Maybe<Scalars['Float']>;
  leadData?: Maybe<Array<LeadData>>;
};

export type LeadDataOutput = {
  __typename?: 'LeadDataOutput';
  id?: Maybe<Scalars['String']>;
  lead_status: Scalars['String'];
  lead_source: Scalars['String'];
  event_name?: Maybe<Scalars['String']>;
  sales_person_id?: Maybe<Scalars['String']>;
  sales_person_name?: Maybe<Scalars['String']>;
  existing_purchaser: Scalars['Boolean'];
  activity_date?: Maybe<Scalars['DateTime']>;
  activity_desc?: Maybe<Scalars['String']>;
  follow_up_remark?: Maybe<Scalars['String']>;
  follow_up_date?: Maybe<Scalars['DateTime']>;
  contact_id: Scalars['String'];
  full_name: Scalars['String'];
  lead_id: Scalars['String'];
  email: Scalars['String'];
  phone_no: Scalars['String'];
  isRegistered?: Maybe<Scalars['Boolean']>;
  project_count: Scalars['Float'];
  converted_to_booking: Scalars['Boolean'];
  gender?: Maybe<Scalars['String']>;
  createdTs?: Maybe<Scalars['DateTime']>;
};

export type LeadHandleByWhichUserOutput = {
  __typename?: 'LeadHandleByWhichUserOutput';
  id: Scalars['String'];
  salesPersonId?: Maybe<Scalars['String']>;
  assignStatus: Scalars['String'];
  eLaunchId?: Maybe<Scalars['String']>;
};

export type LeadIntegrationInput = {
  leadIntegrationId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  integrationType: LeadIntegrationType;
  key: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  integrationUrl?: Maybe<Scalars['String']>;
};

export enum LeadIntegrationType {
  Facebook = 'FACEBOOK',
  Iproperty = 'IPROPERTY',
  Propertyguru = 'PROPERTYGURU',
  Avanser = 'AVANSER',
  IppPg = 'IPP_PG',
  Microsite = 'MICROSITE',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export type LeadSourceInput = {
  name: Scalars['String'];
};

export type LeadStatusCountOutput = {
  __typename?: 'LeadStatusCountOutput';
  projectId?: Maybe<Scalars['String']>;
  waitingCount?: Maybe<Scalars['Float']>;
  openCount?: Maybe<Scalars['Float']>;
  hotCount?: Maybe<Scalars['Float']>;
  coldCount?: Maybe<Scalars['Float']>;
  warmCount?: Maybe<Scalars['Float']>;
  dropCount?: Maybe<Scalars['Float']>;
  bookedCount?: Maybe<Scalars['Float']>;
  reservationCount?: Maybe<Scalars['Float']>;
  signedCount?: Maybe<Scalars['Float']>;
  totalCount?: Maybe<Scalars['Float']>;
  totalConvertedAmount?: Maybe<Scalars['Float']>;
};

export type LeadTemplateReturnOutput = {
  __typename?: 'LeadTemplateReturnOutput';
  message?: Maybe<Scalars['String']>;
  file_name?: Maybe<Scalars['String']>;
  leadIds?: Maybe<Array<Scalars['String']>>;
  file?: Maybe<Scalars['String']>;
};

export type LetterParameter = {
  __typename?: 'LetterParameter';
  displayName?: Maybe<Scalars['String']>;
  columnName?: Maybe<Scalars['String']>;
};

export type LetterTemplate = {
  __typename?: 'LetterTemplate';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LetterTemplateByProject = {
  __typename?: 'LetterTemplateByProject';
  id: Scalars['String'];
  name: Scalars['String'];
  letterTemplateId: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  lastUpdated?: Maybe<Scalars['DateTime']>;
};

export type LetterTemplateInput = {
  standardLetterId: Scalars['String'];
  name: Scalars['String'];
  text: Scalars['String'];
  jointBuyerSign?: Maybe<Scalars['Boolean']>;
};

export type LetterTemplateListing = {
  __typename?: 'LetterTemplateListing';
  letterTypeDesc: Scalars['String'];
  letterTemplates: Array<LetterTemplateEntity>;
};

export type ListOfSalesStaffByTeam = {
  __typename?: 'ListOfSalesStaffByTeam';
  teamId: Scalars['String'];
  teamName: Scalars['String'];
  userId: Scalars['String'];
  userName: Scalars['String'];
};

export type ListOfSalesStaffByUserPermission = {
  __typename?: 'ListOfSalesStaffByUserPermission';
  staffId: Scalars['String'];
  staffName: Scalars['String'];
};

export type LoanAlertAgingInput = {
  isActive: Scalars['Boolean'];
  maxMinorLoanAlertAging: Scalars['Float'];
  maxMajorLoanAlertAging: Scalars['Float'];
};

export type LoanAlertAgingOutput = {
  __typename?: 'LoanAlertAgingOutput';
  isActive: Scalars['Boolean'];
  maxMinorLoanAlertAging: Scalars['Float'];
  maxMajorLoanAlertAging: Scalars['Float'];
};

export type LoanAssignedCountOutput = {
  __typename?: 'LoanAssignedCountOutput';
  total_count: Scalars['Float'];
  active_count: Scalars['Float'];
  withdrawn_count: Scalars['Float'];
};

export type LoanLeadNotificationInput = {
  leadAssignment?: Maybe<Scalars['Boolean']>;
};

export type LoanLeadNotificationOutput = {
  __typename?: 'LoanLeadNotificationOutput';
  leadAssignment?: Maybe<Scalars['Boolean']>;
};

export type LoanProjectCountOutput = {
  __typename?: 'LoanProjectCountOutput';
  project_id: Scalars['String'];
  project_name: Scalars['String'];
  total_count: Scalars['Float'];
  active_count: Scalars['Float'];
  withdrawn_count: Scalars['Float'];
};

export type LoanScreenAccountSpecOutput = {
  __typename?: 'LoanScreenAccountSpecOutput';
  loanPlusProjectId?: Maybe<Scalars['Float']>;
  modifiedDate: Scalars['DateTime'];
};

export type LoanScreenReportOutput = {
  __typename?: 'LoanScreenReportOutput';
  refType: Scalars['String'];
  mediaType: Scalars['String'];
  resourceUrl: Scalars['String'];
  fileName: Scalars['String'];
};

export type LoanScreenStatusOutput = {
  __typename?: 'LoanScreenStatusOutput';
  caseCode: Scalars['String'];
  status: Scalars['String'];
  CCRIS?: Maybe<Scalars['String']>;
  CTOS?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  modifiedDate: Scalars['DateTime'];
};

export type LoanStatusOutput = {
  __typename?: 'LoanStatusOutput';
  count: Scalars['Float'];
  approvedCount: Scalars['Float'];
  acceptedCount: Scalars['Float'];
  rejectedCount: Scalars['Float'];
  withdrawnCount: Scalars['Float'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  accessToken: Scalars['String'];
  user: UserResponse;
};

export type MaritalStatusInput = {
  name: Scalars['String'];
};

export type MasterDataOutput = {
  __typename?: 'MasterDataOutput';
  Genders: Scalars['JSONObject'];
  LandType: Scalars['JSONObject'];
  UOM: Scalars['JSONObject'];
  ReasonCode: Array<ReasonCodeEntity>;
  Region: Array<RegionEntity>;
  Races: Array<RaceEntity>;
  Salutations: Array<SalutationEntity>;
  CurrencyCode: Array<Array<Scalars['String']>>;
  Nationalities: Array<SNationalityEntity>;
  AddressType: Scalars['JSONObject'];
  Countries: Array<CountryMasterDataOutput>;
  City: Array<SCityEntity>;
  MaritalStatus: Array<MaritalStatusEntity>;
  IncomeRanges: Array<IncomeRangeEntity>;
  PaymentMethods: Scalars['JSONObject'];
  PaymentStatus: Scalars['JSONObject'];
  DiscountType: Array<DiscountTypeEntity>;
  DiscountPrefix: Scalars['JSONObject'];
  Language: Scalars['JSONObject'];
  CommercialPurposes: Scalars['JSONObject'];
  PayMethod: Scalars['JSONObject'];
  Tenures: Scalars['JSONObject'];
  IntegrationTypes: Scalars['JSONObject'];
  ProjectTypes: Array<ProjectTypeEntity>;
  PropertyTypes: Array<PropertyTypeEntity>;
  UnitTypes: Array<UnitTypeEntity>;
  UnitLayoutbyProject: Array<UnitLayoutEntity>;
  LeadSources: Array<LeadSourceEntity>;
  UserPermission: Array<Scalars['Float']>;
  Events: Array<EventsEntity>;
  LoanType: Scalars['JSONObject'];
  PurchaserAppSetting: Scalars['JSONObject'];
  ELettering: Scalars['JSONObject'];
  bookingCancellationCount?: Maybe<Scalars['Float']>;
  getRaceCount?: Maybe<Scalars['Float']>;
  SoftwareCode: Scalars['JSONObject'];
  getMaritalCount?: Maybe<Scalars['Float']>;
  getSalutationCount?: Maybe<Scalars['Float']>;
  getLeadSourceCount?: Maybe<Scalars['Float']>;
  getPropertyTypeCount?: Maybe<Scalars['Float']>;
  getProjectTypeCount?: Maybe<Scalars['Float']>;
  getDirectionCount?: Maybe<Scalars['Float']>;
  getUnitCount?: Maybe<Scalars['Float']>;
  getIncomeRangeCount?: Maybe<Scalars['Float']>;
  getLatestUpdatePurchaserProfile?: Maybe<Scalars['DateTime']>;
  getLatestUpdateLeadInfo?: Maybe<Scalars['DateTime']>;
  getLatestUpdatePropertyInfo?: Maybe<Scalars['DateTime']>;
  getLatestUpdateUnitInfo?: Maybe<Scalars['DateTime']>;
  getLatestUpdateELetter?: Maybe<Scalars['DateTime']>;
  getLatestUpdateRegion?: Maybe<Scalars['DateTime']>;
  getLatestUpdateAppointmentType?: Maybe<Scalars['DateTime']>;
  getLatestUpdateReason?: Maybe<Scalars['DateTime']>;
  getLatestUpdateRoundRobin?: Maybe<Scalars['DateTime']>;
  getLatestUpdateEmailTemplateSetup?: Maybe<Scalars['DateTime']>;
};


export type MasterDataOutputPaymentMethodsArgs = {
  saleId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
};


export type MasterDataOutputPaymentStatusArgs = {
  saleId?: Maybe<Scalars['String']>;
  projectId?: Maybe<Scalars['String']>;
};


export type MasterDataOutputUnitLayoutbyProjectArgs = {
  project_id: Scalars['String'];
};


export type MasterDataOutputUserPermissionArgs = {
  projectId: Scalars['String'];
};

export type MediaSource = {
  __typename?: 'MediaSource';
  url: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  videoType?: Maybe<Scalars['String']>;
};

export type MediaSourceInput = {
  url: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  videoType?: Maybe<Scalars['String']>;
};

export type MicrositeNewLeadOutput = {
  __typename?: 'MicrositeNewLeadOutput';
  projectId?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  salesPersonId?: Maybe<Scalars['String']>;
  teamId?: Maybe<Scalars['String']>;
  leadSourceId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  fullName: Scalars['String'];
  email: Scalars['String'];
  phoneNo: Scalars['String'];
  dob?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  passportNo?: Maybe<Scalars['String']>;
  militaryIc?: Maybe<Scalars['String']>;
  homeTel?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  race?: Maybe<Scalars['String']>;
  salutation?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  nationality?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  preferLocation?: Maybe<Scalars['String']>;
  incomeRange?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  utmId?: Maybe<Scalars['String']>;
  utmSource?: Maybe<Scalars['String']>;
  utmMedium?: Maybe<Scalars['String']>;
  utmCampaign?: Maybe<Scalars['String']>;
  utmTerm?: Maybe<Scalars['String']>;
  utmContent?: Maybe<Scalars['String']>;
};

export type MostFavouriteOutput = {
  __typename?: 'MostFavouriteOutput';
  totalFavourite: Scalars['Float'];
  favouriteUnitType: Array<FavouriteUnitType>;
  favouriteUnit: Array<FavouriteUnit>;
};

export type MultipleEsignProjectLetterListingOutput = {
  __typename?: 'MultipleEsignProjectLetterListingOutput';
  letterTypeName?: Maybe<Scalars['String']>;
  letter?: Maybe<Array<ESignProjectLetterListingOutput>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addUser: Scalars['Boolean'];
  editUser: Scalars['Boolean'];
  suspendUser: Scalars['Boolean'];
  unSuspendUser: Scalars['Boolean'];
  resendInvitation: Scalars['Boolean'];
  unBlockUser: Scalars['Boolean'];
  newRole: Scalars['Boolean'];
  editRole: Scalars['Boolean'];
  deleteRole: Scalars['Boolean'];
  roleAssignment: Scalars['Boolean'];
  unblockUser: Scalars['Boolean'];
  addAppointmentType: Scalars['Boolean'];
  editAppointmentType: Scalars['Boolean'];
  setDefaultAppointmentType: Scalars['Boolean'];
  deleteAppointmentType: Scalars['Boolean'];
  deactivateAppointmentType: Scalars['Boolean'];
  removeDefaultAppointmentType: Scalars['Boolean'];
  organizeAppointmentType: Scalars['Boolean'];
  UploadAttachmentProduct: CloudStorageOutput;
  UploadResourceProduct: CloudStorageOutput;
  addCampaign: Scalars['Boolean'];
  editCampaign: Scalars['Boolean'];
  editEvents: Scalars['Boolean'];
  addEvents: Scalars['Boolean'];
  deleteCampaignById: Scalars['Boolean'];
  deleteEventsById: Scalars['Boolean'];
  AddCompany: Scalars['Boolean'];
  EditCompany: Scalars['Boolean'];
  DeleteCompany: Scalars['Boolean'];
  downloadAttachment: AttachmentOutput;
  alterInvitationTemplate: Scalars['Boolean'];
  sendEmailInvitation: Scalars['Boolean'];
  importExistingLeads: Scalars['Boolean'];
  ImportLeads: LeadTemplateReturnOutput;
  sendDocEmailToELaunchLead: Scalars['Boolean'];
  addELaunch: Scalars['Boolean'];
  editELaunch: Scalars['Boolean'];
  deleteELaunch: Scalars['Boolean'];
  updateELaunchAllocation: Scalars['Boolean'];
  createFinancier: Scalars['Boolean'];
  addFinancierContact: Scalars['Boolean'];
  editFinancier: Scalars['Boolean'];
  deleteFinancier: Scalars['Boolean'];
  setDefaultFinancierContact: Scalars['Boolean'];
  assignPanel: Scalars['Boolean'];
  unassignPanel: Scalars['Boolean'];
  removeInvitationContact: Scalars['Boolean'];
  sendProjectInvitation: Scalars['Boolean'];
  editFinancialLimit: Scalars['Boolean'];
  suspendEndFinancier: Scalars['Boolean'];
  autoCapitalization: Scalars['Boolean'];
  newLeadIntegration: Scalars['Boolean'];
  editLeadIntegration: Scalars['Boolean'];
  alterLeadIntegrationCommonStatus: Scalars['Boolean'];
  syncMissMatchSales: Scalars['Boolean'];
  addLetterTemplate: Scalars['Boolean'];
  editLetterTemplate: Scalars['Boolean'];
  deleteLetterTemplate: Scalars['Boolean'];
  assignProjectLetterTemplate: Scalars['Boolean'];
  setDefaultProjectLetterTemplate: Scalars['Boolean'];
  removeDefaultProjectLetterTemplate: Scalars['Boolean'];
  unassignProjectLetter: Scalars['Boolean'];
  updateAccountSpec: Scalars['Boolean'];
  addDirection: Scalars['Boolean'];
  editDirection: Scalars['Boolean'];
  deleteDirectionById: Scalars['Boolean'];
  setDefaultDirection: Scalars['Boolean'];
  removeDefaultDirection: Scalars['Boolean'];
  organizeDirection: Scalars['Boolean'];
  addDiscount: Scalars['Boolean'];
  editDiscount: Scalars['Boolean'];
  activeDiscount: Scalars['Boolean'];
  deactiveDiscount: Scalars['Boolean'];
  deleteDiscount: Scalars['Boolean'];
  assignDiscount: Scalars['Boolean'];
  editAssignDiscount: Scalars['Boolean'];
  unassignDiscount: Scalars['Boolean'];
  setDefaultDiscountForProject: Scalars['Boolean'];
  unmarkDefaultDiscountForProject: Scalars['Boolean'];
  syncIntegrateDiscount: Scalars['Boolean'];
  addIncomeRange: Scalars['Boolean'];
  editIncomeRange: Scalars['Boolean'];
  deleteIncomeRangeById: Scalars['Boolean'];
  organizeIncomeRange: Scalars['Boolean'];
  setDefaultIncomeRange: Scalars['Boolean'];
  removeDefaultIncomeRange: Scalars['Boolean'];
  addLeadSource: Scalars['Boolean'];
  editLeadSource: Scalars['Boolean'];
  deleteLeadSourceById: Scalars['Boolean'];
  changeLeadStatus: Scalars['Boolean'];
  setDefaultLeadSource: Scalars['Boolean'];
  removeDefaultLeadSource: Scalars['Boolean'];
  organizeLeadSource: Scalars['Boolean'];
  addMaritalStatus: Scalars['Boolean'];
  editMaritalStatus: Scalars['Boolean'];
  deleteMaritalStatusById: Scalars['Boolean'];
  setDefaultMaritalStatus: Scalars['Boolean'];
  removeDefaultMaritalStatus: Scalars['Boolean'];
  organizeMaritalStatus: Scalars['Boolean'];
  addNupType: Scalars['Boolean'];
  deleteNupType: Scalars['Boolean'];
  editNupType: Scalars['Boolean'];
  addNupReason: Scalars['Boolean'];
  deleteNupReason: Scalars['Boolean'];
  editNupReason: Scalars['Boolean'];
  addPackage: Scalars['Boolean'];
  editPackage: Scalars['Boolean'];
  deletePackageById: Scalars['Boolean'];
  syncIntegratePackage: Scalars['Boolean'];
  addProjectType: Scalars['Boolean'];
  editProjectType: Scalars['Boolean'];
  deleteProjectTypeById: Scalars['Boolean'];
  setDefaultProjectType: Scalars['Boolean'];
  removeDefaultProjectType: Scalars['Boolean'];
  organizeProjectType: Scalars['Boolean'];
  addPropertyType: Scalars['Boolean'];
  editPropertyType: Scalars['Boolean'];
  deletePropertyTypeById: Scalars['Boolean'];
  setDefaultPropertyType: Scalars['Boolean'];
  removeDefaultPropertyType: Scalars['Boolean'];
  organizePropertyType: Scalars['Boolean'];
  addRace: Scalars['Boolean'];
  editRace: Scalars['Boolean'];
  deleteRaceById: Scalars['Boolean'];
  setDefaultRace: Scalars['Boolean'];
  removeDefaultRace: Scalars['Boolean'];
  organizeRace: Scalars['Boolean'];
  addRegion: Scalars['Boolean'];
  editRegion: Scalars['Boolean'];
  deleteRegionById: Scalars['Boolean'];
  alterRegionCommonStatus: Scalars['Boolean'];
  setDefaultRegion: Scalars['Boolean'];
  removeDefaultRegion: Scalars['Boolean'];
  organizeRegion: Scalars['Boolean'];
  editSalesPackage: Scalars['Boolean'];
  addSalesPackage: Scalars['Boolean'];
  deleteSalesPackage: Scalars['Boolean'];
  addSalutation: Scalars['Boolean'];
  editSalutation: Scalars['Boolean'];
  deleteSalutationById: Scalars['Boolean'];
  organizeSalutation: Scalars['Boolean'];
  setDefaultSalutation: Scalars['Boolean'];
  removeDefaultSalutation: Scalars['Boolean'];
  addUnitType: Scalars['Boolean'];
  editUnitType: Scalars['Boolean'];
  deleteUnitTypeById: Scalars['Boolean'];
  setDefaultUnitType: Scalars['Boolean'];
  removeDefaultUnitType: Scalars['Boolean'];
  organizeUnitType: Scalars['Boolean'];
  addNewsAnnouncement: Scalars['Boolean'];
  editNewsAnnouncement: Scalars['Boolean'];
  publishNewsAnnouncement: Scalars['Boolean'];
  deleteNewsAnnouncement: Scalars['Boolean'];
  saveNotificationPermission: Scalars['Boolean'];
  markAsRead: Scalars['Boolean'];
  editLeadAssignment: Scalars['Boolean'];
  newLeadAssignment: Scalars['Boolean'];
  deleteLeadAssignment: Scalars['Boolean'];
  organizeLeadAssignmentSeq: Scalars['Boolean'];
  updateLeadAssignmentNotificationStatus: Scalars['Boolean'];
  updateStatusToInProgress: Scalars['Boolean'];
  addPaymentGateWay: Scalars['Boolean'];
  editPaymentGateWay: Scalars['Boolean'];
  deletePaymentGateway: Scalars['Boolean'];
  suspendPlatformUser: Scalars['Boolean'];
  unsuspendPlatformUser: Scalars['Boolean'];
  changePlatformUserPassword: Scalars['Boolean'];
  editPlatformUser: Scalars['Boolean'];
  addNewPlatformUser: Scalars['Boolean'];
  assignPlatformUserAccount: Scalars['Boolean'];
  unassignPlatformUserAccount: Scalars['Boolean'];
  assignPlatformUserAccounts: Scalars['Boolean'];
  unassignPlatformUserAccounts: Scalars['Boolean'];
  changePlatformUserPasswordInProfile: Scalars['Boolean'];
  updatePlatformUserProfile: Scalars['Boolean'];
  resendPlatformUserInvitation: Scalars['Boolean'];
  updateAppointmentSchedule: Scalars['Boolean'];
  addSalesGalleryCloseDate: Scalars['Boolean'];
  editSalesGalleryCloseDate: Scalars['Boolean'];
  deleteSalesGalleryCloseDate: Scalars['Boolean'];
  addProject: Scalars['Boolean'];
  editProject: Scalars['Boolean'];
  updateUserLatestEntity: Scalars['Boolean'];
  EditGalleryVideo: Scalars['Boolean'];
  EditGalleryTour: Scalars['Boolean'];
  EditProjectGallery: Scalars['Boolean'];
  DeleteProjectGallery: Scalars['Boolean'];
  EditBlockGallery: Scalars['Boolean'];
  DeleteBlockGallery: Scalars['Boolean'];
  EditGallery: Scalars['Boolean'];
  EditFloorGallery: Scalars['Boolean'];
  DeleteFloorGallery: Scalars['Boolean'];
  DeleteUnitGallery: Scalars['Boolean'];
  EditUnitGallery: Scalars['Boolean'];
  EditProjectSpec: Scalars['Boolean'];
  addReasonCode: Scalars['Boolean'];
  deleteReasonCodeById: Scalars['Boolean'];
  editReasonCode: Scalars['Boolean'];
  setDefaultReasonCode: Scalars['Boolean'];
  removeDefaultReasonCode: Scalars['Boolean'];
  organizeReasonCode: Scalars['Boolean'];
  uploadSalesDoc: Scalars['Boolean'];
  deleteSalesDoc: Scalars['Boolean'];
  updateSalesDoc: Scalars['Boolean'];
  editGatewayUpdates: Scalars['Boolean'];
  addGatewayUpdates: Scalars['Boolean'];
  deleteGatewayUpdatesById: Scalars['Boolean'];
  addSiteProgess: Scalars['Boolean'];
  editSiteProgress: Scalars['Boolean'];
  deleteSiteProgress: Scalars['Boolean'];
  addSolicitor: Scalars['Boolean'];
  editSolicitor: Scalars['Boolean'];
  suspendSolicitor: Scalars['Boolean'];
  syncIntegrateSolicitor: Scalars['Boolean'];
  assignSolicitorToProject: Scalars['Boolean'];
  resendSolicitorAppointedInvitation: Scalars['Boolean'];
  unassignSolicitorFromProject: Scalars['Boolean'];
  markAsDefault: Scalars['Boolean'];
  addSalesTeams: Scalars['Boolean'];
  editSalesTeams: Scalars['Boolean'];
  deleteSalesTeamById: Scalars['Boolean'];
  assignTeamMember: Scalars['Boolean'];
  unassignTeamMember: Scalars['Boolean'];
  alterTeamAllocationPermission: Scalars['Boolean'];
  allocateUnitsForTeam: Scalars['Boolean'];
  integrateUnitFromDotNetPplus: Scalars['Boolean'];
  repullIntegrateUnits: Scalars['Boolean'];
  removeAllUnits: Scalars['Boolean'];
  UpdateUnitStatus: Scalars['Boolean'];
  ImportUnit: UnitExcelReturnOutput;
  resetSalesChartByBlock: Scalars['Boolean'];
  generateUnit: Scalars['Boolean'];
  AssignCarParkToUnit: Scalars['Boolean'];
  AlterUnitTour: Scalars['Boolean'];
  DeleteUnitTourLink: Scalars['Boolean'];
};


export type MutationAddUserArgs = {
  input: NewUserInput;
};


export type MutationEditUserArgs = {
  input: EditUserInput;
};


export type MutationSuspendUserArgs = {
  userId: Scalars['String'];
};


export type MutationUnSuspendUserArgs = {
  userId: Scalars['String'];
};


export type MutationResendInvitationArgs = {
  userId: Scalars['String'];
};


export type MutationUnBlockUserArgs = {
  newPassword: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationNewRoleArgs = {
  permissionList: Array<Scalars['String']>;
  roleName: Scalars['String'];
};


export type MutationEditRoleArgs = {
  permissionList: Array<PermissionInput>;
  roleName: Scalars['String'];
  roleId: Scalars['String'];
};


export type MutationDeleteRoleArgs = {
  roleId: Scalars['String'];
};


export type MutationRoleAssignmentArgs = {
  input: ProjectUserRoleAssignmentInput;
};


export type MutationUnblockUserArgs = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationAddAppointmentTypeArgs = {
  appointmentName: Scalars['String'];
};


export type MutationEditAppointmentTypeArgs = {
  appointmentName: Scalars['String'];
  appointmentId: Scalars['String'];
};


export type MutationSetDefaultAppointmentTypeArgs = {
  appointmentId: Scalars['String'];
};


export type MutationDeleteAppointmentTypeArgs = {
  appointmentId: Scalars['String'];
};


export type MutationDeactivateAppointmentTypeArgs = {
  appointmentId: Scalars['String'];
};


export type MutationRemoveDefaultAppointmentTypeArgs = {
  appointmentId: Scalars['String'];
};


export type MutationOrganizeAppointmentTypeArgs = {
  appointmentId: Array<Scalars['String']>;
};


export type MutationUploadAttachmentProductArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
};


export type MutationUploadResourceProductArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
};


export type MutationAddCampaignArgs = {
  input: AdminCampaignInput;
};


export type MutationEditCampaignArgs = {
  input: AdminCampaignInput;
};


export type MutationEditEventsArgs = {
  input: AdminEventsInput;
};


export type MutationAddEventsArgs = {
  input: AdminEventsInput;
};


export type MutationDeleteCampaignByIdArgs = {
  campaignId: Scalars['String'];
};


export type MutationDeleteEventsByIdArgs = {
  eventsId: Scalars['String'];
};


export type MutationAddCompanyArgs = {
  input: AdminCompanyInput;
};


export type MutationEditCompanyArgs = {
  input: AdminCompanyInput;
};


export type MutationDeleteCompanyArgs = {
  id: Scalars['String'];
};


export type MutationDownloadAttachmentArgs = {
  input: SalesDownloadAttachmentInput;
};


export type MutationAlterInvitationTemplateArgs = {
  salesDocIds: Array<Scalars['String']>;
  invitationTemplateId?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  bodyContent?: Maybe<Scalars['String']>;
  eLaunchId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationSendEmailInvitationArgs = {
  eLaunchLeadBatchId: Scalars['String'];
  eLaunchId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationImportExistingLeadsArgs = {
  contactIds: Array<Scalars['String']>;
  projectId: Scalars['String'];
  batchTitle: Scalars['String'];
  eLaunchId: Scalars['String'];
};


export type MutationImportLeadsArgs = {
  file: Scalars['Upload'];
  eLaunchId: Scalars['String'];
  projectId: Scalars['String'];
  batchTitle: Scalars['String'];
};


export type MutationSendDocEmailToELaunchLeadArgs = {
  subject: Scalars['String'];
  message: Scalars['String'];
  recipients: Array<Scalars['String']>;
  contactIds: Array<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationAddELaunchArgs = {
  input: ELaunchInput;
};


export type MutationEditELaunchArgs = {
  input: ELaunchInput;
};


export type MutationDeleteELaunchArgs = {
  eLaunchId: Scalars['String'];
};


export type MutationUpdateELaunchAllocationArgs = {
  input: ELaunchAllocationInput;
};


export type MutationCreateFinancierArgs = {
  input: FinancierInput;
};


export type MutationAddFinancierContactArgs = {
  input: FinancierContact;
  financier_id: Scalars['String'];
};


export type MutationEditFinancierArgs = {
  input: FinancierInput;
};


export type MutationDeleteFinancierArgs = {
  financier_id: Scalars['String'];
};


export type MutationSetDefaultFinancierContactArgs = {
  financier_id: Scalars['String'];
  project_id: Scalars['String'];
  contactId: Scalars['String'];
};


export type MutationAssignPanelArgs = {
  input: AdminFinancierPanelInput;
};


export type MutationUnassignPanelArgs = {
  project_id: Scalars['String'];
  financier_id: Scalars['String'];
};


export type MutationRemoveInvitationContactArgs = {
  input: AdminFinancierPanelInput;
};


export type MutationSendProjectInvitationArgs = {
  input: AdminFinancierPanelInput;
};


export type MutationEditFinancialLimitArgs = {
  interestRate?: Maybe<Scalars['Float']>;
  financialLimit: Scalars['Float'];
  id: Scalars['String'];
};


export type MutationSuspendEndFinancierArgs = {
  financierId: Scalars['String'];
};


export type MutationNewLeadIntegrationArgs = {
  input: LeadIntegrationInput;
};


export type MutationEditLeadIntegrationArgs = {
  input: LeadIntegrationInput;
};


export type MutationAlterLeadIntegrationCommonStatusArgs = {
  leadIntegrationId: Scalars['String'];
};


export type MutationSyncMissMatchSalesArgs = {
  projectId: Scalars['String'];
};


export type MutationAddLetterTemplateArgs = {
  input: LetterTemplateInput;
};


export type MutationEditLetterTemplateArgs = {
  input: EditLetterTemplateInput;
};


export type MutationDeleteLetterTemplateArgs = {
  letterTemplateId: Scalars['String'];
};


export type MutationAssignProjectLetterTemplateArgs = {
  standardLetterId: Scalars['String'];
  letterTemplateIds: Array<Scalars['String']>;
  projectId: Scalars['String'];
};


export type MutationSetDefaultProjectLetterTemplateArgs = {
  standardLetterId: Scalars['String'];
  projectId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationRemoveDefaultProjectLetterTemplateArgs = {
  standardLetterId: Scalars['String'];
  projectId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationUnassignProjectLetterArgs = {
  standardLetterId: Scalars['String'];
  projectId: Scalars['String'];
  id: Scalars['String'];
};


export type MutationUpdateAccountSpecArgs = {
  loanPlusProjectId: Scalars['Float'];
};


export type MutationAddDirectionArgs = {
  input: DirectionInput;
};


export type MutationEditDirectionArgs = {
  input: EditDirectionInput;
};


export type MutationDeleteDirectionByIdArgs = {
  directionId: Scalars['String'];
};


export type MutationSetDefaultDirectionArgs = {
  directionId: Scalars['String'];
};


export type MutationRemoveDefaultDirectionArgs = {
  directionId: Scalars['String'];
};


export type MutationOrganizeDirectionArgs = {
  directionId: Array<Scalars['String']>;
};


export type MutationAddDiscountArgs = {
  input: DiscountInput;
};


export type MutationEditDiscountArgs = {
  input: EditDiscountInput;
};


export type MutationActiveDiscountArgs = {
  discountId: Scalars['String'];
};


export type MutationDeactiveDiscountArgs = {
  discountId: Scalars['String'];
};


export type MutationDeleteDiscountArgs = {
  discountId: Scalars['String'];
};


export type MutationAssignDiscountArgs = {
  input: AssignDiscountInput;
};


export type MutationEditAssignDiscountArgs = {
  input: AssignDiscountInput;
};


export type MutationUnassignDiscountArgs = {
  projectId: Scalars['String'];
  discountId: Scalars['String'];
};


export type MutationSetDefaultDiscountForProjectArgs = {
  projectId: Scalars['String'];
  discountId: Scalars['String'];
};


export type MutationUnmarkDefaultDiscountForProjectArgs = {
  projectId: Scalars['String'];
  discountId: Scalars['String'];
};


export type MutationAddIncomeRangeArgs = {
  input: IncomeRangeInput;
};


export type MutationEditIncomeRangeArgs = {
  input: EditIncomeRangeInput;
};


export type MutationDeleteIncomeRangeByIdArgs = {
  incomeRangeId: Scalars['String'];
};


export type MutationOrganizeIncomeRangeArgs = {
  incomeRangeIds: Array<Scalars['String']>;
};


export type MutationSetDefaultIncomeRangeArgs = {
  incomeRangeId: Scalars['String'];
};


export type MutationRemoveDefaultIncomeRangeArgs = {
  incomeRangeId: Scalars['String'];
};


export type MutationAddLeadSourceArgs = {
  input: LeadSourceInput;
};


export type MutationEditLeadSourceArgs = {
  input: EditLeadSourceInput;
};


export type MutationDeleteLeadSourceByIdArgs = {
  sourceId: Scalars['String'];
};


export type MutationChangeLeadStatusArgs = {
  status: Scalars['Boolean'];
  sourceId: Scalars['String'];
};


export type MutationSetDefaultLeadSourceArgs = {
  sourceId: Scalars['String'];
};


export type MutationRemoveDefaultLeadSourceArgs = {
  sourceId: Scalars['String'];
};


export type MutationOrganizeLeadSourceArgs = {
  sourceIds: Array<Scalars['String']>;
};


export type MutationAddMaritalStatusArgs = {
  input: MaritalStatusInput;
};


export type MutationEditMaritalStatusArgs = {
  input: EditMaritalStatusInput;
};


export type MutationDeleteMaritalStatusByIdArgs = {
  maritalStatusId: Scalars['String'];
};


export type MutationSetDefaultMaritalStatusArgs = {
  maritalStatusId: Scalars['String'];
};


export type MutationRemoveDefaultMaritalStatusArgs = {
  maritalStatusId: Scalars['String'];
};


export type MutationOrganizeMaritalStatusArgs = {
  maritalStatusIds: Array<Scalars['String']>;
};


export type MutationAddNupTypeArgs = {
  input: NupTypeInput;
};


export type MutationDeleteNupTypeArgs = {
  nupTypeId: Scalars['String'];
};


export type MutationEditNupTypeArgs = {
  input: EditNupTypeInput;
};


export type MutationAddNupReasonArgs = {
  input: NupReasonInput;
};


export type MutationDeleteNupReasonArgs = {
  reasonId: Scalars['String'];
};


export type MutationEditNupReasonArgs = {
  input: EditNupReasonInput;
};


export type MutationAddPackageArgs = {
  input: AddPackageInput;
};


export type MutationEditPackageArgs = {
  input: EditPackageInput;
};


export type MutationDeletePackageByIdArgs = {
  packageId: Scalars['String'];
};


export type MutationSyncIntegratePackageArgs = {
  projectId: Scalars['String'];
};


export type MutationAddProjectTypeArgs = {
  input: ProjectTypeInput;
};


export type MutationEditProjectTypeArgs = {
  input: EditProjectTypeInput;
};


export type MutationDeleteProjectTypeByIdArgs = {
  projectTypeId: Scalars['String'];
};


export type MutationSetDefaultProjectTypeArgs = {
  projectTypeId: Scalars['String'];
};


export type MutationRemoveDefaultProjectTypeArgs = {
  projectTypeId: Scalars['String'];
};


export type MutationOrganizeProjectTypeArgs = {
  projectTypeId: Array<Scalars['String']>;
};


export type MutationAddPropertyTypeArgs = {
  input: PropertyTypeInput;
};


export type MutationEditPropertyTypeArgs = {
  input: EditPropertyTypeInput;
};


export type MutationDeletePropertyTypeByIdArgs = {
  propertyTypeId: Scalars['String'];
};


export type MutationSetDefaultPropertyTypeArgs = {
  propertyTypeId: Scalars['String'];
};


export type MutationRemoveDefaultPropertyTypeArgs = {
  propertyTypeId: Scalars['String'];
};


export type MutationOrganizePropertyTypeArgs = {
  propertyTypeId: Array<Scalars['String']>;
};


export type MutationAddRaceArgs = {
  input: RaceInput;
};


export type MutationEditRaceArgs = {
  input: EditRaceInput;
};


export type MutationDeleteRaceByIdArgs = {
  raceId: Scalars['String'];
};


export type MutationSetDefaultRaceArgs = {
  raceId: Scalars['String'];
};


export type MutationRemoveDefaultRaceArgs = {
  raceId: Scalars['String'];
};


export type MutationOrganizeRaceArgs = {
  raceIds: Array<Scalars['String']>;
};


export type MutationAddRegionArgs = {
  input: RegionInput;
};


export type MutationEditRegionArgs = {
  input: EditRegionInput;
};


export type MutationDeleteRegionByIdArgs = {
  regionId: Scalars['String'];
};


export type MutationAlterRegionCommonStatusArgs = {
  regionId: Scalars['String'];
};


export type MutationSetDefaultRegionArgs = {
  regionId: Scalars['String'];
};


export type MutationRemoveDefaultRegionArgs = {
  regionId: Scalars['String'];
};


export type MutationOrganizeRegionArgs = {
  regionIds: Array<Scalars['String']>;
};


export type MutationEditSalesPackageArgs = {
  input: EditSalesPackageInput;
};


export type MutationAddSalesPackageArgs = {
  input: AddSalesPackageInput;
};


export type MutationDeleteSalesPackageArgs = {
  id: Scalars['String'];
};


export type MutationAddSalutationArgs = {
  input: SalutationInput;
};


export type MutationEditSalutationArgs = {
  input: EditSalutationInput;
};


export type MutationDeleteSalutationByIdArgs = {
  salutationId: Scalars['String'];
};


export type MutationOrganizeSalutationArgs = {
  salutationIds: Array<Scalars['String']>;
};


export type MutationSetDefaultSalutationArgs = {
  salutationId: Scalars['String'];
};


export type MutationRemoveDefaultSalutationArgs = {
  salutationId: Scalars['String'];
};


export type MutationAddUnitTypeArgs = {
  input: UnitTypeInput;
};


export type MutationEditUnitTypeArgs = {
  input: EditUnitTypeInput;
};


export type MutationDeleteUnitTypeByIdArgs = {
  unitTypeId: Scalars['String'];
};


export type MutationSetDefaultUnitTypeArgs = {
  unitTypeId: Scalars['String'];
};


export type MutationRemoveDefaultUnitTypeArgs = {
  unitTypeId: Scalars['String'];
};


export type MutationOrganizeUnitTypeArgs = {
  unitTypeId: Array<Scalars['String']>;
};


export type MutationAddNewsAnnouncementArgs = {
  input: NewsAnnouncementInput;
};


export type MutationEditNewsAnnouncementArgs = {
  input: NewsAnnouncementInput;
};


export type MutationPublishNewsAnnouncementArgs = {
  newsId: Scalars['String'];
};


export type MutationDeleteNewsAnnouncementArgs = {
  newsId: Scalars['String'];
};


export type MutationSaveNotificationPermissionArgs = {
  input: NotificationInput;
};


export type MutationMarkAsReadArgs = {
  notificationIds: Array<Scalars['String']>;
};


export type MutationEditLeadAssignmentArgs = {
  input: OpenLeadAssignmentSettingInput;
};


export type MutationNewLeadAssignmentArgs = {
  input: NewLeadAssignmentInput;
};


export type MutationDeleteLeadAssignmentArgs = {
  leadAssigmentId: Scalars['String'];
};


export type MutationOrganizeLeadAssignmentSeqArgs = {
  id: Array<Scalars['String']>;
};


export type MutationUpdateStatusToInProgressArgs = {
  sale_id: Scalars['String'];
};


export type MutationAddPaymentGateWayArgs = {
  input: PaymentGatewayInput;
};


export type MutationEditPaymentGateWayArgs = {
  input: PaymentGatewayInput;
};


export type MutationDeletePaymentGatewayArgs = {
  payment_gateway_id: Scalars['String'];
};


export type MutationSuspendPlatformUserArgs = {
  userId: Scalars['String'];
};


export type MutationUnsuspendPlatformUserArgs = {
  userId: Scalars['String'];
};


export type MutationChangePlatformUserPasswordArgs = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationEditPlatformUserArgs = {
  input: EditPlatformUserInput;
};


export type MutationAddNewPlatformUserArgs = {
  input: NewPlatformUserInput;
};


export type MutationAssignPlatformUserAccountArgs = {
  accountId: Scalars['String'];
  platformUserId: Scalars['String'];
};


export type MutationUnassignPlatformUserAccountArgs = {
  accountId: Scalars['String'];
  platformUserId: Scalars['String'];
};


export type MutationAssignPlatformUserAccountsArgs = {
  accountIds: Array<Scalars['String']>;
  platformUserId: Scalars['String'];
};


export type MutationUnassignPlatformUserAccountsArgs = {
  accountIds: Array<Scalars['String']>;
  platformUserId: Scalars['String'];
};


export type MutationChangePlatformUserPasswordInProfileArgs = {
  confirmPassword: Scalars['String'];
  newPassword: Scalars['String'];
  currentPassword: Scalars['String'];
};


export type MutationUpdatePlatformUserProfileArgs = {
  input: UpdatePlatformUserProfileInput;
};


export type MutationResendPlatformUserInvitationArgs = {
  userId: Scalars['String'];
};


export type MutationUpdateAppointmentScheduleArgs = {
  input: EditAppointmentScheduleInput;
};


export type MutationAddSalesGalleryCloseDateArgs = {
  input: AddBlockDateInput;
};


export type MutationEditSalesGalleryCloseDateArgs = {
  input: EditBlockDateInput;
};


export type MutationDeleteSalesGalleryCloseDateArgs = {
  input: CloseDateIdInput;
};


export type MutationAddProjectArgs = {
  input: AdminProjectInput;
};


export type MutationEditProjectArgs = {
  input: AdminProjectInput;
};


export type MutationUpdateUserLatestEntityArgs = {
  project_id: Scalars['String'];
};


export type MutationEditGalleryVideoArgs = {
  input: Array<AdminEditGalleryVideoInput>;
};


export type MutationEditGalleryTourArgs = {
  input: Array<AdminEditGalleryTourInput>;
};


export type MutationEditProjectGalleryArgs = {
  input: Array<AdminEditProjectGalleryInput>;
};


export type MutationDeleteProjectGalleryArgs = {
  input: Array<AdminEditProjectGalleryInput>;
};


export type MutationEditBlockGalleryArgs = {
  input: Array<AdminEditLayoutBlockInput>;
};


export type MutationDeleteBlockGalleryArgs = {
  input: Array<AdminEditLayoutBlockInput>;
};


export type MutationEditGalleryArgs = {
  input: Array<AdminEditGalleryInput>;
};


export type MutationEditFloorGalleryArgs = {
  input: Array<AdminEditLayoutFloorInput>;
};


export type MutationDeleteFloorGalleryArgs = {
  input: Array<AdminEditLayoutFloorInput>;
};


export type MutationDeleteUnitGalleryArgs = {
  input: Array<AdminEditLayoutUnitInput>;
};


export type MutationEditUnitGalleryArgs = {
  input: Array<AdminEditLayoutUnitInput>;
};


export type MutationEditProjectSpecArgs = {
  input: AdminSaveProjectSpecInput;
};


export type MutationAddReasonCodeArgs = {
  input: ReasonCodeInput;
};


export type MutationDeleteReasonCodeByIdArgs = {
  reasonCodeId: Scalars['String'];
};


export type MutationEditReasonCodeArgs = {
  input: EditReasonCodeInput;
};


export type MutationSetDefaultReasonCodeArgs = {
  type: Scalars['String'];
  reasonCodeId: Scalars['String'];
};


export type MutationRemoveDefaultReasonCodeArgs = {
  type: Scalars['String'];
  reasonCodeId: Scalars['String'];
};


export type MutationOrganizeReasonCodeArgs = {
  reasonCodeIds: Array<Scalars['String']>;
};


export type MutationUploadSalesDocArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
  input: SalesDocInput;
};


export type MutationDeleteSalesDocArgs = {
  salesDocId: Scalars['String'];
};


export type MutationUpdateSalesDocArgs = {
  file?: Maybe<Scalars['Upload']>;
  input: EditSalesDocInput;
};


export type MutationEditGatewayUpdatesArgs = {
  input: SGatewayUpdateInput;
};


export type MutationAddGatewayUpdatesArgs = {
  input: SGatewayAddInput;
};


export type MutationDeleteGatewayUpdatesByIdArgs = {
  ID: Scalars['String'];
};


export type MutationAddSiteProgessArgs = {
  input: AddSiteProgressInput;
  project_id: Scalars['String'];
};


export type MutationEditSiteProgressArgs = {
  input: EditSiteProgressInput;
};


export type MutationDeleteSiteProgressArgs = {
  siteProgressId: Scalars['String'];
};


export type MutationAddSolicitorArgs = {
  input: AdminSolicitorInput;
};


export type MutationEditSolicitorArgs = {
  input: AdminSolicitorInput;
  solicitor_appointed_id: Scalars['String'];
};


export type MutationSuspendSolicitorArgs = {
  solicitor_appointed_id: Scalars['String'];
};


export type MutationAssignSolicitorToProjectArgs = {
  project_id: Scalars['String'];
  solicitor_appointed_id: Array<Scalars['String']>;
};


export type MutationResendSolicitorAppointedInvitationArgs = {
  project_id: Scalars['String'];
  solicitor_appointed_id: Scalars['String'];
};


export type MutationUnassignSolicitorFromProjectArgs = {
  project_id: Scalars['String'];
  solicitor_id: Scalars['String'];
};


export type MutationMarkAsDefaultArgs = {
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
};


export type MutationAddSalesTeamsArgs = {
  input: TeamInput;
};


export type MutationEditSalesTeamsArgs = {
  input: EditTeamInput;
};


export type MutationDeleteSalesTeamByIdArgs = {
  teamId: Scalars['String'];
};


export type MutationAssignTeamMemberArgs = {
  userIds: Array<Scalars['String']>;
  teamId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationUnassignTeamMemberArgs = {
  userIds: Array<Scalars['String']>;
  teamId: Scalars['String'];
};


export type MutationAlterTeamAllocationPermissionArgs = {
  teamId: Scalars['String'];
};


export type MutationAllocateUnitsForTeamArgs = {
  selectUnitIds: Array<Scalars['String']>;
  teamId: Scalars['String'];
  projectId: Scalars['String'];
};


export type MutationIntegrateUnitFromDotNetPplusArgs = {
  input: AdminUnitIntegrationInput;
  projectID: Scalars['String'];
};


export type MutationRepullIntegrateUnitsArgs = {
  rePull?: Maybe<Scalars['Boolean']>;
  projectId: Scalars['String'];
};


export type MutationRemoveAllUnitsArgs = {
  projectID: Scalars['String'];
};


export type MutationUpdateUnitStatusArgs = {
  models: Array<AdminUnitStatusInput>;
};


export type MutationImportUnitArgs = {
  isSubProduct: Scalars['Boolean'];
  method: Scalars['String'];
  file: Scalars['Upload'];
  project_id: Scalars['String'];
};


export type MutationResetSalesChartByBlockArgs = {
  projectId: Scalars['String'];
  block: Scalars['String'];
};


export type MutationGenerateUnitArgs = {
  input: GenerateUnitInput;
};


export type MutationAssignCarParkToUnitArgs = {
  input: AssignCarkParkInput;
};


export type MutationAlterUnitTourArgs = {
  input: Array<AdminUpdateUnitVirtualModelInput>;
};


export type MutationDeleteUnitTourLinkArgs = {
  projectId: Scalars['String'];
  tourIds: Array<Scalars['String']>;
};

export type NewLeadAssignmentInput = {
  userId: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
};

export type NewPaymentPlan = {
  __typename?: 'NewPaymentPlan';
  event_item: Scalars['String'];
  event_amt: Scalars['Float'];
  event_estimate_date: Scalars['String'];
  endfin_mortgage_retention_id?: Maybe<Scalars['String']>;
  endfin_mortgage_payment_id?: Maybe<Scalars['String']>;
};

export type NewPlatformUserInput = {
  name: Scalars['String'];
  email: Scalars['String'];
  username: Scalars['String'];
  contactNo: Scalars['String'];
  role: Scalars['Boolean'];
};

export type NewUserInput = {
  name: Scalars['String'];
  email: Scalars['String'];
  username: Scalars['String'];
  phoneNo: Scalars['String'];
  superUser?: Maybe<Scalars['Boolean']>;
  allowOpenLead?: Maybe<Scalars['Boolean']>;
  allowPropertyAgency?: Maybe<Scalars['Boolean']>;
  allowGlobalBI?: Maybe<Scalars['Boolean']>;
  allowRoundRobin?: Maybe<Scalars['Boolean']>;
  allowOpenLeadRoundRobin?: Maybe<Scalars['Boolean']>;
};

export type NewsAnnouncementInput = {
  id?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  start_date: Scalars['DateTime'];
  end_date: Scalars['DateTime'];
  project_ids: Array<Scalars['String']>;
  newAttachment?: Maybe<Array<Scalars['Upload']>>;
  reqDeleteAttId?: Maybe<Array<Scalars['String']>>;
};

export type NewsAnnouncementListOutput = {
  __typename?: 'NewsAnnouncementListOutput';
  data: Array<NewsAnnouncementEntity>;
  total: Scalars['Float'];
};

export type NotMatchSaleOutput = {
  __typename?: 'NotMatchSaleOutput';
  SaleStatus: Scalars['String'];
  IfcaSaleId: Scalars['Float'];
  ContactID: Scalars['Float'];
  PXSaleStatus: Scalars['String'];
  UnitNo: Scalars['String'];
  PXSaleId: Scalars['String'];
  CancelDate?: Maybe<Scalars['DateTime']>;
  CancelReason?: Maybe<Scalars['String']>;
  CancelRemarks?: Maybe<Scalars['String']>;
  SaleDate: Scalars['DateTime'];
  SNPDate?: Maybe<Scalars['DateTime']>;
  SNPStampDate?: Maybe<Scalars['DateTime']>;
  SellingPrice: Scalars['Float'];
  SaleStaffEmail?: Maybe<Scalars['String']>;
  PurchaserName?: Maybe<Scalars['String']>;
  PurchaserMobileNo: Scalars['String'];
  PurchaserEmail?: Maybe<Scalars['String']>;
  PurchaserNationality: Scalars['String'];
  PurchaserIdentityNo: Scalars['String'];
  PurchaserSalutation: Scalars['String'];
  PurchaserRace: Scalars['String'];
  PurchaserDOB: Scalars['String'];
  PurchaserGender: Scalars['String'];
  PurchaserMaritalStatus: Scalars['String'];
  PurchaserAddr: Scalars['String'];
  PurchaserCountryName: Scalars['String'];
  PurchaserCityName: Scalars['String'];
  PurchaserStateName: Scalars['String'];
  PurchaserPostCode: Scalars['String'];
  IsCompany: Scalars['String'];
  PXProjectID: Scalars['String'];
  MissMatchType?: Maybe<Scalars['String']>;
};

export type NotificationInput = {
  day?: Maybe<Scalars['Float']>;
  notificationList?: Maybe<Array<Scalars['String']>>;
};

export enum NpvBasicRate {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export type NupReasonInput = {
  code: Scalars['String'];
  description: Scalars['String'];
};

export type NupTypeInput = {
  nupType: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  prefix?: Maybe<Scalars['String']>;
  viaMobile?: Maybe<Scalars['Boolean']>;
  viaAgent?: Maybe<Scalars['Boolean']>;
};

export type OldBalance = {
  __typename?: 'OldBalance';
  event_name: Scalars['String'];
  old_balance: Scalars['Float'];
  net_balance?: Maybe<Scalars['Float']>;
  endfin_mortgage_retention_id?: Maybe<Scalars['String']>;
  endfin_mortgage_payment_id?: Maybe<Scalars['String']>;
  retentions?: Maybe<Array<Scalars['JSONObject']>>;
};

export type OldBalanceBuyBack = {
  __typename?: 'OldBalanceBuyBack';
  event_name: Scalars['String'];
  old_balance: Scalars['Float'];
  net_balance?: Maybe<Scalars['Float']>;
  endfin_mortgage_retention_id?: Maybe<Scalars['String']>;
  endfin_mortgage_payment_id?: Maybe<Scalars['String']>;
  retentions?: Maybe<Array<Scalars['JSONObject']>>;
};

export type OnPremApiResModel = {
  __typename?: 'OnPremApiResModel';
  id?: Maybe<Scalars['String']>;
  apiUrl?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  errno?: Maybe<Scalars['Float']>;
  errMsg?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['Boolean']>;
  apiMsg?: Maybe<Scalars['String']>;
};

export type OnlineUserEntity = AuditEntity & {
  __typename?: 'OnlineUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  commonStatus: Scalars['String'];
  userId: Scalars['String'];
  softwareCode?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  accountName?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  lastLogin: Scalars['DateTime'];
  lastLogout?: Maybe<Scalars['DateTime']>;
  socketId?: Maybe<Scalars['String']>;
  softwarePackage?: Maybe<Scalars['String']>;
};

export type OnlineUsersCountModel = {
  __typename?: 'OnlineUsersCountModel';
  count: Scalars['Float'];
};

export type OnlineUsersModel = {
  __typename?: 'OnlineUsersModel';
  softwareCode: Scalars['String'];
  accountId: Scalars['String'];
  accountName: Scalars['String'];
  userId: Scalars['String'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastLogout?: Maybe<Scalars['DateTime']>;
};

export type OnlineUsersOutput = {
  __typename?: 'OnlineUsersOutput';
  data: Array<OnlineUsersModel>;
  total: Scalars['Float'];
};

export type OpenLeadAssignmentSettingInput = {
  leadAssignmentId: Scalars['String'];
  userId: Scalars['String'];
  weight?: Maybe<Scalars['Float']>;
};

export type OpenLeadSummary = {
  __typename?: 'OpenLeadSummary';
  lastImportedDate?: Maybe<Scalars['DateTime']>;
  lastImportedLeadCount?: Maybe<Scalars['Float']>;
  lastAssignedLeadDate?: Maybe<Scalars['String']>;
  lastAssignedLeadCount?: Maybe<Scalars['Float']>;
  totalBatchImported?: Maybe<Scalars['Float']>;
};

export enum OverduePurchaserDay {
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY',
  DayList = 'DayList',
  GetDay = 'GetDay'
}

export type PAuditEntity = {
  created_ref_table: Scalars['String'];
  modified_ref_table: Scalars['String'];
  created_by: Scalars['String'];
  created_date: Scalars['DateTime'];
  modified_by: Scalars['String'];
  modified_date: Scalars['DateTime'];
};

export type PdpaDetailByProject = {
  __typename?: 'PDPADetailByProject';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  templateBody?: Maybe<Scalars['String']>;
  standardLetterId?: Maybe<Scalars['String']>;
  letterType?: Maybe<Scalars['String']>;
};

export type PackageInput = {
  name: Scalars['String'];
  desc: Scalars['String'];
  listPrice: Scalars['Float'];
  marketValue: Scalars['Float'];
};

export type PanelListDto = {
  __typename?: 'PanelListDto';
  financier_name: Scalars['String'];
  office_tel?: Maybe<Scalars['Float']>;
  bank_name: Scalars['String'];
  logo_url: Scalars['String'];
  total_staff: Scalars['Float'];
  finproject_id: Scalars['String'];
};

export type ParamaterValueOutput = {
  __typename?: 'ParamaterValueOutput';
  installment?: Maybe<Array<Installment>>;
  project: ProjectEntity;
  mainBuyerDetails?: Maybe<ContactEntity>;
  sale?: Maybe<SaleEntity>;
  salesCancellation?: Maybe<SaleCancellationEntity>;
  spouse?: Maybe<ContactEntity>;
  discount?: Maybe<Array<DiscountParamaterValueOutput>>;
  salePackage?: Maybe<Array<PackageEntity>>;
  developerSolicitor?: Maybe<SolicitorAppointedEntity>;
  buyerSolicitor?: Maybe<SolicitorAppointedEntity>;
  unit: UnitEntity;
  company: CompanyEntity;
  jointBuyerDetails?: Maybe<Array<ContactEntity>>;
  jointBuyerSignRequired: Scalars['Boolean'];
  payment?: Maybe<SalePaymentValueOutput>;
  jointBuyers?: Maybe<Array<JointBuyerEntity>>;
  receipt?: Maybe<ReceiptEntity>;
  address?: Maybe<AddressJson>;
  holdingCompany: CompanyEntity;
  developmentCompany: CompanyEntity;
  lead?: Maybe<LeadEntity>;
  saleLoan?: Maybe<Array<SaleLoanEntity>>;
  financier?: Maybe<FinancierEntity>;
  saleLoanRelease?: Maybe<SaleLoanReleaseEntity>;
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
  mortgagePaymentValue?: Maybe<MortgagePaymentEntity>;
  mortgageRetention?: Maybe<MortgageRetentionEntity>;
  mortgageRetentionValues?: Maybe<Array<MortgageRetentionEntity>>;
};

export type PassswordErrorMsgOuput = {
  __typename?: 'PassswordErrorMsgOuput';
  RequiredLength: Scalars['String'];
  RequiredUniqueChars: Scalars['String'];
  RequireNonAlphanumeric: Scalars['String'];
  RequireLowercase: Scalars['String'];
  RequireUppercase: Scalars['String'];
  RequireDigit: Scalars['String'];
};

export type PassswordPolicyOuput = {
  __typename?: 'PassswordPolicyOuput';
  RequiredLength: Scalars['Float'];
  RequiredUniqueChars: Scalars['Float'];
  RequireNonAlphanumeric: Scalars['Boolean'];
  RequireLowercase: Scalars['Boolean'];
  RequireUppercase: Scalars['Boolean'];
  RequireDigit: Scalars['Boolean'];
  ErrorMsg: PassswordErrorMsgOuput;
};

export enum PaymentBy {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export type PaymentGatewayInput = {
  id?: Maybe<Scalars['String']>;
  accountId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  gateway_type: Scalars['String'];
  gateway_info: Scalars['JSONObject'];
};

export type PermissionDetail = {
  __typename?: 'PermissionDetail';
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  module?: Maybe<Scalars['String']>;
  submodule?: Maybe<Scalars['String']>;
  permissionType?: Maybe<PermissionType>;
  permissionId?: Maybe<Scalars['Float']>;
  action?: Maybe<Scalars['String']>;
  parent_id?: Maybe<Scalars['String']>;
  seq_no?: Maybe<Scalars['Float']>;
  package_code: Scalars['String'];
  child?: Maybe<Array<PermissionDetail>>;
  permission_key: Scalars['String'];
};

export type PermissionEntity = {
  __typename?: 'PermissionEntity';
  id: Scalars['ID'];
  accountId?: Maybe<Scalars['ID']>;
  softwareCode: Scalars['String'];
  packageCode: Scalars['String'];
  name: Scalars['String'];
  module: Scalars['String'];
  submodule?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  action?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['ID']>;
  seqNo?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
  permissionOldId?: Maybe<Scalars['Float']>;
  permissionRoleAssignments: Array<PermissionRoleAssignmentEntity>;
};

export type PermissionInput = {
  id: Scalars['String'];
  permissionId: Scalars['Float'];
  package_code: Scalars['String'];
};

export enum PermissionType {
  SalesAdmin = 'SALES_ADMIN',
  Report = 'REPORT'
}

export type PlatformUserAssignedAccountEntity = {
  __typename?: 'PlatformUserAssignedAccountEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  platformUserId: Scalars['String'];
  commonStatus: CommonStatus;
};

export type PlatformUserEntity = {
  __typename?: 'PlatformUserEntity';
  ID: Scalars['String'];
  username: Scalars['String'];
  email: Scalars['String'];
  password: Scalars['String'];
  name: Scalars['String'];
  commonStatus: CommonStatus;
  role: PlatformUserRole;
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  contactNo?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  isActivated: Scalars['Boolean'];
};

export enum PlatformUserRole {
  Admin = 'ADMIN',
  Superadmin = 'SUPERADMIN',
  Staff = 'STAFF'
}

export type PostCodeMasterDataOutput = {
  __typename?: 'PostCodeMasterDataOutput';
  ID: Scalars['String'];
  postcode: Scalars['String'];
  cityID: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type ProgressLogDetails = {
  __typename?: 'ProgressLogDetails';
  spastatus?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  sale_id?: Maybe<Scalars['String']>;
  progresstype?: Maybe<Scalars['String']>;
  progressdesc?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  progressdate?: Maybe<Scalars['DateTime']>;
};

export type ProjectBlockMediaOuput = {
  __typename?: 'ProjectBlockMediaOuput';
  resourceid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  block: Scalars['String'];
  pictureid: Scalars['String'];
};

export type ProjectBookingDetailOutput = {
  __typename?: 'ProjectBookingDetailOutput';
  sale: Scalars['Float'];
  buyer: Scalars['Float'];
  unit: Scalars['Float'];
  joinBuyer: Scalars['Float'];
  bookingFeeAttachments: Scalars['Float'];
  otherAttachments: Scalars['Float'];
};

export type ProjectDetailsOutput = {
  __typename?: 'ProjectDetailsOutput';
  projectId: Scalars['String'];
  projectName: Scalars['String'];
};

export type ProjectDownloadBrochureOutput = {
  __typename?: 'ProjectDownloadBrochureOutput';
  fileName: Scalars['String'];
  content: Scalars['String'];
};

export type ProjectFloorMediaOuput = {
  __typename?: 'ProjectFloorMediaOuput';
  resourceid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  block: Scalars['String'];
  floor: Scalars['Float'];
  pictureid: Scalars['String'];
  floorlabel?: Maybe<Scalars['String']>;
};

export type ProjectGalleryMediaOuput = {
  __typename?: 'ProjectGalleryMediaOuput';
  resourceid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
  pictureid: Scalars['String'];
  seqno?: Maybe<Scalars['Float']>;
};

export type ProjectGalleryOutput = {
  __typename?: 'ProjectGalleryOutput';
  resourceid: Scalars['String'];
  url: Scalars['String'];
  pictureid: Scalars['String'];
  seqno: Scalars['Float'];
  caption?: Maybe<Scalars['String']>;
};

export type ProjectResourceOuput = {
  __typename?: 'ProjectResourceOuput';
  resourceid?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type ProjectSaleListOuput = {
  __typename?: 'ProjectSaleListOuput';
  unit_id: Scalars['String'];
  unit_no: Scalars['String'];
  unit_price: Scalars['String'];
  sale_id: Scalars['String'];
  sales_status: Scalars['String'];
  project_id: Scalars['String'];
  booking_amount?: Maybe<Scalars['Float']>;
  contact_id: Scalars['String'];
  full_name: Scalars['String'];
  salesPerson?: Maybe<UserEntity>;
  date: Scalars['DateTime'];
};

export type ProjectSalesOfficeEntity = {
  __typename?: 'ProjectSalesOfficeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  salesOfficeTel?: Maybe<Scalars['String']>;
  salesOfficeFax?: Maybe<Scalars['String']>;
  salesOfficeAddress?: Maybe<Scalars['String']>;
  propertyManager?: Maybe<Scalars['String']>;
  projectManager?: Maybe<Scalars['String']>;
  generalManager?: Maybe<Scalars['String']>;
  salesMarketingHOD?: Maybe<Scalars['String']>;
  creditControlHOD?: Maybe<Scalars['String']>;
  creditControlOfficeTel?: Maybe<Scalars['String']>;
  creditControlEmail?: Maybe<Scalars['String']>;
  customerCareHOD?: Maybe<Scalars['String']>;
  customerCareContactNo?: Maybe<Scalars['String']>;
  customerCareEmail?: Maybe<Scalars['String']>;
  areaUOM1?: Maybe<Scalars['String']>;
  areaUOM2?: Maybe<Scalars['String']>;
  areaUOM3?: Maybe<Scalars['String']>;
  areaUOMConversion1?: Maybe<Scalars['String']>;
  areaUOMConversion2?: Maybe<Scalars['String']>;
  salesLocalAuthorityName?: Maybe<Scalars['String']>;
  salesLocalAuthorityContactNo?: Maybe<Scalars['String']>;
  salesLocalAuthorityAddress?: Maybe<AddressJson>;
  customerCareLocalAuthorityName?: Maybe<Scalars['String']>;
  customerCareLocalAuthorityContactNo?: Maybe<Scalars['String']>;
  customerCareLocalAuthorityAddress?: Maybe<AddressJson>;
  buildingContractorAwarded?: Maybe<Scalars['String']>;
  buildingContractorName?: Maybe<Scalars['String']>;
  warrantyPeriod?: Maybe<Scalars['Float']>;
  DLPTerm1?: Maybe<Scalars['String']>;
  DLPTerm2?: Maybe<Scalars['String']>;
  salesPermit?: Maybe<Scalars['String']>;
  architecturePermit?: Maybe<Scalars['String']>;
  constructionPermit?: Maybe<Scalars['String']>;
  builtUpArea?: Maybe<Scalars['Float']>;
  densityPercentage?: Maybe<Scalars['Float']>;
  floorArea?: Maybe<Scalars['Float']>;
  floorAreaPercent?: Maybe<Scalars['Float']>;
  commonArea?: Maybe<Scalars['Float']>;
  commonAreaPercent?: Maybe<Scalars['Float']>;
  greenspaceArea?: Maybe<Scalars['Float']>;
  greenspaceAreaPercent?: Maybe<Scalars['Float']>;
  landArea?: Maybe<Scalars['Float']>;
  usageRatioPercent?: Maybe<Scalars['Float']>;
  usagePurpose?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type ProjectSpecManagerOutput = {
  __typename?: 'ProjectSpecManagerOutput';
  name: Scalars['String'];
};

export type ProjectTotalUnitCount = {
  __typename?: 'ProjectTotalUnitCount';
  projectId: Scalars['String'];
  totalunit?: Maybe<Scalars['Float']>;
  reserved?: Maybe<Scalars['Float']>;
  booked?: Maybe<Scalars['Float']>;
  signed?: Maybe<Scalars['Float']>;
  available?: Maybe<Scalars['Float']>;
  unAvailable?: Maybe<Scalars['Float']>;
};

export type ProjectTypeInput = {
  name: Scalars['String'];
};

export type ProjectUnitBlockFloorOuput = {
  __typename?: 'ProjectUnitBlockFloorOuput';
  block: Scalars['String'];
  floor: Scalars['Float'];
  floorlabel: Scalars['String'];
};

export type ProjectUnitLayoutMediaOuput = {
  __typename?: 'ProjectUnitLayoutMediaOuput';
  resourceid?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  caption?: Maybe<Scalars['String']>;
  unitlayoutid?: Maybe<Scalars['String']>;
  unitLayout?: Maybe<Scalars['String']>;
  unit_type_id?: Maybe<Scalars['String']>;
  pictureid: Scalars['String'];
  seqno?: Maybe<Scalars['Float']>;
  desc?: Maybe<Scalars['String']>;
  virtualModelLink?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  unit_type_desc?: Maybe<Scalars['String']>;
  unitcount?: Maybe<Scalars['Float']>;
  noOfBedroom?: Maybe<Scalars['Float']>;
  noOfBathroom?: Maybe<Scalars['Float']>;
};

export type ProjectUserRoleAssignmentInput = {
  projectId: Scalars['String'];
  assignment: Array<UserRoleAssignmentInput>;
};

export type ProjectYoutubeLinkOutput = {
  __typename?: 'ProjectYoutubeLinkOutput';
  url: Scalars['String'];
  thumbnail: Scalars['String'];
  videoType?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['String']>;
};

export type PropertyTypeInput = {
  name: Scalars['String'];
  commercialPurpose: CommercialPurpose;
};

export type PullSaleDetailsOutput = {
  __typename?: 'PullSaleDetailsOutput';
  IfcaSaleId: Scalars['Float'];
  SaleStatus: Scalars['String'];
};

export type PurchaseLeadNotificationInput = {
  keyCollectionAppointment?: Maybe<PurchaserKeyCollectionAppointmentInput>;
  keyCollectionAppointmentReschedule?: Maybe<KeyCollectionAppointmentRescheduleInput>;
};

export type PurchaserAppBookedSubmenuInput = {
  booking_info?: Maybe<Scalars['Boolean']>;
  overall_site_progress?: Maybe<Scalars['Boolean']>;
  loan?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppBookedSubmenuOutput = {
  __typename?: 'PurchaserAppBookedSubmenuOutput';
  booking_info?: Maybe<Scalars['Boolean']>;
  overall_site_progress?: Maybe<Scalars['Boolean']>;
  loan?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppSignedSubmenuInput = {
  s_and_p?: Maybe<Scalars['Boolean']>;
  overall_site_progress?: Maybe<Scalars['Boolean']>;
  accounts?: Maybe<Scalars['Boolean']>;
  key_collection?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppSignedSubmenuOutput = {
  __typename?: 'PurchaserAppSignedSubmenuOutput';
  s_and_p?: Maybe<Scalars['Boolean']>;
  overall_site_progress?: Maybe<Scalars['Boolean']>;
  accounts?: Maybe<Scalars['Boolean']>;
  key_collection?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppSubmenuInput = {
  booked?: Maybe<PurchaserAppBookedSubmenuInput>;
  signed?: Maybe<PurchaserAppSignedSubmenuInput>;
};

export type PurchaserAppSubmenuOutput = {
  __typename?: 'PurchaserAppSubmenuOutput';
  booked?: Maybe<PurchaserAppBookedSubmenuOutput>;
  signed?: Maybe<PurchaserAppSignedSubmenuOutput>;
};

export type PurchaserBookedUnit = {
  __typename?: 'PurchaserBookedUnit';
  unitNo: Scalars['String'];
  saleId: Scalars['String'];
};

export type PurchaserDemographicBiFilterOutput = {
  __typename?: 'PurchaserDemographicBIFilterOutput';
  propertyType?: Maybe<Array<Scalars['String']>>;
  unitLayout?: Maybe<Array<UnitLayoutByProject>>;
};

export type PurchaserDemographicBiOutput = {
  __typename?: 'PurchaserDemographicBIOutput';
  name: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type PurchaserDetailOutput = {
  __typename?: 'PurchaserDetailOutput';
  userId: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  phone: Scalars['String'];
  isLead?: Maybe<Scalars['Boolean']>;
  unitFavouriteAndBookedCount: Scalars['JSONObject'];
  favouriteAndBookedUnits: BookedAndFavUnit;
};


export type PurchaserDetailOutputUnitFavouriteAndBookedCountArgs = {
  eLaunchId: Scalars['String'];
};


export type PurchaserDetailOutputFavouriteAndBookedUnitsArgs = {
  eLaunchId: Scalars['String'];
};

export type PurchaserLeadContactInput = {
  LeadId: Scalars['String'];
  ProjectId: Scalars['String'];
};

export type PurchaserLeadContactOutput = {
  __typename?: 'PurchaserLeadContactOutput';
  LeadId: Scalars['String'];
  ProjectId: Scalars['String'];
};

export type PurchaserLeadNotificationOutput = {
  __typename?: 'PurchaserLeadNotificationOutput';
  keyCollectionAppointment?: Maybe<PurchaserKeyCollectionAppointmentOutput>;
  keyCollectionAppointmentReschedule?: Maybe<PurchaserKeyCollectionAppointmentRescheduleOutput>;
};

export type PurchaserReferenceInput = {
  SaleId: Scalars['Float'];
  ProjectId: Scalars['Float'];
  ProjectID: Scalars['Float'];
  UnitId: Scalars['Float'];
  AccountID: Scalars['Float'];
  SaleStatus: Scalars['String'];
  IsIntegrate?: Maybe<Scalars['Boolean']>;
  IntegrationId?: Maybe<Scalars['String']>;
};

export type PurchaserReferenceOutput = {
  __typename?: 'PurchaserReferenceOutput';
  SaleId: Scalars['Float'];
  ProjectId: Scalars['Float'];
  ProjectID: Scalars['Float'];
  UnitId: Scalars['Float'];
  AccountID: Scalars['Float'];
  SaleStatus: Scalars['String'];
  IsIntegrate?: Maybe<Scalars['Boolean']>;
  IntegrationId?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  isAllowAddUser: Scalars['Boolean'];
  accessSecurityListing: UserAndRoleCount;
  userListing: Array<UserEntity>;
  getEditUser: UserEntity;
  isEmailExist: Scalars['Boolean'];
  isUserNameExist: Scalars['Boolean'];
  getPermission: Scalars['JSONObject'];
  getRoles: Array<RoleEntity>;
  getRoleById: RoleEntity;
  getUserCountByProject?: Maybe<Array<UserCountByProject>>;
  getUserDetails: UserEntity;
  getAccountList?: Maybe<Array<IfcaAccountOutput>>;
  login: Scalars['String'];
  logout: Scalars['Boolean'];
  getAccountName: Scalars['String'];
  passswordPolicy: PassswordPolicyOuput;
  refreshToken: Scalars['String'];
  getAllAppointmentType: Array<AppointmentTypeEntity>;
  DeleteAttachmentProduct: Scalars['Boolean'];
  DeleteAttachmentProducts: Scalars['Boolean'];
  DeleteResourceProduct: Scalars['Boolean'];
  DeleteResourceProducts: Scalars['Boolean'];
  getCampaignList: Array<CampaignEntity>;
  getCampaignById: CampaignEntity;
  getEventsListByCampaign?: Maybe<CampaignEntity>;
  getEventsDetails: EventsEntity;
  getAddEventLeadLink: Scalars['String'];
  CompanyListing: Array<CompanyEntity>;
  CompanyDetail: CompanyEntity;
  getDiscountByProject: Array<DiscountEntity>;
  calculateDiscount: Scalars['Float'];
  calculateIntegrateProjectDiscount: Scalars['Float'];
  exportPurchaser: ReportingExcelOutput;
  getMostFavouriteUnit: MostFavouriteOutput;
  getPurchaserDemoFilter: PurchaserDemographicBiFilterOutput;
  getRaceBI: Array<PurchaserDemographicBiOutput>;
  getNationalityBI: Array<PurchaserDemographicBiOutput>;
  getAgeBI: Array<PurchaserDemographicBiOutput>;
  getLocationBI: Array<PurchaserDemographicBiOutput>;
  GetBookingDetail: SaleEntity;
  getBookingDetailData: BookingDetailOutput;
  getJointBuyerInfo: ContactEntity;
  GetJointBuyer: ContactEntity;
  GetUnitDetails: UnitEntity;
  GetPurchaserDetails: ContactEntity;
  getInvitationTemplateById: ELaunchInvitationTemplateEntity;
  getWhatsAppContent: Scalars['String'];
  getELaunchLeadBatchList: LeadBatchSummaryPageOutput;
  downloadLeadTemplate: LeadTemplateReturnOutput;
  extractImportedLeadToExcel: LeadTemplateReturnOutput;
  LeadsByBatch?: Maybe<LeadByBatchIds>;
  getExistingLeads?: Maybe<SalesLeadOutput>;
  getLeadByContactId: LeadContactEntity;
  getELaunchLeadByBatchId?: Maybe<LeadDataByBatch>;
  getLeadByELaunchId: Array<LeadBatchContactOutput>;
  getRegisteredPurchaserListing: Array<PurchaserDetailOutput>;
  getRegisteredPurchaserDetailsById: RegisteredPurchaserDetailsByIdOutput;
  getELaunchListing: Array<ELaunchEntity>;
  getELaunchById: ELaunchEntity;
  isELaunchCodeExist: Scalars['Boolean'];
  getAllocatedUnitsByELaunchId: Array<ElaunchUnitAllocation>;
  getELaunchLink: Scalars['String'];
  getELaunchUnitAllocationSummary: Array<UnitAllocationSummary>;
  getAllocatedUnitsByBlock: Array<ELaunchAllocationEntity>;
  getFinancierList: Array<FinancierEntity>;
  getFinancierDetail: FinancierEntity;
  isEndFinEmailExist: Scalars['Boolean'];
  panelByProject: Array<EndfinProjectFinancierEntity>;
  panelFinancierList: Array<FinancierEntity>;
  panelDetails: FinancierPanelDetails;
  getProjectLetterForDocListing: Array<ESignProjectLetterListingOutput>;
  getMultiELetterBySaleId: Array<MultipleEsignProjectLetterListingOutput>;
  getELetterPDF: ELetterOutput;
  GetStatesByCountry?: Maybe<Array<StateMasterDataOutput>>;
  GetCitiesByState?: Maybe<Array<CityMasterDataOutput>>;
  GetPostcodeByCity?: Maybe<Array<PostCodeMasterDataOutput>>;
  GetDistrictByCity?: Maybe<Array<DistrictMasterDataOutput>>;
  getIntegrationAccountSpec: AccountSpecEntity;
  getSolicitor: Scalars['Boolean'];
  getLeadIntegration: Array<Lead3rdpartyIntegrationEntity>;
  getLeadIntegrationById: Lead3rdpartyIntegrationEntity;
  getIntegrationSettingFormData: IntegrationTypeGetFormOutput;
  missMatchSaleProjectListing: Array<GetMissMatchSaleProjectListing>;
  notMatchSale: Array<NotMatchSaleOutput>;
  getStandardLetter: StandardLetterEntity;
  getLetterTypeListing: Array<StandardLetterEntity>;
  getLetterTemplateListing: Array<LetterTemplateEntity>;
  getStandardLetterParameters: Array<LetterParameter>;
  getLetterTemplateDetails: EditLetterTemplate;
  getLetterPreview: LetterTemplateEntity;
  getESignLetterTemplateToAssign: Array<ESignLetterTemplateAssignmenttOutput>;
  getLetterTemplateListingByProject: Array<LetterTemplateByProject>;
  getAccountSpec?: Maybe<LoanScreenAccountSpecOutput>;
  getAllDirection?: Maybe<Array<DirectionEntity>>;
  getDirectionById: DirectionEntity;
  getAllDiscount: Array<DiscountEntity>;
  getDiscountById: DiscountEntity;
  getAssignDiscountFormSource: Scalars['JSONObject'];
  getDiscountAssignedByProjectId: Scalars['JSONObject'];
  getDiscountAssigmentByProjectId: Array<DiscountEntity>;
  getAssignedDiscountById: ProjectDiscountEntity;
  getAllIncomeRange?: Maybe<Array<IncomeRangeEntity>>;
  getIncomeRangeById: IncomeRangeEntity;
  getAllLeadSource?: Maybe<Array<LeadSourceEntity>>;
  getLeadSourceById: LeadSourceEntity;
  getAllMaritalStatus?: Maybe<Array<MaritalStatusEntity>>;
  getMaritalStatusById: MaritalStatusEntity;
  GetAllMasterInfo: MasterDataOutput;
  getNupTypeListing: Array<NupTypeEntity>;
  getNupTypeDetail: NupTypeEntity;
  getNupReasonListing: Array<NupReasonEntity>;
  getNupReasonDetail: NupReasonEntity;
  getAllPackageByProject?: Maybe<Array<PackageEntity>>;
  getPackageById: PackageEntity;
  getAllProjectType?: Maybe<Array<ProjectTypeEntity>>;
  getProjectTypeById: ProjectTypeEntity;
  getAllPropertyType?: Maybe<Array<PropertyTypeEntity>>;
  getPropertyTypeById: PropertyTypeEntity;
  getAllRace?: Maybe<Array<RaceEntity>>;
  getRaceById: RaceEntity;
  getListOfRegion?: Maybe<Array<RegionEntity>>;
  isIntegratedProject?: Maybe<Scalars['Boolean']>;
  getSalesPackagesList: Array<PackageEntity>;
  getSalesPackageById: PackageEntity;
  getAllSalutation?: Maybe<Array<SalutationEntity>>;
  getSalutationById: SalutationEntity;
  getAllUnitType?: Maybe<Array<UnitTypeEntity>>;
  getUnitTypeById: UnitTypeEntity;
  getAllNewsAnnouncement: NewsAnnouncementListOutput;
  getNewsAnnouncementDetails: NewsAnnouncementEntity;
  getNotificationPermission: Scalars['JSONObject'];
  getNotificationHistoryDay?: Maybe<Scalars['Float']>;
  getUserNotificationPermission?: Maybe<Array<Scalars['String']>>;
  getNotifications?: Maybe<Scalars['JSONObject']>;
  markAllRead: Scalars['Boolean'];
  getAllOnlineUsers: OnlineUsersOutput;
  getLeadAssignmentListByAccount?: Maybe<Array<OpenLeadAssignmentSettingOutput>>;
  getLeadAssignmentFormSource: Array<OpenLeadAssignmentSettingEntity>;
  getLeadAssigmentById: OpenLeadAssignmentSettingOutput;
  getLeadAssignmentSalesStaff: Array<ListOfSalesStaffByUserPermission>;
  getLeadAssignmentNotification: AccountSpecEntity;
  getIpay88PaymentData: Ipay88PaymentOutput;
  getTransactionStatusByRefNo: Scalars['String'];
  revenueMonsterPaymentUrl: Scalars['String'];
  getPaymentQRCodeURL: Scalars['String'];
  getSalePaymentDataBySaleId: SalePaymentConfirmResultOutput;
  getSalePaymentDataByRefNo: SalePaymentConfirmResultOutput;
  getIpay88PaymentMethodEnum: Scalars['JSONObject'];
  getRevenueMonsterTransactionByRefNo: Scalars['String'];
  getAllTransactions: Array<TransactionStatusOutput>;
  getRmAllTransactions: Scalars['JSONObject'];
  paymentGatewayListing: Array<PaymentGatewayEntity>;
  paymentGatewayDetails: PaymentGatewayEntity;
  getPaymentgatewayEnum: Scalars['JSONObject'];
  getPlatformUsers: Array<PlatformUserEntity>;
  getPlatformUserById: PlatformUserEntity;
  isPlatformUserEmailExist: Scalars['Boolean'];
  isPlatformUserNameExist: Scalars['Boolean'];
  getAssignedAccoutList: Array<PlatformUserAssignedAccountEntity>;
  checkPlatformUserIsAdmin: Scalars['Boolean'];
  getNonAdminAccountList: Array<AccountIdsOuput>;
  getPlatformUserProfile: PlatformUserEntity;
  viewAppointmentSchedule: GetAppoitmentSchedulingOutput;
  viewCloseDateById: SalesGalleryCloseDateEntity;
  getAllProject: Array<ProjectEntity>;
  getCountryStateCity: Array<SCountryEntity>;
  getProjectById: ProjectEntity;
  allowAddProject: Scalars['Boolean'];
  projectDetail: ProjectEntity;
  GetGalleryByProject: Array<ProjectEntity>;
  GetVideoGalleryByProject: Array<Scalars['JSONObject']>;
  GetGalleryTourByProject: Array<Scalars['JSONObject']>;
  GetProjectGalleryByProject: Array<ProjectGalleryOutput>;
  GetBlockGalleryByProject: Array<BlockGalleryOutput>;
  GetDistinctBlockByProjectId: Array<DistinctBlockByProjectOutput>;
  GetFloorGalleryByProject: Array<FloorGalleryOutput>;
  GetDistinctFloorByProjectId: Array<DistinctFloorByProjectOutput>;
  GetUnitGalleryByProject: Array<UnitGalleryOutput>;
  GetDistinctUnitByProjectId: Array<DistinctUnitByProjectOutput>;
  GetDistinctUnitTypeByProjectId: Array<DistinctUnitTypeByProjectOutput>;
  GetGalleryByType: Array<ProjectEntity>;
  GetProjectSpecByProjectId: ProjectSpecEntity;
  getSuserListForProjectSpec: Array<UserEntity>;
  GetIntegrationDetailsByProjectId?: Maybe<ProjectIntegrationEntity>;
  projectIntegrationById: ProjectIntegrationEntity;
  getAllActiveProjectIntegration: Array<ProjectIntegrationEntity>;
  getAllActiveProjectIntegrationWithUrl?: Maybe<Array<GetAllActiveProjectIntegrationWithUrlOutput>>;
  getAllOnPremApiVer: Array<CheckOnPremApiModel>;
  getOnPremApiVer: CheckOnPremApiModel;
  updateAllOnPremApis: Array<OnPremApiResModel>;
  updateOnPremApi: OnPremApiResModel;
  updateOnPremApiByVer: OnPremApiResModel;
  getAllReasonCode?: Maybe<Array<ReasonCodeEntity>>;
  getReasonCodeById: ReasonCodeEntity;
  getSalesDocById: SalesDocEntity;
  getSalesDocList: Array<SalesDocEntity>;
  getSalesDocType: Scalars['JSONObject'];
  getBrochureList: Array<SalesDocEntity>;
  getAllGatewayUpdates: Array<SGatewayUpdates_A>;
  getAllGatewayUpdatesByType: Array<SGatewayUpdates_A>;
  getGatewayUpdatesById: SGatewayUpdates_A;
  getListSiteProgress: SiteProgressListingOutput;
  getEditSource: SiteProgressEntity;
  solicitorList: Array<SolicitorAppointedEntity>;
  solicitorDetails?: Maybe<SolicitorAppointedEntity>;
  solicitorProjectList: Array<SolicitorProjectEntity>;
  isSolicitorExist: Scalars['Boolean'];
  solicitorAppointedList: Array<SolicitorAppointedEntity>;
  solicitorListForAssignment: Array<SolicitorAppointedEntity>;
  solicitorAppointedDetails: SolicitorAppointedEntity;
  getSalesTeamByProject: Array<SaleTeamEntity>;
  getSalesTeamForAllocation: Array<SalesTeamByProjectOutput>;
  getAssignedTeamMembers: Array<UserEntity>;
  getUnassignedTeamMembers: Array<UserEntity>;
  getTeamBeenAllocatedWithUnit?: Maybe<Array<SaleTeamEntity>>;
  getAllocatedUnitsByTeam: Array<SalesChartUnitOutput>;
  getIntegrationParams?: Maybe<IntegrationParamOutput>;
  getCompanyList?: Maybe<Array<IntegrationCompanyOutput>>;
  getProjectList: Array<IntegrationCompanyOutput>;
  getPhaseList: Array<IntegrationCompanyOutput>;
  getPaymentPlan: Array<IntegrationPaymentPlanInfoOutput>;
  getUnitList: Array<IntegrationUnitOutput>;
  getUnitLayoutBlockByProjectId: Array<UnitLayoutBlockOutput>;
  GetBlockByProject: BlockByProjectOutput;
  GetFloorByProjectBlock?: Maybe<Array<FloorOutput>>;
  GetUnitByProjectBlock: Array<UnitEntity>;
  ExportUnit: UnitExcelOutput;
  ImportUnitOptions: ImportUnitOptionOutput;
  GetActiveBlockByProject: Array<Scalars['String']>;
  GetActiveFloorAndUnitByProjectBlock: Array<FloorOutput>;
  UpdateSalesChart: Scalars['Boolean'];
  GetSalesChartData?: Maybe<ProjectEntity>;
  GetSalesChartByBlock: SalesChartFloorUnitOutput;
  GetUnitDetail: UnitEntity;
  getUnitMasterData: UnitMasterDataOutput;
  Get360TourFormDataByProject: Array<BlockOutput>;
  GetUnit360TourByProject: Array<UnitTourVirtualLinkEntity>;
  profile: UserResponse;
};


export type QueryUserListingArgs = {
  activeUserOnly?: Maybe<Scalars['Boolean']>;
  isSuperUser?: Maybe<Scalars['Boolean']>;
  activeStatus?: Maybe<Scalars['String']>;
};


export type QueryGetEditUserArgs = {
  userId: Scalars['String'];
};


export type QueryIsEmailExistArgs = {
  userId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};


export type QueryIsUserNameExistArgs = {
  userId?: Maybe<Scalars['String']>;
  userName: Scalars['String'];
};


export type QueryGetRoleByIdArgs = {
  roleId: Scalars['String'];
};


export type QueryGetUserCountByProjectArgs = {
  roleId: Scalars['String'];
};


export type QueryGetUserDetailsArgs = {
  userId: Scalars['String'];
};


export type QueryLoginArgs = {
  Password: Scalars['String'];
  LoginId: Scalars['String'];
};


export type QueryRefreshTokenArgs = {
  accountID: Scalars['String'];
};


export type QueryDeleteAttachmentProductArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  filename: Scalars['String'];
};


export type QueryDeleteAttachmentProductsArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  filenames: Array<Scalars['String']>;
};


export type QueryDeleteResourceProductArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  fileUrl: Scalars['String'];
};


export type QueryDeleteResourceProductsArgs = {
  isPrivate?: Maybe<Scalars['Boolean']>;
  fileUrls: Array<Scalars['String']>;
};


export type QueryGetCampaignByIdArgs = {
  campaignId: Scalars['String'];
};


export type QueryGetEventsListByCampaignArgs = {
  campaignId: Scalars['String'];
};


export type QueryGetEventsDetailsArgs = {
  eventsId: Scalars['String'];
};


export type QueryGetAddEventLeadLinkArgs = {
  userId: Scalars['String'];
  accountId: Scalars['String'];
  eventId: Scalars['String'];
  campaignId: Scalars['String'];
};


export type QueryCompanyDetailArgs = {
  id: Scalars['String'];
};


export type QueryCalculateDiscountArgs = {
  discount_id: Scalars['String'];
  unit_id: Scalars['String'];
};


export type QueryCalculateIntegrateProjectDiscountArgs = {
  discountIds: Array<Scalars['String']>;
  unitId: Scalars['String'];
};


export type QueryExportPurchaserArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type QueryGetRaceBiArgs = {
  propertyTypeId?: Maybe<Scalars['String']>;
  unitLayoutId?: Maybe<Scalars['String']>;
};


export type QueryGetNationalityBiArgs = {
  propertyTypeId?: Maybe<Scalars['String']>;
  unitLayoutId?: Maybe<Scalars['String']>;
};


export type QueryGetAgeBiArgs = {
  propertyTypeId?: Maybe<Scalars['String']>;
  unitLayoutId?: Maybe<Scalars['String']>;
};


export type QueryGetLocationBiArgs = {
  propertyTypeId?: Maybe<Scalars['String']>;
  unitLayoutId?: Maybe<Scalars['String']>;
};


export type QueryGetBookingDetailArgs = {
  sale_id: Scalars['String'];
};


export type QueryGetBookingDetailDataArgs = {
  projectId: Scalars['String'];
  saleId: Scalars['String'];
};


export type QueryGetJointBuyerInfoArgs = {
  contactId: Scalars['String'];
};


export type QueryGetJointBuyerArgs = {
  contactId: Scalars['String'];
};


export type QueryGetUnitDetailsArgs = {
  unitId: Scalars['String'];
};


export type QueryGetPurchaserDetailsArgs = {
  contactId: Scalars['String'];
};


export type QueryGetInvitationTemplateByIdArgs = {
  invitationTemplateId: Scalars['String'];
};


export type QueryGetWhatsAppContentArgs = {
  eLaunchId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetELaunchLeadBatchListArgs = {
  eLaunchId: Scalars['String'];
};


export type QueryExtractImportedLeadToExcelArgs = {
  eLaunchBatchId: Scalars['String'];
};


export type QueryLeadsByBatchArgs = {
  search?: Maybe<Scalars['String']>;
  page: Scalars['Float'];
  limit: Scalars['Float'];
  batch_id: Scalars['String'];
};


export type QueryGetExistingLeadsArgs = {
  limitFilter?: Maybe<Array<Scalars['String']>>;
  salesPersonFilter?: Maybe<Scalars['String']>;
  leadStatusFilter?: Maybe<Scalars['String']>;
  eLaunchId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetLeadByContactIdArgs = {
  contactId: Scalars['String'];
};


export type QueryGetELaunchLeadByBatchIdArgs = {
  search?: Maybe<Scalars['String']>;
  page: Scalars['Float'];
  limit: Scalars['Float'];
  eLaunchBatchId: Scalars['String'];
};


export type QueryGetLeadByELaunchIdArgs = {
  eLaunchId: Scalars['String'];
};


export type QueryGetRegisteredPurchaserListingArgs = {
  search?: Maybe<Scalars['String']>;
  eLaunchId: Scalars['String'];
};


export type QueryGetRegisteredPurchaserDetailsByIdArgs = {
  eLaunchId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryGetELaunchListingArgs = {
  projectId: Scalars['String'];
};


export type QueryGetELaunchByIdArgs = {
  eLaunchId: Scalars['String'];
};


export type QueryIsELaunchCodeExistArgs = {
  eLaunchID?: Maybe<Scalars['String']>;
  code: Scalars['String'];
};


export type QueryGetAllocatedUnitsByELaunchIdArgs = {
  block: Scalars['String'];
  eLaunchId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetELaunchLinkArgs = {
  eLaunchId: Scalars['String'];
};


export type QueryGetELaunchUnitAllocationSummaryArgs = {
  elaunchId: Scalars['String'];
};


export type QueryGetAllocatedUnitsByBlockArgs = {
  elaunchId: Scalars['String'];
  block: Scalars['String'];
};


export type QueryGetFinancierDetailArgs = {
  financier_id: Scalars['String'];
};


export type QueryIsEndFinEmailExistArgs = {
  email: Scalars['String'];
};


export type QueryPanelByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryPanelFinancierListArgs = {
  financier_id?: Maybe<Scalars['String']>;
  project_id: Scalars['String'];
};


export type QueryPanelDetailsArgs = {
  project_id: Scalars['String'];
  financier_id: Scalars['String'];
};


export type QueryGetProjectLetterForDocListingArgs = {
  saleId: Scalars['String'];
};


export type QueryGetMultiELetterBySaleIdArgs = {
  saleId: Scalars['String'];
};


export type QueryGetELetterPdfArgs = {
  saleId: Scalars['String'];
  letterTemplateId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetStatesByCountryArgs = {
  countryId: Scalars['String'];
};


export type QueryGetCitiesByStateArgs = {
  stateId: Scalars['String'];
};


export type QueryGetPostcodeByCityArgs = {
  cityId: Scalars['String'];
};


export type QueryGetDistrictByCityArgs = {
  cityId: Scalars['String'];
};


export type QueryGetSolicitorArgs = {
  accountId: Scalars['String'];
};


export type QueryGetLeadIntegrationByIdArgs = {
  leadIntegrationId: Scalars['String'];
};


export type QueryNotMatchSaleArgs = {
  projectId: Scalars['String'];
};


export type QueryGetStandardLetterArgs = {
  id: Scalars['String'];
};


export type QueryGetLetterTemplateListingArgs = {
  standardLetterId: Scalars['String'];
};


export type QueryGetStandardLetterParametersArgs = {
  standardLetterId: Scalars['String'];
};


export type QueryGetLetterTemplateDetailsArgs = {
  letterTemplateId: Scalars['String'];
};


export type QueryGetLetterPreviewArgs = {
  letterTemplateId: Scalars['String'];
};


export type QueryGetESignLetterTemplateToAssignArgs = {
  projectId: Scalars['String'];
  standardLetterId: Scalars['String'];
};


export type QueryGetLetterTemplateListingByProjectArgs = {
  projectId: Scalars['String'];
  standardLetterId: Scalars['String'];
};


export type QueryGetDirectionByIdArgs = {
  directionId: Scalars['String'];
};


export type QueryGetDiscountByIdArgs = {
  discountId: Scalars['String'];
};


export type QueryGetAssignDiscountFormSourceArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDiscountAssignedByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDiscountAssigmentByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAssignedDiscountByIdArgs = {
  projectId: Scalars['String'];
  discountId: Scalars['String'];
};


export type QueryGetIncomeRangeByIdArgs = {
  incomeRangeId: Scalars['String'];
};


export type QueryGetLeadSourceByIdArgs = {
  sourceId: Scalars['String'];
};


export type QueryGetMaritalStatusByIdArgs = {
  maritalStatusId: Scalars['String'];
};


export type QueryGetNupTypeDetailArgs = {
  nupTypeId: Scalars['String'];
};


export type QueryGetNupReasonDetailArgs = {
  reasonId: Scalars['String'];
};


export type QueryGetAllPackageByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetPackageByIdArgs = {
  packageId: Scalars['String'];
};


export type QueryGetProjectTypeByIdArgs = {
  projectTypeId: Scalars['String'];
};


export type QueryGetPropertyTypeByIdArgs = {
  propertyTypeId: Scalars['String'];
};


export type QueryGetRaceByIdArgs = {
  raceId: Scalars['String'];
};


export type QueryIsIntegratedProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSalesPackagesListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSalesPackageByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetSalutationByIdArgs = {
  salutationId: Scalars['String'];
};


export type QueryGetUnitTypeByIdArgs = {
  unitTypeId: Scalars['String'];
};


export type QueryGetAllNewsAnnouncementArgs = {
  published?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  page: Scalars['Float'];
  limit: Scalars['Float'];
};


export type QueryGetNewsAnnouncementDetailsArgs = {
  newsId: Scalars['String'];
};


export type QueryGetNotificationsArgs = {
  search?: Maybe<Scalars['String']>;
  page: Scalars['Float'];
  limit: Scalars['Float'];
};


export type QueryGetAllOnlineUsersArgs = {
  online?: Maybe<Scalars['Boolean']>;
  search?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
};


export type QueryGetLeadAssigmentByIdArgs = {
  leadAssigmentId: Scalars['String'];
};


export type QueryGetIpay88PaymentDataArgs = {
  payment_id: Scalars['String'];
  sale_id: Scalars['String'];
};


export type QueryGetTransactionStatusByRefNoArgs = {
  ref_no: Scalars['String'];
};


export type QueryRevenueMonsterPaymentUrlArgs = {
  sale_id: Scalars['String'];
};


export type QueryGetPaymentQrCodeUrlArgs = {
  project_id: Scalars['String'];
  sale_id: Scalars['String'];
};


export type QueryGetSalePaymentDataBySaleIdArgs = {
  sale_id: Scalars['String'];
};


export type QueryGetSalePaymentDataByRefNoArgs = {
  ref_no: Scalars['String'];
};


export type QueryGetRevenueMonsterTransactionByRefNoArgs = {
  sale_id: Scalars['String'];
};


export type QueryGetRmAllTransactionsArgs = {
  limit: Scalars['Float'];
};


export type QueryPaymentGatewayDetailsArgs = {
  payment_gateway_id: Scalars['String'];
};


export type QueryGetPlatformUserByIdArgs = {
  userId: Scalars['String'];
};


export type QueryIsPlatformUserEmailExistArgs = {
  userId?: Maybe<Scalars['String']>;
  email: Scalars['String'];
};


export type QueryIsPlatformUserNameExistArgs = {
  userId?: Maybe<Scalars['String']>;
  userName: Scalars['String'];
};


export type QueryGetAssignedAccoutListArgs = {
  userId: Scalars['String'];
};


export type QueryCheckPlatformUserIsAdminArgs = {
  userId: Scalars['String'];
};


export type QueryGetNonAdminAccountListArgs = {
  userId: Scalars['String'];
};


export type QueryViewAppointmentScheduleArgs = {
  projectId: Scalars['String'];
};


export type QueryViewCloseDateByIdArgs = {
  id: Scalars['String'];
};


export type QueryGetProjectByIdArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectDetailArgs = {
  id: Scalars['String'];
};


export type QueryGetGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetVideoGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetGalleryTourByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetProjectGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetBlockGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDistinctBlockByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetFloorGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDistinctFloorByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetUnitGalleryByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDistinctUnitByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetDistinctUnitTypeByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetGalleryByTypeArgs = {
  galleryType: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetProjectSpecByProjectIdArgs = {
  project_id: Scalars['String'];
};


export type QueryGetIntegrationDetailsByProjectIdArgs = {
  projectId: Scalars['String'];
};


export type QueryProjectIntegrationByIdArgs = {
  projectId: Scalars['String'];
};


export type QueryGetOnPremApiVerArgs = {
  ID: Scalars['String'];
};


export type QueryUpdateOnPremApiArgs = {
  ID: Scalars['String'];
};


export type QueryUpdateOnPremApiByVerArgs = {
  updateApiID: Scalars['String'];
  ID: Scalars['String'];
};


export type QueryGetAllReasonCodeArgs = {
  type: Scalars['String'];
};


export type QueryGetReasonCodeByIdArgs = {
  reasonCodeId: Scalars['String'];
};


export type QueryGetSalesDocByIdArgs = {
  salesDocId: Scalars['String'];
};


export type QueryGetSalesDocListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetBrochureListArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAllGatewayUpdatesByTypeArgs = {
  IntType: Scalars['String'];
};


export type QueryGetGatewayUpdatesByIdArgs = {
  ID: Scalars['String'];
};


export type QueryGetListSiteProgressArgs = {
  search?: Maybe<Scalars['String']>;
  page: Scalars['Float'];
  limit: Scalars['Float'];
  project_id: Scalars['String'];
};


export type QueryGetEditSourceArgs = {
  siteProgressId: Scalars['String'];
};


export type QuerySolicitorDetailsArgs = {
  solicitor_appointed_id: Scalars['String'];
};


export type QuerySolicitorProjectListArgs = {
  solicitor_appointed_id: Scalars['String'];
};


export type QueryIsSolicitorExistArgs = {
  solicitor_code?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  solicitor_appointed_id: Scalars['String'];
};


export type QuerySolicitorAppointedListArgs = {
  project_id: Scalars['String'];
};


export type QuerySolicitorListForAssignmentArgs = {
  project_id: Scalars['String'];
};


export type QuerySolicitorAppointedDetailsArgs = {
  solicitor_appointed_id: Scalars['String'];
};


export type QueryGetSalesTeamByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSalesTeamForAllocationArgs = {
  projectId: Scalars['String'];
};


export type QueryGetAssignedTeamMembersArgs = {
  teamId: Scalars['String'];
};


export type QueryGetUnassignedTeamMembersArgs = {
  teamId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetTeamBeenAllocatedWithUnitArgs = {
  teamId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetAllocatedUnitsByTeamArgs = {
  block: Scalars['String'];
  teamId: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetIntegrationParamsArgs = {
  projectID: Scalars['String'];
};


export type QueryGetCompanyListArgs = {
  projectId: Scalars['String'];
  baseUrl: Scalars['String'];
};


export type QueryGetProjectListArgs = {
  ifcaCompanyID: Scalars['String'];
  baseUrl: Scalars['String'];
};


export type QueryGetPhaseListArgs = {
  ifcaProjectID: Scalars['String'];
  baseUrl: Scalars['String'];
};


export type QueryGetPaymentPlanArgs = {
  projectId?: Maybe<Scalars['String']>;
  baseUrl: Scalars['String'];
};


export type QueryGetUnitListArgs = {
  input: AdminUnitIntegrationInput;
};


export type QueryGetUnitLayoutBlockByProjectIdArgs = {
  ProjectId: Scalars['String'];
};


export type QueryGetBlockByProjectArgs = {
  isSubProduct: Scalars['Boolean'];
  projectId: Scalars['String'];
};


export type QueryGetFloorByProjectBlockArgs = {
  isSubProduct: Scalars['Boolean'];
  block: Scalars['String'];
  projectId: Scalars['String'];
};


export type QueryGetUnitByProjectBlockArgs = {
  isSubProduct: Scalars['Boolean'];
  block?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
};


export type QueryExportUnitArgs = {
  isSubProduct?: Maybe<Scalars['Boolean']>;
  project_id: Scalars['String'];
};


export type QueryImportUnitOptionsArgs = {
  isSubProduct: Scalars['Boolean'];
  project_id: Scalars['String'];
};


export type QueryGetActiveBlockByProjectArgs = {
  ProjectId: Scalars['String'];
};


export type QueryGetActiveFloorAndUnitByProjectBlockArgs = {
  Block: Scalars['String'];
  ProjectId: Scalars['String'];
};


export type QueryUpdateSalesChartArgs = {
  models: Array<AdminUnitSalesChartInput>;
};


export type QueryGetSalesChartDataArgs = {
  projectId: Scalars['String'];
};


export type QueryGetSalesChartByBlockArgs = {
  block: Scalars['String'];
  project_id: Scalars['String'];
};


export type QueryGetUnitDetailArgs = {
  unitId: Scalars['String'];
};


export type QueryGetUnitMasterDataArgs = {
  projectId: Scalars['String'];
};


export type QueryGet360TourFormDataByProjectArgs = {
  projectId: Scalars['String'];
};


export type QueryGetUnit360TourByProjectArgs = {
  projectId: Scalars['String'];
};

export type QueryFilterString = {
  __typename?: 'QueryFilterString';
  Column: Scalars['String'];
  Expression: Scalars['String'];
  Value: Scalars['String'];
  ParameterName?: Maybe<Scalars['String']>;
};

export type QueryFilterStringInput = {
  Column: Scalars['String'];
  Expression: Scalars['String'];
  Value: Scalars['String'];
  ParameterName?: Maybe<Scalars['String']>;
};

export type QueryParameter = {
  __typename?: 'QueryParameter';
  Name: Scalars['String'];
  Type?: Maybe<Scalars['String']>;
  ValueType: Scalars['String'];
  Value: Scalars['String'];
};

export type QueryParameterInput = {
  Name: Scalars['String'];
  Type?: Maybe<Scalars['String']>;
  ValueType: Scalars['String'];
  Value: Scalars['String'];
};

export type RaceInput = {
  name: Scalars['String'];
};

export type ReasonCodeInput = {
  name: Scalars['String'];
  type: Scalars['String'];
};

export type RegionInput = {
  name: Scalars['String'];
};

export type RegisteredPurchaserDetailsByIdOutput = {
  __typename?: 'RegisteredPurchaserDetailsByIdOutput';
  purchaserDetail: PurchaserDetailOutput;
  favouriteUnits: Array<Scalars['String']>;
  bookedUnits: Array<PurchaserBookedUnit>;
};

export type ReportParameter = {
  __typename?: 'ReportParameter';
  Name: Scalars['String'];
  Description: Scalars['String'];
  Type: Scalars['String'];
  Visible?: Maybe<Scalars['Boolean']>;
  AllowNull?: Maybe<Scalars['Boolean']>;
  DropDownMember?: Maybe<DropDownMember>;
  MultiValue?: Maybe<Scalars['Boolean']>;
  IsDateRange?: Maybe<Scalars['Boolean']>;
  GlobalType?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
};

export type ReportParameterInput = {
  Name: Scalars['String'];
  Description: Scalars['String'];
  Type: Scalars['String'];
  Visible?: Maybe<Scalars['Boolean']>;
  AllowNull?: Maybe<Scalars['Boolean']>;
  DropDownMember?: Maybe<DropDownMemberInput>;
  MultiValue?: Maybe<Scalars['Boolean']>;
  IsDateRange?: Maybe<Scalars['Boolean']>;
  GlobalType?: Maybe<Scalars['String']>;
  Tag?: Maybe<Scalars['String']>;
};

export type ReportingExcelOutput = {
  __typename?: 'ReportingExcelOutput';
  base64: Scalars['String'];
  projectName: Scalars['String'];
};

export enum RoundingModeInt {
  Down = 'DOWN',
  Up = 'UP',
  Rounding = 'ROUNDING',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export enum RoundingPrecisionInt {
  PointZeroOneCent = 'POINT_ZERO_ONE_CENT',
  ZeroPointOneCent = 'ZERO_POINT_ONE_CENT',
  Dollar = 'DOLLAR',
  DollarTen = 'DOLLAR_TEN',
  DollarHundred = 'DOLLAR_HUNDRED',
  DollarThousand = 'DOLLAR_THOUSAND',
  DollarTenThousand = 'DOLLAR_TEN_THOUSAND',
  DollarHundredThousand = 'DOLLAR_HUNDRED_THOUSAND',
  DollarMillion = 'DOLLAR_MILLION',
  DescriptionList = 'DescriptionList',
  GetDescription = 'GetDescription'
}

export type SGatewayUpdates_A = AuditEntity & {
  __typename?: 'SGatewayUpdates_A';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  IntegrationType?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  md5?: Maybe<Scalars['String']>;
  hasSqlUpdate: Scalars['Boolean'];
  url?: Maybe<Scalars['String']>;
  verifySql?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
  releaseNote?: Maybe<Scalars['String']>;
  commonStatus: CommonStatus;
};

export type SnpSigningReminderInput = {
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  purchaserReceive?: Maybe<Scalars['Boolean']>;
  beforeDay?: Maybe<Scalars['Float']>;
  afterDay?: Maybe<Scalars['Float']>;
};

export type SnpSigningReminderOutput = {
  __typename?: 'SNPSigningReminderOutput';
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  purchaserReceive?: Maybe<Scalars['Boolean']>;
  beforeDay?: Maybe<Scalars['Float']>;
  afterDay?: Maybe<Scalars['Float']>;
};

export type SaleLeadNotificationInput = {
  leadAssignment?: Maybe<Scalars['Boolean']>;
  loanAssignment?: Maybe<LoanAssignmentInput>;
  solicitorCaseAssignment?: Maybe<SolicitorCaseAssignmentInput>;
  bookingCancellation?: Maybe<BookingCancellationNotificationInput>;
  booking?: Maybe<BookingNotificationInput>;
  reservation?: Maybe<BookingNotificationInput>;
  snpSigningReminder?: Maybe<SnpSigningReminderInput>;
  bookingReassignment?: Maybe<Scalars['Boolean']>;
};

export type SaleLeadNotificationOutput = {
  __typename?: 'SaleLeadNotificationOutput';
  leadAssignment?: Maybe<Scalars['Boolean']>;
  loanAssignment?: Maybe<LoanAssignmentOutput>;
  solicitorCaseAssignment?: Maybe<SolicitorCaseAssignmentOutput>;
  bookingCancellation?: Maybe<BookingCancellationNotificationOutput>;
  booking?: Maybe<BookingNotificationOutput>;
  reservation?: Maybe<BookingNotificationOutput>;
  snpSigningReminder?: Maybe<SnpSigningReminderOutput>;
  bookingReassignment?: Maybe<Scalars['Boolean']>;
};

export type SaleLoanNotice = {
  __typename?: 'SaleLoanNotice';
  sale_id: Scalars['String'];
  sale_loan_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_id?: Maybe<Scalars['String']>;
  sale_loan_payment_plan_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_payment_plan_id?: Maybe<Scalars['String']>;
  sale_loan_retention_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_retention_id?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
};

export type SalePaymentConfirmResultOutput = {
  __typename?: 'SalePaymentConfirmResultOutput';
  amount: Scalars['String'];
  refNo?: Maybe<Scalars['String']>;
  companyName: Scalars['String'];
  address: AddressJson;
  officeTel?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  unitNo: Scalars['String'];
  unitId?: Maybe<Scalars['String']>;
  devName: Scalars['String'];
  resultUrl: Scalars['String'];
  paymentId: Scalars['String'];
  refundPolicyConsentRequired?: Maybe<Scalars['String']>;
  paymentGatewayRefundPolicy?: Maybe<Scalars['String']>;
};

export type SalePaymentValueOutput = {
  __typename?: 'SalePaymentValueOutput';
  amount: Scalars['Float'];
  receiptNo: Scalars['String'];
};

export type SaleRebateBillingStageOutput = {
  __typename?: 'SaleRebateBillingStageOutput';
  billId: Scalars['String'];
  paymentEvent: Scalars['String'];
};

export type SaleRebateCampaignOutput = {
  __typename?: 'SaleRebateCampaignOutput';
  campaignId: Scalars['String'];
  campaignName: Scalars['String'];
};

export type SaleRebateDetailsOutput = {
  __typename?: 'SaleRebateDetailsOutput';
  rebateId: Scalars['String'];
  seqNo: Scalars['Float'];
  discountName: Scalars['String'];
  roundingPrecisionId?: Maybe<Scalars['Float']>;
  roundingPrecisionName?: Maybe<Scalars['String']>;
  roundTypeId?: Maybe<Scalars['Float']>;
  roundTypeName?: Maybe<Scalars['String']>;
  computationId?: Maybe<Scalars['Float']>;
  computationBasisName?: Maybe<Scalars['String']>;
  rebateAmt: Scalars['Float'];
  taxAmt?: Maybe<Scalars['Float']>;
  workProgressStage?: Maybe<Scalars['String']>;
  documentAmt?: Maybe<Scalars['Float']>;
  rebateStatus?: Maybe<Scalars['String']>;
  rebateRemarks?: Maybe<Scalars['String']>;
  campaignName?: Maybe<Scalars['String']>;
  campaignID?: Maybe<Scalars['String']>;
  rebateDesc?: Maybe<Scalars['String']>;
};

export type SaleRebateDiscAndTaxAmt = {
  __typename?: 'SaleRebateDiscAndTaxAmt';
  discountAmt: Scalars['Float'];
  taxAmt: Scalars['Float'];
  enableInputTaxAndDiscount: Scalars['Boolean'];
};

export type SaleRebateFormMasterDataOutput = {
  __typename?: 'SaleRebateFormMasterDataOutput';
  nextRebateSeqNo: Scalars['Float'];
  rebateDiscount: Array<DiscountEntity>;
  roundingPrecision: Array<ElementTypeOutput>;
  roudingMode: Array<ElementTypeOutput>;
  computationBasis: Array<ElementTypeOutput>;
  campaigns: Array<SaleRebateCampaignOutput>;
  workProgressStage: Array<SaleRebateWorkProgressStageOutput>;
  billingStage: Array<SaleRebateBillingStageOutput>;
};

export type SaleRebateWorkProgressStageOutput = {
  __typename?: 'SaleRebateWorkProgressStageOutput';
  workProgressStageId: Scalars['String'];
  workProgressStageName: Scalars['String'];
};

export type SaleRegistrationValueOutput = {
  __typename?: 'SaleRegistrationValueOutput';
  fullName?: Maybe<Scalars['String']>;
};

export type SaleTaxOutput = {
  __typename?: 'SaleTaxOutput';
  sale_id: Scalars['String'];
  tax_id: Scalars['String'];
  tax_code?: Maybe<Scalars['String']>;
  tax_desc?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  tax_rate: Scalars['Float'];
};

export type SaleTeamMemberLeadAssignmentOutput = {
  __typename?: 'SaleTeamMemberLeadAssignmentOutput';
  teamId: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  leadCount?: Maybe<Scalars['Float']>;
};

export type SalesAgingDetails = {
  __typename?: 'SalesAgingDetails';
  alertAgingActivated?: Maybe<Scalars['Boolean']>;
  salesAlertAging?: Maybe<SalesAlertAginggOutput>;
};

export type SalesAlertAgingInput = {
  isActive: Scalars['Boolean'];
  maxMinorSalesAlertAging: Scalars['Float'];
  maxMajorSalesAlertAging: Scalars['Float'];
};

export type SalesAlertAgingOutput = {
  __typename?: 'SalesAlertAgingOutput';
  isActive: Scalars['Boolean'];
  maxMinorSalesAlertAging: Scalars['Float'];
  maxMajorSalesAlertAging: Scalars['Float'];
};

export type SalesAlertAginggOutput = {
  __typename?: 'SalesAlertAginggOutput';
  isActive: Scalars['Boolean'];
  maxMinorSalesAlertAging: Scalars['Float'];
  maxMajorSalesAlertAging: Scalars['Float'];
};

export type SalesChartFloorOutput = {
  __typename?: 'SalesChartFloorOutput';
  floor: Scalars['Float'];
  floor_label?: Maybe<Scalars['String']>;
};

export type SalesChartFloorUnitOutput = {
  __typename?: 'SalesChartFloorUnitOutput';
  floors: Array<SalesChartFloorOutput>;
  units: Array<SalesChartUnitOutput>;
};

export type SalesChartOutput = {
  __typename?: 'SalesChartOutput';
  unit_id: Scalars['String'];
  common_status?: Maybe<Scalars['String']>;
  unit_status?: Maybe<Scalars['String']>;
  coordinates?: Maybe<Scalars['String']>;
  unit_type?: Maybe<UnitTypeEntity>;
  price: Scalars['Float'];
  time_lock?: Maybe<Scalars['DateTime']>;
  user_id?: Maybe<Scalars['String']>;
  isBumi: Scalars['Boolean'];
};

export type SalesChartUnitOutput = {
  __typename?: 'SalesChartUnitOutput';
  unit_id: Scalars['String'];
  unit_no: Scalars['String'];
  unit_status: Scalars['String'];
  unit_type?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  floor?: Maybe<Scalars['Float']>;
  floor_label?: Maybe<Scalars['String']>;
  cell: Scalars['Float'];
  status?: Maybe<Scalars['String']>;
  isBumi?: Maybe<Scalars['Boolean']>;
};

export type SalesDocCountByTypeOutput = {
  __typename?: 'SalesDocCountByTypeOutput';
  brochureCount?: Maybe<Scalars['Float']>;
  kitCount?: Maybe<Scalars['Float']>;
  eventCount?: Maybe<Scalars['Float']>;
  otherCount?: Maybe<Scalars['Float']>;
};

export type SalesDocInput = {
  docName: Scalars['String'];
  allowSalesTeam: Scalars['Boolean'];
  allowAgency: Scalars['Boolean'];
  projectId: Scalars['String'];
  type: Scalars['String'];
};

export type SalesDownloadAttachmentInput = {
  attachmentUrl: Scalars['String'];
  attachmentName: Scalars['String'];
};

export type SalesLeadOutput = {
  __typename?: 'SalesLeadOutput';
  total?: Maybe<Scalars['Float']>;
  openTotal?: Maybe<Scalars['Float']>;
  hotTotal?: Maybe<Scalars['Float']>;
  warmTotal?: Maybe<Scalars['Float']>;
  coldTotal?: Maybe<Scalars['Float']>;
  dropTotal?: Maybe<Scalars['Float']>;
  waitingListTotal?: Maybe<Scalars['Float']>;
  soldTotal?: Maybe<Scalars['Float']>;
  signTotal?: Maybe<Scalars['Float']>;
  data?: Maybe<Array<LeadDataOutput>>;
  showSaleStaff?: Maybe<Scalars['Boolean']>;
  reservedTotal?: Maybe<Scalars['Float']>;
  salesAgingDetails?: Maybe<SalesAgingDetails>;
};

export enum SalesPermission {
  ProjectSalesLeadRead = 'PROJECT_SALES_LEAD____READ',
  ProjectSalesLeadAssign = 'PROJECT_SALES_LEAD____ASSIGN',
  ProjectWaitingListRead = 'PROJECT_WAITING_LIST____READ',
  ProjectWaitingListMoveToTop = 'PROJECT_WAITING_LIST____MOVE_TO_TOP',
  ProjectWaitingListLeaveQueue = 'PROJECT_WAITING_LIST____LEAVE_QUEUE',
  ProjectBookingListRead = 'PROJECT_BOOKING_LIST____READ',
  ProjectBookingListAllowBook = 'PROJECT_BOOKING_LIST____ALLOW_BOOK',
  ProjectBookingListCancel = 'PROJECT_BOOKING_LIST____CANCEL',
  ProjectBookingListOnline = 'PROJECT_BOOKING_LIST____ONLINE',
  ProjectBookingListEditDiscount = 'PROJECT_BOOKING_LIST____EDIT_DISCOUNT',
  ProjectBookingListEditSalesPackages = 'PROJECT_BOOKING_LIST____EDIT_SALES_PACKAGES',
  ProjectBookingListEditSalesRebates = 'PROJECT_BOOKING_LIST____EDIT_SALES_REBATES',
  ProjectLoanRead = 'PROJECT_LOAN____READ',
  ProjectReadAll = 'PROJECT_______READ_ALL',
  ProjectReadTeam = 'PROJECT_______READ_TEAM',
  ProjectReadSelf = 'PROJECT_______READ_SELF',
  ProjectReadInternalAndAgencyTeam = 'PROJECT_______READ_INTERNAL_AND_AGENCY_TEAM',
  ProjectAppointedAgencyRead = 'PROJECT_APPOINTED_AGENCY____READ',
  ProjectBusinessInsightsRead = 'PROJECT_BUSINESS_INSIGHTS____READ',
  ProjectBusinessInsightsSalesPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_PERFORMANCE_READ',
  ProjectBusinessInsightsSalesTeamPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_TEAM_PERFORMANCE_READ',
  ProjectBusinessInsightsPurchaserDemographicRead = 'PROJECT_BUSINESS_INSIGHTS_PURCHASER_DEMOGRAPHIC_READ',
  ProjectBusinessInsightsCampaignPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_CAMPAIGN_PERFORMANCE_READ',
  ProjectBusinessInsightsLeadDemographicRead = 'PROJECT_BUSINESS_INSIGHTS_LEAD_DEMOGRAPHIC_READ',
  ProjectBusinessInsightsSalesLeadPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_LEAD_PERFORMANCE_READ',
  ProjectBusinessInsightsSalesLeadTeamPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_LEAD_TEAM_PERFORMANCE_READ',
  ProjectBusinessInsightsLeadSourceRead = 'PROJECT_BUSINESS_INSIGHTS_LEAD_SOURCE_READ',
  ProjectBusinessInsightsBookingListRead = 'PROJECT_BUSINESS_INSIGHTS_BOOKING_LIST_READ',
  ProjectBusinessInsightsWaitingListRead = 'PROJECT_BUSINESS_INSIGHTS_WAITING_LIST_READ',
  ProjectBusinessInsightsLoanRead = 'PROJECT_BUSINESS_INSIGHTS_LOAN_READ',
  ProjectBusinessInsightsSalesMovementRead = 'PROJECT_BUSINESS_INSIGHTS_SALES_MOVEMENT_READ',
  ProjectBusinessInsightsPaymentSourceRead = 'PROJECT_BUSINESS_INSIGHTS_PAYMENT_SOURCE_READ',
  ProjectBusinessInsightsBookingListAnalysisRead = 'PROJECT_BUSINESS_INSIGHTS_BOOKING_LIST_ANALYSIS_READ',
  ProjectBusinessInsightsELaunchPerformanceRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_PERFORMANCE_READ',
  ProjectBusinessInsightsELaunchPurchaserDemographicRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_PURCHASER_DEMOGRAPHIC_READ',
  ProjectBusinessInsightsELaunchBookingTimeTakenRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_BOOKING_TIME_TAKEN_READ',
  ProjectBusinessInsightsELaunchMostFavouriteRead = 'PROJECT_BUSINESS_INSIGHTS_E_LAUNCH_MOST_FAVOURITE_READ',
  ProjectBusinessActiveSalesPerformanceRead = 'PROJECT_BUSINESS_ACTIVE_SALES_PERFORMANCE_READ',
  ProjectDigitalDocumentsPurchaserBooking = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_BOOKING',
  ProjectDigitalDocumentsPurchaserLoan = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_LOAN',
  ProjectDigitalDocumentsPurchaserSales = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_SALES',
  ProjectNotificationBookingListAllowBook = 'PROJECT_NOTIFICATION_BOOKING_LIST_ALLOW_BOOK',
  ProjectNotificationBookingListBookingFee = 'PROJECT_NOTIFICATION_BOOKING_LIST_BOOKING_FEE',
  ProjectNotificationBookingListSpaReminder = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_REMINDER',
  ProjectNotificationBookingListCancel = 'PROJECT_NOTIFICATION_BOOKING_LIST_CANCEL',
  ProjectNotificationBookingListSpaSign = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_SIGN',
  ProjectNotificationBookingListSpaStamped = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_STAMPED',
  ProjectNotificationBookingListSpaCollected = 'PROJECT_NOTIFICATION_BOOKING_LIST_SPA_COLLECTED',
  ProjectNotificationSalesLeadAssignProejct = 'PROJECT_NOTIFICATION_SALES_LEAD_ASSIGN_PROEJCT',
  ProjectNotificationSalesLeadAssign = 'PROJECT_NOTIFICATION_SALES_LEAD_ASSIGN',
  ProjectNotificationSalesLeadReassign = 'PROJECT_NOTIFICATION_SALES_LEAD_REASSIGN',
  ProjectNotificationSalesLeadDrop = 'PROJECT_NOTIFICATION_SALES_LEAD_DROP',
  ProjectNotificationSalesLeadUnattended = 'PROJECT_NOTIFICATION_SALES_LEAD_UNATTENDED',
  ProjectNotificationSalesLeadAging = 'PROJECT_NOTIFICATION_SALES_LEAD_AGING',
  ProjectNotificationWaitingListLeadJoint = 'PROJECT_NOTIFICATION_WAITING_LIST_LEAD_JOINT',
  ProjectNotificationWaitingListAvailable = 'PROJECT_NOTIFICATION_WAITING_LIST_AVAILABLE',
  ProjectNotificationWaitingListUnavailable = 'PROJECT_NOTIFICATION_WAITING_LIST_UNAVAILABLE',
  ProjectNotificationWaitingListLeadLeaveQueue = 'PROJECT_NOTIFICATION_WAITING_LIST_LEAD_LEAVE_QUEUE',
  ProjectNotificationWaitingListMoveToTop = 'PROJECT_NOTIFICATION_WAITING_LIST_MOVE_TO_TOP',
  ProjectNotificationCollaborativeAgecny = 'PROJECT_NOTIFICATION_COLLABORATIVE_AGECNY',
  ProjectNotificationCollaborativeEndFinancier = 'PROJECT_NOTIFICATION_COLLABORATIVE_END_FINANCIER',
  ProjectNotificationCollaborativeSolicitor = 'PROJECT_NOTIFICATION_COLLABORATIVE_SOLICITOR',
  ProjectNotificationLoanAssign = 'PROJECT_NOTIFICATION_LOAN_ASSIGN',
  ProjectNotificationLoanIssued = 'PROJECT_NOTIFICATION_LOAN_ISSUED',
  ProjectNotificationLoanAccepted = 'PROJECT_NOTIFICATION_LOAN_ACCEPTED',
  ProjectNotificationLoanWithdrawal = 'PROJECT_NOTIFICATION_LOAN_WITHDRAWAL',
  ProjectDigitalDocumentsPurchaserBookingCreate = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_BOOKING_CREATE',
  ProjectDigitalDocumentsPurchaserBookingDelete = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_BOOKING_DELETE',
  ProjectDigitalDocumentsPurchaserLoanCreate = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_LOAN_CREATE',
  ProjectDigitalDocumentsPurchaserLoanDelete = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_LOAN_DELETE',
  ProjectDigitalDocumentsPurchaserSalesCreate = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_SALES_CREATE',
  ProjectDigitalDocumentsPurchaserSalesDelete = 'PROJECT_DIGITAL_DOCUMENTS_PURCHASER_SALES_DELETE',
  ProjectSolicitorAssignmentRead = 'PROJECT_SOLICITOR_ASSIGNMENT____READ',
  ProjectSolicitorAssignmentReassignment = 'PROJECT_SOLICITOR_ASSIGNMENT_REASSIGNMENT',
  ProjectSolicitorSpaSign = 'PROJECT_SOLICITOR_SPA_SIGN',
  AdminProjectProjectDetailsRead = 'ADMIN_PROJECT_PROJECT_DETAILS_READ',
  AdminProjectGalleryRead = 'ADMIN_PROJECT_GALLERY_READ',
  AdminProjectUnitSetupRead = 'ADMIN_PROJECT_UNIT_SETUP_READ',
  AdminProjectCarParkSetupRead = 'ADMIN_PROJECT_CAR_PARK_SETUP_READ',
  AdminProjectLayoutImagesRead = 'ADMIN_PROJECT_LAYOUT_IMAGES_READ',
  AdminProjectSalesChartSetupRead = 'ADMIN_PROJECT_SALES_CHART_SETUP_READ',
  AdminProjectSalesDocumentsRead = 'ADMIN_PROJECT_SALES_DOCUMENTS_READ',
  AdminProjectUnitAllocationRead = 'ADMIN_PROJECT_UNIT_ALLOCATION_READ',
  AdminProjectSiteProgressRead = 'ADMIN_PROJECT_SITE_PROGRESS_READ',
  AdminProjectRoleAuthorizationRead = 'ADMIN_PROJECT_ROLE_AUTHORIZATION_READ',
  AdminProjectStandardLetterRead = 'ADMIN_PROJECT_STANDARD_LETTER_READ',
  AdminProjectTeamAssignmentRead = 'ADMIN_PROJECT_TEAM_ASSIGNMENT_READ',
  AdminProjectSalesPackagesRead = 'ADMIN_PROJECT_SALES_PACKAGES_READ',
  AdminProjectDiscountRead = 'ADMIN_PROJECT_DISCOUNT_READ',
  AdminProjectPanelEndFinancierRead = 'ADMIN_PROJECT_PANEL_END_FINANCIER_READ',
  AdminProjectPanelSolicitorRead = 'ADMIN_PROJECT_PANEL_SOLICITOR_READ',
  AdminProjectPolicySettingRead = 'ADMIN_PROJECT_POLICY_SETTING_READ',
  AdminRead = 'ADMIN__READ',
  WorkdeskProjectWorkdeskAppointmentAppointmentAdd = 'WORKDESK_PROJECT_WORKDESK_APPOINTMENT_APPOINTMENT_ADD',
  ProjectNotificationLoanAmountUpdate = 'PROJECT_NOTIFICATION_LOAN_AMOUNT_UPDATE',
  AdminProjectEmailLetterRead = 'ADMIN_PROJECT_EMAIL_LETTER_READ',
  ProjectBookingListEditPurchaserAndJointBuyer = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER',
  ProjectBookingListEditPurchaserAndJointBuyerSequence = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_SEQUENCE',
  ProjectBookingListEditSalesTeamAndSalesPersonnel = 'PROJECT_BOOKING_LIST____EDIT_SALES_TEAM_AND_SALES_PERSONNEL',
  ProjectBookingListEditPurchaserAndJointBuyerNameAndIc = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_NAME_AND_IC',
  ProjectBookingListEditPurchaserAndJointBuyerCompanyRegNo = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_COMPANY_REG_NO',
  ProjectBookingListEditPurchaserAndJointBuyerIdType = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_ID_TYPE',
  ProjectBookingListEditPurchaserAndJointBuyerTinNoAndSstRegNo = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_TIN_NO_AND_SST_REG_NO',
  ProjectBookingListEditPurchaserAndJointBuyerNationality = 'PROJECT_BOOKING_LIST____EDIT_PURCHASER_AND_JOINT_BUYER_NATIONALITY'
}

export type SalesStatutoryDocumentEntity = {
  __typename?: 'SalesStatutoryDocumentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId?: Maybe<Scalars['String']>;
  contactId?: Maybe<Scalars['String']>;
  unitStatutoryId: Scalars['String'];
  statutoryDocumentId: Scalars['String'];
  newSalesStatutoryDocumentId: Scalars['String'];
  notaryId: Scalars['String'];
  bpnLandArea: Scalars['Float'];
  documentDate: Scalars['DateTime'];
  documentRef: Scalars['String'];
  attachment?: Maybe<Scalars['String']>;
  isMerge: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  sales: Array<SaleEntity>;
  statutoryDocument: Array<StatutoryDocumentEntity>;
};

export type SalesTeamOutput = {
  __typename?: 'SalesTeamOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  users: Array<SalesTeamUserOuput>;
  commonStatus?: Maybe<Scalars['String']>;
};

export type SalesTeamUserInfoOuput = {
  __typename?: 'SalesTeamUserInfoOuput';
  ID: Scalars['String'];
  name: Scalars['String'];
  contactNo: Scalars['String'];
  email: Scalars['String'];
};

export type SalesTeamUserOuput = {
  __typename?: 'SalesTeamUserOuput';
  id: Scalars['String'];
  name: Scalars['String'];
  teamId: Scalars['String'];
  leadCount?: Maybe<Scalars['Float']>;
};

export type SalutationInput = {
  name: Scalars['String'];
};

export type ShareInput = {
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['String'];
  sharedMethod?: Maybe<Scalars['String']>;
};

export type SolicitorAlertAgingInput = {
  isActive: Scalars['Boolean'];
  maxMinorSolicitorAlertAging: Scalars['Float'];
  maxMajorSolicitorAlertAging: Scalars['Float'];
};

export type SolicitorAlertAgingOutput = {
  __typename?: 'SolicitorAlertAgingOutput';
  isActive: Scalars['Boolean'];
  maxMinorSolicitorAlertAging: Scalars['Float'];
  maxMajorSolicitorAlertAging: Scalars['Float'];
};

export type SolicitorLeadNotificationInput = {
  leadAssignment?: Maybe<Scalars['Boolean']>;
};

export type SolicitorLeadNotificationOutput = {
  __typename?: 'SolicitorLeadNotificationOutput';
  leadAssignment?: Maybe<Scalars['Boolean']>;
};

export type StandardAuditEntity = {
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
};

export type StandardCoreBaseEntity = AuditEntity & {
  __typename?: 'StandardCoreBaseEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
};

export type StateMasterDataOutput = {
  __typename?: 'StateMasterDataOutput';
  ID: Scalars['String'];
  name: Scalars['String'];
  countryID: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type StaticData = {
  __typename?: 'StaticData';
  Value: Scalars['String'];
  Desc: Scalars['String'];
};

export type StaticDataInput = {
  Value: Scalars['String'];
  Desc: Scalars['String'];
};

export type SubdistrictMasterDataOutput = {
  __typename?: 'SubdistrictMasterDataOutput';
  ID: Scalars['String'];
  name: Scalars['String'];
  districID: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type TeamInput = {
  name: Scalars['String'];
  projectId: Scalars['String'];
};

export type TotpSecretTyes = {
  __typename?: 'TotpSecretTyes';
  is2FA?: Maybe<Scalars['Boolean']>;
  totpSecret?: Maybe<Scalars['String']>;
  dataURL?: Maybe<Scalars['String']>;
  otpURL?: Maybe<Scalars['String']>;
};

export type TransactionStatusOutput = {
  __typename?: 'TransactionStatusOutput';
  refNo: Scalars['String'];
  status: Scalars['String'];
};

export type Unit = {
  unitId: Scalars['String'];
  unitNo: Scalars['String'];
  carPark: Array<CarPark>;
};

export type UnitAllocationSummary = {
  __typename?: 'UnitAllocationSummary';
  block: Scalars['String'];
  count: Scalars['Float'];
  unitType: Scalars['String'];
  favouriteCount: Scalars['Float'];
  bookedCount: Scalars['Float'];
};

export type UnitExcelOutput = {
  __typename?: 'UnitExcelOutput';
  base64: Scalars['String'];
  projectname: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
};

export type UnitExcelReturnOutput = {
  __typename?: 'UnitExcelReturnOutput';
  message: Scalars['String'];
  file_name: Scalars['String'];
  file?: Maybe<Scalars['String']>;
  isSubProduct?: Maybe<Scalars['Boolean']>;
};

export type UnitGalleryOutput = {
  __typename?: 'UnitGalleryOutput';
  resourceid: Scalars['String'];
  url: Scalars['String'];
  pictureid: Scalars['String'];
  seqno: Scalars['Float'];
  caption?: Maybe<Scalars['String']>;
  virtualModelLink?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  unit_layout_id?: Maybe<Scalars['String']>;
  unit_type_id?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  unit_type_desc?: Maybe<Scalars['String']>;
  no_of_bedroom?: Maybe<Scalars['Float']>;
  no_of_bathroom?: Maybe<Scalars['Float']>;
};

export type UnitImportCountOutput = {
  __typename?: 'UnitImportCountOutput';
  unitIds: Array<Scalars['String']>;
  leadCount: Scalars['Float'];
  agencyUnitCount: Scalars['Float'];
  salesCount: Scalars['Float'];
  bookingCount: Scalars['Float'];
  assignCarparkCount: Scalars['Float'];
  saleSubproductCount: Scalars['Float'];
  architectCertCount: Scalars['Float'];
  elaunchCount: Scalars['Float'];
  priceAdjustmentCount: Scalars['Float'];
  projectTitleCount: Scalars['Float'];
  bridgingFinancierCount: Scalars['Float'];
  unitIntegrationCount: Scalars['Float'];
  elaunchFavouriteCount: Scalars['Float'];
  saleChartCount: Scalars['Float'];
  saleTeamAllocationCount: Scalars['Float'];
};

export type UnitImportOptionOutput = {
  __typename?: 'UnitImportOptionOutput';
  displayImportMethods: Scalars['Boolean'];
  overwrite: Scalars['Boolean'];
  append: Scalars['Boolean'];
  integrated: Scalars['Boolean'];
  modify: Scalars['Boolean'];
  emptyProject: Scalars['Boolean'];
  unitIds: Array<Scalars['String']>;
};

export type UnitLayoutBlockOutput = {
  __typename?: 'UnitLayoutBlockOutput';
  unitLayoutId?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  unit_type_desc?: Maybe<Scalars['String']>;
  unit_type_id?: Maybe<Scalars['String']>;
};

export type UnitLayoutOutput = {
  __typename?: 'UnitLayoutOutput';
  unitLayoutId?: Maybe<Scalars['String']>;
  unitLayoutName?: Maybe<Scalars['String']>;
};

export type UnitMortgageOutput = {
  __typename?: 'UnitMortgageOutput';
  unitId: Scalars['String'];
  unitPrice: Scalars['Float'];
  unitNo: Scalars['String'];
  financierList?: Maybe<Array<FinancierUnitMortgage>>;
};

export type UnitTourOutput = {
  __typename?: 'UnitTourOutput';
  id: Scalars['String'];
  virtualModelLink: Scalars['String'];
  block: Scalars['String'];
  unitLayoutId?: Maybe<Scalars['String']>;
  unitTypeId?: Maybe<Scalars['String']>;
};

export type UnitTypeInput = {
  name: Scalars['String'];
};

export type UnitTypeLinkOutput = {
  __typename?: 'UnitTypeLinkOutput';
  unitTypeId?: Maybe<Scalars['String']>;
  unitTypeName?: Maybe<Scalars['String']>;
};

export type UpdateApiModel = {
  __typename?: 'UpdateApiModel';
  id?: Maybe<Scalars['String']>;
  UpdateApiUrl?: Maybe<Scalars['String']>;
  IntegrationType?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['String']>;
  zipUrl?: Maybe<Scalars['String']>;
  hasSqlUpdate?: Maybe<Scalars['Boolean']>;
  md5?: Maybe<Scalars['String']>;
  verifySql?: Maybe<Scalars['String']>;
  sql?: Maybe<Scalars['String']>;
};

export type UpdateAuditInput = {
  modBy?: Maybe<Scalars['String']>;
};

export type UpdatePlatformUserProfileInput = {
  name: Scalars['String'];
  contactNo: Scalars['String'];
  avatar?: Maybe<Scalars['Upload']>;
};


export type UserEntity = {
  __typename?: 'UserEntity';
  ID: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  contactNo: Scalars['String'];
  is2FA?: Maybe<Scalars['Boolean']>;
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  superUser: Scalars['Boolean'];
  accountID: Scalars['String'];
  softwareCode: Scalars['String'];
  loginAttempt: Scalars['Float'];
  blockDuration: Scalars['Float'];
  blockCount: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  deviceIP?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  userFeaturePermission: UserFeaturePermissionEntity;
  isActivated: Scalars['Boolean'];
  isSuspendible: Scalars['Boolean'];
};

export type UserInput = {
  ID?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  contactNo: Scalars['String'];
  email: Scalars['String'];
  hashed?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  superUser?: Maybe<Scalars['Boolean']>;
  department?: Maybe<Scalars['String']>;
  address?: Maybe<AddressInput>;
  commonStatus?: Maybe<CommonStatus>;
};

export type UserOutput = {
  __typename?: 'UserOutput';
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
};

export type UserResponse = AuditEntity & {
  __typename?: 'UserResponse';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  ID: Scalars['String'];
  name: Scalars['String'];
  userName: Scalars['String'];
  email: Scalars['String'];
  contactNo: Scalars['String'];
  confirmed: Scalars['Boolean'];
  superUser: Scalars['Boolean'];
  accountID: Scalars['String'];
  commonStatus: CommonStatus;
  password?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  deviceIP?: Maybe<Scalars['String']>;
  loginTs?: Maybe<Scalars['DateTime']>;
  blockDuration?: Maybe<Scalars['Float']>;
  blockCount?: Maybe<Scalars['Float']>;
  loginAttempt?: Maybe<Scalars['Float']>;
  is2FA?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Address>;
  errors?: Maybe<Array<FieldError>>;
};

export type UserRoleAssignmentInput = {
  roleId: Scalars['String'];
  userIds: Array<Scalars['String']>;
};

export type WithdrawnLoanStatusOutput = {
  __typename?: 'WithdrawnLoanStatusOutput';
  count: Scalars['Float'];
  developerCancelledCount: Scalars['Float'];
  customerRejectedCount: Scalars['Float'];
  loanRejectedCount: Scalars['Float'];
  customerCancelledCount: Scalars['Float'];
};

export type AccountSpecEntity = {
  __typename?: 'accountSpecEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  loanPlusProjectId?: Maybe<Scalars['Float']>;
  loanPlusInfo: Scalars['JSONObject'];
  accountCode?: Maybe<Scalars['String']>;
  integrationAutoCapitalize: Scalars['Boolean'];
  leadAssignmentActivated: Scalars['Boolean'];
  purchaserAccountRef?: Maybe<PurchaserAccountReferenceEntity>;
  projectIntegration?: Maybe<Array<ProjectIntegrationEntity>>;
  smptInfo?: Maybe<SmtpInfoOutput>;
  purchaserAppCss?: Maybe<PurchaserAppCssOutput>;
};

export type AccountsNameModel = {
  __typename?: 'accountsNameModel';
  accountId: Scalars['String'];
  count: Scalars['Float'];
};

export type AddBlockDateInput = {
  appointmentScheduleId: Scalars['String'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  startTime: Scalars['String'];
  endTime: Scalars['String'];
};

export type AddressPaymentReminder = {
  __typename?: 'addressPaymentReminder';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
};

export type AgencyAppointedCount = {
  __typename?: 'agencyAppointedCount';
  totalAppointed?: Maybe<Scalars['Float']>;
  lastAppointedDate?: Maybe<Scalars['DateTime']>;
};

export type AgencyAppointedEntity = AuditEntity & {
  __typename?: 'agencyAppointedEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  agencyId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  email: Scalars['String'];
  officeTel: Scalars['String'];
  address: AddressJson;
  contactName: Scalars['String'];
  contactPhoneNo: Scalars['String'];
  contactEmail: Scalars['String'];
  invitationLink: Scalars['String'];
  agentNegotiator: Scalars['Boolean'];
  logoUrl?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  sales?: Maybe<Array<SaleEntity>>;
  agencyUnitCounts?: Maybe<AgentUnitCounts>;
  pictureBlockUrl?: Maybe<Scalars['String']>;
  agencyContractProjectCount?: Maybe<Scalars['Float']>;
};


export type AgencyAppointedEntityAgencyUnitCountsArgs = {
  projectId: Scalars['String'];
};


export type AgencyAppointedEntityPictureBlockUrlArgs = {
  block: Scalars['String'];
};

export type AgencyContactEntity = AuditEntity & {
  __typename?: 'agencyContactEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  userId: Scalars['String'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  user: AgencyUserEntity;
  agencyUserRole: AgencyUserRoleEntity;
  agencyAppointed: AgencyAppointedEntity;
  languageSet: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  reportingTo?: Maybe<Scalars['String']>;
  reportingToUserId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  isSuspendible: Scalars['Boolean'];
  isDeletable: Scalars['Boolean'];
  selectedLanguageDesc: Scalars['String'];
};

export type AgencyContractEntity = AuditEntity & {
  __typename?: 'agencyContractEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  agencyId: Scalars['String'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  allowUpdateLoanStatus: Scalars['Boolean'];
  allowWaitinglist: Scalars['Boolean'];
  isExpired: Scalars['Boolean'];
  allocatedUnitId: Array<Scalars['String']>;
  commonStatus: Scalars['String'];
  agency: AgencyEntity;
  project: ProjectEntity;
  attachment?: Maybe<Array<AttachmentEntity>>;
};

export type AgencyEntity = AuditEntity & {
  __typename?: 'agencyEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type AgencyNotificationEntity = {
  __typename?: 'agencyNotificationEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  permissionId: Scalars['Float'];
  subject: Scalars['String'];
  body: Scalars['String'];
  agencyNotificationRecipient: Array<AgencyNotificationRecipientEntity>;
};

export type AgencyNotificationPolicyEntity = {
  __typename?: 'agencyNotificationPolicyEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  userId: Scalars['String'];
  permissionId: Scalars['Float'];
  notificationDuration: Scalars['Float'];
};

export type AgencyNotificationRecipientEntity = AuditEntity & {
  __typename?: 'agencyNotificationRecipientEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  notificationId: Scalars['String'];
  recipientId: Scalars['String'];
  isRead: Scalars['Boolean'];
  agencyNotification: AgencyNotificationEntity;
};

export type AgencySalesChartOutput = {
  __typename?: 'agencySalesChartOutput';
  unit_id: Scalars['String'];
  unit_status: Scalars['String'];
  status?: Maybe<Scalars['String']>;
  unit_type: Scalars['String'];
  unit_no: Scalars['String'];
  coordinates: Scalars['String'];
  price: Scalars['Float'];
};

export type AgencyUnitAllocationEntity = AuditEntity & {
  __typename?: 'agencyUnitAllocationEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  agencyId: Scalars['String'];
  projectId: Scalars['String'];
  unitId: Scalars['String'];
  agency: AgencyEntity;
  project: ProjectEntity;
  unit: UnitEntity;
};

export type AgencyUserEntity = AuditEntity & {
  __typename?: 'agencyUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loginId: Scalars['String'];
  passwordHash?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  forgotPasswordLink?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type AgencyUserRoleEntity = AuditEntity & {
  __typename?: 'agencyUserRoleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  agencyId: Scalars['String'];
  userId: Scalars['String'];
  reportPersonId?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  commonStatus: Scalars['String'];
  agency: AgencyEntity;
  reportPerson: AgencyUserEntity;
  user: AgencyUserEntity;
};

export type AgentPermissionEntity = AuditEntity & {
  __typename?: 'agentPermissionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  agencyId: Scalars['String'];
  agencyUserId: Scalars['String'];
  projectId: Scalars['String'];
  allowBook: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  agency: AgencyEntity;
  agencyUser: AgencyUserEntity;
  project: ProjectEntity;
  agencyContact?: Maybe<AgencyContactEntity>;
};

export type AgentUnitCounts = {
  __typename?: 'agentUnitCounts';
  allocatedunit?: Maybe<Scalars['Float']>;
  bookedunit?: Maybe<Scalars['Float']>;
  spasignedunit?: Maybe<Scalars['Float']>;
};

export type AllocationEntity = {
  __typename?: 'allocationEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  debitRefTable: Scalars['String'];
  debitId: Scalars['String'];
  creditRefTable: Scalars['String'];
  creditId: Scalars['String'];
  allocateAmount: Scalars['Float'];
  financialBillingId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  createdTs: Scalars['DateTime'];
  creditNote?: Maybe<CreditNoteEntity>;
  receipt?: Maybe<ReceiptEntity>;
  rebate?: Maybe<RebateEntity>;
  project: ProjectEntity;
  progressBilling?: Maybe<ProgressBillingEntity>;
  miscBilling?: Maybe<MiscBillingEntity>;
  debitNote?: Maybe<DebitNoteEntity>;
  refund?: Maybe<RefundEntity>;
  contra?: Maybe<ContraEntity>;
  interest?: Maybe<LateInterestDetailEntity>;
  allowReversal: Scalars['Boolean'];
  documentNo?: Maybe<Scalars['String']>;
  allocationDate?: Maybe<Scalars['DateTime']>;
  originalId?: Maybe<Scalars['String']>;
  allocateBaseAmount: Scalars['Float'];
  allocateVatAmount: Scalars['Float'];
  allocateLuxAmount: Scalars['Float'];
  allocateWthAmount: Scalars['Float'];
  allocateVatRate: Scalars['Float'];
  allocateLuxRate: Scalars['Float'];
  allocateWthRate: Scalars['Float'];
};

export type AppointmentSchduleInput = {
  appointmentSchedulingId: Scalars['String'];
};

export type AppointmentSchedulingEntity = {
  __typename?: 'appointmentSchedulingEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  startTime: Scalars['String'];
  endTime: Scalars['String'];
  participantLimit: Scalars['Float'];
  salesGalleryCloseDate: Array<SalesGalleryCloseDateEntity>;
};

export type ApprovalPolicyAssignmentEntity = {
  __typename?: 'approvalPolicyAssignmentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  entityId: Scalars['String'];
  category: Scalars['String'];
  approvalList: Array<ApprovalListJson>;
  lowerLimit?: Maybe<Scalars['Float']>;
  upperLimit?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
};

export type ApprovalPolicyEntity = {
  __typename?: 'approvalPolicyEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  category: Scalars['String'];
  approvalList: Array<ApprovalListJson>;
  lowerLimit?: Maybe<Scalars['Float']>;
  upperLimit?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
};

export type ArchitectCertEntity = {
  __typename?: 'architectCertEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  certificateDate: Scalars['DateTime'];
  certificateNo: Scalars['String'];
  commonStatus: Scalars['String'];
  architectCertWorkProgress?: Maybe<Array<ArchitectCertWorkProgressEntity>>;
  architectCertUnit?: Maybe<Array<ArchitectCertUnitEntity>>;
};

export type ArchitectCertUnitEntity = {
  __typename?: 'architectCertUnitEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  architectCertId: Scalars['String'];
  unitId: Scalars['String'];
  status: Scalars['String'];
  commonStatus: Scalars['String'];
  architectCert: ArchitectCertEntity;
  units?: Maybe<UnitEntity>;
};

export type ArchitectCertWorkProgressEntity = {
  __typename?: 'architectCertWorkProgressEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  architectCertId: Scalars['String'];
  workProgressId: Scalars['String'];
  commonStatus: Scalars['String'];
  architectCerts: ArchitectCertEntity;
  progress: Array<WorkProgressEntity>;
  paymentPlanDetail?: Maybe<Array<PaymentPlanDetailEntity>>;
};

export type AreaVarianceEntity = {
  __typename?: 'areaVarianceEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  builtUp: Scalars['Float'];
  actualBuiltUp: Scalars['Float'];
  landArea: Scalars['Float'];
  actualLandArea: Scalars['Float'];
  formula: Scalars['String'];
  compensateAmount: Scalars['Float'];
  documentNo?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  refId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  sales?: Maybe<SaleEntity>;
};

export type AssignCarkParkInput = {
  variable: Array<Unit>;
  projectId: Scalars['String'];
};

export type AssignDiscountInput = {
  discountId: Scalars['String'];
  projectId: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  expired_date: Scalars['DateTime'];
};

export type AttachmentEmateraiEntity = AuditEntity & {
  __typename?: 'attachmentEmateraiEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  refTable: Scalars['String'];
  refType: Scalars['String'];
  refId: Scalars['String'];
  docNo?: Maybe<Scalars['String']>;
  docAmt?: Maybe<Scalars['Float']>;
  mediaType: Scalars['String'];
  resourceUrl: Scalars['String'];
  fileName: Scalars['String'];
  bucketFileName: Scalars['String'];
  fileNameSign?: Maybe<Scalars['String']>;
  fileToken?: Maybe<Scalars['String']>;
  fileSerialNumber?: Maybe<Scalars['String']>;
  fileStatus?: Maybe<Scalars['String']>;
  isPrivate: Scalars['Boolean'];
  seqNo: Scalars['Float'];
  softwareCode: Scalars['String'];
  resourceUrlSigned: Scalars['String'];
};

export type AttachmentEntity = AuditEntity & {
  __typename?: 'attachmentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  refTable: Scalars['String'];
  refType: Scalars['String'];
  refId: Scalars['String'];
  mediaType: Scalars['String'];
  resourceUrl: Scalars['String'];
  fileName: Scalars['String'];
  bucketFileName: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  seqNo: Scalars['Float'];
  softwareCode: Scalars['String'];
  allowDelete?: Maybe<Scalars['Boolean']>;
};

export type AutoReleaseNotificationReminderInput = {
  reminderDay?: Maybe<Scalars['Float']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
};

export type AutoReleaseNotificationReminderOutput = {
  __typename?: 'autoReleaseNotificationReminderOutput';
  reminderDay?: Maybe<Scalars['Float']>;
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
};

export type BankEntity = {
  __typename?: 'bankEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  financier: Array<FinancierEntity>;
};

export type BillItemEntity = {
  __typename?: 'billItemEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  billItemType: Scalars['String'];
  systemUse: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  msicId?: Maybe<Scalars['String']>;
  classificationId?: Maybe<Scalars['String']>;
};

export type BillItemIntEntity = {
  __typename?: 'billItemIntEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  billItemType: Scalars['String'];
  latePaymentInterest?: Maybe<Scalars['String']>;
  taxSchemeId: Scalars['String'];
  creditTerm: Scalars['Float'];
  gracePeriod: Scalars['Float'];
  systemUse?: Maybe<Scalars['Boolean']>;
  commonStatus: Scalars['String'];
};

export type BookingAttachmentsOutput = {
  __typename?: 'bookingAttachmentsOutput';
  bookingFeeAttachments: Array<AttachmentEntity>;
  bookingCcrAttachments: Array<AttachmentEntity>;
  bookingNricAttachments: Array<AttachmentEntity>;
  bookingPdpaAttachments: Array<AttachmentEntity>;
  solicitorAgreementAttachments: Array<AttachmentEntity>;
  solicitorOthersAttachments: Array<AttachmentEntity>;
};

export type BookingWaitlistEntity = {
  __typename?: 'bookingWaitlistEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  contactId: Scalars['String'];
  salesPersonId: Scalars['String'];
  leadId: Scalars['String'];
  teamId: Scalars['String'];
  agentPersonId?: Maybe<Scalars['String']>;
  agencyAcctId?: Maybe<Scalars['String']>;
  queueTime: Scalars['DateTime'];
  leaveTime?: Maybe<Scalars['DateTime']>;
  reason?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  seqno: Scalars['Float'];
  contact: LeadContactEntity;
  project: ProjectEntity;
  unit: UnitEntity;
  lead: LeadEntity;
  team: SaleTeamEntity;
  salesPerson?: Maybe<UserEntity>;
  agency?: Maybe<UserEntity>;
};

export type BridgingFinancierEntity = {
  __typename?: 'bridgingFinancierEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  solicitorId: Scalars['String'];
  solicitorReferenceNo: Scalars['String'];
  chargeExecutionType: Scalars['String'];
  chargeExecutionValue: Scalars['Float'];
  commonStatus: Scalars['String'];
  bridgingFinancierUnit: Array<BridgingFinancierUnitEntity>;
};

export type BridgingFinancierUnitEntity = {
  __typename?: 'bridgingFinancierUnitEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  projectBridgingFinancierId: Scalars['String'];
  unitId: Scalars['String'];
  amount: Scalars['Float'];
  commonStatus: Scalars['String'];
  bridgingFinancier: BridgingFinancierEntity;
};

export type CampaignEntity = {
  __typename?: 'campaignEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  commonStatus?: Maybe<Scalars['String']>;
  events: Array<EventsEntity>;
  saleRebatePackage: SaleRebatePackageEntity;
  getCampaignEventsCount: Scalars['Float'];
  isDeletable: Scalars['Boolean'];
};

export type CarParkInstallmentEntity = {
  __typename?: 'carParkInstallmentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  carParkId: Scalars['String'];
  rescheduleId?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentAmt?: Maybe<Scalars['Float']>;
  baseAmt?: Maybe<Scalars['Float']>;
  taxAmt?: Maybe<Scalars['Float']>;
  transDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  glGenerated?: Maybe<Scalars['String']>;
  billType?: Maybe<Scalars['String']>;
  carparkPaymentId?: Maybe<Scalars['String']>;
  carParkPaymentPlan: CarParkPaymentPlanEntity;
  documentNo?: Maybe<Scalars['String']>;
  recordStatus: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type CarParkPaymentPlanEntity = {
  __typename?: 'carParkPaymentPlanEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  carParkId: Scalars['String'];
  billType: BillType;
  paymentAmt: Scalars['Float'];
  purchaserPaymentPlanDetailsId: Scalars['String'];
  noInstallment: Scalars['Float'];
  billCount: Scalars['Float'];
  billFrequency: BillFrequency;
  billAfter: BillAfter;
  carParkInstallment: Array<CarParkInstallmentEntity>;
  purchaserPaymentPlanDetails: PurchaserPaymentPlanDetailsEntity;
};

export type CollectionActivityEntity = {
  __typename?: 'collectionActivityEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  activityDate: Scalars['DateTime'];
  activityRemark: Scalars['String'];
  completedDate: Scalars['DateTime'];
  activityStatus: Scalars['String'];
  activityType: Scalars['String'];
  commonStatus: Scalars['String'];
  followedUpId: Scalars['String'];
};

export type CollectionActivityIndoEntity = {
  __typename?: 'collectionActivityIndoEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  overduePurchaserAccountId?: Maybe<Scalars['String']>;
  activityDate: Scalars['DateTime'];
  activityRemark?: Maybe<Scalars['String']>;
  completedDate: Scalars['DateTime'];
  activityStatus?: Maybe<Scalars['String']>;
  followedUpId?: Maybe<Scalars['String']>;
  followedUpDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
};

export type CommissionPackageTargetDetailEntity = AuditEntity & {
  __typename?: 'commissionPackageTargetDetailEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  commissionPackageTargetId: Scalars['ID'];
  positionId?: Maybe<Scalars['ID']>;
  teamPositionId?: Maybe<Scalars['ID']>;
  dealClosure: Scalars['Float'];
  overriding: Scalars['Float'];
  commonStatus: Scalars['String'];
  position?: Maybe<JobPositionEntity>;
};

export type CommissionPackageTargetEntity = AuditEntity & {
  __typename?: 'commissionPackageTargetEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  refId: Scalars['ID'];
  refTable: Scalars['String'];
  minimumTarget: Scalars['Float'];
  commonStatus: Scalars['String'];
  commissionPackageTargetDetails: Array<CommissionPackageTargetDetailEntity>;
};

export type CommissionPaymentEntity = AuditEntity & {
  __typename?: 'commissionPaymentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  refId: Scalars['ID'];
  refTable: Scalars['String'];
  paidToDate: Scalars['Float'];
  release: Scalars['Float'];
  remarks: Scalars['String'];
  commonStatus: Scalars['String'];
  commissionStatutoryDocs: Array<CommissionStatutoryDocumentEntity>;
  companyCommission: CompanyCommissionEntity;
  projectCommission: ProjectCommissionEntity;
};

export type CommissionStatutoryDocumentEntity = AuditEntity & {
  __typename?: 'commissionStatutoryDocumentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  refId: Scalars['ID'];
  refTable: Scalars['String'];
  commissionPaymentId: Scalars['ID'];
  statutoryDocId: Scalars['ID'];
  commonStatus: Scalars['String'];
  statutoryDocument: StatutoryDocumentEntity;
  commissionPayment: CommissionPaymentEntity;
};

export type CommissionTypeEntity = {
  __typename?: 'commissionTypeEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  name: Scalars['String'];
  interval: Scalars['Float'];
  payOutType: Scalars['String'];
  targetBy: Scalars['String'];
  commonStatus: Scalars['String'];
  companyCommissions: Array<CompanyCommissionEntity>;
  projectCommissions: Array<ProjectCommissionEntity>;
};

export type CompanyArAgingPolicyEntity = {
  __typename?: 'companyArAgingPolicyEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  period1: Scalars['Float'];
  period2: Scalars['Float'];
  period3: Scalars['Float'];
  period4: Scalars['Float'];
  period5: Scalars['Float'];
  period6: Scalars['Float'];
  commonStatus: Scalars['String'];
  company: CompanyEntity;
};

export type CompanyBankAccountEntity = {
  __typename?: 'companyBankAccountEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  bankProfileId: Scalars['String'];
  code: Scalars['String'];
  accountNo: Scalars['String'];
  accountType: Scalars['String'];
  swiftCode: Scalars['String'];
  currency: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  bankProfile: CompanyBankProfileEntity;
  collection?: Maybe<Array<ReceiptEntity>>;
  receiptReversal?: Maybe<Array<ReceiptReversalEntity>>;
  projectBankIndos?: Maybe<Array<ProjectBankIndoEntity>>;
  financier: Array<FinancierEntity>;
};

export type CompanyBankProfileEntity = {
  __typename?: 'companyBankProfileEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  name: Scalars['String'];
  address: Scalars['String'];
  phoneNo: Scalars['String'];
  commonStatus: Scalars['String'];
  company: CompanyEntity;
  bankAccount: Array<CompanyBankAccountEntity>;
};

export type CompanyCommissionEntity = {
  __typename?: 'companyCommissionEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  companyId: Scalars['ID'];
  commissionTypeId: Scalars['ID'];
  description: Scalars['String'];
  commonStatus: Scalars['String'];
  commissionType: CommissionTypeEntity;
  commissionPayments: Array<CommissionPaymentEntity>;
};

export type CompanyCommissionPackageDetailEntity = {
  __typename?: 'companyCommissionPackageDetailEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  companyCommissionPackageId: Scalars['ID'];
  effectiveDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  companyCommissionPackage: CompanyCommissionPackageEntity;
  commissionPackageTargets: Array<CommissionPackageTargetEntity>;
};

export type CompanyCommissionPackageEntity = {
  __typename?: 'companyCommissionPackageEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  companyId: Scalars['ID'];
  companyCommissionId: Scalars['ID'];
  principal: Scalars['String'];
  commonStatus: Scalars['String'];
  companyCommissionPackageDetails: Array<CompanyCommissionPackageDetailEntity>;
  companyCommission: CompanyCommissionEntity;
};

export type CompanyCommissionTeamDetailEntity = {
  __typename?: 'companyCommissionTeamDetailEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  companyCommissionTeamId: Scalars['ID'];
  principal: Scalars['String'];
  positionId?: Maybe<Scalars['ID']>;
  level?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['ID']>;
  commonStatus: Scalars['String'];
  companyCommissionTeam: CompanyCommissionTeamEntity;
  parent?: Maybe<CompanyCommissionTeamDetailEntity>;
  children?: Maybe<Array<CompanyCommissionTeamDetailEntity>>;
  position?: Maybe<JobPositionEntity>;
};

export type CompanyCommissionTeamEntity = {
  __typename?: 'companyCommissionTeamEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  companyId: Scalars['ID'];
  generateDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  details: Array<CompanyCommissionTeamDetailEntity>;
  saleCommissionTeams: Array<SaleCommissionTeamEntity>;
};

export type CompanyEntity = {
  __typename?: 'companyEntity';
  id: Scalars['String'];
  parentCompanyId?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  baseCurrencyId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  address?: Maybe<AddressJson>;
  contactNo?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  sstNo?: Maybe<Scalars['String']>;
  gstNo?: Maybe<Scalars['String']>;
  gstExpiryDate?: Maybe<Scalars['DateTime']>;
  groupGstRegNo?: Maybe<Scalars['String']>;
  image?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  imageBucketFile?: Maybe<Scalars['String']>;
  websiteUrl?: Maybe<Scalars['String']>;
  regionId?: Maybe<Scalars['String']>;
  imageLogoPosition?: Maybe<Scalars['String']>;
  watermarkImplementation?: Maybe<Scalars['Boolean']>;
  watermarkWording?: Maybe<Scalars['String']>;
  isoImplementation?: Maybe<Scalars['Boolean']>;
  isoLogoPosition?: Maybe<Scalars['String']>;
  companyTax?: Maybe<CompanyTax>;
  recordStatus: Scalars['String'];
  development: ProjectEntity;
  holding: ProjectEntity;
  companyArAgingPolicy?: Maybe<CompanyArAgingPolicyEntity>;
  township: Array<TownshipEntity>;
  bankProfile: Array<CompanyBankProfileEntity>;
  isDeletable: Scalars['Boolean'];
  region?: Maybe<RegionEntity>;
};

export type CompanyExtEntity = {
  __typename?: 'companyExtEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  groupGstRegNo?: Maybe<Scalars['String']>;
  gstRegNo?: Maybe<Scalars['String']>;
  gstEffectiveDate?: Maybe<Scalars['DateTime']>;
  sstRegNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type CompanyNumberSetupEntity = {
  __typename?: 'companyNumberSetupEntity';
  id: Scalars['String'];
  nextNumber: Scalars['Float'];
  companyId: Scalars['String'];
  numberFormatId: Scalars['String'];
  numberFormat: NumberFormatEntity;
};

export type CompanyRewardInputDetailEntity = {
  __typename?: 'companyRewardInputDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  companyCommissionCalcId: Scalars['String'];
  companyCommissionPackageId: Scalars['String'];
  saleId: Scalars['String'];
  docDate: Scalars['DateTime'];
  docNo: Scalars['String'];
  netSelling: Scalars['Float'];
  commissionType: Scalars['String'];
  commissionDate: Scalars['DateTime'];
  commissionAmt: Scalars['Float'];
  commonStatus: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  modTs: Scalars['DateTime'];
  modBy: Scalars['String'];
};

export type CompanyRewardInputEntity = {
  __typename?: 'companyRewardInputEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  generateDate: Scalars['DateTime'];
  principal: Scalars['String'];
  employeeId: Scalars['String'];
  employeeName: Scalars['String'];
  totalSelling: Scalars['Float'];
  totalCommission: Scalars['Float'];
  commonStatus: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  modTs: Scalars['DateTime'];
  modBy: Scalars['String'];
};

export type ContactAddressEntity = {
  __typename?: 'contactAddressEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  address: AddressJson;
  contactId: Scalars['String'];
  contact: ContactEntity;
  isPrimary: Scalars['Boolean'];
};

export type ContactEntity = {
  __typename?: 'contactEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  fullName: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  militaryIc?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  address?: Maybe<AddressJson>;
  homeTel?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  bookingWaitlists: Array<BookingWaitlistEntity>;
  jointBuyers: Array<JointBuyerEntity>;
  leads?: Maybe<Array<LeadEntity>>;
  sales: Array<SaleEntity>;
  salutation?: Maybe<SalutationEntity>;
  nationality?: Maybe<SNationalityEntity>;
  race?: Maybe<RaceEntity>;
  maritalStatus?: Maybe<MaritalStatusEntity>;
  incomeRange?: Maybe<IncomeRangeEntity>;
  contactExt?: Maybe<ContactExtensionEntity>;
  addressList?: Maybe<Array<ContactAddressEntity>>;
  signatureUrl?: Maybe<Scalars['String']>;
  jointBuyerSignature?: Maybe<Scalars['String']>;
  isPurchaserRegisted?: Maybe<Scalars['Boolean']>;
  spouse?: Maybe<ContactEntity>;
  contactAddress?: Maybe<Array<AddressJson>>;
};


export type ContactEntityLeadsArgs = {
  project_id?: Maybe<Scalars['String']>;
};

export type ContactExtensionEntity = AuditEntity & {
  __typename?: 'contactExtensionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  contactId: Scalars['String'];
  identityType: Scalars['String'];
  customerOrigin: Scalars['String'];
  isBumi: Scalars['Boolean'];
  isVip: Scalars['Boolean'];
  isForeignPurchase: Scalars['Boolean'];
  subscribeMaterialSms: Scalars['Boolean'];
  subscribeMaterialWhatsapp: Scalars['Boolean'];
  subscribeMaterialEmail: Scalars['Boolean'];
  subscribeMaterialPaNews: Scalars['Boolean'];
  mailingMethod: Scalars['String'];
  tin?: Maybe<Scalars['String']>;
  sstNo?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  contact?: Maybe<ContactEntity>;
  professionId?: Maybe<Scalars['String']>;
  religionId?: Maybe<Scalars['String']>;
  nameOnTax?: Maybe<Scalars['String']>;
  taxRegistrationNo?: Maybe<Scalars['String']>;
  taxRegistrationAddress?: Maybe<Scalars['String']>;
  isPrincipalBuyer: Scalars['Boolean'];
};

export type ContactNupJson = {
  __typename?: 'contactNupJson';
  name?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  identitytype?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  hometel?: Maybe<Scalars['String']>;
  officetel?: Maybe<Scalars['String']>;
};

export type ContraEntity = {
  __typename?: 'contraEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentDate: Scalars['DateTime'];
  documentAmount: Scalars['Float'];
  requestedBy?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  commonStatus: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  billItemId: Scalars['String'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  allowReversal: Scalars['Boolean'];
  refId?: Maybe<Scalars['String']>;
  ref_table?: Maybe<Scalars['String']>;
};

export type CountryCodeEntity = {
  __typename?: 'countryCodeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type CreditNoteEntity = {
  __typename?: 'creditNoteEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentAmount: Scalars['Float'];
  adjustDocumentReference?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  status: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submittedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  billItemId?: Maybe<Scalars['String']>;
  allowReversal: Scalars['Boolean'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  isReversal: Scalars['Boolean'];
};

export type CurrencyExchangeRateEntity = {
  __typename?: 'currencyExchangeRateEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  fromCurrencyCode: Scalars['String'];
  toCurrencyCode: Scalars['String'];
  fromAmt: Scalars['Float'];
  toAmt: Scalars['Float'];
  exchangeRate: Scalars['Float'];
  currencyLog?: Maybe<Array<CurrencyLogObject>>;
  commonStatus: Scalars['String'];
};

export type CurrencyLogInput = {
  to_amt: Scalars['Float'];
  from_amt: Scalars['Float'];
  exchange_rate: Scalars['Float'];
  modifiedBy: Scalars['String'];
  modifiedName: Scalars['String'];
  modifiedDate: Scalars['DateTime'];
};

/** JsonType */
export type CurrencyLogObject = {
  __typename?: 'currencyLogObject';
  to_amt: Scalars['Float'];
  from_amt: Scalars['Float'];
  exchange_rate: Scalars['Float'];
  modifiedBy: Scalars['String'];
  modifiedName: Scalars['String'];
  modifiedDate: Scalars['DateTime'];
};

export type DebitNoteEntity = {
  __typename?: 'debitNoteEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentAmount: Scalars['Float'];
  dueDate: Scalars['DateTime'];
  creditTerm: Scalars['Float'];
  isIncludeHoliday: Scalars['Boolean'];
  interestRate: Scalars['Float'];
  adjustDocumentReference?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  status: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submittedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  sales?: Maybe<SaleEntity>;
  billItemId?: Maybe<Scalars['String']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  allowReversal: Scalars['Boolean'];
  isReversal: Scalars['Boolean'];
};

export type DepositEntity = {
  __typename?: 'depositEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  depositTypeId: Scalars['String'];
  refId: Scalars['String'];
  ref_table: Scalars['String'];
  paymentMethod: Scalars['String'];
  documentDate: Scalars['DateTime'];
  documentAmount: Scalars['Float'];
  documentRef?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  bankAccountId: Scalars['String'];
  chequeNo?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedDate?: Maybe<Scalars['DateTime']>;
  submittedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  voidDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  documentNo?: Maybe<Scalars['String']>;
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  creditCardType?: Maybe<Scalars['String']>;
  convertedToPayment: Scalars['Boolean'];
};

export type DirectionEntity = {
  __typename?: 'directionEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seq_no?: Maybe<Scalars['Float']>;
  units: Array<UnitEntity>;
  isDeletable: Scalars['Boolean'];
};

export type DiscountEntity = {
  __typename?: 'discountEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  discountTypeId?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  formula?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
  discountVal?: Maybe<Scalars['Float']>;
  isIntegrated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  projectDiscounts: Array<ProjectDiscountEntity>;
  salesDiscount: Array<SaleDiscountEntity>;
  discountIntegration?: Maybe<Array<IntegrationDiscountEntity>>;
  saleRebatePackage?: Maybe<Array<SaleRebatePackageEntity>>;
  discountType?: Maybe<DiscountTypeEntity>;
  saleSubProduct?: Maybe<SaleSubproductEntity>;
  isDiscountRebate: Scalars['Boolean'];
  isDeletable: Scalars['Boolean'];
};

/** JsonType */
export type DiscountListingObject = {
  __typename?: 'discountListingObject';
  discountId: Scalars['String'];
  title: Scalars['String'];
  seqNo: Scalars['Float'];
  amount: Scalars['Float'];
  formula: Scalars['String'];
  discountMethod: Scalars['String'];
};

export type DiscountListingUnitTransferInput = {
  discountId: Scalars['String'];
  title: Scalars['String'];
  seqNo: Scalars['Float'];
  amount: Scalars['Float'];
  formula: Scalars['String'];
  discountMethod: Scalars['String'];
};

/** JsonType */
export type DiscountObject = {
  __typename?: 'discountObject';
  discardBumi: Scalars['Boolean'];
  discounts?: Maybe<Array<DiscountListingObject>>;
};

export type DiscountTypeEntity = AuditEntity & {
  __typename?: 'discountTypeEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  systemUse: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  discount?: Maybe<DiscountEntity>;
};

export type DiscountUnitTransferInput = {
  discardBumi: Scalars['Boolean'];
  discounts?: Maybe<Array<DiscountListingUnitTransferInput>>;
};

export type DocumentNumberDetailEntity = {
  __typename?: 'documentNumberDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  documentNumberHeaderId: Scalars['String'];
  sequence: Scalars['Float'];
  formatType: Scalars['String'];
  resetBy?: Maybe<Scalars['String']>;
  formatValue: Scalars['String'];
  nextNumber?: Maybe<Scalars['Float']>;
  startFrom?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
  submittedTs?: Maybe<Scalars['DateTime']>;
  submittedBy: Scalars['String'];
  approvedTs?: Maybe<Scalars['DateTime']>;
  approvedBy: Scalars['String'];
  documentNumberHeader: DocumentNumberHeaderEntity;
};

export type DocumentNumberHeaderEntity = {
  __typename?: 'documentNumberHeaderEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  type: DocumentNumberHeaderTypeIndoEnum;
  sampleOutput: Scalars['String'];
  refTable: Scalars['String'];
  refRecordId: Scalars['String'];
  isAutoDocNo?: Maybe<Scalars['Boolean']>;
  docNumGenerated?: Maybe<Scalars['Boolean']>;
  commonStatus: Scalars['String'];
  submittedTs?: Maybe<Scalars['DateTime']>;
  submittedBy: Scalars['String'];
  approvedTs?: Maybe<Scalars['DateTime']>;
  approvedBy: Scalars['String'];
  documentNumberDetails?: Maybe<Array<DocumentNumberDetailEntity>>;
  documentNumberResetBy?: Maybe<Array<DocumentNumberResetByEntity>>;
};

export type DocumentNumberResetByEntity = {
  __typename?: 'documentNumberResetByEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  documentNumberHeaderId: Scalars['String'];
  companyId: Scalars['String'];
  year?: Maybe<Scalars['Float']>;
  month?: Maybe<Scalars['Float']>;
  nextNumber?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
  documentNumberHeader: DocumentNumberHeaderEntity;
};

export type DownpaymentReminderEntity = AuditEntity & {
  __typename?: 'downpaymentReminderEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
  progressBillingId: Scalars['String'];
  generationBatch?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  share?: Maybe<Array<ShareObject>>;
  balanceAmount: Scalars['Float'];
};

export type DropDownDataOutput = {
  __typename?: 'dropDownDataOutput';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ELaunchAllocationEntity = AuditEntity & {
  __typename?: 'eLaunchAllocationEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  eLaunchId: Scalars['String'];
  unitId: Scalars['String'];
  eLaunch: ELaunchEntity;
  unit: UnitEntity;
  totalFavouriteCount: Scalars['Float'];
};

export type ELaunchContactEntity = AuditEntity & {
  __typename?: 'eLaunchContactEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  userId: Scalars['String'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  pictureUrl?: Maybe<Scalars['String']>;
  elaunchUser: ELaunchUserEntity;
  getLangMasterData: Array<LanguageNamesOutput>;
  userLanguageChoose: LanguageOutput;
};

export type ELaunchEntity = AuditEntity & {
  __typename?: 'eLaunchEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  publishDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  terminationDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  eLaunchAllocation?: Maybe<Array<ELaunchAllocationEntity>>;
  eLaunchLeadBatch?: Maybe<Array<ELaunchLeadBatchEntity>>;
  hasEnded?: Maybe<Scalars['Boolean']>;
  hasPublished?: Maybe<Scalars['Boolean']>;
  totalUnitAllocationCount?: Maybe<Scalars['Float']>;
  totalBookedUnitAllocationCount?: Maybe<Scalars['Float']>;
  totalInvitedPurchaserCount?: Maybe<Scalars['Float']>;
  totalBookedUnit: Scalars['Float'];
  invitationTemplateId?: Maybe<Scalars['String']>;
};

export type ELaunchFavouriteUnitEntity = AuditEntity & {
  __typename?: 'eLaunchFavouriteUnitEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  userId: Scalars['String'];
  eLaunchId: Scalars['String'];
  unitId: Scalars['String'];
  commonStatus: Scalars['String'];
  eLaunchUser: ELaunchUserEntity;
};

export type ELaunchInvitationTemplateEntity = AuditEntity & {
  __typename?: 'eLaunchInvitationTemplateEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  eLaunchId: Scalars['String'];
  subject?: Maybe<Scalars['String']>;
  content: Scalars['String'];
  salesDocId?: Maybe<Array<Scalars['String']>>;
  accountSpec: AccountSpecEntity;
  eLaunch: ELaunchEntity;
  salesDoc?: Maybe<SalesDocEntity>;
  commonStatus: Scalars['String'];
};

export type ELaunchLeadBatchEntity = AuditEntity & {
  __typename?: 'eLaunchLeadBatchEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  eLaunchId: Scalars['String'];
  batchTitle: Scalars['String'];
  recordCount: Scalars['Float'];
  lastEmailSend?: Maybe<Array<LastEmailSendOutput>>;
  eLaunch: ELaunchEntity;
  totalRegisteredLeadCount: Scalars['Float'];
};

export type ELaunchLeadEntity = AuditEntity & {
  __typename?: 'eLaunchLeadEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  eLaunchBatchId: Scalars['String'];
  leadId: Scalars['String'];
  eLaunchLeadBatch: ELaunchLeadBatchEntity;
  lead: LeadEntity;
};

export type ELaunchLogEntity = AuditEntity & {
  __typename?: 'eLaunchLogEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  eLaunchId: Scalars['String'];
  log: Scalars['JSONObject'];
  eLaunch: ELaunchEntity;
};

export type ELaunchOtpEntity = AuditEntity & {
  __typename?: 'eLaunchOtpEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  phoneNo: Scalars['String'];
  otpCode: Scalars['String'];
  otpType: Scalars['String'];
  otpExpiry: Scalars['DateTime'];
  ipAddress?: Maybe<Scalars['String']>;
};

export type ELaunchRegisterEntity = AuditEntity & {
  __typename?: 'eLaunchRegisterEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  userId: Scalars['String'];
  eLaunchId: Scalars['String'];
  leadId: Scalars['String'];
  invitedById?: Maybe<Scalars['String']>;
  invitedBy?: Maybe<Scalars['String']>;
  eLaunch: ELaunchEntity;
  eLaunchUser: ELaunchUserEntity;
};

export type ELaunchUserEntity = AuditEntity & {
  __typename?: 'eLaunchUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  loginId: Scalars['String'];
  activated: Scalars['Boolean'];
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  forgotPasswordLink?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  languageSet: Scalars['String'];
};

export type EditBlockDateInput = {
  id: Scalars['String'];
  appointmentScheduleId: Scalars['String'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  startTime: Scalars['String'];
  endTime: Scalars['String'];
};

export type EditSiteProgressInput = {
  id: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  publishDate: Scalars['DateTime'];
  attachment?: Maybe<Array<Scalars['Upload']>>;
  reqDeleteAttId?: Maybe<Array<Scalars['String']>>;
};

export type EmailLetterEntity = {
  __typename?: 'emailLetterEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  emailType: Scalars['String'];
  commonStatus: Scalars['String'];
  emailLetterParameter: Array<EmailLetterParameterEntity>;
  emailLetterTemplate: Array<EmailLetterTemplateEntity>;
  seqNo: Scalars['Float'];
};

export type EmailLetterParameterEntity = {
  __typename?: 'emailLetterParameterEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  emailLetterId: Scalars['String'];
  displayName: Scalars['String'];
  columnName: Scalars['String'];
  commonStatus: Scalars['String'];
  emailLetter: EmailLetterEntity;
};

export type EmailLetterTemplateEntity = AuditEntity & {
  __typename?: 'emailLetterTemplateEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  emailLetterId: Scalars['String'];
  name: Scalars['String'];
  templateBody?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  emailLetter: EmailLetterEntity;
  systemUse: Scalars['Boolean'];
  projectEmailLetter: ProjectEmailLetterEntity;
};

export type EmailLogEntity = {
  __typename?: 'emailLogEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  refId: Scalars['String'];
  refType: Scalars['String'];
  content: Scalars['String'];
  subject: Scalars['String'];
  recipientEmail: Scalars['String'];
  ccEmails: Scalars['String'];
  bccEmails: Scalars['String'];
  isEmailSent: Scalars['Boolean'];
  errorMessage?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type EmployeeJobPositionEntity = AuditEntity & {
  __typename?: 'employeeJobPositionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  positionId: Scalars['String'];
  jobPosition: JobPositionEntity;
  employeeName: Scalars['String'];
  commonStatus?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type EndfinContactEntity = {
  __typename?: 'endfinContactEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
  user: EndfinUserEntity;
};

export type EndfinFinancierEntity = {
  __typename?: 'endfinFinancierEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  activated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  endfinUserRoles: Array<EndfinUserRoleEntity>;
  financiers: Array<FinancierEntity>;
  staffCount?: Maybe<Scalars['Float']>;
  financier?: Maybe<FinancierEntity>;
};

export type EndfinLoanAppActivityEntity = {
  __typename?: 'endfinLoanAppActivityEntity';
  id: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  activityType: Scalars['String'];
  loanAppId: Scalars['String'];
  loanAppStatusId: Scalars['String'];
  loanApp: EndfinLoanAppEntity;
  loanAppStatus: EndfinLoanAppStatusEntity;
  createdBy?: Maybe<Scalars['String']>;
  createdDate: Scalars['DateTime'];
  activityTypeDesc: Scalars['String'];
};

export type EndfinLoanAppEntity = {
  __typename?: 'endfinLoanAppEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  applyAmount: Scalars['Float'];
  applyDate: Scalars['DateTime'];
  approvalDate?: Maybe<Scalars['DateTime']>;
  assignedDate?: Maybe<Scalars['DateTime']>;
  tenure?: Maybe<Scalars['Float']>;
  approvalAmount?: Maybe<Scalars['Float']>;
  financierId: Scalars['String'];
  loanAppStatusId: Scalars['String'];
  saleId: Scalars['String'];
  userId: Scalars['String'];
  loanType: Scalars['String'];
  financier: FinancierEntity;
  loanAppStatus: EndfinLoanAppStatusEntity;
  sale: SaleEntity;
  user?: Maybe<EndfinUserEntity>;
  endfinLoanAppActivities: Array<EndfinLoanAppActivityEntity>;
  staff?: Maybe<EndfinUserEntity>;
  activityData?: Maybe<Array<EndfinLoanAppActivityEntity>>;
  lastActivity?: Maybe<EndfinLoanAppActivityEntity>;
  documentData?: Maybe<Array<AttachmentEntity>>;
  eLetteringExistenceType?: Maybe<Array<Scalars['String']>>;
  agingDate?: Maybe<Scalars['DateTime']>;
};

export type EndfinLoanAppStatusEntity = {
  __typename?: 'endfinLoanAppStatusEntity';
  id: Scalars['String'];
  statusCode: Scalars['String'];
  statusName: Scalars['String'];
  stages: Scalars['Float'];
  seqNo: Scalars['Float'];
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  endfinLoanAppActivities: Array<EndfinLoanAppActivityEntity>;
};

export type EndfinNotificationEntity = AuditEntity & {
  __typename?: 'endfinNotificationEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  permissionId: Scalars['Float'];
  subject: Scalars['String'];
  body: Scalars['String'];
  endfinNotificationRecipient: Array<EndfinNotificationRecipientEntity>;
};

export type EndfinNotificationPolicyEntity = {
  __typename?: 'endfinNotificationPolicyEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  userId: Scalars['String'];
  permissionId: Scalars['Float'];
  notificationDuration: Scalars['Float'];
};

export type EndfinNotificationRecipientEntity = AuditEntity & {
  __typename?: 'endfinNotificationRecipientEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  notificationId: Scalars['String'];
  recipientId: Scalars['String'];
  isRead: Scalars['Boolean'];
  endfinNotification: EndfinNotificationEntity;
};

export type EndfinProjectFinancierEntity = {
  __typename?: 'endfinProjectFinancierEntity';
  id: Scalars['String'];
  isPanel: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  financierId: Scalars['String'];
  projectId: Scalars['String'];
  financialLimit: Scalars['Float'];
  interestRate?: Maybe<Scalars['Float']>;
  financier: FinancierEntity;
  project: ProjectEntity;
  financierInfo: FinancierEntity;
  assignedDate: Scalars['DateTime'];
  financierStatus: Scalars['Boolean'];
  financierCommonStatus: Scalars['String'];
};

export type EndfinUserEntity = {
  __typename?: 'endfinUserEntity';
  id: Scalars['String'];
  loginId: Scalars['String'];
  passwordHash?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  forgotPasswordLink?: Maybe<Scalars['String']>;
  endfinContacts: EndfinContactEntity;
  endfinUserRoles: EndfinUserRoleEntity;
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  contact?: Maybe<EndfinContactEntity>;
  userRole?: Maybe<EndfinUserRoleEntity>;
  assignedLoanCount?: Maybe<LoanAssignedCountOutput>;
  projectLoanCount?: Maybe<Array<LoanProjectCountOutput>>;
};

export type EndfinUserRoleEntity = {
  __typename?: 'endfinUserRoleEntity';
  id: Scalars['String'];
  role: Scalars['String'];
  commonStatus: Scalars['String'];
  financierId: Scalars['String'];
  userId: Scalars['String'];
  financier: EndfinFinancierEntity;
  user: EndfinUserEntity;
};

export type EntityRoleUserAssignmentEntity = AuditEntity & {
  __typename?: 'entityRoleUserAssignmentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  entityId: Scalars['String'];
  roleId: Scalars['String'];
  userId: Scalars['String'];
};

export type EventsEntity = {
  __typename?: 'eventsEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  campaignId: Scalars['String'];
  name: Scalars['String'];
  desc?: Maybe<Scalars['String']>;
  website: Scalars['String'];
  location: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  budget: Scalars['Float'];
  commonStatus?: Maybe<Scalars['String']>;
  campaign: CampaignEntity;
  isDeletable: Scalars['Boolean'];
};

export type FinancialBillingEntity = {
  __typename?: 'financialBillingEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  saleLoanId: Scalars['String'];
  financierId: Scalars['String'];
  progressBillingId: Scalars['String'];
  documentAmount?: Maybe<Scalars['Float']>;
  principalAmt: Scalars['Float'];
  taxAmount?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
  progressBilling?: Maybe<ProgressBillingEntity>;
  saleLoan?: Maybe<SaleLoanEntity>;
};

export type FinancierContactEntity = {
  __typename?: 'financierContactEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  email: Scalars['String'];
  phoneNo: Scalars['String'];
  financierId: Scalars['String'];
  financier: FinancierEntity;
};

export type FinancierContacts = {
  __typename?: 'financierContacts';
  id: Scalars['String'];
  name: Scalars['String'];
  phoneNo: Scalars['String'];
  email: Scalars['String'];
  invitationDate?: Maybe<Scalars['DateTime']>;
  default?: Maybe<Scalars['Boolean']>;
};

export type FinancierEntity = {
  __typename?: 'financierEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  address?: Maybe<AddressJson>;
  projectInvitation?: Maybe<Array<FinancierProject>>;
  officeTel?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  accountId: Scalars['String'];
  financierId?: Maybe<Scalars['String']>;
  logoUrl?: Maybe<Scalars['String']>;
  financierCode?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  disbursementFinancierId?: Maybe<Scalars['String']>;
  financier: EndfinFinancierEntity;
  financierContact: Array<FinancierContactEntity>;
  saleLoanRelease: Array<SaleLoanReleaseEntity>;
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  endfinProjectFinanciers: Array<EndfinProjectFinancierEntity>;
  saleLoan?: Maybe<Array<SaleLoanEntity>>;
  collection?: Maybe<Array<SaleLoanEntity>>;
  receiptReversal?: Maybe<Array<ReceiptReversalEntity>>;
  bank?: Maybe<CompanyBankAccountEntity>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  assignedProjectCount: Scalars['Float'];
  loanCount: Scalars['Float'];
  financialLimit?: Maybe<Scalars['Float']>;
};

export type FinancierPanelDetails = {
  __typename?: 'financierPanelDetails';
  id: Scalars['String'];
  name: Scalars['String'];
  endfinFinancierId?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  address?: Maybe<AddressJson>;
  financierContact: Array<FinancierContacts>;
};

export type FinancierProjectStaff = {
  __typename?: 'financierProjectStaff';
  name?: Maybe<Scalars['String']>;
};

export type FinancierStaff = {
  __typename?: 'financierStaff';
  user_id: Scalars['String'];
  name: Scalars['String'];
  role: Scalars['String'];
  email: Scalars['String'];
  phone_no: Scalars['String'];
  common_status: Scalars['String'];
};

export type FinancierUnitMortgage = {
  __typename?: 'financierUnitMortgage';
  financierName?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
};

export type FormatVa = {
  __typename?: 'formatVa';
  formatType: Scalars['String'];
  formatValue: Scalars['String'];
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Float']>;
};

export type GenerateUnitInput = {
  projectId: Scalars['String'];
  blockNumber: Scalars['String'];
  floorList: Array<Scalars['Float']>;
  specialList?: Maybe<Array<SpecialListInput>>;
  unitList: Array<Scalars['String']>;
  propertyType: Scalars['String'];
  listPrice: Scalars['Float'];
  builtUpArea: Scalars['Float'];
  direction?: Maybe<Scalars['String']>;
  unitType: Scalars['String'];
  unitLayout: Scalars['String'];
  isSubproduct: Scalars['Boolean'];
};

export type GetAllActiveProjectIntegrationWithUrlOutput = {
  __typename?: 'getAllActiveProjectIntegrationWithUrlOutput';
  id?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  integrationType: Scalars['String'];
  integrationUrl: Scalars['String'];
  companyName: Scalars['String'];
  message?: Maybe<Scalars['String']>;
};

export type GetAppoitmentSchedulingOutput = {
  __typename?: 'getAppoitmentSchedulingOutput';
  id: Scalars['String'];
  projectId: Scalars['String'];
  startTime: Scalars['String'];
  endTime: Scalars['String'];
  maxPaxPerAppoitment?: Maybe<Scalars['Float']>;
  closeDate?: Maybe<Array<SaleGalleryCloseDateTime>>;
};

export type GetMissMatchSaleProjectListing = {
  __typename?: 'getMissMatchSaleProjectListing';
  projectId: Scalars['String'];
  projectName: Scalars['String'];
  projectImageUrl?: Maybe<Scalars['String']>;
  missMatchSalesCount?: Maybe<Scalars['Float']>;
};

export type GlAccountEntity = {
  __typename?: 'glAccountEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  glType: Scalars['String'];
  refTable: Scalars['String'];
  refId: Scalars['String'];
  glAccountCode: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type GlExportEntity = {
  __typename?: 'glExportEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  glDate: Scalars['DateTime'];
  glType: Scalars['String'];
  glTransactionType: Scalars['String'];
  glAccountCode: Scalars['String'];
  costCentre: Scalars['String'];
  journalType: Scalars['String'];
  refDocumentDate: Scalars['DateTime'];
  refTable: Scalars['String'];
  refId: Scalars['String'];
  refDocumentNo: Scalars['String'];
  refDescription?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  debitAmount: Scalars['Float'];
  creditAmount: Scalars['Float'];
  glGenerationBatch: Scalars['String'];
  posted: Scalars['Boolean'];
  commonStatus: Scalars['String'];
};

/** JsonType */
export type IncludeInDetail = {
  __typename?: 'includeInDetail';
  paymentPlanDetailId?: Maybe<Scalars['String']>;
};

export type IncomeRangeEntity = {
  __typename?: 'incomeRangeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  range: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  sales: Array<SaleEntity>;
  contact: Array<ContactEntity>;
  leadContact: Array<LeadContactEntity>;
  isDeletable: Scalars['Boolean'];
};

export type Installment = {
  __typename?: 'installment';
  description: Scalars['String'];
  documentDate: Scalars['DateTime'];
  documentAmt: Scalars['Float'];
  documentNo: Scalars['String'];
};

export type InstallmentEntity = {
  __typename?: 'installmentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  rescheduleId?: Maybe<Scalars['String']>;
  oldInstallmentId?: Maybe<Scalars['String']>;
  rescheduleDetailId?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentAmt?: Maybe<Scalars['Float']>;
  baseAmt?: Maybe<Scalars['Float']>;
  taxAmt?: Maybe<Scalars['Float']>;
  transDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  glGenerated?: Maybe<Scalars['String']>;
  billType?: Maybe<Scalars['String']>;
  salePaymentId?: Maybe<Scalars['String']>;
  sale: SaleEntity;
  salesPaymentPlan: SalesPaymentPlanEntity;
  documentNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type InstallmentListPaymentReminderOutput = {
  __typename?: 'installmentListPaymentReminderOutput';
  id?: Maybe<Scalars['String']>;
  installmentId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentAmt?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  allocationDate?: Maybe<Scalars['DateTime']>;
  intervalDays?: Maybe<Scalars['Float']>;
  allocateAmt?: Maybe<Scalars['Float']>;
  outstanding?: Maybe<Scalars['Float']>;
  dueInstallment?: Maybe<Scalars['Float']>;
  penaltyAmt?: Maybe<Scalars['Float']>;
  allocSeq?: Maybe<Scalars['Float']>;
  orderSeq?: Maybe<Scalars['Float']>;
  saleIdDrRow?: Maybe<Scalars['Float']>;
};

export type IntegrationDiscountEntity = {
  __typename?: 'integrationDiscountEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  discountId: Scalars['String'];
  ifcaDiscountId: Scalars['Float'];
  effectiveDate?: Maybe<Scalars['DateTime']>;
  expiredDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  discount: DiscountEntity;
  project: ProjectEntity;
  projectIntegration: ProjectIntegrationEntity;
};

export type IntegrationPackageEntity = {
  __typename?: 'integrationPackageEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  packageId: Scalars['String'];
  ifcaPackageId: Scalars['Float'];
  commonStatus: Scalars['String'];
  package: PackageEntity;
  project: ProjectEntity;
};

export type IntegrationSolicitorEntity = {
  __typename?: 'integrationSolicitorEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  solicitorId: Scalars['String'];
  ifcaSolicitorId: Scalars['Float'];
  commonStatus: Scalars['String'];
  solicitor: SolicitorAppointedEntity;
  project: ProjectEntity;
  projectIntegration: ProjectIntegrationEntity;
};

export type InterestEntity = {
  __typename?: 'interestEntity';
  id: Scalars['String'];
  overdueAmount: Scalars['String'];
  interestDate: Scalars['DateTime'];
  interestRate: Scalars['String'];
  interestAmount: Scalars['String'];
  trxStatus: Scalars['String'];
  invoiceId: Scalars['String'];
  postedDate?: Maybe<Scalars['DateTime']>;
  overdueDay: Scalars['Float'];
  commonStatus: Scalars['String'];
  batchId?: Maybe<Scalars['String']>;
  isWaive: Scalars['Boolean'];
  account_id: Scalars['String'];
  invoice: LedgerEntity;
  ledger: LedgerEntity;
  project: ProjectEntity;
  sale: SaleEntity;
};

export type JobPositionEntity = AuditEntity & {
  __typename?: 'jobPositionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  position: Scalars['String'];
  commonStatus?: Maybe<Scalars['String']>;
  employeeJobPosition: Array<EmployeeJobPositionEntity>;
};

export type JointBuyerEntity = {
  __typename?: 'jointBuyerEntity';
  id: Scalars['String'];
  contactId: Scalars['String'];
  saleId: Scalars['String'];
  commonStatus: Scalars['String'];
  ifcaContactId: Scalars['String'];
  ifcaSaleId: Scalars['Float'];
  seq_no?: Maybe<Scalars['Float']>;
  jointBuyerName?: Maybe<Scalars['String']>;
  jointBuyerIdentityNo?: Maybe<Scalars['String']>;
  jointBuyerIdentityType?: Maybe<Scalars['String']>;
  contact: ContactEntity;
  sale: SaleEntity;
};

export type KeyCollectionAppointmentEntity = {
  __typename?: 'keyCollectionAppointmentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  keyCollectionTimeslotId: Scalars['String'];
  plumberId?: Maybe<Scalars['String']>;
  electricianId?: Maybe<Scalars['String']>;
  alarmVendorId?: Maybe<Scalars['String']>;
  siteSupervisorId?: Maybe<Scalars['String']>;
  handOverDate?: Maybe<Scalars['DateTime']>;
  keysCollected?: Maybe<Scalars['Float']>;
  sanitaryDate?: Maybe<Scalars['DateTime']>;
  sanitaryRemark?: Maybe<Scalars['String']>;
  electricalDate?: Maybe<Scalars['DateTime']>;
  electricalRemark?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  commonStatus: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  keyCollectionTimeslot?: Maybe<ProjectKeyCollectionTimeSlotEntity>;
};

export type KeyCollectionAppointmentRescheduleInput = {
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: Maybe<Scalars['Boolean']>;
  purchaserUserReceive?: Maybe<Scalars['Boolean']>;
};

export type LadEntity = {
  __typename?: 'ladEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  startWith: Scalars['String'];
  unitLadPercent: Scalars['Float'];
  unitDuration: Scalars['Float'];
  payoutPercent: Scalars['Float'];
  spaPercent: Scalars['Float'];
  commonFacility: Scalars['Boolean'];
  facilityLadPercent?: Maybe<Scalars['Float']>;
  facilityLadDuration?: Maybe<Scalars['Float']>;
  unitLadAmount: Scalars['Float'];
  facilityLadAmount?: Maybe<Scalars['Float']>;
  byFacilityDate?: Maybe<Scalars['DateTime']>;
  isSimulate: Scalars['Boolean'];
  contraId?: Maybe<Scalars['String']>;
  generationBatch: Scalars['String'];
  byUnitDate: Scalars['DateTime'];
  generationBatchDate: Scalars['DateTime'];
  unitDueDays?: Maybe<Scalars['Float']>;
  facilityDueDays?: Maybe<Scalars['Float']>;
  documentNo?: Maybe<Scalars['String']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
};

export type LateInterestDetailEntity = {
  __typename?: 'lateInterestDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  lateInterestId: Scalars['String'];
  refTable: Scalars['String'];
  refId: Scalars['String'];
  overdueDay: Scalars['Float'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  interestStartDate: Scalars['DateTime'];
  interestEndDate?: Maybe<Scalars['DateTime']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentAmount: Scalars['Float'];
  interestAmount: Scalars['Float'];
  calculateAmt: Scalars['Float'];
  calculateRate: Scalars['Float'];
  dueDate?: Maybe<Scalars['DateTime']>;
  creditTerm?: Maybe<Scalars['Float']>;
  isIncludeHoliday: Scalars['Boolean'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  submittedDate?: Maybe<Scalars['DateTime']>;
  submittedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  commonStatus: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  allocation?: Maybe<Array<AllocationEntity>>;
  billItemId: Scalars['String'];
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  generationBatch?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  allowReversal: Scalars['Boolean'];
  waiveAmt: Scalars['Float'];
};

export type LateInterestEntity = {
  __typename?: 'lateInterestEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentAmount: Scalars['Float'];
  totalNegotiateAmt: Scalars['Float'];
  totalWaiveAmt: Scalars['Float'];
  description: Scalars['String'];
  bankAccount?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  submittedDate?: Maybe<Scalars['DateTime']>;
  submittedBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  commonStatus: Scalars['String'];
  taxSchemeId: Scalars['String'];
};

export type Lead3rdPartyIntegrationPostLogEntity = {
  __typename?: 'lead3rdPartyIntegrationPostLogEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  integrationType: Scalars['String'];
  receiveDate: Scalars['DateTime'];
  body: Scalars['JSONObject'];
  modifiedDate?: Maybe<Scalars['DateTime']>;
  isSuccess: Scalars['Boolean'];
  response?: Maybe<Scalars['String']>;
  header: Scalars['JSONObject'];
};

export type Lead3rdpartyIntegrationEntity = {
  __typename?: 'lead3rdpartyIntegrationEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  integrationType: Scalars['String'];
  title: Scalars['String'];
  commonStatus: Scalars['String'];
  integrationUrl?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  token?: Maybe<Scalars['String']>;
  loginId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  project?: Maybe<ProjectEntity>;
};

export type LeadActivityEntity = {
  __typename?: 'leadActivityEntity';
  id: Scalars['String'];
  leadId: Scalars['String'];
  activityDesc?: Maybe<Scalars['String']>;
  activityType: Scalars['String'];
  activityDate: Scalars['DateTime'];
  leadStatus: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  followUpDate?: Maybe<Scalars['DateTime']>;
  followUpRemark?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  actionBy?: Maybe<Scalars['String']>;
  fromPersonId?: Maybe<Scalars['String']>;
  fromProject: ProjectEntity;
  fromTeam: SaleTeamEntity;
  lead: LeadEntity;
  personId?: Maybe<Scalars['String']>;
  project: ProjectEntity;
  team: SaleTeamEntity;
  activityAudio?: Maybe<Scalars['String']>;
};

export type LeadAddressEntity = {
  __typename?: 'leadAddressEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  contactId: Scalars['String'];
  address: AddressJson;
  leadContact: LeadContactEntity;
  isPrimary: Scalars['Boolean'];
};

export type LeadAssignmentSettingEntity = {
  __typename?: 'leadAssignmentSettingEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  userId: Scalars['String'];
  weight: Scalars['Float'];
  seq: Scalars['Float'];
  leadCount: Scalars['Float'];
  lastAssign: Scalars['DateTime'];
};

export type LeadBatchEntity = AuditEntity & {
  __typename?: 'leadBatchEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  batchTitle: Scalars['String'];
  recordCount: Scalars['Float'];
  leads: Array<LeadEntity>;
  accountId: Scalars['String'];
  lastAssignedToProject: LeadActivityEntity;
  assignedToProjectLeadCount: Scalars['Float'];
};

export type LeadContactEntity = {
  __typename?: 'leadContactEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  fullName: Scalars['String'];
  email: Scalars['String'];
  altEmail?: Maybe<Array<Scalars['String']>>;
  phoneNo: Scalars['String'];
  dob?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  icNo?: Maybe<Scalars['String']>;
  militaryIc?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyRegNo?: Maybe<Scalars['String']>;
  address?: Maybe<AddressJson>;
  homeTel?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  distance: Scalars['Float'];
  bookingWaitlists: Array<BookingWaitlistEntity>;
  jointBuyers: Array<JointBuyerEntity>;
  leads?: Maybe<Array<LeadEntity>>;
  sales: Array<SaleEntity>;
  leadJointBuyers: Array<LeadJointBuyerEntity>;
  salutation?: Maybe<SalutationEntity>;
  nationality?: Maybe<SNationalityEntity>;
  race?: Maybe<RaceEntity>;
  maritalStatus?: Maybe<MaritalStatusEntity>;
  incomeRange?: Maybe<IncomeRangeEntity>;
  addressList?: Maybe<Array<LeadAddressEntity>>;
  identityType?: Maybe<Scalars['String']>;
  signatureUrl?: Maybe<Scalars['String']>;
  jointBuyerSignature?: Maybe<Scalars['String']>;
  leadAddress?: Maybe<Array<AddressJson>>;
};

export type LeadEntity = {
  __typename?: 'leadEntity';
  id: Scalars['String'];
  leadStatus: Scalars['String'];
  assignStatus?: Maybe<Scalars['String']>;
  accountId: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  batchId?: Maybe<Scalars['String']>;
  contactId: Scalars['String'];
  leadSourceId: Scalars['String'];
  eventId?: Maybe<Scalars['String']>;
  incomeRangeId?: Maybe<Scalars['String']>;
  propertyTypeId?: Maybe<Scalars['String']>;
  agencyAcctId?: Maybe<Scalars['String']>;
  preferLocation?: Maybe<Scalars['String']>;
  referralName?: Maybe<Scalars['String']>;
  referralContactNo?: Maybe<Scalars['String']>;
  referralReferenceNo?: Maybe<Scalars['String']>;
  lastLeadActId?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  batch: LeadBatchEntity;
  contact: LeadContactEntity;
  leadSource: LeadSourceEntity;
  project: ProjectEntity;
  salesPersonId: Scalars['String'];
  teamId: Scalars['String'];
  team?: Maybe<SaleTeamEntity>;
  unit: UnitEntity;
  leadActivities: Array<LeadActivityEntity>;
  sales: Array<SaleEntity>;
  waitingList: Array<BookingWaitlistEntity>;
  leadJointBuyers: Array<LeadJointBuyerEntity>;
  occupation?: Maybe<Scalars['String']>;
  utm_id?: Maybe<Scalars['String']>;
  utm_source?: Maybe<Scalars['String']>;
  utm_medium?: Maybe<Scalars['String']>;
  utm_campaign?: Maybe<Scalars['String']>;
  utm_term?: Maybe<Scalars['String']>;
  utm_content?: Maybe<Scalars['String']>;
  salesPerson?: Maybe<UserEntity>;
  leadDetailsActivity?: Maybe<Array<LeadActivityDetails>>;
  events?: Maybe<EventsEntity>;
  LeadActivity: Scalars['JSONObject'];
  LeadStatus: Scalars['JSONObject'];
  incomeRange?: Maybe<IncomeRangeEntity>;
  propertyType?: Maybe<PropertyTypeEntity>;
  loanScreening?: Maybe<LoanScreenStatusOutput>;
  leadAddress?: Maybe<Array<AddressJson>>;
};

export type LeadJointBuyerEntity = {
  __typename?: 'leadJointBuyerEntity';
  id: Scalars['String'];
  contactId: Scalars['String'];
  leadId: Scalars['String'];
  contact: LeadContactEntity;
  lead: LeadEntity;
  commonStatus: Scalars['String'];
};

export type LeadSourceEntity = {
  __typename?: 'leadSourceEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  systemUse: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seqNo?: Maybe<Scalars['Float']>;
  leads: Array<LeadEntity>;
  sales: Array<SaleEntity>;
  isDeletable: Scalars['Boolean'];
};

export type LedgerEntity = {
  __typename?: 'ledgerEntity';
  id: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  docAmount: Scalars['String'];
  referenceNo?: Maybe<Scalars['String']>;
  trxDate: Scalars['DateTime'];
  taxAmount?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  mode: Scalars['String'];
  trxStatus: Scalars['String'];
  voidDate?: Maybe<Scalars['DateTime']>;
  voidReason?: Maybe<Scalars['String']>;
  postedDate?: Maybe<Scalars['DateTime']>;
  paymentMethod?: Maybe<Scalars['String']>;
  paymentInclude?: Maybe<Scalars['Boolean']>;
  interestInvoice: Array<InterestEntity>;
  interestLegder: Array<InterestEntity>;
  account_id: Scalars['String'];
  adjustmentType?: Maybe<Scalars['String']>;
  debtorClass?: Maybe<Scalars['String']>;
  trxClass?: Maybe<Scalars['String']>;
  invoice: LedgerEntity;
  ledgers: Array<LedgerEntity>;
  project: ProjectEntity;
  sale: SaleEntity;
  schedule: ScheduleEntity;
  tax_id: Scalars['String'];
  reminders: Array<ReminderEntity>;
};

export type LetterSignEntity = AuditEntity & {
  __typename?: 'letterSignEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  contactId: Scalars['String'];
  sale: SaleEntity;
};

export type LetterTemplateEntity = AuditEntity & {
  __typename?: 'letterTemplateEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  standardLetterId: Scalars['String'];
  name: Scalars['String'];
  templateBody?: Maybe<Scalars['String']>;
  jointBuyerSignRequired: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  standardLetter: StandardLetterEntity;
  projectLetter: Array<ProjectLetterEntity>;
  standardLetterDataSourceVersion?: Maybe<Scalars['Float']>;
  isReportDesignEditor: Scalars['Boolean'];
  defaulted: Scalars['Boolean'];
  allowToDelete: Scalars['Boolean'];
};

export type LoanAssignmentInput = {
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  endFinUserReceive?: Maybe<Scalars['Boolean']>;
};

export type LoanAssignmentOutput = {
  __typename?: 'loanAssignmentOutput';
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  endFinUserReceive?: Maybe<Scalars['Boolean']>;
};

export type LoanPaymentEntity = {
  __typename?: 'loanPaymentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleLoanReleaseNotificationId: Scalars['String'];
  documentDate: Scalars['DateTime'];
  documentAmt: Scalars['Float'];
  bankAccountId: Scalars['String'];
  saleLoanPaymentPlanDetails?: Maybe<Array<SaleLoanNotice>>;
  postDate?: Maybe<Scalars['DateTime']>;
  postBy?: Maybe<Scalars['String']>;
  approvalStatus: Scalars['String'];
  commonStatus: Scalars['String'];
  loanPaymentNo?: Maybe<Scalars['String']>;
};

export type LoanScreenEntity = {
  __typename?: 'loanScreenEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  serviceProvider: Scalars['String'];
  caseCode?: Maybe<Scalars['String']>;
  refCode?: Maybe<Scalars['String']>;
  reportType: Scalars['String'];
  payload: Scalars['JSONObject'];
  reportUrl?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  refTable: Scalars['String'];
  refId: Scalars['String'];
  project: ProjectEntity;
};

export type MaritalStatusEntity = {
  __typename?: 'maritalStatusEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  commonStatus: Scalars['String'];
  systemUse: Scalars['Boolean'];
  defaulted: Scalars['Boolean'];
  seqNo?: Maybe<Scalars['Float']>;
  contacts: Array<ContactEntity>;
  isDeletable: Scalars['Boolean'];
};

export type MasteringVaEntity = {
  __typename?: 'masteringVAEntity';
  id: Scalars['String'];
  bankGroup: Scalars['String'];
  companyCode: Scalars['String'];
  sequenceNumber: Scalars['String'];
  remark?: Maybe<Scalars['String']>;
  effectiveDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  units?: Maybe<Array<UnitEntity>>;
  projectId: Scalars['String'];
  statusVa: Scalars['String'];
  format?: Maybe<Array<FormatVa>>;
};

export type MiscBillingEntity = {
  __typename?: 'miscBillingEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentDate: Scalars['DateTime'];
  documentAmount: Scalars['Float'];
  dueDate: Scalars['DateTime'];
  creditTerm: Scalars['Float'];
  isIncludeHoliday: Scalars['Boolean'];
  requestedBy?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  generationBatch?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated?: Maybe<Scalars['Boolean']>;
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  commonStatus: Scalars['String'];
  voidDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  sales?: Maybe<SaleEntity>;
  billItemId: Scalars['String'];
  allowReversal: Scalars['Boolean'];
};

export type MortgagePaymentEntity = {
  __typename?: 'mortgagePaymentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  endfinancierMortgagePlanId: Scalars['String'];
  name: Scalars['String'];
  percentage: Scalars['String'];
  paymentEvent: Scalars['String'];
  eventItem?: Maybe<Scalars['String']>;
  eventStatutoryDocId?: Maybe<Scalars['String']>;
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  saleLoanPayment: SaleLoanPaymentEntity;
  saleLoanRelease: SaleLoanReleaseEntity;
};

export type MortgagePlanEntity = {
  __typename?: 'mortgagePlanEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  financierId: Scalars['String'];
  name: Scalars['String'];
  saleLoan: SaleLoanEntity;
  saleLoanRelease: SaleLoanReleaseEntity;
};

export type MortgageRetentionEntity = {
  __typename?: 'mortgageRetentionEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  endfinMortgagePaymentId: Scalars['String'];
  name: Scalars['String'];
  retentionBy: Scalars['String'];
  retentionValue: Scalars['String'];
  retentionEvent: Scalars['String'];
  eventItem?: Maybe<Scalars['String']>;
  eventStatutoryDocId?: Maybe<Scalars['String']>;
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  saleLoanRetention: SaleLoanRetentionEntity;
  saleLoanRelease: SaleLoanReleaseEntity;
};

export type MotTrackingEntity = {
  __typename?: 'motTrackingEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  titleExecutionDate: Scalars['DateTime'];
  titleNotificationDate: Scalars['DateTime'];
  titleForward: Scalars['DateTime'];
  motReceiptNo: Scalars['String'];
  motTransferDate: Scalars['DateTime'];
  motSubmissionNo?: Maybe<Scalars['String']>;
  motSubmissionDate: Scalars['DateTime'];
  motMortgageNo: Scalars['String'];
  motMortgageDate: Scalars['DateTime'];
  instructionToSolicitor: Scalars['DateTime'];
  motIn: Scalars['DateTime'];
  motOut: Scalars['DateTime'];
  receiveMotCancellation: Scalars['DateTime'];
  forwardMotDirector: Scalars['DateTime'];
  receiveMotDirector: Scalars['DateTime'];
  forwardMotComSec: Scalars['DateTime'];
  receiveMotComSec: Scalars['DateTime'];
  receiveLawyerAcknowledgement: Scalars['DateTime'];
  requestForTitle: Scalars['DateTime'];
  releaseForTitle: Scalars['DateTime'];
  receivedTitleDutyTransferred: Scalars['DateTime'];
  confirmationPresentationReceipt: Scalars['DateTime'];
  receivedFrom?: Maybe<Scalars['String']>;
  stampDutyPaymentDate: Scalars['DateTime'];
  stampDutyPayment: Scalars['Float'];
  remark?: Maybe<Scalars['String']>;
  motSolicitorId: Scalars['String'];
  motSolicitorReferenceNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  units?: Maybe<UnitEntity>;
};

export type NewsAnnouncementEntity = AuditEntity & {
  __typename?: 'newsAnnouncementEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  title: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  isPublish: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  newsProjects: Array<NewsProjectEntity>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  isExpired?: Maybe<Scalars['Boolean']>;
};


export type NewsAnnouncementEntityAttachmentArgs = {
  limit?: Maybe<Scalars['Float']>;
};

export type NewsProjectEntity = AuditEntity & {
  __typename?: 'newsProjectEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  newsId: Scalars['String'];
  projectId: Scalars['String'];
  commonStatus: Scalars['String'];
  newsAnnouncement: NewsAnnouncementEntity;
};

export type NotaryContactEntity = {
  __typename?: 'notaryContactEntity';
  id: Scalars['String'];
  notaryAppointedId: Scalars['String'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNo: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type NotaryEntity = {
  __typename?: 'notaryEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  notaryId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  notaryCode?: Maybe<Scalars['String']>;
  ppatNo?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  invitationLink?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type NotaryProjectEntity = {
  __typename?: 'notaryProjectEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  notaryId?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
};

export type NumberFormatEntity = {
  __typename?: 'numberFormatEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  numberFormat: Scalars['String'];
  numberType: Scalars['String'];
  commonStatus: Scalars['String'];
  companyNumberSetups: Array<CompanyNumberSetupEntity>;
};

export type NupEntity = {
  __typename?: 'nupEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
  companyId: Scalars['String'];
  unitId: Scalars['String'];
  contactId?: Maybe<Scalars['String']>;
  typeId: Scalars['String'];
  mediaId: Scalars['String'];
  code: Scalars['String'];
  status: Scalars['String'];
  amount: Scalars['Float'];
  description?: Maybe<Scalars['String']>;
  remarks?: Maybe<Scalars['String']>;
  ktpUrl?: Maybe<Scalars['String']>;
  npwpUrl?: Maybe<Scalars['String']>;
  paymentUrl?: Maybe<Scalars['String']>;
  reasonId: Scalars['String'];
  rejectedBy?: Maybe<Scalars['String']>;
  reservedDate?: Maybe<Scalars['DateTime']>;
  rejectedDate?: Maybe<Scalars['DateTime']>;
  expiredDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  nupNumber?: Maybe<Scalars['String']>;
  professionId?: Maybe<Scalars['String']>;
  religionId?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  salutationId?: Maybe<SalutationEntity>;
  nationalityId?: Maybe<SNationalityEntity>;
  maritalStatusId?: Maybe<MaritalStatusEntity>;
  address: AddressJson;
  contact: ContactNupJson;
};

export type NupReasonEntity = {
  __typename?: 'nupReasonEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type NupTypeEntity = {
  __typename?: 'nupTypeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  companyId: Scalars['String'];
  type: Scalars['String'];
  description: Scalars['String'];
  amount: Scalars['Float'];
  prefix: Scalars['String'];
  viaMobile: Scalars['Boolean'];
  viaAgent: Scalars['Boolean'];
  refundable: Scalars['Boolean'];
  discount: Scalars['Float'];
  expiredTime: Scalars['Float'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

/** JsonType */
export type OldSaleDetail = {
  __typename?: 'oldSaleDetail';
  discounts?: Maybe<Array<DiscountListingObject>>;
};

export type OldSaleDetailInput = {
  discounts?: Maybe<Array<DiscountListingUnitTransferInput>>;
};

export type OpenLeadAssignmentSettingEntity = {
  __typename?: 'openLeadAssignmentSettingEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  userId: Scalars['String'];
  weight: Scalars['Float'];
  seq: Scalars['Float'];
  leadCount: Scalars['Float'];
  lastAssign: Scalars['DateTime'];
};

export type OpenLeadAssignmentSettingOutput = {
  __typename?: 'openLeadAssignmentSettingOutput';
  leadAssignmentId: Scalars['String'];
  staffName: Scalars['String'];
  staffId: Scalars['String'];
  weightage: Scalars['Float'];
  seqNo: Scalars['Float'];
};

export type OverduedPurchaserAccountDetailsEntity = {
  __typename?: 'overduedPurchaserAccountDetailsEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  overduedPurchaserAccountId: Scalars['String'];
  billMethod: Scalars['String'];
  refId: Scalars['String'];
  commonStatus: Scalars['String'];
  overduedPurchaserAccount: OverduedPurchaserAccountEntity;
};

export type OverduedPurchaserAccountEntity = {
  __typename?: 'overduedPurchaserAccountEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  assignTo?: Maybe<Scalars['String']>;
  assignedDate?: Maybe<Scalars['DateTime']>;
  batchId: Scalars['String'];
  generateDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  overduedPurchaserAccountDetails?: Maybe<OverduedPurchaserAccountDetailsEntity>;
};

export type PackageEntity = {
  __typename?: 'packageEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  desc?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  listPrice: Scalars['Float'];
  marketValue: Scalars['Float'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  isIntegrated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  project: ProjectEntity;
  salesPackage: Array<SaleEntity>;
  integrationPackage: Array<IntegrationPackageEntity>;
  packageExt?: Maybe<PackageExtEntity>;
  salesContractPackage?: Maybe<SalePackageEntity>;
  isDeletable: Scalars['Boolean'];
};

export type PackageExtEntity = {
  __typename?: 'packageExtEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  packageId: Scalars['String'];
  taxSchemeId: Scalars['String'];
  defaulted: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  package: PackageEntity;
};

export type PackagesInstallmentEntity = {
  __typename?: 'packagesInstallmentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  salePackageId: Scalars['String'];
  rescheduleId?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['DateTime']>;
  documentAmt?: Maybe<Scalars['Float']>;
  baseAmt?: Maybe<Scalars['Float']>;
  taxAmt?: Maybe<Scalars['Float']>;
  transDate?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  glGenerated?: Maybe<Scalars['String']>;
  billType?: Maybe<Scalars['String']>;
  packagesPaymentId?: Maybe<Scalars['String']>;
  packagesPaymentPlan: PackagesPaymentPlanEntity;
  documentNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type PackagesPaymentPlanEntity = {
  __typename?: 'packagesPaymentPlanEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  salePackageId: Scalars['String'];
  billType: BillType;
  paymentAmt: Scalars['Float'];
  purchaserPaymentPlanDetailsId: Scalars['String'];
  noInstallment: Scalars['Float'];
  billCount: Scalars['Float'];
  billFrequency: BillFrequency;
  billAfter: BillAfter;
  packagesInstallment: Array<PackagesInstallmentEntity>;
  purchaserPaymentPlanDetails: PurchaserPaymentPlanDetailsEntity;
  salePackage: SalePackageEntity;
};

export type ParameterEntity = {
  __typename?: 'parameterEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  parameterType: Scalars['String'];
  name: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  defaulted: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  saleContact: SaleContactEntity;
};

export type PasswordPolicyEntity = {
  __typename?: 'passwordPolicyEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  requiredMinNoCharacter?: Maybe<Scalars['Float']>;
  requiredUpperLowerCase: Scalars['Boolean'];
  requiredDigit: Scalars['Boolean'];
  requiredSpecialCharacter: Scalars['Boolean'];
  passwordResetByDay?: Maybe<Scalars['Float']>;
  notAllowReusePasswordForLast?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
};

export type PaymentGatewayEntity = {
  __typename?: 'paymentGatewayEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  gatewayType: Scalars['String'];
  title: Scalars['String'];
  gatewayInfo: Scalars['JSONObject'];
  commonStatus: Scalars['String'];
  projectSpecs: Array<ProjectSpecEntity>;
  gatewayTypeDesc: Scalars['String'];
  lastUpdate?: Maybe<Scalars['DateTime']>;
  assignedProjectCount: Scalars['Float'];
  isDeletable: Scalars['Boolean'];
};

export type PaymentPlanDetailEntity = {
  __typename?: 'paymentPlanDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  paymentPlanId: Scalars['String'];
  title: Scalars['String'];
  stageSeqNo: Scalars['Float'];
  isDownpayment: Scalars['Boolean'];
  isWithInterest: Scalars['Boolean'];
  workProgressId: Scalars['String'];
  amountType: Scalars['String'];
  amountValue: Scalars['Float'];
  numberOfPayment?: Maybe<Scalars['Float']>;
  stakeholderDuration?: Maybe<Scalars['Float']>;
  isStakeholder: Scalars['Boolean'];
  isVpStage: Scalars['Boolean'];
  installmentBillingDay?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
  includeInDetailId?: Maybe<Array<IncludeInDetail>>;
  workProgress?: Maybe<WorkProgressEntity>;
  architectCertWorkProgress?: Maybe<ArchitectCertWorkProgressEntity>;
  payment: PaymentPlanEntity;
  progressBilling?: Maybe<Array<ProgressBillingEntity>>;
};

export type PaymentPlanEntity = {
  __typename?: 'paymentPlanEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  payMethod?: Maybe<Scalars['String']>;
  effectiveDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  details?: Maybe<Array<PaymentPlanDetailEntity>>;
  projectPaymentPlan?: Maybe<Array<ProjectPaymentPlanEntity>>;
  unitExt?: Maybe<UnitExtensionEntity>;
  saleExt?: Maybe<SaleExtensionEntity>;
};

export type PaymentReminderDocumentOutput = {
  __typename?: 'paymentReminderDocumentOutput';
  docNo: Scalars['String'];
  desc?: Maybe<Scalars['String']>;
  balanceAmt: Scalars['Float'];
  docAmt: Scalars['Float'];
  reminderSeq: Scalars['Float'];
};

export type PaymentReminderEntity = {
  __typename?: 'paymentReminderEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  saleId: Scalars['String'];
  refTable: Scalars['String'];
  refId: Scalars['String'];
  reminderSeq: Scalars['Float'];
  balanceAmount: Scalars['Float'];
  intervalDays: Scalars['Float'];
  reminderNo?: Maybe<Scalars['String']>;
  generationBatch?: Maybe<Scalars['String']>;
  share?: Maybe<Array<ShareObject>>;
  commonStatus: Scalars['String'];
};

export type PaymentReminderRawOutput = {
  __typename?: 'paymentReminderRawOutput';
  reminderDate: Scalars['DateTime'];
  buyerName: Scalars['String'];
  correspondenceAddress?: Maybe<AddressPaymentReminder>;
  email: Scalars['String'];
  unitNo: Scalars['String'];
  unitPrice?: Maybe<Scalars['Float']>;
  unitPhase?: Maybe<Scalars['Float']>;
  builtUpArea?: Maybe<Scalars['Float']>;
  actualBuiltUpArea?: Maybe<Scalars['Float']>;
  projectName?: Maybe<Scalars['String']>;
  projectAddress?: Maybe<Scalars['String']>;
  projectCity?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyAddress?: Maybe<AddressPaymentReminder>;
  companyOfficeTel?: Maybe<Scalars['String']>;
  companyEmail?: Maybe<Scalars['String']>;
  clusterName?: Maybe<Scalars['String']>;
  clusterCode?: Maybe<Scalars['String']>;
  townshipName?: Maybe<Scalars['String']>;
  floorLabel?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  billingList: Array<PaymentReminderDocumentOutput>;
};

export type PdfOutput = {
  __typename?: 'pdfOutput';
  base64: Scalars['String'];
  fileName: Scalars['String'];
};

export type PermissionRoleAssignmentEntity = AuditEntity & {
  __typename?: 'permissionRoleAssignmentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  roleId: Scalars['String'];
  permissionId: Scalars['Float'];
  permission_uuid: Scalars['String'];
  permission: PermissionEntity;
};

export type PictureBlockEntity = {
  __typename?: 'pictureBlockEntity';
  id: Scalars['String'];
  block: Scalars['String'];
  seqNo: Scalars['Float'];
  project: ProjectEntity;
  resource: ResourceEntity;
};

export type PictureFloorEntity = {
  __typename?: 'pictureFloorEntity';
  id: Scalars['String'];
  block: Scalars['String'];
  floor: Scalars['Float'];
  seqNo: Scalars['Float'];
  project: ProjectEntity;
  resource: ResourceEntity;
};

export type PictureGalleryEntity = {
  __typename?: 'pictureGalleryEntity';
  id: Scalars['String'];
  seqNo: Scalars['Float'];
  project: ProjectEntity;
  resource: ResourceEntity;
};

export type PictureUnitlayoutEntity = {
  __typename?: 'pictureUnitlayoutEntity';
  id: Scalars['String'];
  seqNo: Scalars['Float'];
  virtualModelLink: Scalars['String'];
  block: Scalars['String'];
  unitType?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  resource: ResourceEntity;
  unitLayout: UnitLayoutEntity;
  noOfBedroom: Scalars['Float'];
  noOfBathroom: Scalars['Float'];
  project: ProjectEntity;
};

export type PostLogEntity = {
  __typename?: 'postLogEntity';
  id: Scalars['String'];
  body: Scalars['JSONObject'];
  postDate: Scalars['DateTime'];
  response?: Maybe<Scalars['String']>;
  unitId?: Maybe<Scalars['Float']>;
  modifiedDate: Scalars['DateTime'];
  isSuccess: Scalars['Boolean'];
  retryCount?: Maybe<Scalars['Float']>;
  endpoint?: Maybe<Scalars['String']>;
};

export type PriceAdjustmentEntity = {
  __typename?: 'priceAdjustmentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  name: Scalars['String'];
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  reason: Scalars['String'];
  computationMode: Scalars['String'];
  computationValue: Scalars['Float'];
  remark?: Maybe<Scalars['String']>;
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  priceAdjustmentUnit: Array<PriceAdjustmentUnitEntity>;
};

export type PriceAdjustmentUnitEntity = {
  __typename?: 'priceAdjustmentUnitEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  commonStatus: Scalars['String'];
  priceAdjustmentId: Scalars['String'];
  unitId: Scalars['String'];
  unitListPrice: Scalars['Float'];
  newUnitListPrice: Scalars['Float'];
  priceAdjustments: PriceAdjustmentEntity;
  units: UnitEntity;
};

export type ProgressBillingEntity = {
  __typename?: 'progressBillingEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  billItemId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  paymentPlanDetailId: Scalars['String'];
  isStakeholder: Scalars['Boolean'];
  documentNo?: Maybe<Scalars['String']>;
  documentAmount?: Maybe<Scalars['Float']>;
  documentRef?: Maybe<Scalars['String']>;
  principalAmt?: Maybe<Scalars['Float']>;
  description: Scalars['String'];
  documentDate?: Maybe<Scalars['DateTime']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  creditTerm: Scalars['Float'];
  isIncludeHoliday: Scalars['Boolean'];
  isDownpayment: Scalars['Boolean'];
  isInstallment: Scalars['Boolean'];
  isVpStage: Scalars['Boolean'];
  interestRate?: Maybe<Scalars['Float']>;
  chargePercent: Scalars['Float'];
  stageSeqNo: Scalars['Float'];
  installmentSeqNo?: Maybe<Scalars['Float']>;
  generationBatchCreditTerm?: Maybe<Scalars['Float']>;
  generationBatch?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  addOnRefTable?: Maybe<Scalars['String']>;
  addOnRefId?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  paymentPlanDetail?: Maybe<PaymentPlanDetailEntity>;
  sales?: Maybe<SaleEntity>;
  subproduct?: Maybe<SaleSubproductEntity>;
  stakeholderProcess?: Maybe<StakeholderProcessEntity>;
  taxLedger?: Maybe<Array<TaxLedgerEntity>>;
  financialBilling?: Maybe<Array<FinancialBillingEntity>>;
  allowReversal: Scalars['Boolean'];
};

export type ProjectAreaVarianceEntity = {
  __typename?: 'projectAreaVarianceEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  name: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  formula?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type ProjectBankIndoEntity = {
  __typename?: 'projectBankIndoEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  bankAccountId: Scalars['String'];
  bankProfileId: Scalars['String'];
  commonStatus: Scalars['String'];
  project: ProjectEntity;
  bankAccount: CompanyBankAccountEntity;
};

export type ProjectCarparkPaymentPlanEntity = {
  __typename?: 'projectCarparkPaymentPlanEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  paymentPlanId: Scalars['String'];
  defaulted: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  purchaserPaymentPlan: PurchaserPaymentPlanEntity;
};

export type ProjectClusterEntity = {
  __typename?: 'projectClusterEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  name: Scalars['String'];
  desc: Scalars['String'];
  unitExt: Array<UnitExtensionEntity>;
};

export type ProjectCommissionEntity = AuditEntity & {
  __typename?: 'projectCommissionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  projectId: Scalars['ID'];
  commissionTypeId: Scalars['ID'];
  description: Scalars['String'];
  rateClassification: Scalars['String'];
  commonStatus: Scalars['String'];
  commissionType: CommissionTypeEntity;
  commissionPayments: Array<CommissionPaymentEntity>;
};

export type ProjectCommissionPackageDetailEntity = {
  __typename?: 'projectCommissionPackageDetailEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  projectCommissionPackageId: Scalars['ID'];
  type: Scalars['String'];
  refId?: Maybe<Scalars['ID']>;
  refTable?: Maybe<Scalars['String']>;
  effectiveDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  projectCommissionPackage: ProjectCommissionPackageEntity;
  commissionPackageTargets: Array<CommissionPackageTargetEntity>;
};

export type ProjectCommissionPackageEntity = {
  __typename?: 'projectCommissionPackageEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  projectId: Scalars['ID'];
  projectCommissionId: Scalars['ID'];
  principal: Scalars['String'];
  commonStatus: Scalars['String'];
  projectCommissionPackageDetails: Array<ProjectCommissionPackageDetailEntity>;
  projectCommission: ProjectCommissionEntity;
};

export type ProjectCommissionPackageInputDetailEntity = {
  __typename?: 'projectCommissionPackageInputDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  projectCommissionCalcId: Scalars['String'];
  projectCommissionPackageId: Scalars['String'];
  saleId: Scalars['String'];
  docDate: Scalars['DateTime'];
  docNo: Scalars['String'];
  netSelling: Scalars['Float'];
  commissionType: Scalars['String'];
  commissionDate: Scalars['DateTime'];
  commissionAmt: Scalars['Float'];
  commonStatus: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  modTs: Scalars['DateTime'];
  modBy: Scalars['String'];
  projectCommisionPackage?: Maybe<ProjectCommissionPackageEntity>;
};

export type ProjectCommissionPackageInputEntity = {
  __typename?: 'projectCommissionPackageInputEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  generateDate: Scalars['DateTime'];
  principal: Scalars['String'];
  employeeId: Scalars['String'];
  employeeName: Scalars['String'];
  totalSelling: Scalars['Float'];
  totalCommission: Scalars['Float'];
  commonStatus: Scalars['String'];
  createdBy: Scalars['String'];
  createdTs: Scalars['DateTime'];
  modTs: Scalars['DateTime'];
  modBy: Scalars['String'];
};

export type ProjectCommissionPackageListingEntity = {
  __typename?: 'projectCommissionPackageListingEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  projectId: Scalars['ID'];
  projectCommissionId: Scalars['ID'];
  principal: Scalars['String'];
  commonStatus: Scalars['String'];
  packageTypes: Array<ProjectCommissionPackageDetailEntity>;
  projectCommissionPackageDetails: Array<ProjectCommissionPackageDetailEntity>;
  projectCommission: ProjectCommissionEntity;
};

export type ProjectCommissionPackageTypes = {
  __typename?: 'projectCommissionPackageTypes';
  id: Scalars['ID'];
  name: Scalars['String'];
  projectCommissionPackageDetails: Array<ProjectCommissionPackageDetailEntity>;
};

export type ProjectCommissionTeamDetailEntity = {
  __typename?: 'projectCommissionTeamDetailEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  projectId: Scalars['ID'];
  projectCommissionTeamId: Scalars['ID'];
  principal: Scalars['String'];
  positionId: Scalars['ID'];
  agencyAppointedId?: Maybe<Scalars['ID']>;
  level?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['ID']>;
  commonStatus: Scalars['String'];
  projectCommissionTeam: ProjectCommissionTeamEntity;
  parent?: Maybe<ProjectCommissionTeamDetailEntity>;
  children?: Maybe<Array<ProjectCommissionTeamDetailEntity>>;
  position?: Maybe<JobPositionEntity>;
  agency?: Maybe<AgencyAppointedEntity>;
};

export type ProjectCommissionTeamEntity = {
  __typename?: 'projectCommissionTeamEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  projectId: Scalars['ID'];
  generateDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  details: Array<ProjectCommissionTeamDetailEntity>;
};

export type ProjectConstructionEntity = {
  __typename?: 'projectConstructionEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  architectureStructure?: Maybe<Scalars['String']>;
  numberBlockUnit?: Maybe<Scalars['Float']>;
  landProprietor?: Maybe<Scalars['String']>;
  planner?: Maybe<Scalars['String']>;
  buildingDesigner?: Maybe<Scalars['String']>;
  superStructureType?: Maybe<Scalars['String']>;
  propertyAgent?: Maybe<Scalars['String']>;
  architect?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  landPermitDate?: Maybe<Scalars['DateTime']>;
  taxRegNo?: Maybe<Scalars['String']>;
  spaDuration?: Maybe<Scalars['Float']>;
  basePrice?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
};

export type ProjectDiscountEntity = {
  __typename?: 'projectDiscountEntity';
  id: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  expired_date: Scalars['DateTime'];
  projectId: Scalars['String'];
  discountId: Scalars['String'];
  project: ProjectEntity;
  defaulted: Scalars['Boolean'];
  discount: DiscountEntity;
  commonStatus: Scalars['String'];
};

export type ProjectEmailLetterEntity = AuditEntity & {
  __typename?: 'projectEmailLetterEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  commonStatus: Scalars['String'];
  emailLetterTemplateId: Scalars['String'];
  projectId: Scalars['String'];
  subject: Scalars['String'];
  templateBody: Scalars['String'];
  project: ProjectEntity;
  emailLetterTemplate: EmailLetterTemplateEntity;
};

export type ProjectEntity = {
  __typename?: 'projectEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  townshipName?: Maybe<Scalars['String']>;
  desc?: Maybe<Scalars['String']>;
  completionDate?: Maybe<Scalars['DateTime']>;
  launchDate?: Maybe<Scalars['DateTime']>;
  projectAddress?: Maybe<Scalars['String']>;
  saleGalleryAddress?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  projectGps?: Maybe<Scalars['String']>;
  saleGalleryGps?: Maybe<Scalars['String']>;
  minPrice?: Maybe<Scalars['Float']>;
  maxPrice?: Maybe<Scalars['Float']>;
  amenities?: Maybe<Array<Amenities>>;
  tenure: Scalars['String'];
  landType: Scalars['String'];
  uom: Scalars['String'];
  isIntegrated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  projectCode: Scalars['String'];
  country: Scalars['String'];
  currency: Scalars['String'];
  vpDate?: Maybe<Scalars['DateTime']>;
  videoLink?: Maybe<Array<MediaSource>>;
  virtualModelLink?: Maybe<Array<MediaSource>>;
  allocations: Array<AllocationEntity>;
  bookingWaitlists: Array<BookingWaitlistEntity>;
  endfinProjectFinanciers: Array<EndfinProjectFinancierEntity>;
  interests: Array<InterestEntity>;
  leads: Array<LeadEntity>;
  leadActivitiesFromProject: Array<LeadActivityEntity>;
  saleTeamAllocation: Array<SaleTeamAllocationEntity>;
  leadActivitiesProject: Array<LeadActivityEntity>;
  ledgers: Array<LedgerEntity>;
  pictureBlocks: Array<PictureBlockEntity>;
  pictureFloors: Array<PictureFloorEntity>;
  pictureGalleries: Array<PictureGalleryEntity>;
  accountId: Scalars['String'];
  developmentCompanyId: Scalars['String'];
  holdingCompanyId: Scalars['String'];
  developmentCompany: CompanyEntity;
  holdingCompany: CompanyEntity;
  projectType: ProjectTypeEntity;
  projectSpecs: ProjectSpecEntity;
  reminders: Array<ReminderEntity>;
  sales: Array<SaleEntity>;
  salesCharts: Array<SalesChartEntity>;
  schedules: Array<ScheduleEntity>;
  units: Array<UnitEntity>;
  unitLayouts: Array<UnitLayoutEntity>;
  packages: Array<PackageEntity>;
  integrationDiscount: Array<IntegrationDiscountEntity>;
  discounts: Array<ProjectDiscountEntity>;
  agencyContract: Array<AgencyContractEntity>;
  salesDoc: Array<SalesDocEntity>;
  loanScreens: Array<LoanScreenEntity>;
  projectIntegration: ProjectIntegrationEntity;
  projectLetter: Array<ProjectLetterEntity>;
  projectExt?: Maybe<ProjectExtEntity>;
  pictureUnitLayouts: Array<PictureUnitlayoutEntity>;
  saleLoan: SaleLoanEntity;
  projectEmailLetter: Array<ProjectEmailLetterEntity>;
  projectBankIndos: Array<ProjectBankIndoEntity>;
  firstGalleryImage?: Maybe<ProjectResourceOuput>;
  projectSpec: Array<ProjectSpecEntity>;
  landTypeDesc: Scalars['String'];
  tenureDesc: Scalars['String'];
  company?: Maybe<CompanyEntity>;
  existingPurchaser?: Maybe<Scalars['Float']>;
  embededYoutubeLink?: Maybe<Array<ProjectYoutubeLinkOutput>>;
  embededVimeoLink?: Maybe<Array<ProjectYoutubeLinkOutput>>;
  embededGoogleDriveLink?: Maybe<Array<ProjectYoutubeLinkOutput>>;
  virtualModel?: Maybe<Array<ProjectResourceOuput>>;
  galleryImage?: Maybe<Array<ProjectGalleryMediaOuput>>;
  blockGalleryImage?: Maybe<Array<ProjectBlockMediaOuput>>;
  pictureBlockUrl?: Maybe<Scalars['String']>;
  floorGalleryImage?: Maybe<Array<ProjectFloorMediaOuput>>;
  unitLayoutGalleryImage?: Maybe<Array<ProjectUnitLayoutMediaOuput>>;
  unitTourVirtual?: Maybe<Array<UnitTourVirtualOutput>>;
  attachment?: Maybe<Array<AttachmentEntity>>;
  projectDetailsUnit?: Maybe<Array<UnitEntity>>;
  resourcefloor?: Maybe<Array<ResourceEntity>>;
  resourceunitlayout?: Maybe<Array<ResourceEntity>>;
  builtup?: Maybe<Array<Scalars['Float']>>;
  totalLoanCount?: Maybe<Scalars['Float']>;
  activeLoans?: Maybe<ActiveLoanStatusOutput>;
  withdrawnLoans?: Maybe<WithdrawnLoanStatusOutput>;
  loanStatusList: Array<EndfinLoanAppStatusEntity>;
  distinctBlock: Array<Scalars['String']>;
  saleschartBlock: Array<Scalars['String']>;
  distinctBlockFloor?: Maybe<Array<ProjectUnitBlockFloorOuput>>;
  unitMinPrice?: Maybe<Scalars['String']>;
  unitMaxPrice?: Maybe<Scalars['String']>;
  unitMinBuiltUp?: Maybe<Scalars['String']>;
  unitMaxBuiltUp?: Maybe<Scalars['String']>;
  unitTypes?: Maybe<Array<UnitTypeOutput>>;
  agencySalesChartUnitDisplay?: Maybe<Array<AgencySalesChartOutput>>;
  agencyAppointedCount?: Maybe<AgencyAppointedCount>;
  solicitorCount?: Maybe<SolicitorStatusCount>;
  countUnitTotal: Scalars['Float'];
  countUnitAvailable: Scalars['Float'];
  countUnitReserved: Scalars['Float'];
  countUnitSigned: Scalars['Float'];
  countUnassignedLeads: Scalars['Float'];
  leadStatusCount?: Maybe<LeadStatusCountOutput>;
  countWaitlistTotal: CountWaitingUnitOutput;
  countBookConfirmation?: Maybe<BookingConfirmationStatusOutput>;
  countBook?: Maybe<BookStatusOutput>;
  isSaleMade: Scalars['Boolean'];
  solicitorLayoutList?: Maybe<Array<SolicitorLayoutList>>;
  countLoan?: Maybe<LoanStatusOutput>;
  uomDesc: Scalars['String'];
  IsSubscribed: Scalars['JSONObject'];
  isManager: Scalars['Boolean'];
  priceRange?: Maybe<Scalars['String']>;
  allowBook: Scalars['Boolean'];
  agencyPermission?: Maybe<AgencyPermissionOutput>;
  authorizedAgent?: Maybe<AuthorizedAgentOutput>;
  agentTotalUnitSold?: Maybe<AgentTotalUnitSoldOutput>;
  agencyContractPolicy?: Maybe<AgencyContractPolicyOutput>;
  projectLastUpdate?: Maybe<Scalars['DateTime']>;
  galleryLastUpdate?: Maybe<Scalars['DateTime']>;
  layoutImagesLastUpdate?: Maybe<Scalars['DateTime']>;
  unitSetupLastUpdate?: Maybe<Scalars['DateTime']>;
  carParkSetupLastUpdate?: Maybe<Scalars['DateTime']>;
  salesChartLastUpdate?: Maybe<Scalars['DateTime']>;
  unitAllocationLastUpdate?: Maybe<Scalars['DateTime']>;
  projectBrochureLastUpdate?: Maybe<Scalars['DateTime']>;
  salesPackageLastUpdate?: Maybe<Scalars['DateTime']>;
  discountLastUpdate?: Maybe<Scalars['DateTime']>;
  efPanelLastUpdate?: Maybe<Scalars['DateTime']>;
  policySettingLastUpdate?: Maybe<Scalars['DateTime']>;
  solicitorLastUpdate?: Maybe<Scalars['DateTime']>;
  salesDocLastUpdate?: Maybe<Scalars['DateTime']>;
  roleAuthorizationLastUpdate?: Maybe<Scalars['DateTime']>;
  teamAssignmentLastUpdate?: Maybe<Scalars['DateTime']>;
  siteProgressLastUpdate?: Maybe<Scalars['DateTime']>;
  standardLetterLastUpdate?: Maybe<Scalars['DateTime']>;
  eLaunchLastUpdate?: Maybe<Scalars['DateTime']>;
  appointmentSchedulingLastUpdate?: Maybe<Scalars['DateTime']>;
};


export type ProjectEntityPictureBlockUrlArgs = {
  block: Scalars['String'];
};


export type ProjectEntityAgencySalesChartUnitDisplayArgs = {
  agencyId: Scalars['String'];
  block: Scalars['String'];
};


export type ProjectEntitySolicitorLayoutListArgs = {
  solicitorAppointedId?: Maybe<Scalars['String']>;
};


export type ProjectEntityAgentTotalUnitSoldArgs = {
  contactId: Scalars['String'];
};

export type ProjectExtEntity = {
  __typename?: 'projectExtEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  bankProfileId: Scalars['String'];
  bankAccountId?: Maybe<Scalars['String']>;
  plotNo?: Maybe<Scalars['String']>;
  townshipId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  project: ProjectEntity;
  companyBankProfile?: Maybe<CompanyBankProfileEntity>;
  companyBankAccount?: Maybe<CompanyBankAccountEntity>;
  township?: Maybe<TownshipEntity>;
};

export type ProjectFireInsuranceEntity = {
  __typename?: 'projectFireInsuranceEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  companyName?: Maybe<Scalars['String']>;
  companyAddress?: Maybe<AddressJson>;
  certificateNo?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type ProjectIntegrationEntity = {
  __typename?: 'projectIntegrationEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  integrationUrl?: Maybe<Scalars['String']>;
  integrationId?: Maybe<Scalars['String']>;
  ifcaCompanyId?: Maybe<Scalars['String']>;
  ifcaProjectId?: Maybe<Scalars['String']>;
  ifcaPhaseId?: Maybe<Scalars['String']>;
  ifcaCompanyName?: Maybe<Scalars['String']>;
  ifcaProjectName?: Maybe<Scalars['String']>;
  ifcaPhaseName?: Maybe<Scalars['String']>;
  integrationType?: Maybe<Scalars['String']>;
  paymentPlanId?: Maybe<Scalars['String']>;
  paymentPlanCode?: Maybe<Scalars['String']>;
  paymentPlanDesc?: Maybe<Scalars['String']>;
  gracePeriod?: Maybe<Scalars['String']>;
  isDiscountIntegrated: Scalars['Boolean'];
  isPackagesIntegrated: Scalars['Boolean'];
  isSolicitorIntegrated: Scalars['Boolean'];
  isRebateIntegrated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
};

export type ProjectKeyCollectionContractorEntity = {
  __typename?: 'projectKeyCollectionContractorEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  name: Scalars['String'];
  contactNo: Scalars['String'];
  email: Scalars['String'];
  contractorType: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type ProjectKeyCollectionScheduleEntity = {
  __typename?: 'projectKeyCollectionScheduleEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  startTime: Scalars['String'];
  endTime: Scalars['String'];
  interval: Scalars['Float'];
  teamMember: TeamMemberObject;
  commonStatus: Scalars['String'];
  timeslot: Array<ProjectKeyCollectionTimeSlotEntity>;
};

export type ProjectKeyCollectionTimeSlotEntity = {
  __typename?: 'projectKeyCollectionTimeSlotEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  collectionScheduleId: Scalars['String'];
  userId: Scalars['String'];
  scheduleDate: Scalars['DateTime'];
  scheduleTime: Scalars['String'];
  commonStatus: Scalars['String'];
  keyCollectionSchedule?: Maybe<ProjectKeyCollectionScheduleEntity>;
  appointment?: Maybe<KeyCollectionAppointmentEntity>;
};

export type ProjectLadEntity = {
  __typename?: 'projectLadEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  startWith: Scalars['String'];
  unitLadPercent: Scalars['Float'];
  unitDuration: Scalars['Float'];
  payoutPercent: Scalars['Float'];
  spaPercent?: Maybe<Scalars['Float']>;
  commonFacility: Scalars['Boolean'];
  facilityLadPercent?: Maybe<Scalars['Float']>;
  facilityLadDuration?: Maybe<Scalars['Float']>;
  taxSchemeId: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type ProjectLastActiveTransactionsEntity = {
  __typename?: 'projectLastActiveTransactionsEntity';
  project_id: Scalars['String'];
  transaction_date: Scalars['DateTime'];
  cancelled: Scalars['Float'];
  booked: Scalars['Float'];
  signed: Scalars['Float'];
  total: Scalars['Float'];
};

export type ProjectLateInterestEntity = {
  __typename?: 'projectLateInterestEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  loanGracePeriod: Scalars['Float'];
  minimumInterestAmount: Scalars['Float'];
  excludePaymentDate: Scalars['Boolean'];
  excludeHoliday: Scalars['Boolean'];
  enableFloatingInterest: Scalars['Boolean'];
  loanGracePeriodStartWith: Scalars['String'];
  taxSchemeId?: Maybe<Scalars['String']>;
};

export type ProjectLateInterestExceptionEntity = {
  __typename?: 'projectLateInterestExceptionEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  remark: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  commonStatus: Scalars['String'];
};

export type ProjectLetterEntity = {
  __typename?: 'projectLetterEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  defaulted: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  project: ProjectEntity;
  letterTemplate: LetterTemplateEntity;
};

export type ProjectLetterTemplateEntity = {
  __typename?: 'projectLetterTemplateEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  standardLetterId: Scalars['String'];
  name: Scalars['String'];
  templateBody?: Maybe<Scalars['String']>;
  jointBuyerSignRequired: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  standardLetter: StandardLetterEntity;
  defaulted: Scalars['Boolean'];
  standardLetterDataSourceVersion?: Maybe<Scalars['Float']>;
  isReportDesignEditor: Scalars['Boolean'];
};

export type ProjectMiscChargesEntity = {
  __typename?: 'projectMiscChargesEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  billItemId: Scalars['String'];
  interestRate: Scalars['Float'];
  remark?: Maybe<Scalars['String']>;
  formula: Scalars['String'];
  commonStatus: Scalars['String'];
  taxSchemeId: Scalars['String'];
};

export type ProjectPackagePaymentPlanEntity = {
  __typename?: 'projectPackagePaymentPlanEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  paymentPlanId: Scalars['String'];
  defaulted: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  purchaserPaymentPlan: PurchaserPaymentPlanEntity;
};

export type ProjectPaymentPlanEntity = {
  __typename?: 'projectPaymentPlanEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  paymentPlanId: Scalars['String'];
  defaulted: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  paymentPlan: PaymentPlanEntity;
  purchaserPaymentPlan: PurchaserPaymentPlanEntity;
};

export type ProjectPaymentReminderExceptionEntity = AuditEntity & {
  __typename?: 'projectPaymentReminderExceptionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  maxReminder?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
};

export type ProjectPermitEntity = {
  __typename?: 'projectPermitEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  permitNo: Scalars['String'];
  permitType: Scalars['String'];
  issueDate: Scalars['DateTime'];
  expiryDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
};

export type ProjectPolicyEntity = {
  __typename?: 'projectPolicyEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  interestRate: Scalars['Float'];
  creditTerms: Scalars['Float'];
  roundingPrecision: Scalars['String'];
  roundingMode: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type ProjectReminderEntity = AuditEntity & {
  __typename?: 'projectReminderEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  spaReminder1?: Maybe<Scalars['Float']>;
  spaReminder2?: Maybe<Scalars['Float']>;
  spaReminder3?: Maybe<Scalars['Float']>;
  spaReminder4?: Maybe<Scalars['Float']>;
  downpaymentReminder1?: Maybe<Scalars['Float']>;
  downpaymentReminder2?: Maybe<Scalars['Float']>;
  downpaymentReminder3?: Maybe<Scalars['Float']>;
  downpaymentReminder4?: Maybe<Scalars['Float']>;
  paymentReminder1: Scalars['Float'];
  paymentReminder2: Scalars['Float'];
  paymentReminder3: Scalars['Float'];
  paymentReminder4: Scalars['Float'];
  minimumAmount?: Maybe<Scalars['Float']>;
  reminderFor?: Maybe<Scalars['String']>;
  paymentReminderScheduler: Scalars['Boolean'];
  paymentReminderSchedulerTime: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type ProjectSalesPolicyDetailsEntity = {
  __typename?: 'projectSalesPolicyDetailsEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectSalesPolicyId: Scalars['String'];
  landAreaFrom?: Maybe<Scalars['Float']>;
  landAreaTo?: Maybe<Scalars['Float']>;
  depositAmount?: Maybe<Scalars['Float']>;
  recordStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  projectSalesPolicy: ProjectSalesPolicyEntity;
};

export type ProjectSalesPolicyEntity = {
  __typename?: 'projectSalesPolicyEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  npvBasicRate?: Maybe<NpvBasicRate>;
  npvRate?: Maybe<Scalars['Float']>;
  roundingPrecision: RoundingPrecisionInt;
  roundingMode: RoundingModeInt;
  interestBasicRate: InterestBasicRate;
  interestRate: Scalars['Float'];
  collectLandDeposit: Scalars['Boolean'];
  ujpMinimumDepositAmount: Scalars['Float'];
  ujpDepositAmount: Scalars['Float'];
  generateOverdueDebtorEvery: OverduePurchaserDay;
  generateOverdueDebtorTime: Scalars['String'];
  recordStatus: Scalars['String'];
  taxSchemeId: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  policyDetails: Array<ProjectSalesPolicyDetailsEntity>;
};

export type ProjectSpecEntity = {
  __typename?: 'projectSpecEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  bookingSignRequired: Scalars['Boolean'];
  bookingFormLang: Scalars['String'];
  lateInterestRate?: Maybe<Scalars['Float']>;
  creditTerm?: Maybe<Scalars['Float']>;
  gracePeriod?: Maybe<Scalars['Float']>;
  reminder_1Duration?: Maybe<Scalars['Float']>;
  reminder_2Duration?: Maybe<Scalars['Float']>;
  reminder_3Duration?: Maybe<Scalars['Float']>;
  reminder_4Duration?: Maybe<Scalars['Float']>;
  minBookingfeeAmount: Scalars['Float'];
  bookingfeeAmountRequired: Scalars['Boolean'];
  bookingFeeMandatory: Scalars['Boolean'];
  nricAttachmentRequired: Scalars['Boolean'];
  ccrAttachmentRequired: Scalars['Boolean'];
  minAgeRequired: Scalars['Boolean'];
  minAge?: Maybe<Scalars['Float']>;
  templateCompanyShow?: Maybe<Scalars['String']>;
  templatePackagesShow: Scalars['Boolean'];
  templateDiscountsShow: Scalars['Boolean'];
  templateAddressShow: Scalars['Boolean'];
  templateRemarksShow: Scalars['Boolean'];
  templateMaritalStatusShow: Scalars['Boolean'];
  bookingPDPAconsentRequired: Scalars['Boolean'];
  bookingRefundPolicyconsentRequired: Scalars['Boolean'];
  statementRefundPolicy?: Maybe<Scalars['String']>;
  loanconsentRequired: Scalars['Boolean'];
  loanScreening: Scalars['Boolean'];
  trGeneration: Scalars['Boolean'];
  ELetteringSMSRequired: Scalars['Boolean'];
  expectedSnpRequired: Scalars['Boolean'];
  expectedSnpDuration?: Maybe<Scalars['Float']>;
  autoAssignLeadActivated: Scalars['Boolean'];
  assignStartTime?: Maybe<Scalars['String']>;
  assignEndTime?: Maybe<Scalars['String']>;
  autoReassignLeadActivated: Scalars['Boolean'];
  autoReassignLeadDuration?: Maybe<Scalars['Float']>;
  reassignStartTime?: Maybe<Scalars['String']>;
  reassignEndTime?: Maybe<Scalars['String']>;
  notifyUnattendedLeadActivated: Scalars['Boolean'];
  notifyUnattendedLeadDuration?: Maybe<Scalars['Float']>;
  unattendedLeadNotificationMethod?: Maybe<Array<Scalars['String']>>;
  unattendedLeadManagerHandled?: Maybe<Array<Scalars['String']>>;
  leadAgingActivated: Scalars['Boolean'];
  leadAgingNotificationMethod?: Maybe<Array<Scalars['String']>>;
  leadIdleOne?: Maybe<Scalars['Float']>;
  leadIdleTwo?: Maybe<Scalars['Float']>;
  leadIdleThree?: Maybe<Scalars['Float']>;
  leadAgingManagerHandled?: Maybe<Array<Scalars['String']>>;
  alertAgingActivated: Scalars['Boolean'];
  salesAlertAging?: Maybe<SalesAlertAgingOutput>;
  loanAlertAging?: Maybe<LoanAlertAgingOutput>;
  solicitorAlertAging?: Maybe<SolicitorAlertAgingOutput>;
  paymentGatewayId?: Maybe<Scalars['String']>;
  paymentGatewayRefundPolicy?: Maybe<Scalars['String']>;
  paymentGateway?: Maybe<PaymentGatewayEntity>;
  project: ProjectEntity;
  purchaserAppSetting: Scalars['String'];
  unitSort: Scalars['String'];
  leadAssignNotificationActivated: Scalars['Boolean'];
  reservationSales: Scalars['Boolean'];
  reservationAgency: Scalars['Boolean'];
  autoReleaseReservationDay: Scalars['Float'];
  leadAssignNotificationMethod?: Maybe<Array<Scalars['String']>>;
  saleLeadNotification?: Maybe<SaleLeadNotificationOutput>;
  agencyLeadNotification?: Maybe<AgencyLeadNotificationOutput>;
  loanLeadNotification?: Maybe<LoanLeadNotificationOutput>;
  solicitorLeadNotification?: Maybe<SolicitorLeadNotificationOutput>;
  purchaserLeadNotification?: Maybe<PurchaserLeadNotificationOutput>;
  autoReleaseNotificationReminder?: Maybe<AutoReleaseNotificationReminderOutput>;
  display2DChart: Scalars['Boolean'];
  isIfcaReceiptDefaultDesc: Scalars['Boolean'];
  ifcaReceiptDesc: Scalars['String'];
  unitLockSales: Scalars['Boolean'];
  unitLockAgency: Scalars['Boolean'];
  unitLockDuration: Scalars['Float'];
  unitLockBufferDuration: Scalars['Float'];
  purchaserAppSubmenu?: Maybe<PurchaserAppSubmenuOutput>;
  leadEmailRequired: Scalars['Boolean'];
  getAccountSpec?: Maybe<AccountSpecEntity>;
  isReservationEnable?: Maybe<Scalars['Boolean']>;
  leadAgingManagerNames?: Maybe<Array<ProjectSpecManagerOutput>>;
  getSoftwareCode?: Maybe<Array<Scalars['JSONObject']>>;
  unattendedLeadManagerNames?: Maybe<Array<ProjectSpecManagerOutput>>;
  formLang?: Maybe<Scalars['String']>;
  SoftwareCode: Scalars['JSONObject'];
  purchaserAppSettings: Scalars['String'];
};

export type ProjectTitleEntity = AuditEntity & {
  __typename?: 'projectTitleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  titleType: Scalars['String'];
  titleNo: Scalars['String'];
  issueDate: Scalars['DateTime'];
  receiveDate: Scalars['DateTime'];
  expiryDate: Scalars['DateTime'];
  remark?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  projectTitleUnits: Array<ProjectTitleUnitEntity>;
};

export type ProjectTitleUnitEntity = {
  __typename?: 'projectTitleUnitEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  projectTitleId: Scalars['String'];
  unitId: Scalars['String'];
  commonStatus: Scalars['String'];
  projectTitle: ProjectTitleEntity;
  units: UnitEntity;
};

export type ProjectTypeEntity = {
  __typename?: 'projectTypeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  projects: Array<ProjectEntity>;
  seq_no?: Maybe<Scalars['Float']>;
  isDeletable: Scalars['Boolean'];
};

export type PromotionalItemEntity = {
  __typename?: 'promotionalItemEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  name: Scalars['String'];
  cost: Scalars['Float'];
  description: Scalars['String'];
  recordStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  promotionalPackagesItem?: Maybe<PromotionalPackagesItemEntity>;
};

export type PromotionalPackagesEntity = {
  __typename?: 'promotionalPackagesEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  name: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  recordStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  items?: Maybe<Array<PromotionalPackagesItemEntity>>;
  salePackage: SalePackageEntity;
};

export type PromotionalPackagesItemEntity = {
  __typename?: 'promotionalPackagesItemEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  promotionalPackagesId: Scalars['String'];
  promotionalItemId: Scalars['String'];
  costPrice: Scalars['Float'];
  promoPrice: Scalars['Float'];
  description: Scalars['String'];
  recordStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  packages: PromotionalPackagesEntity;
  promotionalItem: PromotionalItemEntity;
};

export type PropertyTypeEntity = {
  __typename?: 'propertyTypeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  landPlots: Scalars['Boolean'];
  commercialPurpose: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seq_no?: Maybe<Scalars['Float']>;
  units: Array<UnitEntity>;
  propertyTypeExt?: Maybe<PropertyTypeExtEntity>;
  commercialPurposeDesc: Scalars['String'];
  isDeletable: Scalars['Boolean'];
};

export type PropertyTypeExtEntity = {
  __typename?: 'propertyTypeExtEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  propertyTypeId: Scalars['String'];
  bookingFeeAmt: Scalars['Float'];
  commonStatus: Scalars['String'];
  propertyType: PropertyTypeEntity;
};

export type PurchaserAccountReferenceEntity = AuditEntity & {
  __typename?: 'purchaserAccountReferenceEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  userId: Scalars['String'];
  refId?: Maybe<Array<PurchaserReferenceOutput>>;
  commonStatus: Scalars['String'];
};

export type PurchaserAppCssInput = {
  logoUrl?: Maybe<Scalars['String']>;
  cardColor?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  backgroundSize?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  backgroundRepeat?: Maybe<Scalars['String']>;
  backgroundPosition?: Maybe<Scalars['String']>;
  backgroundAttachment?: Maybe<Scalars['String']>;
  showPurchaserAppWord?: Maybe<Scalars['Boolean']>;
  boxShadow?: Maybe<Scalars['String']>;
  showLoginIcon?: Maybe<Scalars['Boolean']>;
};

export type PurchaserAppCssOutput = {
  __typename?: 'purchaserAppCssOutput';
  logoUrl?: Maybe<Scalars['String']>;
  cardColor?: Maybe<Scalars['String']>;
  headerColor?: Maybe<Scalars['String']>;
  backgroundSize?: Maybe<Scalars['String']>;
  backgroundImage?: Maybe<Scalars['String']>;
  backgroundRepeat?: Maybe<Scalars['String']>;
  backgroundPosition?: Maybe<Scalars['String']>;
  backgroundAttachment?: Maybe<Scalars['String']>;
  showPurchaserAppWord?: Maybe<Scalars['Boolean']>;
  boxShadow?: Maybe<Scalars['String']>;
  showLoginIcon?: Maybe<Scalars['Boolean']>;
};

export type PurchaserContactEntity = AuditEntity & {
  __typename?: 'purchaserContactEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  userId: Scalars['String'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  lead?: Maybe<Array<PurchaserLeadContactOutput>>;
  user: PurchaserUserEntity;
};

export type PurchaserIdTypeEntity = AuditEntity & {
  __typename?: 'purchaserIDTypeEntity';
  createdTs: Scalars['DateTime'];
  createdBy: Scalars['String'];
  modTs: Scalars['DateTime'];
  modBy: Scalars['String'];
  id: Scalars['String'];
  accountId: Scalars['String'];
  identityDoc: Scalars['String'];
  description: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type PurchaserKeyCollectionAppointmentInput = {
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: Maybe<Scalars['Boolean']>;
  purchaserUserReceive?: Maybe<Scalars['Boolean']>;
};

export type PurchaserKeyCollectionAppointmentOutput = {
  __typename?: 'purchaserKeyCollectionAppointmentOutput';
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: Maybe<Scalars['Boolean']>;
  purchaserUserReceive?: Maybe<Scalars['Boolean']>;
};

export type PurchaserKeyCollectionAppointmentRescheduleOutput = {
  __typename?: 'purchaserKeyCollectionAppointmentRescheduleOutput';
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  keyCollectionSalesPersonReceive?: Maybe<Scalars['Boolean']>;
  purchaserUserReceive?: Maybe<Scalars['Boolean']>;
};

export type PurchaserNotificationEntity = {
  __typename?: 'purchaserNotificationEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  subject: Scalars['String'];
  body: Scalars['String'];
  purchaserNotificationRecipient: Array<PurchaserNotificationRecipientEntity>;
};

export type PurchaserNotificationRecipientEntity = {
  __typename?: 'purchaserNotificationRecipientEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  notificationId: Scalars['String'];
  recipientId: Scalars['String'];
  isRead: Scalars['Boolean'];
  purchaserNotification: PurchaserNotificationEntity;
};

export type PurchaserPaymentEntity = AuditEntity & {
  __typename?: 'purchaserPaymentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  unitId: Scalars['String'];
  ifcaSaleId?: Maybe<Scalars['Float']>;
  saleId?: Maybe<Scalars['String']>;
  receiptNo?: Maybe<Scalars['String']>;
  paymentGatewayId?: Maybe<Scalars['String']>;
  paymentStatus: Scalars['String'];
  paymentMethod: Scalars['String'];
  amount: Scalars['Float'];
  refNo?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['DateTime']>;
  transactionMethod?: Maybe<Scalars['String']>;
  response: Scalars['JSONObject'];
};

export type PurchaserPaymentPlanDetailsEntity = {
  __typename?: 'purchaserPaymentPlanDetailsEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  purchaserPaymentPlanId: Scalars['String'];
  title: Scalars['String'];
  paymentBy: PaymentBy;
  paymentValue: Scalars['Float'];
  billType: BillType;
  noInstallment: Scalars['Float'];
  deductBookingFee: DeductBookingFee;
  billCount: Scalars['Float'];
  billFrequency: BillFrequency;
  billAfter: Scalars['String'];
  recordStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  payment: PurchaserPaymentPlanEntity;
  salesPaymentPlan: Array<SalesPaymentPlanEntity>;
};

export type PurchaserPaymentPlanEntity = {
  __typename?: 'purchaserPaymentPlanEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  effectiveDate: Scalars['DateTime'];
  markUpPercentage: Scalars['Float'];
  recordStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  details?: Maybe<Array<PurchaserPaymentPlanDetailsEntity>>;
  projectPaymentPlans: Array<ProjectPaymentPlanEntity>;
  projectCarparkPaymentPlans: Array<ProjectCarparkPaymentPlanEntity>;
  projectPackagePaymentPlans: Array<ProjectPackagePaymentPlanEntity>;
};

export type PurchaserTransferIndoDetailsEntity = {
  __typename?: 'purchaserTransferIndoDetailsEntity';
  id: Scalars['String'];
  purchaserTransferIndoId: Scalars['String'];
  status: Scalars['String'];
  contactId: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  address?: Maybe<AddressJson>;
  commonStatus: Scalars['String'];
};

export type PurchaserTransferIndoEntity = {
  __typename?: 'purchaserTransferIndoEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  transferDate: Scalars['DateTime'];
  adminFee: Scalars['Float'];
  miscBillId: Scalars['String'];
  documentNo: Scalars['String'];
  approvedDate: Scalars['DateTime'];
  approvedBy: Scalars['String'];
  approvalStatus: Scalars['String'];
  commonStatus: Scalars['String'];
  purchaserTransferIndoDetails?: Maybe<PurchaserTransferIndoDetailsEntity>;
};

export type PurchaserUserEntity = AuditEntity & {
  __typename?: 'purchaserUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  loginId: Scalars['String'];
  passwordHash?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  forgotPasswordLink?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  purchaserAccountReference?: Maybe<PurchaserAccountReferenceEntity>;
};

export type RaceEntity = {
  __typename?: 'raceEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seqNo?: Maybe<Scalars['Float']>;
  contacts: Array<ContactEntity>;
  isDeletable: Scalars['Boolean'];
};

export type ReasonCodeEntity = {
  __typename?: 'reasonCodeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seqNo?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
  systemUse: Scalars['Boolean'];
  isDeletable: Scalars['Boolean'];
};

export type RebateEntity = {
  __typename?: 'rebateEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentDate: Scalars['DateTime'];
  documentAmount: Scalars['Float'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  status: Scalars['String'];
  requestedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  submittedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  saleRebatePackage: SaleRebatePackageEntity;
  allocation?: Maybe<Array<AllocationEntity>>;
  billItemId: Scalars['String'];
  allowReversal: Scalars['Boolean'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type ReceiptEntity = {
  __typename?: 'receiptEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  financierId?: Maybe<Scalars['String']>;
  paymentMethod: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentDate: Scalars['DateTime'];
  currency?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  documentAmount: Scalars['Float'];
  receiptAmount: Scalars['Float'];
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  creditCardFacilityId?: Maybe<Scalars['String']>;
  creditCardType?: Maybe<Scalars['String']>;
  bankAccountId?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  cbGenerationBatch?: Maybe<Scalars['String']>;
  cbGenerated: Scalars['Boolean'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  commonStatus: Scalars['String'];
  allocation?: Maybe<Array<AllocationEntity>>;
  sales?: Maybe<SaleEntity>;
  financiers?: Maybe<Array<FinancierEntity>>;
  accounts?: Maybe<Array<CompanyBankAccountEntity>>;
  allowReversal: Scalars['Boolean'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  generationBatch: Scalars['String'];
  generationBatchDate: Scalars['DateTime'];
  refId?: Maybe<Scalars['String']>;
  refTable?: Maybe<Scalars['String']>;
};

export type ReceiptReversalEntity = {
  __typename?: 'receiptReversalEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  financierId?: Maybe<Scalars['String']>;
  documentNo: Scalars['String'];
  description: Scalars['String'];
  documentDate: Scalars['DateTime'];
  currency?: Maybe<Scalars['String']>;
  exchangeRate?: Maybe<Scalars['Float']>;
  documentAmount: Scalars['Float'];
  receiptAmount: Scalars['Float'];
  bankAccountId?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  cbGenerationBatch?: Maybe<Scalars['String']>;
  cbGenerated: Scalars['Boolean'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  financiers?: Maybe<Array<FinancierEntity>>;
  bankAccount?: Maybe<Array<CompanyBankAccountEntity>>;
};

export type RedemptionDetailEntity = {
  __typename?: 'redemptionDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  redemptionId: Scalars['String'];
  unitId: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  redemptionAmount: Scalars['Float'];
  contraId?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  redemption: RedemptionEntity;
};

export type RedemptionEntity = {
  __typename?: 'redemptionEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  paymentParty: Scalars['String'];
  paidById: Scalars['String'];
  documentDate: Scalars['DateTime'];
  referenceNo?: Maybe<Scalars['String']>;
  redemptionSum: Scalars['Float'];
  submittedBy?: Maybe<Scalars['DateTime']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  isPosted: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  redemptionDetails: Array<RedemptionDetailEntity>;
};

export type RefinancingEntity = {
  __typename?: 'refinancingEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  refTable?: Maybe<Scalars['String']>;
  refId: Scalars['String'];
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  rrDate: Scalars['DateTime'];
  rrSolicitorId: Scalars['String'];
  rrSolicitorReferenceNo: Scalars['String'];
  doaDate: Scalars['DateTime'];
  doaSolicitorId: Scalars['String'];
  doaSolicitorReferenceNo: Scalars['String'];
  loanAgreementDate: Scalars['DateTime'];
  loanAmount: Scalars['Float'];
  loanSolicitorId: Scalars['String'];
  loanSolicitorReferenceNo?: Maybe<Scalars['String']>;
  loanSeqNo?: Maybe<Scalars['Float']>;
  generationBatch: Scalars['String'];
  status: Scalars['String'];
  completedDate?: Maybe<Scalars['DateTime']>;
  commonStatus: Scalars['String'];
};

export type RefundEntity = {
  __typename?: 'refundEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  refundMethod: Scalars['String'];
  documentNo?: Maybe<Scalars['String']>;
  documentRef?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  documentDate: Scalars['DateTime'];
  documentAmount: Scalars['Float'];
  chequeDate?: Maybe<Scalars['DateTime']>;
  chequeExpireDate?: Maybe<Scalars['DateTime']>;
  bankAccountId?: Maybe<Scalars['String']>;
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  submittedDate?: Maybe<Scalars['DateTime']>;
  submittedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  commonStatus: Scalars['String'];
  sales?: Maybe<SaleEntity>;
  creditCardType?: Maybe<Scalars['String']>;
};

export type RegionEntity = {
  __typename?: 'regionEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  systemUse: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seqNo?: Maybe<Scalars['Float']>;
  isDeletable: Scalars['Boolean'];
};

export type ReminderBasicOutput = {
  __typename?: 'reminderBasicOutput';
  multiple: Scalars['Boolean'];
  isProject: Scalars['Boolean'];
  emailTemplate?: Maybe<Scalars['String']>;
  standardParameters?: Maybe<Array<Scalars['String']>>;
  letterTemplateList?: Maybe<Array<ReminderTemplateListOutput>>;
};

export type ReminderEntity = {
  __typename?: 'reminderEntity';
  id: Scalars['String'];
  reminderNo?: Maybe<Scalars['String']>;
  balanceAmount: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
  commonStatus: Scalars['String'];
  batchId: Scalars['String'];
  trxStatus: Scalars['String'];
  ledger: LedgerEntity;
  project: ProjectEntity;
  sale: SaleEntity;
};

export type ReminderOutput = {
  __typename?: 'reminderOutput';
  downloadFile: Scalars['Boolean'];
  isProject?: Maybe<Scalars['Boolean']>;
  letterTemplateList?: Maybe<Array<ShareLetterTemplateOutput>>;
};

export type ReminderTemplateListOutput = {
  __typename?: 'reminderTemplateListOutput';
  letterTemplateId: Scalars['String'];
  name: Scalars['String'];
};

export type ReportPermissionEntity = AuditEntity & {
  __typename?: 'reportPermissionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  roleId: Scalars['String'];
  permissionId: Scalars['Float'];
};

export type RescheduleDetailEntity = {
  __typename?: 'rescheduleDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  rescheduleId: Scalars['String'];
  installmentId: Scalars['String'];
  ledgerType: Scalars['String'];
  documentDate: Scalars['DateTime'];
  baseAmt: Scalars['Float'];
  taxAmt: Scalars['Float'];
  description: Scalars['String'];
  isSelected: Scalars['Boolean'];
  reschedule: RescheduleEntity;
  billType: Scalars['String'];
  startDate: Scalars['DateTime'];
};

export type RescheduleEntity = {
  __typename?: 'rescheduleEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  documentNo: Scalars['String'];
  rescheduleDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  premiumAmt: Scalars['Float'];
  description: Scalars['String'];
  approvalStatus: Scalars['String'];
  detail?: Maybe<Array<RescheduleDetailEntity>>;
  recordStatus: Scalars['String'];
  billType: Scalars['String'];
  isLoanDifferential: Scalars['Boolean'];
};

export type ResourceEntity = AuditEntity & {
  __typename?: 'resourceEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  mediaType: Scalars['String'];
  resourceUrl: Scalars['String'];
  fileName: Scalars['String'];
  bucketFileName: Scalars['String'];
  isPrivate: Scalars['Boolean'];
  caption?: Maybe<Scalars['String']>;
  pictureBlocks: Array<PictureBlockEntity>;
  pictureFloors: Array<PictureFloorEntity>;
  pictureGalleries: Array<PictureGalleryEntity>;
  pictureUnitlayouts: Array<PictureUnitlayoutEntity>;
  account_id: Scalars['String'];
  salesCharts: Array<SalesChartEntity>;
};

export type RoleEntity = AuditEntity & {
  __typename?: 'roleEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  softwareCode: Scalars['String'];
  name: Scalars['String'];
  permissions: Array<Scalars['String']>;
  returnSalePermissionOutput: Array<SalesPermission>;
  permissionIds: Array<Scalars['String']>;
  users?: Maybe<Array<UserEntity>>;
  userCountByRole: Scalars['Float'];
  salesAndReportPermission: Array<Scalars['String']>;
  salesAndReportPermissionIds: Array<Scalars['String']>;
  isDeletable: Scalars['Boolean'];
};


export type RoleEntityUsersArgs = {
  projectId?: Maybe<Scalars['String']>;
};

export type SCityEntity = {
  __typename?: 'sCityEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  commonStatus: Scalars['String'];
  sPostcode?: Maybe<Array<SPostcodeEntity>>;
  state: SStateEntity;
};

export type SCountryEntity = {
  __typename?: 'sCountryEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  commonStatus: Scalars['String'];
  sStates: Array<SStateEntity>;
};

export type SGatewayAddInput = {
  IntegrationType: Scalars['String'];
  version: Scalars['String'];
  hasSqlUpdate: Scalars['Boolean'];
  sql?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  releaseNote?: Maybe<Scalars['String']>;
};

export type SGatewayUpdateInput = {
  ID: Scalars['String'];
  IntegrationType: Scalars['String'];
  version: Scalars['String'];
  hasSqlUpdate: Scalars['Boolean'];
  sql?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  releaseNote?: Maybe<Scalars['String']>;
};

export type SNationalityEntity = {
  __typename?: 'sNationalityEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  commonStatus: Scalars['String'];
  contacts: Array<ContactEntity>;
  leadContacts: Array<LeadContactEntity>;
};

export type SPostcodeEntity = {
  __typename?: 'sPostcodeEntity';
  id: Scalars['String'];
  postcode: Scalars['String'];
  commonStatus: Scalars['String'];
  citys: SCityEntity;
};

export type SStateEntity = {
  __typename?: 'sStateEntity';
  id: Scalars['String'];
  name: Scalars['String'];
  sCities?: Maybe<Array<SCityEntity>>;
  commonStatus: Scalars['String'];
  country: SCountryEntity;
};

export type SUserEntity = {
  __typename?: 'sUserEntity';
  ID: Scalars['String'];
  userName?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  contactNo: Scalars['String'];
  is2FA?: Maybe<Scalars['Boolean']>;
  commonStatus: CommonStatus;
  confirmed: Scalars['Boolean'];
  avatar?: Maybe<Scalars['String']>;
  superUser: Scalars['Boolean'];
  accountID: Scalars['String'];
  softwareCode: Scalars['String'];
  loginAttempt: Scalars['Float'];
  blockDuration: Scalars['Float'];
  blockCount: Scalars['Float'];
  loginTs?: Maybe<Scalars['DateTime']>;
  deviceIP?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  department?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastestAccessedEntity?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  userFeaturePermission: UserFeaturePermissionEntity;
  isActivated: Scalars['Boolean'];
  isSuspendible: Scalars['Boolean'];
  deviceToken?: Maybe<Scalars['String']>;
  lastPwdChangedDate?: Maybe<Scalars['DateTime']>;
  languageSet?: Maybe<Scalars['String']>;
};

export type SaleCancellationEntity = AuditEntity & {
  __typename?: 'saleCancellationEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  cancellationDate: Scalars['DateTime'];
  forfeitureSum: Scalars['Float'];
  taxSchemeId: Scalars['String'];
  cancelReason: Scalars['String'];
  remark: Scalars['String'];
  status: Scalars['String'];
  commonStatus: Scalars['String'];
  refundTax: Scalars['Boolean'];
  chargeFinalTax: Scalars['Boolean'];
  taxToDate: Scalars['Float'];
  finalTaxToDate: Scalars['Float'];
  refundAmt: Scalars['Float'];
  sales?: Maybe<SaleEntity>;
  reasonCode?: Maybe<ReasonCodeEntity>;
};

export type SaleCommissionTeamEntity = AuditEntity & {
  __typename?: 'saleCommissionTeamEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  companyId: Scalars['String'];
  saleId: Scalars['String'];
  companyCommissionTeamId?: Maybe<Scalars['String']>;
  employeeId?: Maybe<Scalars['String']>;
  employeeName?: Maybe<Scalars['String']>;
  jobPositionId?: Maybe<Scalars['String']>;
  jobPositionName?: Maybe<Scalars['String']>;
  level?: Maybe<Scalars['Float']>;
  parentId?: Maybe<Scalars['String']>;
  isDealClosure: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  companyCommissionTeam: CompanyCommissionTeamEntity;
};

export type SaleContactEntity = AuditEntity & {
  __typename?: 'saleContactEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  name: Scalars['String'];
  contactNo: Scalars['String'];
  officeTel?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  salutationId?: Maybe<Scalars['String']>;
  relationshipId?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  isPrimary: Scalars['Boolean'];
  salutation?: Maybe<SalutationEntity>;
  parameter?: Maybe<ParameterEntity>;
};

export type SaleDiscountEntity = {
  __typename?: 'saleDiscountEntity';
  id: Scalars['String'];
  saleId: Scalars['String'];
  discountId: Scalars['String'];
  createdTs: Scalars['DateTime'];
  discount: DiscountEntity;
  sale: SaleEntity;
  amount: Scalars['Float'];
  seqNo: Scalars['Float'];
  saleDiscountExtension?: Maybe<SalesDiscountExtEntity>;
};

export type SaleEntity = {
  __typename?: 'saleEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  unitId: Scalars['String'];
  salesPersonId?: Maybe<Scalars['String']>;
  developerSolicitorId?: Maybe<Scalars['String']>;
  leadId?: Maybe<Scalars['String']>;
  eventId?: Maybe<Scalars['String']>;
  salesTeamId?: Maybe<Scalars['String']>;
  distance?: Maybe<Scalars['String']>;
  developerReference?: Maybe<Scalars['String']>;
  buyerReference?: Maybe<Scalars['String']>;
  salesNo: Scalars['String'];
  trNo: Scalars['String'];
  bookingRemark?: Maybe<Scalars['String']>;
  bookDate: Scalars['DateTime'];
  reserveDate?: Maybe<Scalars['DateTime']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  cancelledDate?: Maybe<Scalars['DateTime']>;
  cancelledBy?: Maybe<Scalars['String']>;
  cancelledReason?: Maybe<Scalars['String']>;
  cancelReasonId?: Maybe<Scalars['String']>;
  salesStatus: Scalars['String'];
  isBumi: Scalars['Boolean'];
  paymentMethod?: Maybe<Scalars['String']>;
  paymentReference?: Maybe<Scalars['String']>;
  bookingAmount?: Maybe<Scalars['Float']>;
  paymentRemark?: Maybe<Scalars['String']>;
  listPrice?: Maybe<Scalars['Float']>;
  billMethod?: Maybe<Scalars['String']>;
  taxRate?: Maybe<Scalars['Float']>;
  taxAmt?: Maybe<Scalars['Float']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  spaDate?: Maybe<Scalars['DateTime']>;
  stampDate?: Maybe<Scalars['DateTime']>;
  spaNo?: Maybe<Scalars['String']>;
  developerSpaStatus?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  vpDate?: Maybe<Scalars['DateTime']>;
  address?: Maybe<AddressJson>;
  package?: Maybe<Array<Scalars['String']>>;
  agentPersonId?: Maybe<Scalars['String']>;
  agencyAcctId?: Maybe<Scalars['String']>;
  agencyContractId?: Maybe<Scalars['String']>;
  saleOrigin: Scalars['String'];
  retryCount: Scalars['Float'];
  pendingIntegrate: Scalars['Boolean'];
  ifcaContactId: Scalars['String'];
  ifcaSaleId: Scalars['Float'];
  ifcaSaleNo: Scalars['String'];
  expectedSnpDate?: Maybe<Scalars['DateTime']>;
  isCompany: Scalars['Boolean'];
  collectedDate?: Maybe<Scalars['DateTime']>;
  elaunchId?: Maybe<Scalars['String']>;
  bookingTimeTaken?: Maybe<Scalars['Float']>;
  buyerName?: Maybe<Scalars['String']>;
  buyerIdentityNo?: Maybe<Scalars['String']>;
  buyerIdentityType?: Maybe<Scalars['String']>;
  snpReminderBeforeDaysNotify: Scalars['Boolean'];
  snpReminderAfterDaysNotify: Scalars['Boolean'];
  endfinLoanApps: Array<EndfinLoanAppEntity>;
  interests: Array<InterestEntity>;
  jointBuyers: Array<JointBuyerEntity>;
  ledgers: Array<LedgerEntity>;
  reminders: Array<ReminderEntity>;
  letterSign: Array<LetterSignEntity>;
  buyerSolicitor?: Maybe<SolicitorAppointedEntity>;
  agencyAccId?: Maybe<AgencyEntity>;
  contact: ContactEntity;
  developerSolicitor?: Maybe<SolicitorAppointedEntity>;
  lead: LeadEntity;
  project: ProjectEntity;
  salesTeam?: Maybe<SaleTeamEntity>;
  stakeholder: SolicitorAppointedEntity;
  unit: UnitEntity;
  unitIntegration?: Maybe<UnitIntegrationEntity>;
  schedules: Array<ScheduleEntity>;
  leadSource?: Maybe<LeadSourceEntity>;
  incomeRange?: Maybe<IncomeRangeEntity>;
  salesDiscount: Array<SaleDiscountEntity>;
  solicitorProgressLog?: Maybe<Array<SolicitorProgressLogEntity>>;
  salePayment?: Maybe<SalePaymentEntity>;
  accountSpec?: Maybe<AccountSpecEntity>;
  integrationDiscount?: Maybe<Array<IntegrationDiscountEntity>>;
  projectIntegration?: Maybe<Array<ProjectIntegrationEntity>>;
  saleLoan?: Maybe<Array<SaleLoanEntity>>;
  motTracking?: Maybe<Array<MotTrackingEntity>>;
  referralName?: Maybe<Scalars['String']>;
  referralContactNo?: Maybe<Scalars['String']>;
  referralReferenceNo?: Maybe<Scalars['String']>;
  convertedToBooking: Scalars['Boolean'];
  isReservationVerify: Scalars['Boolean'];
  saleExtension?: Maybe<SaleExtensionEntity>;
  spaReminder?: Maybe<Array<SpaReminderEntity>>;
  saleCancellation?: Maybe<SaleCancellationEntity>;
  attachment?: Maybe<AttachmentEntity>;
  agencyUser?: Maybe<AgencyContactEntity>;
  progressBilling?: Maybe<Array<ProgressBillingEntity>>;
  saleRebate?: Maybe<Array<SaleRebatePackageEntity>>;
  nonIntegratedRebate?: Maybe<Array<SaleRebateEntity>>;
  receipt?: Maybe<Array<ReceiptEntity>>;
  receiptReversal?: Maybe<Array<ReceiptReversalEntity>>;
  miscBilling?: Maybe<Array<MiscBillingEntity>>;
  subProduct?: Maybe<Array<SaleSubproductEntity>>;
  salePackage?: Maybe<Array<SalePackageEntity>>;
  debitNote?: Maybe<Array<DebitNoteEntity>>;
  refund?: Maybe<Array<RefundEntity>>;
  lateInterest?: Maybe<Array<LateInterestDetailEntity>>;
  areaVariance?: Maybe<Array<AreaVarianceEntity>>;
  keyCollectionAppointment?: Maybe<Array<KeyCollectionAppointmentEntity>>;
  lateInterestException?: Maybe<ProjectLateInterestExceptionEntity>;
  employerName?: Maybe<Scalars['String']>;
  employerAddress?: Maybe<Scalars['String']>;
  spouseContactId?: Maybe<Scalars['String']>;
  spouse?: Maybe<ContactEntity>;
  markUpBy?: Maybe<Scalars['String']>;
  markUpValue?: Maybe<Scalars['Float']>;
  markUpReason?: Maybe<Scalars['String']>;
  markUpAmount?: Maybe<Scalars['Float']>;
  addressList?: Maybe<Array<ContactAddressEntity>>;
  installments?: Maybe<Array<InstallmentEntity>>;
  salesStatutoryDocument?: Maybe<Array<SalesStatutoryDocumentEntity>>;
  isAutoReleaseNotified: Scalars['Boolean'];
  attendedBy?: Maybe<Scalars['String']>;
  followUpBy?: Maybe<Scalars['String']>;
  salesPerson?: Maybe<Scalars['String']>;
  salesTeamName?: Maybe<Scalars['String']>;
  cancelledByUser?: Maybe<UserEntity>;
  packageList: Array<PackageEntity>;
  discount: Array<SaleDiscountEntity>;
  events?: Maybe<EventsEntity>;
  projectCompany: CompanyEntity;
  joinBuyer: Array<JointBuyerEntity>;
  joinBuyerInfo?: Maybe<JointBuyerInfoForBookingListing>;
  bookingFeeAttachments: Array<AttachmentEntity>;
  bookingFeeInfo?: Maybe<SalePaymentEntity>;
  bookingAttachments: BookingAttachmentsOutput;
  bookingAttachmentsCount: Scalars['Float'];
  bookingBadgeCount: Scalars['Float'];
  otherAttachments: Array<AttachmentEntity>;
  taxDetail?: Maybe<Array<SaleTaxOutput>>;
  progressLogSolicitor?: Maybe<Array<ProgressLogDetails>>;
  endfinLoanAppsCount: Scalars['Float'];
  SaleStatusList: Scalars['JSONObject'];
  buyerSignatureUrl?: Maybe<Scalars['String']>;
  PdpaSignatureUrl?: Maybe<Scalars['String']>;
  paymentMethodDesc?: Maybe<Scalars['String']>;
  loanScreening?: Maybe<LoanScreenStatusOutput>;
  loanScreeningReports?: Maybe<Array<LoanScreenReportOutput>>;
  isCustomisedBookingForm: Scalars['Boolean'];
  repeatPurchaserSales?: Maybe<Scalars['Float']>;
  repeatPurchaserAgency?: Maybe<Scalars['Float']>;
  contactId?: Maybe<Scalars['String']>;
  contactAddress?: Maybe<Array<AddressJson>>;
};

export type SaleExtensionEntity = AuditEntity & {
  __typename?: 'saleExtensionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  paymentPlanId?: Maybe<Scalars['String']>;
  totalSalesValue?: Maybe<Scalars['Float']>;
  salesType?: Maybe<Scalars['String']>;
  discardBumiDiscount?: Maybe<Scalars['Boolean']>;
  isCashBuyer?: Maybe<Scalars['Boolean']>;
  loanGracePeriod?: Maybe<Scalars['Float']>;
  creditTerm?: Maybe<Scalars['Float']>;
  eventId?: Maybe<Scalars['String']>;
  campaignId?: Maybe<Scalars['String']>;
  isGenerateReminder?: Maybe<Scalars['Boolean']>;
  isGenerateInterest?: Maybe<Scalars['Boolean']>;
  salesConvertedStatus: Scalars['String'];
  sales: SaleEntity;
  paymentPlan?: Maybe<PaymentPlanEntity>;
  salesRegistrationDate?: Maybe<Scalars['DateTime']>;
  salesRegistrationNo?: Maybe<Scalars['String']>;
  paymentPlanMarkUpAmt: Scalars['Float'];
  submittedBy?: Maybe<Scalars['String']>;
  submittedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  taxScheme?: Maybe<TaxSchemeEntity>;
};

export type SaleGalleryCloseDateTime = {
  __typename?: 'saleGalleryCloseDateTime';
  closeId: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  BlockstartTime: Scalars['String'];
  BlockendTime: Scalars['String'];
};

export type SaleLoanCancellationDetailEntity = AuditEntity & {
  __typename?: 'saleLoanCancellationDetailEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleLoanCancellationId: Scalars['String'];
  saleLoanId: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type SaleLoanCancellationEntity = AuditEntity & {
  __typename?: 'saleLoanCancellationEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  cancelDate: Scalars['DateTime'];
  cancelReason: Scalars['String'];
  cancelRemark?: Maybe<Scalars['String']>;
  approvalStatus: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type SaleLoanEntity = AuditEntity & {
  __typename?: 'saleLoanEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  financierId: Scalars['String'];
  borrowerName?: Maybe<Scalars['String']>;
  projectId: Scalars['String'];
  financierReference?: Maybe<Scalars['String']>;
  solicitorId?: Maybe<Scalars['String']>;
  solicitorReference?: Maybe<Scalars['String']>;
  borrowerAddress?: Maybe<AddressJson>;
  loanLooDate?: Maybe<Scalars['DateTime']>;
  loanPeriod?: Maybe<Scalars['Float']>;
  loanAmount?: Maybe<Scalars['Float']>;
  loanPercentage?: Maybe<Scalars['Float']>;
  gstFinanceByBank?: Maybe<Scalars['Boolean']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  totalLoanAmount?: Maybe<Scalars['Float']>;
  loanSeqno?: Maybe<Scalars['Float']>;
  loanLimit?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  renoticeDate?: Maybe<Scalars['DateTime']>;
  rrDate?: Maybe<Scalars['DateTime']>;
  rrSolicitorId?: Maybe<Scalars['String']>;
  rrSolicitorReferenceNo?: Maybe<Scalars['String']>;
  commonStatus?: Maybe<Scalars['String']>;
  endfinancierMortgagePlanId: Scalars['String'];
  saleLoanExtId: Scalars['String'];
  sale?: Maybe<SaleEntity>;
  financiers?: Maybe<Array<FinancierEntity>>;
  solicitorAppointed?: Maybe<Array<SolicitorAppointedEntity>>;
  financialBilling?: Maybe<Array<FinancialBillingEntity>>;
  project: ProjectEntity;
  saleLoanPayment: SaleLoanPaymentEntity;
  mortgagePlan: MortgagePlanEntity;
  saleLoanExt: SaleLoanExtensionEntity;
  generationBatchDate?: Maybe<Scalars['DateTime']>;
  generationBatch?: Maybe<Scalars['String']>;
};

export type SaleLoanExtensionEntity = AuditEntity & {
  __typename?: 'saleLoanExtensionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  loanApprovalDate?: Maybe<Scalars['DateTime']>;
  loanSignDate?: Maybe<Scalars['DateTime']>;
  applyAmt: Scalars['Float'];
  approvedAmt?: Maybe<Scalars['Float']>;
  financierRef: Scalars['String'];
  borrowerAcct?: Maybe<Scalars['String']>;
  isDifferentialRescheduled: Scalars['Boolean'];
  loanInterestRate?: Maybe<Scalars['Float']>;
  loanInterestMonth?: Maybe<Scalars['Float']>;
  constructionDate: Scalars['DateTime'];
  description: Scalars['String'];
  approvalStatus: Scalars['String'];
  cancelReason?: Maybe<Scalars['String']>;
  cancelDate?: Maybe<Scalars['DateTime']>;
  submittedBy: Scalars['String'];
  submittedDate: Scalars['DateTime'];
  isRefinanced: Scalars['Boolean'];
  saleLoanNo?: Maybe<Scalars['String']>;
  saleLoan: SaleLoanEntity;
};

export type SaleLoanNoticeInput = {
  sale_id: Scalars['String'];
  sale_loan_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_id?: Maybe<Scalars['String']>;
  sale_loan_payment_plan_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_payment_plan_id?: Maybe<Scalars['String']>;
  sale_loan_retention_id?: Maybe<Scalars['String']>;
  sale_loan_refinancing_retention_id?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
};

export type SaleLoanPaymentEntity = AuditEntity & {
  __typename?: 'saleLoanPaymentEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  saleLoanId: Scalars['String'];
  loanAmount: Scalars['Float'];
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  endfinMortgagePaymentId: Scalars['String'];
  saleLoan: SaleLoanEntity;
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
  saleLoanPayment: SaleLoanPaymentEntity;
  saleLoanRetention: SaleLoanRetentionEntity;
};

export type SaleLoanRefinancingPaymentPlanEntity = AuditEntity & {
  __typename?: 'saleLoanRefinancingPaymentPlanEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  saleLoanRefinancingId: Scalars['String'];
  eventItem: Scalars['String'];
  loanAmount: Scalars['Float'];
  estimateDate?: Maybe<Scalars['DateTime']>;
  endfinMortgagePaymentId: Scalars['String'];
  saleLoanRefinancing: SalesLoanRefinancingEntity;
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
};

export type SaleLoanRefinancingRetentionEntity = AuditEntity & {
  __typename?: 'saleLoanRefinancingRetentionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  saleLoanRefinancingId: Scalars['String'];
  eventItem: Scalars['String'];
  loanAmount: Scalars['Float'];
  estimateDate?: Maybe<Scalars['DateTime']>;
  endfinMortgagePaymentId: Scalars['String'];
  endfinMortgageRetentionId: Scalars['String'];
  saleLoanRefinancing: SalesLoanRefinancingEntity;
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
  mortgageRetention: MortgageRetentionEntity;
};

export type SaleLoanReleaseEntity = {
  __typename?: 'saleLoanReleaseEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  financierId: Scalars['String'];
  endFinancierMortgageId: Scalars['String'];
  endfinMortgagePaymentPlanId?: Maybe<Scalars['String']>;
  endfinMortgageRetentionId?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['DateTime']>;
  docNo?: Maybe<Scalars['String']>;
  saleLoanPaymentPlanDetails?: Maybe<Array<SaleLoanNotice>>;
  isPaid: Scalars['Boolean'];
  approvalStatus: Scalars['String'];
  submittedDate?: Maybe<Scalars['DateTime']>;
  submittedBy?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  financier?: Maybe<FinancierEntity>;
  mortgagePayment?: Maybe<MortgagePaymentEntity>;
  mortgagePlan?: Maybe<MortgagePlanEntity>;
  mortgageRetention?: Maybe<MortgageRetentionEntity>;
};

export type SaleLoanRetentionEntity = AuditEntity & {
  __typename?: 'saleLoanRetentionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  saleLoanPaymentId: Scalars['String'];
  retentionValue: Scalars['Float'];
  expectedCount: Scalars['Float'];
  expectedFreq: Scalars['String'];
  expectedFrom: Scalars['String'];
  endfinMortgageRetentionId: Scalars['String'];
  saleLoanPayment: SaleLoanPaymentEntity;
  mortgageRetention: MortgageRetentionEntity;
};

export type SalePackageEntity = AuditEntity & {
  __typename?: 'salePackageEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  packageId?: Maybe<Scalars['String']>;
  promotionalPackageId: Scalars['String'];
  openMarketValue?: Maybe<Scalars['Float']>;
  sellingPrice?: Maybe<Scalars['Float']>;
  taxSchemeId?: Maybe<Scalars['String']>;
  workProgressId?: Maybe<Scalars['String']>;
  discountId?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['Float']>;
  isIncludeContract: Scalars['Boolean'];
  sellingMethod: Scalars['String'];
  paymentPlanId?: Maybe<Scalars['String']>;
  projectPackagePaymentPlanId?: Maybe<Scalars['String']>;
  sales?: Maybe<SaleEntity>;
  package: PackageEntity;
  workProgress: WorkProgressEntity;
  commonStatus: Scalars['String'];
  numRow?: Maybe<Scalars['Float']>;
  promotionalPackage: PromotionalPackagesEntity;
  packagesPaymentPlan: Array<PackagesPaymentPlanEntity>;
};

export type SalePaymentEntity = {
  __typename?: 'salePaymentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  paymentGatewayId?: Maybe<Scalars['String']>;
  bankId?: Maybe<Scalars['String']>;
  receiptNo?: Maybe<Scalars['String']>;
  paymentMethod?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
  transactionDate?: Maybe<Scalars['DateTime']>;
  transactionMethod?: Maybe<Scalars['String']>;
  refNo?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  response: Scalars['JSONObject'];
  sale: SaleEntity;
  attachment?: Maybe<AttachmentEntity>;
  verificationStatus: Scalars['String'];
  approvedBy?: Maybe<Scalars['String']>;
  approvedTs?: Maybe<Scalars['DateTime']>;
  rejectedBy?: Maybe<Scalars['String']>;
  rejectedTs?: Maybe<Scalars['DateTime']>;
  bookingFeeAttachments: Array<AttachmentEntity>;
  paymentMethodDesc?: Maybe<Scalars['String']>;
};

export type SaleRebateEntity = {
  __typename?: 'saleRebateEntity';
  id: Scalars['String'];
  saleId: Scalars['String'];
  discountId: Scalars['String'];
  discount: DiscountEntity;
  sale: SaleEntity;
  amount: Scalars['Float'];
  seqNo: Scalars['Float'];
  saleDiscountExtension?: Maybe<SalesDiscountExtEntity>;
};

export type SaleRebatePackageEntity = AuditEntity & {
  __typename?: 'saleRebatePackageEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  discountId: Scalars['String'];
  discountMethod: Scalars['String'];
  roundingMode: Scalars['String'];
  roundingPrecision: Scalars['String'];
  campaignId: Scalars['String'];
  workProgressId: Scalars['String'];
  discountAmount: Scalars['Float'];
  rebateId?: Maybe<Scalars['String']>;
  seqNo?: Maybe<Scalars['Float']>;
  workProgress: WorkProgressEntity;
  discount: DiscountEntity;
  campaign: CampaignEntity;
  rebate?: Maybe<RebateEntity>;
  sales?: Maybe<SaleEntity>;
};

export type SaleSubproductEntity = AuditEntity & {
  __typename?: 'saleSubproductEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  unitId: Scalars['String'];
  discountId?: Maybe<Scalars['String']>;
  discountAmount?: Maybe<Scalars['Float']>;
  sellingPrice: Scalars['Float'];
  sellingMethod: Scalars['String'];
  paymentPlanId?: Maybe<Scalars['String']>;
  unit?: Maybe<UnitEntity>;
  sales?: Maybe<SaleEntity>;
  discount?: Maybe<DiscountEntity>;
  progressBilling?: Maybe<Array<ProgressBillingEntity>>;
  commonStatus: Scalars['String'];
  taxSchemeId: Scalars['String'];
  taxScheme: TaxSchemeEntity;
  projectCarparkPaymentPlanId?: Maybe<Scalars['String']>;
};

export type SaleTeamAllocationEntity = {
  __typename?: 'saleTeamAllocationEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  teamId: Scalars['String'];
  unitId: Scalars['String'];
  unit: UnitEntity;
  saleTeam: SaleTeamEntity;
  project: ProjectEntity;
};

export type SaleTeamEntity = {
  __typename?: 'saleTeamEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  name: Scalars['String'];
  enableAllocation: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  leads: Array<LeadEntity>;
  leadActivities: Array<LeadActivityEntity>;
  leadActivitiesTeam: Array<LeadActivityEntity>;
  sales: Array<SaleEntity>;
  saleTeamUsers?: Maybe<Array<SaleTeamUserEntity>>;
  saleTeamUnitAllocation?: Maybe<Array<SaleTeamAllocationEntity>>;
  waitlistTeam?: Maybe<Array<BookingWaitlistEntity>>;
  saleTeamMembers?: Maybe<Array<SaleTeamUserEntity>>;
  memberCount?: Maybe<Scalars['Float']>;
  checkPermission?: Maybe<Scalars['String']>;
};

export type SaleTeamUserEntity = {
  __typename?: 'saleTeamUserEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  teamId: Scalars['String'];
  userId: Scalars['String'];
  acceptLead: Scalars['Boolean'];
  saleTeam: SaleTeamEntity;
  user?: Maybe<UserEntity>;
};

export type SalesCancellationEntity = AuditEntity & {
  __typename?: 'salesCancellationEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  notifiedDate: Scalars['DateTime'];
  approvalLevel?: Maybe<Scalars['Float']>;
  status: Scalars['String'];
};

export type SalesChartEntity = {
  __typename?: 'salesChartEntity';
  id: Scalars['String'];
  block: Scalars['String'];
  floor: Scalars['Float'];
  coordinates: Scalars['String'];
  project: ProjectEntity;
  resource: ResourceEntity;
  unit: UnitEntity;
};

export type SalesDiscountExtEntity = AuditEntity & {
  __typename?: 'salesDiscountExtEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleDiscountId: Scalars['String'];
  formula: Scalars['String'];
  discountMethod: Scalars['String'];
  saleDiscount: SaleDiscountEntity;
};

export type SalesDocEntity = AuditEntity & {
  __typename?: 'salesDocEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  docName: Scalars['String'];
  type: Scalars['String'];
  allowSalesTeam: Scalars['Boolean'];
  allowAgency: Scalars['Boolean'];
  attachment: AttachmentEntity;
  typeDescription: Scalars['String'];
};

export type SalesGalleryCloseDateEntity = {
  __typename?: 'salesGalleryCloseDateEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  startTime: Scalars['String'];
  endTime: Scalars['String'];
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  appointmentSchedulingId: Scalars['String'];
  appointmentScheduling: AppointmentSchedulingEntity;
};

export type SalesLandDepositEntity = {
  __typename?: 'salesLandDepositEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  projectId: Scalars['String'];
  depositTypeId: Scalars['String'];
  depositBillingAmount: Scalars['Float'];
  description: Scalars['String'];
  recordStatus: Scalars['String'];
  project: ProjectEntity;
  sale: SaleEntity;
};

export type SalesLoanBuyBackEntity = {
  __typename?: 'salesLoanBuyBackEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  refTable: Scalars['String'];
  refRecordId: Scalars['String'];
  financierId: Scalars['String'];
  buyBackAmt: Scalars['Float'];
  buyBackDate: Scalars['DateTime'];
  bankAccountId: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
  oldBalance: Array<OldBalanceBuyBack>;
  submittedDate: Scalars['DateTime'];
  submittedBy: Scalars['String'];
  approvedDate: Scalars['DateTime'];
  approvedBy: Scalars['String'];
  approvalStatus: Scalars['String'];
  commonStatus: Scalars['String'];
  docNo?: Maybe<Scalars['String']>;
};

export type SalesLoanRefinancingEntity = {
  __typename?: 'salesLoanRefinancingEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  loanRefTable: Scalars['String'];
  loanRefRecordId: Scalars['String'];
  refinancingDate: Scalars['DateTime'];
  newFinancierId: Scalars['String'];
  borrowerName: Scalars['String'];
  endfinancierMortgageId: Scalars['String'];
  endfinMortgagePaymentplanId: Scalars['String'];
  endfinMortgageRetentionId: Scalars['String'];
  borrowerAcct: Scalars['String'];
  remarks?: Maybe<Scalars['String']>;
  oldBalance: Array<OldBalance>;
  newPaymentPlan: Array<NewPaymentPlan>;
  submittedDate: Scalars['DateTime'];
  submittedBy: Scalars['String'];
  approvedDate: Scalars['DateTime'];
  approvedBy: Scalars['String'];
  approvalStatus: Scalars['String'];
  commonStatus: Scalars['String'];
  isRefinanced: Scalars['Boolean'];
  refinancingNo?: Maybe<Scalars['String']>;
  saleLoanRefinancingPaymentPlan: SaleLoanRefinancingPaymentPlanEntity;
  saleLoanRefinancingRetention: SaleLoanRefinancingRetentionEntity;
};

export type SalesPaymentPlanEntity = {
  __typename?: 'salesPaymentPlanEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  saleId: Scalars['String'];
  billType: BillType;
  isFixAmt: Scalars['Boolean'];
  value: Scalars['Float'];
  paymentAmt: Scalars['Float'];
  purchaserPaymentPlanDetailsId: Scalars['String'];
  noInstallment: Scalars['Float'];
  billCount: Scalars['Float'];
  billFrequency: BillFrequency;
  billAfter: BillAfter;
  installment: Array<InstallmentEntity>;
  purchaserPaymentPlanDetails: PurchaserPaymentPlanDetailsEntity;
  deductBookingFee: DeductBookingFee;
  projectPaymentPlanId: Scalars['String'];
};

export type SalesStatisticEntity = AuditEntity & {
  __typename?: 'salesStatisticEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  contactId: Scalars['String'];
  unitId: Scalars['String'];
  listPrice: Scalars['Float'];
  spaPrice?: Maybe<Scalars['Float']>;
  transactionDate: Scalars['DateTime'];
  saleStatus: Scalars['String'];
};

export type SalesTeamByProjectOutput = {
  __typename?: 'salesTeamByProjectOutput';
  id: Scalars['String'];
  name: Scalars['String'];
  enableAllocation: Scalars['Boolean'];
  allocatedUnits: Scalars['Float'];
  totalUnits: Scalars['Float'];
};

export type SalutationEntity = {
  __typename?: 'salutationEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  contacts: Array<ContactEntity>;
  saleContact: SaleContactEntity;
  isDeletable: Scalars['Boolean'];
};

export type ScheduleEntity = {
  __typename?: 'scheduleEntity';
  id: Scalars['String'];
  description: Scalars['String'];
  docAmount: Scalars['String'];
  scheduleDate: Scalars['DateTime'];
  billedDate?: Maybe<Scalars['DateTime']>;
  batchId?: Maybe<Scalars['String']>;
  ledgers: Array<LedgerEntity>;
  project: ProjectEntity;
  sale: SaleEntity;
};

export type ShareLetterTemplateOutput = {
  __typename?: 'shareLetterTemplateOutput';
  letterTemplateId: Scalars['String'];
  letterTemplateName: Scalars['String'];
};

/** JsonType */
export type ShareObject = {
  __typename?: 'shareObject';
  sharedBy: Scalars['String'];
  sharedDateTime: Scalars['String'];
  sharedMethod?: Maybe<Scalars['String']>;
};

export type SiteProgressAttachmentOutput = {
  __typename?: 'siteProgressAttachmentOutput';
  attachmentId?: Maybe<Scalars['String']>;
  resourceUrl?: Maybe<Scalars['String']>;
};

export type SiteProgressEntity = {
  __typename?: 'siteProgressEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  title: Scalars['String'];
  publishDate: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  attachment: Array<AttachmentEntity>;
};

export type SiteProgressListingOutput = {
  __typename?: 'siteProgressListingOutput';
  total?: Maybe<Scalars['Float']>;
  data?: Maybe<Array<SiteProgressEntity>>;
};

export type SmtpInfoInput = {
  hostName: Scalars['String'];
  userName: Scalars['String'];
  password: Scalars['String'];
  maxRetry: Scalars['Float'];
  portNumber: Scalars['Float'];
  enableSSL?: Maybe<Scalars['Boolean']>;
  lastUpdatedDate?: Maybe<Scalars['DateTime']>;
  lastUpdateBy?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
};

export type SmtpInfoOutput = {
  __typename?: 'smtpInfoOutput';
  hostName: Scalars['String'];
  userName: Scalars['String'];
  password: Scalars['String'];
  maxRetry: Scalars['Float'];
  portNumber: Scalars['Float'];
  enableSSL?: Maybe<Scalars['Boolean']>;
  lastUpdatedDate?: Maybe<Scalars['DateTime']>;
  lastUpdateBy?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTs?: Maybe<Scalars['DateTime']>;
  modBy?: Maybe<Scalars['String']>;
  modTs?: Maybe<Scalars['DateTime']>;
};

export type SolicitorAppointedContactEntity = AuditEntity & {
  __typename?: 'solicitorAppointedContactEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  solicitorAppointedId: Scalars['String'];
  solicitor: SolicitorAppointedEntity;
};

export type SolicitorAppointedCount = {
  __typename?: 'solicitorAppointedCount';
  totalAppointed?: Maybe<Scalars['Float']>;
  lastAppointedDate?: Maybe<Scalars['DateTime']>;
};

export type SolicitorAppointedEntity = AuditEntity & {
  __typename?: 'solicitorAppointedEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  solicitorId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  officeTel?: Maybe<Scalars['String']>;
  solicitorCode?: Maybe<Scalars['String']>;
  address?: Maybe<AddressJson>;
  contactName?: Maybe<Scalars['String']>;
  contactPhoneNo?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  invitationLink: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  isIntegrated: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  saleBuyerSolicitor: Array<SaleEntity>;
  subsaleBuyerSolicitor: Array<SubsaleEntity>;
  saleDeveloperSolicitor: Array<SaleEntity>;
  saleStakeholder: Array<SaleEntity>;
  saleLoan: Array<SaleLoanEntity>;
  unitExt: Array<UnitExtensionEntity>;
  unitExtLawyer: Array<UnitExtensionEntity>;
  contact: Array<SolicitorAppointedContactEntity>;
  assignedProjectCount: Scalars['Float'];
  projectCount?: Maybe<Scalars['Float']>;
  unitCount?: Maybe<Scalars['Float']>;
  solicitorUnitCount?: Maybe<SolicitorUnitCount>;
  default?: Maybe<Scalars['Boolean']>;
  solicitorStatus: Scalars['Boolean'];
};


export type SolicitorAppointedEntitySolicitorUnitCountArgs = {
  project_id: Scalars['String'];
};


export type SolicitorAppointedEntityDefaultArgs = {
  projectId: Scalars['String'];
};


export type SolicitorAppointedEntitySolicitorStatusArgs = {
  project_id: Scalars['String'];
};

export type SolicitorCaseAssignmentInput = {
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  solicitorUserReceive?: Maybe<Scalars['Boolean']>;
};

export type SolicitorCaseAssignmentOutput = {
  __typename?: 'solicitorCaseAssignmentOutput';
  salesUserReceive?: Maybe<Scalars['Boolean']>;
  agencyUserReceive?: Maybe<Scalars['Boolean']>;
  solicitorUserReceive?: Maybe<Scalars['Boolean']>;
};

export type SolicitorContactEntity = AuditEntity & {
  __typename?: 'solicitorContactEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  userId: Scalars['String'];
  name: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  phoneNo?: Maybe<Scalars['String']>;
  photoUrl?: Maybe<Scalars['String']>;
  user: SolicitorUserEntity;
  commonStatus?: Maybe<Scalars['String']>;
  isSuspendible: Scalars['Boolean'];
};

export type SolicitorEntity = AuditEntity & {
  __typename?: 'solicitorEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  address?: Maybe<AddressJson>;
  officeTel?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type SolicitorLayoutList = {
  __typename?: 'solicitorLayoutList';
  project_id: Scalars['String'];
  solicitor_project_id: Scalars['String'];
  layout_id: Scalars['String'];
  desc: Scalars['String'];
  allotted: Scalars['Float'];
  sold: Scalars['Float'];
  total_selling: Scalars['Float'];
};

export type SolicitorNotificationEntity = AuditEntity & {
  __typename?: 'solicitorNotificationEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  permissionId: Scalars['Float'];
  subject: Scalars['String'];
  body: Scalars['String'];
  solicitorNotificationRecipient: Array<SolicitorNotificationRecipientEntity>;
};

export type SolicitorNotificationPolicyEntity = {
  __typename?: 'solicitorNotificationPolicyEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  permissionId: Scalars['Float'];
  userId: Scalars['String'];
  notificationDuration: Scalars['Float'];
};

export type SolicitorNotificationRecipientEntity = AuditEntity & {
  __typename?: 'solicitorNotificationRecipientEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  notificationId: Scalars['String'];
  recipientId: Scalars['String'];
  isRead: Scalars['Boolean'];
  solicitorNotification: SolicitorNotificationEntity;
};

export type SolicitorProgressLogEntity = AuditEntity & {
  __typename?: 'solicitorProgressLogEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  solicitorId?: Maybe<Scalars['String']>;
  saleId: Scalars['String'];
  spaStatus?: Maybe<Scalars['String']>;
  remark?: Maybe<Scalars['String']>;
  progressDesc?: Maybe<Scalars['String']>;
  progressType: Scalars['String'];
  progressDate: Scalars['DateTime'];
  actionBy: Scalars['String'];
  sale: SaleEntity;
};

export type SolicitorProjectEntity = AuditEntity & {
  __typename?: 'solicitorProjectEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  solicitorId: Scalars['String'];
  projectId: Scalars['String'];
  defaulted: Scalars['Boolean'];
  project?: Maybe<ProjectEntity>;
};

export type SolicitorStatusCount = {
  __typename?: 'solicitorStatusCount';
  totalCount?: Maybe<Scalars['Float']>;
  toBeAssignedCount?: Maybe<Scalars['Float']>;
  assignedCount?: Maybe<Scalars['Float']>;
  bookedCount?: Maybe<Scalars['Float']>;
  snpSignedCount?: Maybe<Scalars['Float']>;
  reservationCount?: Maybe<Scalars['Float']>;
};

export type SolicitorUnitAllocationEntity = AuditEntity & {
  __typename?: 'solicitorUnitAllocationEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  solicitorId: Scalars['String'];
  projectId: Scalars['String'];
  unitId: Scalars['String'];
  unit: UnitEntity;
};

export type SolicitorUnitCount = {
  __typename?: 'solicitorUnitCount';
  sold?: Maybe<Scalars['Float']>;
  allocated?: Maybe<Scalars['Float']>;
};

export type SolicitorUserEntity = AuditEntity & {
  __typename?: 'solicitorUserEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  solicitorId: Scalars['String'];
  loginId: Scalars['String'];
  passwordHash?: Maybe<Scalars['String']>;
  activated: Scalars['Boolean'];
  accessToken?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  forgotPasswordLink?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
};

export type SpaReminderEntity = AuditEntity & {
  __typename?: 'spaReminderEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  reminderDate: Scalars['DateTime'];
  reminderSeq: Scalars['Float'];
  generationBatch?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  share?: Maybe<Array<ShareObject>>;
  sales?: Maybe<SaleEntity>;
};

export type SpecialListInput = {
  floor: Scalars['Float'];
  displayFloorNo: Scalars['String'];
};

export type StakeholderProcessEntity = {
  __typename?: 'stakeholderProcessEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  solicitorId: Scalars['String'];
  progressBillingId: Scalars['String'];
  financialBillingId?: Maybe<Scalars['String']>;
  collectionDate?: Maybe<Scalars['DateTime']>;
  collectionReferenceNo?: Maybe<Scalars['String']>;
  collectionBatch?: Maybe<Scalars['String']>;
  amount: Scalars['Float'];
  durationFlag?: Maybe<Scalars['String']>;
  duration: Scalars['Float'];
  dueDate?: Maybe<Scalars['DateTime']>;
  releaseDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  progressBilling?: Maybe<ProgressBillingEntity>;
  status: Scalars['String'];
  contraId?: Maybe<Scalars['String']>;
  isReversal: Scalars['Boolean'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type StakeholderProcessReleaseDetailEntity = {
  __typename?: 'stakeholderProcessReleaseDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  stakeholderProcessReleaseId: Scalars['String'];
  stakeholderProcessId: Scalars['String'];
  releaseAmount: Scalars['Float'];
  commonStatus: Scalars['String'];
};

export type StakeholderProcessReleaseEntity = {
  __typename?: 'stakeholderProcessReleaseEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
  releaseDate: Scalars['DateTime'];
  releaseMethod: Scalars['String'];
  releaseReferenceNo?: Maybe<Scalars['String']>;
  releaseRemark?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  bankAccountId: Scalars['String'];
  status: Scalars['String'];
  glGenerationBatch?: Maybe<Scalars['String']>;
  glGenerated: Scalars['String'];
  glGenerationReversedBatch?: Maybe<Scalars['String']>;
  gl_generated_reversed: Scalars['String'];
  isReversal: Scalars['Boolean'];
  voidBy?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['DateTime']>;
};

export type StampDutyDetailEntity = {
  __typename?: 'stampDutyDetailEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  stampExtId: Scalars['ID'];
  fromAmt: Scalars['String'];
  toAmt: Scalars['String'];
  value: Scalars['String'];
  commonStatus: Scalars['String'];
  stampDutyExt: StampDutyExtEntity;
};

export type StampDutyEntity = {
  __typename?: 'stampDutyEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  code: Scalars['String'];
  description: Scalars['String'];
  commonStatus: Scalars['String'];
  stampDutyExts: Array<StampDutyExtEntity>;
};

export type StampDutyExtEntity = {
  __typename?: 'stampDutyExtEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  stampDutyId: Scalars['ID'];
  effectiveDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  stampDuty: StampDutyEntity;
  stampDutyDetails: Array<StampDutyDetailEntity>;
};

export type StampDutyIntegrationEntity = {
  __typename?: 'stampDutyIntegrationEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  type: Scalars['String'];
  projectLetterTemplateId: Scalars['String'];
  extension: Scalars['String'];
  stampDutyId: Scalars['String'];
  commonStatus: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
};

export type StandardLetterDataSourceEntity = {
  __typename?: 'standardLetterDataSourceEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  standardLetterId: Scalars['String'];
  name: Scalars['String'];
  dataSource: Array<DataSource>;
  queryFilterString: Array<QueryFilterString>;
  queryParameter: Array<QueryParameter>;
  reportParameter: Array<ReportParameter>;
  version: Scalars['Float'];
};

export type StandardLetterEntity = {
  __typename?: 'standardLetterEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  letterCategory: Scalars['String'];
  letterType: Scalars['String'];
  commonStatus: Scalars['String'];
  standardLetterParameter: Array<StandardLetterParameterEntity>;
  letterTemplate: Array<LetterTemplateEntity>;
  projectTemplate: Array<ProjectLetterTemplateEntity>;
  isAllowHtmlEditor: Scalars['Boolean'];
  isAllowReportDesignEditor: Scalars['Boolean'];
  count: Scalars['Float'];
  countByProject: Scalars['Float'];
};


export type StandardLetterEntityCountByProjectArgs = {
  projectId: Scalars['String'];
};

export type StandardLetterParameterEntity = {
  __typename?: 'standardLetterParameterEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  standardLetterId: Scalars['String'];
  displayName: Scalars['String'];
  columnName: Scalars['String'];
  commonStatus: Scalars['String'];
  standardLetter: StandardLetterEntity;
};

export type StatutoryDocumentEntity = {
  __typename?: 'statutoryDocumentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  perSalesContract: Scalars['Boolean'];
  code?: Maybe<Scalars['String']>;
  salesStatutoryDocument?: Maybe<Array<SalesStatutoryDocumentEntity>>;
  commissionStatutoryDocuments: Array<CommissionStatutoryDocumentEntity>;
};

export type SubsaleEntity = {
  __typename?: 'subsaleEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  unitId: Scalars['String'];
  subsaleCategory: Scalars['String'];
  rrDate: Scalars['DateTime'];
  spaDate: Scalars['DateTime'];
  sellingPrice: Scalars['Float'];
  doaDate: Scalars['DateTime'];
  buyerSolicitorId: Scalars['String'];
  buyerSolicitorReferenceNo: Scalars['String'];
  vendorSolicitorId: Scalars['String'];
  vendorSolicitorReferenceNo: Scalars['String'];
  administrationCharges: Scalars['Float'];
  printingCharges: Scalars['Float'];
  serviceChargeDeposit: Scalars['Float'];
  dmcDate: Scalars['DateTime'];
  contactId: Scalars['String'];
  completedDate?: Maybe<Scalars['DateTime']>;
  status: Scalars['String'];
  buyerName: Scalars['String'];
  buyerIdentityNo: Scalars['String'];
  isCompany: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  units?: Maybe<UnitEntity>;
  buyerSolicitor?: Maybe<SolicitorAppointedEntity>;
  subsaleJointBuyers?: Maybe<Array<SubsaleJointBuyerEntity>>;
  subsaleLoans?: Maybe<Array<SubsaleLoanEntity>>;
};

export type SubsaleJointBuyerEntity = {
  __typename?: 'subsaleJointBuyerEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  subsaleId: Scalars['String'];
  contactId: Scalars['String'];
  ranking: Scalars['Float'];
  commonStatus: Scalars['String'];
  subsales: SubsaleEntity;
};

export type SubsaleLoanEntity = {
  __typename?: 'subsaleLoanEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  subsaleId: Scalars['String'];
  financierId: Scalars['String'];
  financierReferenceNo: Scalars['String'];
  RRDate: Scalars['DateTime'];
  RRSolicitorId: Scalars['String'];
  RRSolicitorReferenceNo: Scalars['String'];
  DOADate: Scalars['DateTime'];
  DOASolicitorId: Scalars['String'];
  DOASolicitorReferenceNo: Scalars['String'];
  LoanSolicitorId: Scalars['String'];
  loanSolicitorReferenceNo: Scalars['String'];
  loanSeqNo: Scalars['Float'];
  commonStatus: Scalars['String'];
  subsales: SubsaleEntity;
};

export type TaxDetailEntity = {
  __typename?: 'taxDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  taxId: Scalars['String'];
  tax: TaxEntity;
  effectiveDate: Scalars['DateTime'];
  rate: Scalars['Float'];
  commonStatus: Scalars['String'];
};

export type TaxEntity = {
  __typename?: 'taxEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  schemeTypeId: Scalars['String'];
  schemeType: TaxSchemeTypeEntity;
  code: Scalars['String'];
  description: Scalars['String'];
  classType: Scalars['String'];
  isClaimable: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  taxDetail: Array<TaxDetailEntity>;
  taxSchemeDetailItem: Array<TaxSchemeDetailItemEntity>;
};

export type TaxExtEntity = {
  __typename?: 'taxExtEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  taxId: Scalars['String'];
  isFinal: Scalars['Boolean'];
};

export type TaxLedgerEntity = {
  __typename?: 'taxLedgerEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  refTable: Scalars['String'];
  refId: Scalars['String'];
  taxSchemeId: Scalars['String'];
  taxId: Scalars['String'];
  taxSchemeDetailId?: Maybe<Scalars['String']>;
  taxRate: Scalars['Float'];
  taxAmount: Scalars['Float'];
  commonStatus: Scalars['String'];
  progressBilling?: Maybe<ProgressBillingEntity>;
};

export type TaxOnSeqInput = {
  taxSchemeDetailItemId: Scalars['String'];
  seqNo: Scalars['Float'];
};

/** JsonType */
export type TaxOnSeqObjects = {
  __typename?: 'taxOnSeqObjects';
  taxSchemeDetailItemId: Scalars['String'];
  seqNo: Scalars['Float'];
};

export type TaxSchemeDetailEntity = {
  __typename?: 'taxSchemeDetailEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  taxSchemeId: Scalars['String'];
  taxScheme: TaxSchemeEntity;
  effectiveDate: Scalars['DateTime'];
  commonStatus: Scalars['String'];
  taxSchemeDetailItems?: Maybe<Array<TaxSchemeDetailItemEntity>>;
};

export type TaxSchemeDetailItemEntity = {
  __typename?: 'taxSchemeDetailItemEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  taxSchemeDetailId: Scalars['String'];
  taxSchemeDetail: TaxSchemeDetailEntity;
  taxId: Scalars['String'];
  tax: TaxEntity;
  computeMethod: Scalars['String'];
  seqNo?: Maybe<Scalars['Float']>;
  taxOnSeq?: Maybe<Array<TaxOnSeqObjects>>;
  commonStatus: Scalars['String'];
};

export type TaxSchemeEntity = {
  __typename?: 'taxSchemeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  isExclusive?: Maybe<Scalars['Boolean']>;
  commonStatus: Scalars['String'];
  taxSchemeDetails?: Maybe<Array<TaxSchemeDetailEntity>>;
};

export type TaxSchemeTypeEntity = {
  __typename?: 'taxSchemeTypeEntity';
  id: Scalars['String'];
  code: Scalars['String'];
  name: Scalars['String'];
  softwareCode: Scalars['String'];
  commonStatus: Scalars['String'];
  tax?: Maybe<Array<TaxEntity>>;
};

export type TaxTransactionCodeDetailEntity = {
  __typename?: 'taxTransactionCodeDetailEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  taxTransactionCodeId: Scalars['String'];
  taxTransactionCode: TaxTransactionCodeEntity;
  type: Scalars['String'];
  code: Scalars['String'];
  description: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type TaxTransactionCodeEntity = {
  __typename?: 'taxTransactionCodeEntity';
  id: Scalars['ID'];
  accountId: Scalars['ID'];
  taxTrxCode: Scalars['String'];
  description: Scalars['String'];
  commonStatus: Scalars['String'];
  details?: Maybe<Array<TaxTransactionCodeDetailEntity>>;
};

export type TeamMember = {
  person_in_charge: Array<Scalars['String']>;
};

/** JsonType */
export type TeamMemberObject = {
  __typename?: 'teamMemberObject';
  person_in_charge: Array<Scalars['String']>;
};

export type TownshipEntity = {
  __typename?: 'townshipEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  companyId: Scalars['String'];
  name: Scalars['String'];
  code: Scalars['String'];
  location: Scalars['String'];
  logoUrl?: Maybe<Scalars['String']>;
  seqNo: Scalars['Float'];
  commonStatus: Scalars['String'];
  company: CompanyEntity;
  projectExt?: Maybe<Array<ProjectExtEntity>>;
};

export type TransactionMidtransDetailEntity = {
  __typename?: 'transactionMidtransDetailEntity';
  id: Scalars['String'];
  billingId: Scalars['String'];
  creditId: Scalars['String'];
  debitId: Scalars['String'];
  billingName: Scalars['String'];
  amount: Scalars['Float'];
  transactionMidtransId: Scalars['String'];
};

export type TransactionMidtransEntity = {
  __typename?: 'transactionMidtransEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  transactionId?: Maybe<Scalars['String']>;
  snapToken?: Maybe<Scalars['String']>;
  grossAmount: Scalars['Float'];
  paymentType?: Maybe<Scalars['String']>;
  paymentStatus?: Maybe<Scalars['String']>;
  customerDetails: Scalars['JSONObject'];
};

export type UnitEntity = {
  __typename?: 'unitEntity';
  id: Scalars['String'];
  unitNo: Scalars['String'];
  phase?: Maybe<Scalars['String']>;
  unitTypeId?: Maybe<Scalars['String']>;
  unitLayoutId?: Maybe<Scalars['String']>;
  unitLayoutDes?: Maybe<Scalars['String']>;
  facingDirectionId?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['Float']>;
  floorLabel?: Maybe<Scalars['String']>;
  builtUp: Scalars['Float'];
  landArea?: Maybe<Scalars['String']>;
  extraLandArea?: Maybe<Scalars['Float']>;
  facingDirection?: Maybe<DirectionEntity>;
  facingView?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  bottomPrice?: Maybe<Scalars['Float']>;
  timeLock?: Maybe<Scalars['DateTime']>;
  cell: Scalars['Float'];
  hsdNo?: Maybe<Scalars['String']>;
  ptdNo?: Maybe<Scalars['String']>;
  cccDate?: Maybe<Scalars['DateTime']>;
  isCccReady: Scalars['Boolean'];
  isBumi: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
  parentId?: Maybe<Scalars['String']>;
  unitStatus: Scalars['String'];
  unitLockBy?: Maybe<Scalars['String']>;
  bookingWaitlists?: Maybe<Array<BookingWaitlistEntity>>;
  leads: Array<LeadEntity>;
  sales: Array<SaleEntity>;
  salesCharts?: Maybe<SalesChartEntity>;
  projectId: Scalars['String'];
  project: ProjectEntity;
  unitLayout?: Maybe<UnitLayoutEntity>;
  unitType?: Maybe<UnitTypeEntity>;
  propertyType: PropertyTypeEntity;
  unitIntegration?: Maybe<UnitIntegrationEntity>;
  architectCertUnits?: Maybe<Array<ArchitectCertUnitEntity>>;
  subsaleUnit?: Maybe<SubsaleEntity>;
  unitExt?: Maybe<UnitExtensionEntity>;
  projectTitleUnit?: Maybe<ProjectTitleUnitEntity>;
  motTracking?: Maybe<Array<MotTrackingEntity>>;
  saleSubProduct?: Maybe<SaleSubproductEntity>;
  carParks?: Maybe<Array<UnitEntity>>;
  units?: Maybe<UnitEntity>;
  priceAdjustmentUnit?: Maybe<PriceAdjustmentUnitEntity>;
  cellLabel?: Maybe<Scalars['String']>;
  projectSpec: Array<ProjectSpecEntity>;
  waitingListCount?: Maybe<Scalars['Float']>;
  projectDetailsUnitLayout?: Maybe<UnitLayoutEntity>;
  floorLayoutUrl?: Maybe<Scalars['String']>;
  unitLayoutUrl?: Maybe<Scalars['String']>;
  unitLayoutVitualLink?: Maybe<Array<Scalars['String']>>;
  events: Array<EventsEntity>;
  leadSelection: Array<LeadEntity>;
  getIntegratedProjectCarParkNo?: Maybe<Scalars['String']>;
};

export type UnitExtensionEntity = {
  __typename?: 'unitExtensionEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  unitId: Scalars['String'];
  stakeholderId?: Maybe<Scalars['String']>;
  lawyerId?: Maybe<Scalars['String']>;
  paymentPlanId?: Maybe<Scalars['String']>;
  vpLetterDate?: Maybe<Scalars['DateTime']>;
  vpBillingDate?: Maybe<Scalars['DateTime']>;
  dlpExpiryDate?: Maybe<Scalars['DateTime']>;
  bumiAllocation?: Maybe<Scalars['Boolean']>;
  builtUpAreaRate?: Maybe<Scalars['Float']>;
  landAreaRate?: Maybe<Scalars['Float']>;
  extraLandAreaRate?: Maybe<Scalars['Float']>;
  actualBuiltUpArea?: Maybe<Scalars['Float']>;
  actualLandArea?: Maybe<Scalars['Float']>;
  scheduleLaunchDate?: Maybe<Scalars['DateTime']>;
  unitAddress?: Maybe<AddressJson>;
  shareValue?: Maybe<Scalars['String']>;
  usableArea?: Maybe<Scalars['Float']>;
  lotPtNo?: Maybe<Scalars['String']>;
  hsdHsmNo?: Maybe<Scalars['String']>;
  masterGrantNo?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  subdivisionMukim?: Maybe<Scalars['String']>;
  leasePejakanNegeri?: Maybe<Scalars['String']>;
  noOfKey?: Maybe<Scalars['Float']>;
  noOfStorey?: Maybe<Scalars['Float']>;
  remark?: Maybe<Scalars['String']>;
  stampDutyWaiver?: Maybe<Scalars['Boolean']>;
  bumiReleaseDate?: Maybe<Scalars['DateTime']>;
  bumiReleaseReferenceNo?: Maybe<Scalars['String']>;
  dlp1Date?: Maybe<Scalars['DateTime']>;
  dlp2Date?: Maybe<Scalars['DateTime']>;
  premium?: Maybe<Scalars['String']>;
  commonStatus: Scalars['String'];
  units: UnitEntity;
  paymentPlan?: Maybe<PaymentPlanEntity>;
  stakeholder?: Maybe<SolicitorAppointedEntity>;
  lawyer?: Maybe<SolicitorAppointedEntity>;
  clusterId: Scalars['String'];
  projectCluster: ProjectClusterEntity;
  taxSchemeId: Scalars['String'];
  taxScheme: TaxSchemeEntity;
  bookingFee?: Maybe<Scalars['Float']>;
};

export type UnitIntegrationEntity = {
  __typename?: 'unitIntegrationEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  unitId: Scalars['String'];
  projectId: Scalars['String'];
  ifcaBlockId: Scalars['Float'];
  ifcaUnitId: Scalars['Float'];
  commonStatus: Scalars['String'];
  unit: UnitEntity;
  accountSpec?: Maybe<AccountSpecEntity>;
  projectIntegration?: Maybe<ProjectIntegrationEntity>;
  sale?: Maybe<SaleEntity>;
  waitingList?: Maybe<BookingWaitlistEntity>;
};

export type UnitLayout = {
  __typename?: 'unitLayout';
  propertyTypeId?: Maybe<Scalars['String']>;
  unitLayoutId?: Maybe<Scalars['String']>;
  unitLayoutDesc?: Maybe<Scalars['String']>;
};

export type UnitLayoutByProject = {
  __typename?: 'unitLayoutByProject';
  propertyType?: Maybe<Scalars['String']>;
  unitLayout?: Maybe<Array<UnitLayout>>;
};

export type UnitLayoutEntity = {
  __typename?: 'unitLayoutEntity';
  id: Scalars['String'];
  projectId: Scalars['String'];
  desc: Scalars['String'];
  pictureUnitlayouts: Array<PictureUnitlayoutEntity>;
  units: Array<UnitEntity>;
  project: ProjectEntity;
  unitTourVirtualLinks: Array<UnitTourVirtualLinkEntity>;
};

export type UnitMasterDataOutput = {
  __typename?: 'unitMasterDataOutput';
  propertyType?: Maybe<Array<DropDownDataOutput>>;
  paymentPlan?: Maybe<Array<DropDownDataOutput>>;
  direction?: Maybe<Array<DropDownDataOutput>>;
  unitType?: Maybe<Array<DropDownDataOutput>>;
  unitLayout?: Maybe<Array<DropDownDataOutput>>;
  solicitor?: Maybe<Array<DropDownDataOutput>>;
};

export type UnitOfMeasurementEntity = AuditEntity & {
  __typename?: 'unitOfMeasurementEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  accountId: Scalars['String'];
  uom: Scalars['String'];
  description: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type UnitStatutoryDocumentEntity = {
  __typename?: 'unitStatutoryDocumentEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  unitId: Scalars['String'];
  statutoryDocId: Scalars['String'];
  commonStatus: Scalars['String'];
  docCnt: Scalars['Float'];
};

export type UnitTourVirtualLinkEntity = {
  __typename?: 'unitTourVirtualLinkEntity';
  id: Scalars['String'];
  projectId: Scalars['String'];
  block: Scalars['String'];
  unitTypeId?: Maybe<Scalars['String']>;
  unitLayoutId?: Maybe<Scalars['String']>;
  virtualModelLink: Scalars['String'];
  seqNo: Scalars['Float'];
  unitLayout: UnitLayoutEntity;
  unitType: UnitTypeEntity;
};

export type UnitTourVirtualOutput = {
  __typename?: 'unitTourVirtualOutput';
  tourId: Scalars['String'];
  block: Scalars['String'];
  unitLayoutId?: Maybe<Scalars['String']>;
  unitTypeId?: Maybe<Scalars['String']>;
  unitLayoutName?: Maybe<Scalars['String']>;
  unitTypeName?: Maybe<Scalars['String']>;
  virtualModelLink: Scalars['String'];
};

export type UnitTranserIndoEntity = {
  __typename?: 'unitTranserIndoEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  oldSaleId: Scalars['String'];
  newSaleId: Scalars['String'];
  transferDate: Scalars['DateTime'];
  adminFee: Scalars['Float'];
  cancelReasonId: Scalars['String'];
  miscBillId: Scalars['String'];
  oldAllocationAmt: Scalars['Float'];
  oldOutstandingAmt: Scalars['Float'];
  documentNo?: Maybe<Scalars['String']>;
  approvedDate?: Maybe<Scalars['DateTime']>;
  approvedBy?: Maybe<Scalars['String']>;
  approvalStatus?: Maybe<Scalars['String']>;
};

export type UnitTransferEntity = AuditEntity & {
  __typename?: 'unitTransferEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  saleId: Scalars['String'];
  oldUnitId: Scalars['String'];
  newUnitId: Scalars['String'];
  newListPrice: Scalars['Float'];
  newSellingPrice: Scalars['Float'];
  transferDate: Scalars['DateTime'];
  paymentPlanId: Scalars['String'];
  paymentMethod: Scalars['String'];
  administrationCharges: Scalars['Float'];
  reason: Scalars['String'];
  remark: Scalars['String'];
  discount?: Maybe<DiscountObject>;
  status: Scalars['String'];
  oldSaleDetail?: Maybe<OldSaleDetail>;
  oldSellingPrice?: Maybe<Scalars['Float']>;
  commonStatus: Scalars['String'];
};

export type UnitTypeEntity = {
  __typename?: 'unitTypeEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  commonStatus: Scalars['String'];
  defaulted: Scalars['Boolean'];
  seq_no?: Maybe<Scalars['Float']>;
  units: Array<UnitEntity>;
  unitTourVirtualLinks: Array<UnitTourVirtualLinkEntity>;
  isDeletable: Scalars['Boolean'];
};

export type UnitTypeOutput = {
  __typename?: 'unitTypeOutput';
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  builtUp?: Maybe<Scalars['Float']>;
};

export type UnitViewLogEntity = {
  __typename?: 'unitViewLogEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  unitId: Scalars['String'];
  userId: Scalars['String'];
  projectId: Scalars['String'];
  block: Scalars['String'];
  softwareCode: Scalars['String'];
  visitTime: Scalars['DateTime'];
  leftTime?: Maybe<Scalars['DateTime']>;
  socketId?: Maybe<Scalars['String']>;
  ipAddress?: Maybe<Scalars['String']>;
};

export type UserAndRoleCount = {
  __typename?: 'userAndRoleCount';
  totalUser?: Maybe<Scalars['String']>;
  activeUser?: Maybe<Scalars['Float']>;
  availableUser?: Maybe<Scalars['String']>;
  rolesCount?: Maybe<Scalars['Float']>;
  platformUserCount?: Maybe<Scalars['Float']>;
};

export type UserCountByProject = {
  __typename?: 'userCountByProject';
  projectName: Scalars['String'];
  userCount?: Maybe<Scalars['Float']>;
};

export type UserFeaturePermissionEntity = AuditEntity & {
  __typename?: 'userFeaturePermissionEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  userId: Scalars['String'];
  allowOpenlead: Scalars['Boolean'];
  allowPropertyAgency: Scalars['Boolean'];
  allowGlobalBI: Scalars['Boolean'];
  notificationHistory: Scalars['Float'];
  allowRoundRobin: Scalars['Boolean'];
  allowOpenLeadRoundRobin: Scalars['Boolean'];
};

export type UserNotificationSettingEntity = {
  __typename?: 'userNotificationSettingEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  userId: Scalars['String'];
  permissionId: Scalars['Float'];
};

export type WorkFlowApprovedStepEntity = AuditEntity & {
  __typename?: 'workFlowApprovedStepEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  workFlowStepId: Scalars['String'];
  approvalRoleId: Scalars['String'];
  approverId: Scalars['String'];
  approvalDate: Scalars['DateTime'];
  notifiedDate: Scalars['DateTime'];
  statusRemark?: Maybe<Scalars['String']>;
  approvalStatus: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type WorkFlowEntity = AuditEntity & {
  __typename?: 'workFlowEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  approvalPolicyAssignmentId: Scalars['String'];
  entityId: Scalars['String'];
  refId: Scalars['String'];
  refTable: Scalars['String'];
  submitterId: Scalars['String'];
  submitDate: Scalars['DateTime'];
  workFlowStatus: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type WorkFlowStepEntity = AuditEntity & {
  __typename?: 'workFlowStepEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  workFlowId: Scalars['String'];
  approvalRoleId: Scalars['String'];
  notifiedDate: Scalars['DateTime'];
  stepNo: Scalars['Float'];
  statusRemark?: Maybe<Scalars['String']>;
  approvalStatus: Scalars['String'];
  commonStatus: Scalars['String'];
};

export type WorkProgressEntity = {
  __typename?: 'workProgressEntity';
  id: Scalars['String'];
  accountId: Scalars['String'];
  name: Scalars['String'];
  systemUse: Scalars['Boolean'];
  isVp: Scalars['Boolean'];
  isCarPark: Scalars['Boolean'];
  commonStatus: Scalars['String'];
  paymentPlanDetail: Array<PaymentPlanDetailEntity>;
  saleRebatePackage?: Maybe<Array<SaleRebatePackageEntity>>;
  salePackage?: Maybe<Array<SalePackageEntity>>;
  archCert: Array<ArchitectCertWorkProgressEntity>;
};

export type WorkdeskNotificationEntity = AuditEntity & {
  __typename?: 'workdeskNotificationEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  permissionId: Scalars['Float'];
  subject: Scalars['String'];
  body: Scalars['String'];
  wdNotificationRecipient: Array<WorkdeskNotificationRecipientEntity>;
};

export type WorkdeskNotificationRecipientEntity = AuditEntity & {
  __typename?: 'workdeskNotificationRecipientEntity';
  createdTs: Scalars['DateTime'];
  createdBy?: Maybe<Scalars['String']>;
  modTs: Scalars['DateTime'];
  modBy?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  accountId: Scalars['String'];
  projectId: Scalars['String'];
  notificationId: Scalars['String'];
  recipientId: Scalars['String'];
  isRead: Scalars['Boolean'];
  workdeskNotification: WorkdeskNotificationEntity;
};

export type AccessSecurityListingQueryVariables = Exact<{ [key: string]: never; }>;


export type AccessSecurityListingQuery = (
  { __typename?: 'Query' }
  & { accessSecurityListing: (
    { __typename?: 'userAndRoleCount' }
    & Pick<UserAndRoleCount, 'totalUser' | 'activeUser' | 'rolesCount' | 'availableUser' | 'platformUserCount'>
  ) }
);

export type UserListingQueryVariables = Exact<{
  activeStatus?: Maybe<Scalars['String']>;
}>;


export type UserListingQuery = (
  { __typename?: 'Query' }
  & { userListing: Array<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID' | 'name' | 'contactNo' | 'email' | 'superUser' | 'commonStatus' | 'isActivated' | 'isSuspendible'>
    & { userFeaturePermission: (
      { __typename?: 'userFeaturePermissionEntity' }
      & Pick<UserFeaturePermissionEntity, 'allowOpenlead' | 'allowPropertyAgency'>
    ) }
  )> }
);

export type GetUserDetailsQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserDetailsQuery = (
  { __typename?: 'Query' }
  & { getUserDetails: (
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID' | 'name' | 'email' | 'contactNo' | 'superUser' | 'commonStatus' | 'isActivated'>
    & { userFeaturePermission: (
      { __typename?: 'userFeaturePermissionEntity' }
      & Pick<UserFeaturePermissionEntity, 'allowOpenlead' | 'allowPropertyAgency' | 'allowGlobalBI' | 'allowRoundRobin' | 'allowOpenLeadRoundRobin'>
    ) }
  ) }
);

export type GetUserByIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetUserByIdQuery = (
  { __typename?: 'Query' }
  & { getEditUser: (
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID' | 'name' | 'userName' | 'email' | 'contactNo' | 'superUser' | 'isActivated'>
    & { userFeaturePermission: (
      { __typename?: 'userFeaturePermissionEntity' }
      & Pick<UserFeaturePermissionEntity, 'allowOpenlead' | 'allowPropertyAgency' | 'allowGlobalBI' | 'allowRoundRobin' | 'allowOpenLeadRoundRobin'>
    ) }
  ) }
);

export type EditUserMutationVariables = Exact<{
  input: EditUserInput;
}>;


export type EditUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editUser'>
);

export type AddUserMutationVariables = Exact<{
  input: NewUserInput;
}>;


export type AddUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addUser'>
);

export type SuspendUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type SuspendUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'suspendUser'>
);

export type UnSuspendUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UnSuspendUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unSuspendUser'>
);

export type GetPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPermissionQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getPermission'>
);

export type RoleListQueryVariables = Exact<{ [key: string]: never; }>;


export type RoleListQuery = (
  { __typename?: 'Query' }
  & { getRoles: Array<(
    { __typename?: 'roleEntity' }
    & Pick<RoleEntity, 'id' | 'name' | 'permissions' | 'isDeletable' | 'userCountByRole'>
  )> }
);

export type GetRolesByIdQueryVariables = Exact<{
  roleId: Scalars['String'];
}>;


export type GetRolesByIdQuery = (
  { __typename?: 'Query' }
  & { getRoleById: (
    { __typename?: 'roleEntity' }
    & Pick<RoleEntity, 'id' | 'name' | 'permissions' | 'permissionIds'>
  ) }
);

export type NewRoleMutationVariables = Exact<{
  roleName: Scalars['String'];
  permissionList: Array<Scalars['String']> | Scalars['String'];
}>;


export type NewRoleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'newRole'>
);

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['String'];
}>;


export type DeleteRoleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteRole'>
);

export type EditRoleMutationVariables = Exact<{
  roleId: Scalars['String'];
  roleName: Scalars['String'];
  permissionList: Array<PermissionInput> | PermissionInput;
}>;


export type EditRoleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editRole'>
);

export type NonSuperUserListingQueryVariables = Exact<{ [key: string]: never; }>;


export type NonSuperUserListingQuery = (
  { __typename?: 'Query' }
  & { userListing: Array<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID' | 'name'>
  )> }
);

export type RoleListByProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type RoleListByProjectQuery = (
  { __typename?: 'Query' }
  & { getRoles: Array<(
    { __typename?: 'roleEntity' }
    & Pick<RoleEntity, 'id' | 'name' | 'permissions'>
    & { users?: Maybe<Array<(
      { __typename?: 'UserEntity' }
      & Pick<UserEntity, 'ID'>
    )>> }
  )> }
);

export type RoleAssignmentMutationVariables = Exact<{
  input: ProjectUserRoleAssignmentInput;
}>;


export type RoleAssignmentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'roleAssignment'>
);

export type GetUserCountByProjectQueryVariables = Exact<{
  roleId: Scalars['String'];
}>;


export type GetUserCountByProjectQuery = (
  { __typename?: 'Query' }
  & { getUserCountByProject?: Maybe<Array<(
    { __typename?: 'userCountByProject' }
    & Pick<UserCountByProject, 'projectName' | 'userCount'>
  )>> }
);

export type IsAllowAddUserQueryVariables = Exact<{ [key: string]: never; }>;


export type IsAllowAddUserQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isAllowAddUser'>
);

export type ResendEmailInvitationMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ResendEmailInvitationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resendInvitation'>
);

export type IsEmailExistQueryVariables = Exact<{
  email: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}>;


export type IsEmailExistQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isEmailExist'>
);

export type IsUserNameExistQueryVariables = Exact<{
  userName: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}>;


export type IsUserNameExistQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isUserNameExist'>
);

export type GetPlatformUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlatformUsersQuery = (
  { __typename?: 'Query' }
  & { getPlatformUsers: Array<(
    { __typename?: 'PlatformUserEntity' }
    & Pick<PlatformUserEntity, 'ID' | 'name' | 'email' | 'commonStatus' | 'role' | 'isActivated'>
  )> }
);

export type SuspendPlatformUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type SuspendPlatformUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'suspendPlatformUser'>
);

export type UnsuspendPlatformUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type UnsuspendPlatformUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unsuspendPlatformUser'>
);

export type ChangePlatformUserPasswordMutationVariables = Exact<{
  userId: Scalars['String'];
  newPassword: Scalars['String'];
  confirmPassword: Scalars['String'];
}>;


export type ChangePlatformUserPasswordMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'changePlatformUserPassword'>
);

export type GetPlatformUserByIdQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetPlatformUserByIdQuery = (
  { __typename?: 'Query' }
  & { getPlatformUserById: (
    { __typename?: 'PlatformUserEntity' }
    & Pick<PlatformUserEntity, 'ID' | 'name' | 'username' | 'email' | 'contactNo' | 'role' | 'isActivated'>
  ) }
);

export type EditPlatformUserMutationVariables = Exact<{
  input: EditPlatformUserInput;
}>;


export type EditPlatformUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editPlatformUser'>
);

export type AddNewPlatformUserMutationVariables = Exact<{
  input: NewPlatformUserInput;
}>;


export type AddNewPlatformUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addNewPlatformUser'>
);

export type IsPlatformUserEmailExistQueryVariables = Exact<{
  email: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}>;


export type IsPlatformUserEmailExistQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isPlatformUserEmailExist'>
);

export type IsPlatformUserNameExistQueryVariables = Exact<{
  userName: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
}>;


export type IsPlatformUserNameExistQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isPlatformUserNameExist'>
);

export type GetAssignedAccoutListQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetAssignedAccoutListQuery = (
  { __typename?: 'Query' }
  & { getAssignedAccoutList: Array<(
    { __typename?: 'PlatformUserAssignedAccountEntity' }
    & Pick<PlatformUserAssignedAccountEntity, 'id' | 'accountId' | 'platformUserId'>
  )> }
);

export type AssignPlatformUserAccountMutationVariables = Exact<{
  platformUserId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type AssignPlatformUserAccountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'assignPlatformUserAccount'>
);

export type UnassignPlatformUserAccountMutationVariables = Exact<{
  platformUserId: Scalars['String'];
  accountId: Scalars['String'];
}>;


export type UnassignPlatformUserAccountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unassignPlatformUserAccount'>
);

export type GetNonAdminAccountListQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type GetNonAdminAccountListQuery = (
  { __typename?: 'Query' }
  & { getNonAdminAccountList: Array<(
    { __typename?: 'AccountIdsOuput' }
    & Pick<AccountIdsOuput, 'ID'>
  )> }
);

export type AssignPlatformUserAccountsMutationVariables = Exact<{
  platformUserId: Scalars['String'];
  accountIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type AssignPlatformUserAccountsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'assignPlatformUserAccounts'>
);

export type UnassignPlatformUserAccountsMutationVariables = Exact<{
  platformUserId: Scalars['String'];
  accountIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnassignPlatformUserAccountsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unassignPlatformUserAccounts'>
);

export type CheckPlatformUserIsAdminQueryVariables = Exact<{
  userId: Scalars['String'];
}>;


export type CheckPlatformUserIsAdminQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'checkPlatformUserIsAdmin'>
);

export type ResendPlatformUserInvitationMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type ResendPlatformUserInvitationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resendPlatformUserInvitation'>
);

export type LoginQueryVariables = Exact<{
  LoginId: Scalars['String'];
  Password: Scalars['String'];
}>;


export type LoginQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'login'>
);

export type LogoutQueryVariables = Exact<{ [key: string]: never; }>;


export type LogoutQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'logout'>
);

export type AccountNameQueryVariables = Exact<{ [key: string]: never; }>;


export type AccountNameQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getAccountName'>
);

export type GetAccountListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountListQuery = (
  { __typename?: 'Query' }
  & { getAccountList?: Maybe<Array<(
    { __typename?: 'IfcaAccountOutput' }
    & Pick<IfcaAccountOutput, 'id' | 'name'>
  )>> }
);

export type PasswordPolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type PasswordPolicyQuery = (
  { __typename?: 'Query' }
  & { passswordPolicy: (
    { __typename?: 'PassswordPolicyOuput' }
    & Pick<PassswordPolicyOuput, 'RequiredLength' | 'RequiredUniqueChars' | 'RequireNonAlphanumeric' | 'RequireLowercase' | 'RequireUppercase' | 'RequireDigit'>
    & { ErrorMsg: (
      { __typename?: 'PassswordErrorMsgOuput' }
      & Pick<PassswordErrorMsgOuput, 'RequiredLength' | 'RequiredUniqueChars' | 'RequireNonAlphanumeric' | 'RequireLowercase' | 'RequireUppercase' | 'RequireDigit'>
    ) }
  ) }
);

export type UnblockUserMutationVariables = Exact<{
  userId: Scalars['String'];
  newPassword: Scalars['String'];
  confirmPassword: Scalars['String'];
}>;


export type UnblockUserMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unblockUser'>
);

export type SwitchAccountQueryVariables = Exact<{
  accountID: Scalars['String'];
}>;


export type SwitchAccountQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'refreshToken'>
);

export type GetPlatformUserProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlatformUserProfileQuery = (
  { __typename?: 'Query' }
  & { getPlatformUserProfile: (
    { __typename?: 'PlatformUserEntity' }
    & Pick<PlatformUserEntity, 'ID' | 'name' | 'username' | 'email' | 'contactNo' | 'role' | 'avatar'>
  ) }
);

export type ChangePlatformUserPasswordInProfileMutationVariables = Exact<{
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  confirmPassword: Scalars['String'];
}>;


export type ChangePlatformUserPasswordInProfileMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'changePlatformUserPasswordInProfile'>
);

export type UpdatePlatformUserProfileMutationVariables = Exact<{
  input: UpdatePlatformUserProfileInput;
}>;


export type UpdatePlatformUserProfileMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updatePlatformUserProfile'>
);

export type CountryQueryVariables = Exact<{ [key: string]: never; }>;


export type CountryQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & { Countries: Array<(
      { __typename?: 'CountryMasterDataOutput' }
      & Pick<CountryMasterDataOutput, 'ID' | 'name'>
    )> }
  ) }
);

export type StateQueryVariables = Exact<{
  countryId: Scalars['String'];
}>;


export type StateQuery = (
  { __typename?: 'Query' }
  & { GetStatesByCountry?: Maybe<Array<(
    { __typename?: 'StateMasterDataOutput' }
    & Pick<StateMasterDataOutput, 'ID' | 'name'>
  )>> }
);

export type CityQueryVariables = Exact<{
  stateId: Scalars['String'];
}>;


export type CityQuery = (
  { __typename?: 'Query' }
  & { GetCitiesByState?: Maybe<Array<(
    { __typename?: 'CityMasterDataOutput' }
    & Pick<CityMasterDataOutput, 'ID' | 'name'>
  )>> }
);

export type PostcodeQueryVariables = Exact<{
  cityId: Scalars['String'];
}>;


export type PostcodeQuery = (
  { __typename?: 'Query' }
  & { GetPostcodeByCity?: Maybe<Array<(
    { __typename?: 'PostCodeMasterDataOutput' }
    & Pick<PostCodeMasterDataOutput, 'ID' | 'postcode'>
  )>> }
);

export type GetAllAppointmentTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllAppointmentTypeQuery = (
  { __typename?: 'Query' }
  & { getAllAppointmentType: Array<(
    { __typename?: 'AppointmentTypeEntity' }
    & Pick<AppointmentTypeEntity, 'id' | 'name' | 'seqNo' | 'defaulted' | 'systemUse' | 'commonStatus' | 'isDeletable'>
  )> }
);

export type AddAppointmentTypeMutationVariables = Exact<{
  appointmentName: Scalars['String'];
}>;


export type AddAppointmentTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addAppointmentType'>
);

export type EditAppointmentTypeMutationVariables = Exact<{
  appointmentName: Scalars['String'];
  appointmentId: Scalars['String'];
}>;


export type EditAppointmentTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editAppointmentType'>
);

export type SetDefaultAppointmentTypeMutationVariables = Exact<{
  appointmentId: Scalars['String'];
}>;


export type SetDefaultAppointmentTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultAppointmentType'>
);

export type DeleteAppointmentTypeMutationVariables = Exact<{
  appointmentId: Scalars['String'];
}>;


export type DeleteAppointmentTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteAppointmentType'>
);

export type DeactivateAppointmentTypeMutationVariables = Exact<{
  appointmentId: Scalars['String'];
}>;


export type DeactivateAppointmentTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deactivateAppointmentType'>
);

export type OrganizeAppointmentTypeMutationVariables = Exact<{
  appointmentId: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeAppointmentTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeAppointmentType'>
);

export type RemoveDefaultAppointmentTypeMutationVariables = Exact<{
  appointmentId: Scalars['String'];
}>;


export type RemoveDefaultAppointmentTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultAppointmentType'>
);

export type CampaignDataQueryVariables = Exact<{ [key: string]: never; }>;


export type CampaignDataQuery = (
  { __typename?: 'Query' }
  & { getCampaignList: Array<(
    { __typename?: 'campaignEntity' }
    & Pick<CampaignEntity, 'name' | 'id' | 'startDate' | 'endDate' | 'getCampaignEventsCount' | 'isDeletable'>
  )> }
);

export type CampaignDataByIdQueryVariables = Exact<{
  campaign_id: Scalars['String'];
}>;


export type CampaignDataByIdQuery = (
  { __typename?: 'Query' }
  & { getCampaignById: (
    { __typename?: 'campaignEntity' }
    & Pick<CampaignEntity, 'name' | 'id' | 'startDate' | 'endDate'>
  ) }
);

export type GetEventsbyCampaignQueryVariables = Exact<{
  campaign_id: Scalars['String'];
}>;


export type GetEventsbyCampaignQuery = (
  { __typename?: 'Query' }
  & { getEventsListByCampaign?: Maybe<(
    { __typename?: 'campaignEntity' }
    & { events: Array<(
      { __typename?: 'eventsEntity' }
      & Pick<EventsEntity, 'id' | 'name' | 'desc' | 'startDate' | 'endDate' | 'budget' | 'isDeletable'>
    )> }
  )> }
);

export type GetEventsDetailsQueryVariables = Exact<{
  events_id: Scalars['String'];
}>;


export type GetEventsDetailsQuery = (
  { __typename?: 'Query' }
  & { getEventsDetails: (
    { __typename?: 'eventsEntity' }
    & Pick<EventsEntity, 'name' | 'desc' | 'website' | 'location' | 'startDate' | 'endDate' | 'budget' | 'campaignId'>
  ) }
);

export type GetEventsEditDetailsQueryVariables = Exact<{
  events_id: Scalars['String'];
  campaign_id: Scalars['String'];
}>;


export type GetEventsEditDetailsQuery = (
  { __typename?: 'Query' }
  & { getEventsDetails: (
    { __typename?: 'eventsEntity' }
    & Pick<EventsEntity, 'name' | 'desc' | 'website' | 'location' | 'startDate' | 'endDate' | 'budget'>
  ), getCampaignById: (
    { __typename?: 'campaignEntity' }
    & Pick<CampaignEntity, 'startDate' | 'endDate'>
  ) }
);

export type AddEventsMutationVariables = Exact<{
  input: AdminEventsInput;
}>;


export type AddEventsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addEvents'>
);

export type EditEventsMutationVariables = Exact<{
  input: AdminEventsInput;
}>;


export type EditEventsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editEvents'>
);

export type AddCampaignMutationVariables = Exact<{
  input: AdminCampaignInput;
}>;


export type AddCampaignMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addCampaign'>
);

export type EditCampaignMutationVariables = Exact<{
  input: AdminCampaignInput;
}>;


export type EditCampaignMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editCampaign'>
);

export type DeleteCampaignMutationVariables = Exact<{
  campaignID: Scalars['String'];
}>;


export type DeleteCampaignMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteCampaignById'>
);

export type DeleteEventsMutationVariables = Exact<{
  eventsID: Scalars['String'];
}>;


export type DeleteEventsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteEventsById'>
);

export type GetAllDirectionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDirectionQuery = (
  { __typename?: 'Query' }
  & { getAllDirection?: Maybe<Array<(
    { __typename?: 'directionEntity' }
    & Pick<DirectionEntity, 'id' | 'name' | 'commonStatus' | 'defaulted' | 'seq_no' | 'isDeletable'>
  )>> }
);

export type EditDirectionMutationVariables = Exact<{
  input: EditDirectionInput;
}>;


export type EditDirectionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editDirection'>
);

export type AddDirectionMutationVariables = Exact<{
  input: DirectionInput;
}>;


export type AddDirectionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addDirection'>
);

export type DeleteDirectionByIdMutationVariables = Exact<{
  directionId: Scalars['String'];
}>;


export type DeleteDirectionByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteDirectionById'>
);

export type SetDefaultDirectionMutationVariables = Exact<{
  directionId: Scalars['String'];
}>;


export type SetDefaultDirectionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultDirection'>
);

export type RemoveDefaultDirectionMutationVariables = Exact<{
  directionId: Scalars['String'];
}>;


export type RemoveDefaultDirectionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultDirection'>
);

export type OrganizeDirectionMutationVariables = Exact<{
  directionId: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeDirectionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeDirection'>
);

export type GetAllDiscountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllDiscountQuery = (
  { __typename?: 'Query' }
  & { getAllDiscount: Array<(
    { __typename?: 'discountEntity' }
    & Pick<DiscountEntity, 'id' | 'discountTypeId' | 'title' | 'description' | 'formula' | 'prefix' | 'isIntegrated' | 'isDeletable'>
  )> }
);

export type GetDiscountByIdQueryVariables = Exact<{
  discountId: Scalars['String'];
}>;


export type GetDiscountByIdQuery = (
  { __typename?: 'Query' }
  & { getDiscountById: (
    { __typename?: 'discountEntity' }
    & Pick<DiscountEntity, 'title' | 'formula' | 'id' | 'discountTypeId' | 'prefix' | 'description' | 'discountVal' | 'isIntegrated'>
  ), GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'DiscountPrefix'>
    & { DiscountType: Array<(
      { __typename?: 'discountTypeEntity' }
      & Pick<DiscountTypeEntity, 'id' | 'name'>
    )> }
  ) }
);

export type EditDiscountMutationVariables = Exact<{
  input: EditDiscountInput;
}>;


export type EditDiscountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editDiscount'>
);

export type GetDiscountMasterInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiscountMasterInfoQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'DiscountPrefix'>
    & { DiscountType: Array<(
      { __typename?: 'discountTypeEntity' }
      & Pick<DiscountTypeEntity, 'id' | 'name'>
    )> }
  ) }
);

export type DeleteDiscountMutationVariables = Exact<{
  discountId: Scalars['String'];
}>;


export type DeleteDiscountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteDiscount'>
);

export type SyncIntegrateDiscountMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncIntegrateDiscountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'syncIntegrateDiscount'>
);

export type AddDiscountMutationVariables = Exact<{
  input: DiscountInput;
}>;


export type AddDiscountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addDiscount'>
);

export type GetDiscountAssignedByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetDiscountAssignedByProjectIdQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getDiscountAssignedByProjectId'>
);

export type AssignDiscountMutationVariables = Exact<{
  input: AssignDiscountInput;
}>;


export type AssignDiscountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'assignDiscount'>
);

export type EditAssignDiscountMutationVariables = Exact<{
  input: AssignDiscountInput;
}>;


export type EditAssignDiscountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editAssignDiscount'>
);

export type UnassignDiscountMutationVariables = Exact<{
  projectId: Scalars['String'];
  discountId: Scalars['String'];
}>;


export type UnassignDiscountMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unassignDiscount'>
);

export type GetAssignedDiscountByIdQueryVariables = Exact<{
  discountId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetAssignedDiscountByIdQuery = (
  { __typename?: 'Query' }
  & { getAssignedDiscountById: (
    { __typename?: 'projectDiscountEntity' }
    & Pick<ProjectDiscountEntity, 'id' | 'effectiveDate' | 'expired_date' | 'projectId' | 'discountId'>
    & { discount: (
      { __typename?: 'discountEntity' }
      & Pick<DiscountEntity, 'id' | 'title'>
    ) }
  ) }
);

export type GetAssignDiscountFormSourceQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetAssignDiscountFormSourceQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getAssignDiscountFormSource'>
);

export type SetDefaultDiscountForProjectMutationVariables = Exact<{
  discountId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type SetDefaultDiscountForProjectMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultDiscountForProject'>
);

export type UnmarkDefaultDiscountForProjectMutationVariables = Exact<{
  discountId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type UnmarkDefaultDiscountForProjectMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unmarkDefaultDiscountForProject'>
);

export type GetELaunchListingQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetELaunchListingQuery = (
  { __typename?: 'Query' }
  & { getELaunchListing: Array<(
    { __typename?: 'eLaunchEntity' }
    & Pick<ELaunchEntity, 'id' | 'name' | 'publishDate' | 'startDate' | 'endDate' | 'terminationDate' | 'totalUnitAllocationCount' | 'totalBookedUnitAllocationCount' | 'totalInvitedPurchaserCount' | 'invitationTemplateId' | 'hasEnded'>
    & { eLaunchLeadBatch?: Maybe<Array<(
      { __typename?: 'eLaunchLeadBatchEntity' }
      & Pick<ELaunchLeadBatchEntity, 'totalRegisteredLeadCount' | 'recordCount'>
    )>> }
  )> }
);

export type GetELaunchByIdQueryVariables = Exact<{
  eLaunchId: Scalars['String'];
}>;


export type GetELaunchByIdQuery = (
  { __typename?: 'Query' }
  & { getELaunchById: (
    { __typename?: 'eLaunchEntity' }
    & Pick<ELaunchEntity, 'id' | 'name' | 'startDate' | 'endDate' | 'publishDate' | 'code' | 'terminationDate' | 'totalUnitAllocationCount' | 'totalBookedUnitAllocationCount' | 'totalInvitedPurchaserCount' | 'totalBookedUnit' | 'hasEnded' | 'hasPublished'>
    & { eLaunchLeadBatch?: Maybe<Array<(
      { __typename?: 'eLaunchLeadBatchEntity' }
      & Pick<ELaunchLeadBatchEntity, 'totalRegisteredLeadCount' | 'recordCount'>
    )>> }
  ) }
);

export type GetELaunchLinkQueryVariables = Exact<{
  eLaunchId: Scalars['String'];
}>;


export type GetELaunchLinkQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getELaunchLink'>
);

export type AddELaunchMutationVariables = Exact<{
  input: ELaunchInput;
}>;


export type AddELaunchMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addELaunch'>
);

export type EditELaunchMutationVariables = Exact<{
  input: ELaunchInput;
}>;


export type EditELaunchMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editELaunch'>
);

export type IsELaunchCodeExistQueryVariables = Exact<{
  code: Scalars['String'];
  eLaunchID?: Maybe<Scalars['String']>;
}>;


export type IsELaunchCodeExistQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isELaunchCodeExist'>
);

export type DeleteELaunchMutationVariables = Exact<{
  eLaunchId: Scalars['String'];
}>;


export type DeleteELaunchMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteELaunch'>
);

export type GetAllocatedUnitsByELaunchIdQueryVariables = Exact<{
  projectId: Scalars['String'];
  eLaunchId: Scalars['String'];
  block: Scalars['String'];
}>;


export type GetAllocatedUnitsByELaunchIdQuery = (
  { __typename?: 'Query' }
  & { getELaunchById: (
    { __typename?: 'eLaunchEntity' }
    & Pick<ELaunchEntity, 'name' | 'startDate' | 'endDate'>
  ), getAllocatedUnitsByELaunchId: Array<(
    { __typename?: 'ElaunchUnitAllocation' }
    & Pick<ElaunchUnitAllocation, 'unit_id' | 'unit_no' | 'unit_status' | 'unit_type' | 'price' | 'floor' | 'floor_label' | 'cell' | 'status' | 'favouriteCount' | 'unitType' | 'isBumi'>
  )> }
);

export type GetELaunchUnitAllocationSummaryQueryVariables = Exact<{
  elaunchId: Scalars['String'];
}>;


export type GetELaunchUnitAllocationSummaryQuery = (
  { __typename?: 'Query' }
  & { getELaunchById: (
    { __typename?: 'eLaunchEntity' }
    & Pick<ELaunchEntity, 'name' | 'startDate' | 'endDate'>
  ), getELaunchUnitAllocationSummary: Array<(
    { __typename?: 'UnitAllocationSummary' }
    & Pick<UnitAllocationSummary, 'block' | 'count' | 'unitType' | 'favouriteCount' | 'bookedCount'>
  )> }
);

export type GetELaunchUnitAllocationQueryVariables = Exact<{
  block: Scalars['String'];
  eLaunchId: Scalars['String'];
}>;


export type GetELaunchUnitAllocationQuery = (
  { __typename?: 'Query' }
  & { getELaunchById: (
    { __typename?: 'eLaunchEntity' }
    & Pick<ELaunchEntity, 'name'>
  ), getAllocatedUnitsByBlock: Array<(
    { __typename?: 'eLaunchAllocationEntity' }
    & Pick<ELaunchAllocationEntity, 'totalFavouriteCount'>
    & { unit: (
      { __typename?: 'unitEntity' }
      & Pick<UnitEntity, 'id' | 'unitNo' | 'unitStatus'>
    ) }
  )> }
);

export type UpdateELaunchAllocationMutationVariables = Exact<{
  input: ELaunchAllocationInput;
}>;


export type UpdateELaunchAllocationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateELaunchAllocation'>
);

export type GetELaunchRegisteredPurchaserQueryVariables = Exact<{
  search?: Maybe<Scalars['String']>;
  eLaunchId: Scalars['String'];
}>;


export type GetELaunchRegisteredPurchaserQuery = (
  { __typename?: 'Query' }
  & { getRegisteredPurchaserListing: Array<(
    { __typename?: 'PurchaserDetailOutput' }
    & Pick<PurchaserDetailOutput, 'userId' | 'name' | 'email' | 'phone' | 'unitFavouriteAndBookedCount' | 'isLead'>
    & { favouriteAndBookedUnits: (
      { __typename?: 'BookedAndFavUnit' }
      & Pick<BookedAndFavUnit, 'favouriteUnits' | 'bookedUnits'>
    ) }
  )> }
);

export type GetRegisteredPurchaserDetailsByIdQueryVariables = Exact<{
  userId: Scalars['String'];
  eLaunchId: Scalars['String'];
}>;


export type GetRegisteredPurchaserDetailsByIdQuery = (
  { __typename?: 'Query' }
  & { getRegisteredPurchaserDetailsById: (
    { __typename?: 'RegisteredPurchaserDetailsByIdOutput' }
    & Pick<RegisteredPurchaserDetailsByIdOutput, 'favouriteUnits'>
    & { purchaserDetail: (
      { __typename?: 'PurchaserDetailOutput' }
      & Pick<PurchaserDetailOutput, 'name' | 'email' | 'phone' | 'isLead'>
    ), bookedUnits: Array<(
      { __typename?: 'PurchaserBookedUnit' }
      & Pick<PurchaserBookedUnit, 'unitNo' | 'saleId'>
    )> }
  ) }
);

export type GetBusinessInsightSummaryDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessInsightSummaryDataQuery = (
  { __typename?: 'Query' }
  & { getMostFavouriteUnit: (
    { __typename?: 'MostFavouriteOutput' }
    & Pick<MostFavouriteOutput, 'totalFavourite'>
  ) }
);

export type GetMostFavouriteUnitQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMostFavouriteUnitQuery = (
  { __typename?: 'Query' }
  & { getMostFavouriteUnit: (
    { __typename?: 'MostFavouriteOutput' }
    & { favouriteUnit: Array<(
      { __typename?: 'FavouriteUnit' }
      & Pick<FavouriteUnit, 'unitNo' | 'count'>
    )>, favouriteUnitType: Array<(
      { __typename?: 'FavouriteUnitType' }
      & Pick<FavouriteUnitType, 'unitType' | 'count'>
    )> }
  ) }
);

export type GetPurchaserDemoFilterQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPurchaserDemoFilterQuery = (
  { __typename?: 'Query' }
  & { getPurchaserDemoFilter: (
    { __typename?: 'PurchaserDemographicBIFilterOutput' }
    & Pick<PurchaserDemographicBiFilterOutput, 'propertyType'>
    & { unitLayout?: Maybe<Array<(
      { __typename?: 'unitLayoutByProject' }
      & Pick<UnitLayoutByProject, 'propertyType'>
      & { unitLayout?: Maybe<Array<(
        { __typename?: 'unitLayout' }
        & Pick<UnitLayout, 'propertyTypeId' | 'unitLayoutId' | 'unitLayoutDesc'>
      )>> }
    )>> }
  ) }
);

export type GetPurchaserDemographicDataQueryVariables = Exact<{
  unitLayoutId?: Maybe<Scalars['String']>;
  propertyTypeId?: Maybe<Scalars['String']>;
}>;


export type GetPurchaserDemographicDataQuery = (
  { __typename?: 'Query' }
  & { getRaceBI: Array<(
    { __typename?: 'PurchaserDemographicBIOutput' }
    & Pick<PurchaserDemographicBiOutput, 'name' | 'value'>
  )>, getNationalityBI: Array<(
    { __typename?: 'PurchaserDemographicBIOutput' }
    & Pick<PurchaserDemographicBiOutput, 'name' | 'value'>
  )>, getAgeBI: Array<(
    { __typename?: 'PurchaserDemographicBIOutput' }
    & Pick<PurchaserDemographicBiOutput, 'name' | 'value'>
  )>, getLocationBI: Array<(
    { __typename?: 'PurchaserDemographicBIOutput' }
    & Pick<PurchaserDemographicBiOutput, 'name' | 'value'>
  )> }
);

export type ExportPurchaserQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type ExportPurchaserQuery = (
  { __typename?: 'Query' }
  & { exportPurchaser: (
    { __typename?: 'ReportingExcelOutput' }
    & Pick<ReportingExcelOutput, 'base64' | 'projectName'>
  ) }
);

export type GetBookingDetailDataQueryVariables = Exact<{
  saleId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetBookingDetailDataQuery = (
  { __typename?: 'Query' }
  & { getBookingDetailData: (
    { __typename?: 'BookingDetailOutput' }
    & Pick<BookingDetailOutput, 'cancelledDate' | 'cancelledReason' | 'cancelledByName' | 'buyerCompanyName' | 'buyerCompanyRegNo' | 'buyerName' | 'buyerNric' | 'salesId' | 'salesStatus' | 'salePaymentId' | 'isjointBuyerComplete' | 'isPurchaserInfoComplete' | 'buyerPhoneNo' | 'buyerEmail' | 'salesNo' | 'unitNo' | 'unitLayout' | 'unitLayoutDes' | 'landArea' | 'extraLandArea' | 'builtUp' | 'isCompany' | 'sellingPrice' | 'listPrice' | 'paymentMethod' | 'buyerId' | 'unitId' | 'bookingRemark' | 'personName' | 'teamName' | 'agencyName' | 'agencyUserName'>
    & { attachmentCount?: Maybe<(
      { __typename?: 'BookingListAttachmentOutput' }
      & Pick<BookingListAttachmentOutput, 'isAttachmentComplete' | 'requiredDocCount' | 'completedDocCount'>
    )>, joinBuyer: Array<(
      { __typename?: 'jointBuyerEntity' }
      & { contact: (
        { __typename?: 'contactEntity' }
        & Pick<ContactEntity, 'fullName'>
      ) }
    )> }
  ), GetBookingDetail: (
    { __typename?: 'saleEntity' }
    & { loanScreening?: Maybe<(
      { __typename?: 'LoanScreenStatusOutput' }
      & Pick<LoanScreenStatusOutput, 'caseCode' | 'status' | 'CCRIS' | 'CTOS' | 'createdDate' | 'modifiedDate'>
    )> }
  ) }
);

export type BookingAttachmentsQueryVariables = Exact<{
  saleId: Scalars['String'];
}>;


export type BookingAttachmentsQuery = (
  { __typename?: 'Query' }
  & { GetBookingDetail: (
    { __typename?: 'saleEntity' }
    & Pick<SaleEntity, 'id' | 'salesStatus' | 'sellingPrice' | 'salesPerson' | 'bookDate'>
    & { contact: (
      { __typename?: 'contactEntity' }
      & Pick<ContactEntity, 'id' | 'fullName' | 'companyName'>
      & { nationality?: Maybe<(
        { __typename?: 'sNationalityEntity' }
        & Pick<SNationalityEntity, 'name'>
      )> }
    ), unit: (
      { __typename?: 'unitEntity' }
      & Pick<UnitEntity, 'id' | 'unitNo' | 'price'>
      & { projectSpec: Array<(
        { __typename?: 'projectSpecEntity' }
        & Pick<ProjectSpecEntity, 'bookingPDPAconsentRequired'>
      )> }
    ), bookingAttachments: (
      { __typename?: 'bookingAttachmentsOutput' }
      & { bookingCcrAttachments: Array<(
        { __typename?: 'attachmentEntity' }
        & Pick<AttachmentEntity, 'id' | 'accountId' | 'refTable' | 'refId' | 'refType' | 'mediaType' | 'resourceUrl' | 'fileName' | 'bucketFileName' | 'isPrivate' | 'seqNo' | 'allowDelete'>
      )>, bookingNricAttachments: Array<(
        { __typename?: 'attachmentEntity' }
        & Pick<AttachmentEntity, 'id' | 'accountId' | 'refTable' | 'refId' | 'refType' | 'mediaType' | 'resourceUrl' | 'fileName' | 'bucketFileName' | 'isPrivate' | 'seqNo' | 'allowDelete'>
      )>, bookingFeeAttachments: Array<(
        { __typename?: 'attachmentEntity' }
        & Pick<AttachmentEntity, 'id' | 'accountId' | 'refTable' | 'refId' | 'refType' | 'mediaType' | 'resourceUrl' | 'fileName' | 'bucketFileName' | 'isPrivate' | 'seqNo' | 'allowDelete'>
      )>, bookingPdpaAttachments: Array<(
        { __typename?: 'attachmentEntity' }
        & Pick<AttachmentEntity, 'id' | 'accountId' | 'refTable' | 'refId' | 'refType' | 'mediaType' | 'resourceUrl' | 'fileName' | 'bucketFileName' | 'isPrivate' | 'seqNo' | 'allowDelete'>
      )> }
    ), loanScreeningReports?: Maybe<Array<(
      { __typename?: 'LoanScreenReportOutput' }
      & Pick<LoanScreenReportOutput, 'refType' | 'mediaType' | 'resourceUrl' | 'fileName'>
    )>> }
  ) }
);

export type JointBuyerDetailsQueryVariables = Exact<{
  sale_id: Scalars['String'];
}>;


export type JointBuyerDetailsQuery = (
  { __typename?: 'Query' }
  & { GetBookingDetail: (
    { __typename?: 'saleEntity' }
    & Pick<SaleEntity, 'id' | 'bookDate' | 'salesStatus' | 'sellingPrice' | 'salesPerson'>
    & { unit: (
      { __typename?: 'unitEntity' }
      & Pick<UnitEntity, 'id' | 'unitNo' | 'price'>
    ), contact: (
      { __typename?: 'contactEntity' }
      & Pick<ContactEntity, 'id' | 'fullName' | 'companyName'>
    ), joinBuyer: Array<(
      { __typename?: 'jointBuyerEntity' }
      & Pick<JointBuyerEntity, 'id' | 'commonStatus'>
      & { contact: (
        { __typename?: 'contactEntity' }
        & Pick<ContactEntity, 'id' | 'fullName' | 'phoneNo' | 'email'>
      ) }
    )> }
  ) }
);

export type DownloadAttachmentMutationVariables = Exact<{
  input: SalesDownloadAttachmentInput;
}>;


export type DownloadAttachmentMutation = (
  { __typename?: 'Mutation' }
  & { downloadAttachment: (
    { __typename?: 'AttachmentOutput' }
    & Pick<AttachmentOutput, 'content' | 'fileName'>
  ) }
);

export type SendDocEmailToELaunchLeadMutationVariables = Exact<{
  recipients: Array<Scalars['String']> | Scalars['String'];
  contactIds: Array<Scalars['String']> | Scalars['String'];
  projectId: Scalars['String'];
  message: Scalars['String'];
  subject: Scalars['String'];
}>;


export type SendDocEmailToELaunchLeadMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendDocEmailToELaunchLead'>
);

export type OpenLeadDownloadTemplateQueryVariables = Exact<{ [key: string]: never; }>;


export type OpenLeadDownloadTemplateQuery = (
  { __typename?: 'Query' }
  & { downloadLeadTemplate: (
    { __typename?: 'LeadTemplateReturnOutput' }
    & Pick<LeadTemplateReturnOutput, 'file_name' | 'file'>
  ) }
);

export type ExtractImportedLeadToExcelQueryVariables = Exact<{
  eLaunchBatchId: Scalars['String'];
}>;


export type ExtractImportedLeadToExcelQuery = (
  { __typename?: 'Query' }
  & { extractImportedLeadToExcel: (
    { __typename?: 'LeadTemplateReturnOutput' }
    & Pick<LeadTemplateReturnOutput, 'file_name' | 'file'>
  ) }
);

export type GetLeadByELauchIdQueryVariables = Exact<{
  eLaunchId: Scalars['String'];
}>;


export type GetLeadByELauchIdQuery = (
  { __typename?: 'Query' }
  & { getLeadByELaunchId: Array<(
    { __typename?: 'LeadBatchContactOutput' }
    & Pick<LeadBatchContactOutput, 'contactId' | 'fullName' | 'email' | 'phoneNo'>
  )> }
);

export type GetELaunchLeadBatchListQueryVariables = Exact<{
  eLaunchId: Scalars['String'];
}>;


export type GetELaunchLeadBatchListQuery = (
  { __typename?: 'Query' }
  & { getELaunchLeadBatchList: (
    { __typename?: 'LeadBatchSummaryPageOutput' }
    & Pick<LeadBatchSummaryPageOutput, 'eLaunchId' | 'eLaunchName' | 'totalImportedLead' | 'totalRegisteredLead' | 'leadBatchs' | 'endDate'>
  ) }
);

export type LeadsByBatchQueryVariables = Exact<{
  batchId: Scalars['String'];
  page: Scalars['Float'];
  limit: Scalars['Float'];
  search?: Maybe<Scalars['String']>;
}>;


export type LeadsByBatchQuery = (
  { __typename?: 'Query' }
  & { LeadsByBatch?: Maybe<(
    { __typename?: 'LeadByBatchIds' }
    & Pick<LeadByBatchIds, 'id' | 'batchTitle' | 'createdTs' | 'isExpired' | 'recordCount'>
    & { leadData?: Maybe<Array<(
      { __typename?: 'LeadDataOutput' }
      & Pick<LeadDataOutput, 'full_name' | 'gender' | 'phone_no' | 'email' | 'lead_source' | 'isRegistered'>
    )>> }
  )> }
);

export type GetExistingLeadsQueryVariables = Exact<{
  projectId: Scalars['String'];
  eLaunchId: Scalars['String'];
  leadStatusFilter?: Maybe<Scalars['String']>;
  salesPersonFilter?: Maybe<Scalars['String']>;
  limitFilter?: Maybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetExistingLeadsQuery = (
  { __typename?: 'Query' }
  & { getExistingLeads?: Maybe<(
    { __typename?: 'SalesLeadOutput' }
    & Pick<SalesLeadOutput, 'total' | 'openTotal' | 'hotTotal' | 'coldTotal' | 'dropTotal' | 'waitingListTotal' | 'soldTotal' | 'signTotal' | 'reservedTotal'>
    & { data?: Maybe<Array<(
      { __typename?: 'LeadDataOutput' }
      & Pick<LeadDataOutput, 'id' | 'sales_person_id' | 'sales_person_name' | 'contact_id' | 'full_name' | 'lead_status' | 'lead_source' | 'event_name' | 'activity_date' | 'activity_desc' | 'follow_up_remark' | 'follow_up_date' | 'email' | 'phone_no'>
    )>> }
  )> }
);

export type ImportExistingLeadsMutationVariables = Exact<{
  contactIds: Array<Scalars['String']> | Scalars['String'];
  eLaunchId: Scalars['String'];
  batchTitle: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type ImportExistingLeadsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'importExistingLeads'>
);

export type OpenLeadImportLeadsMutationVariables = Exact<{
  batchTitle: Scalars['String'];
  projectId: Scalars['String'];
  eLaunchId: Scalars['String'];
  file: Scalars['Upload'];
}>;


export type OpenLeadImportLeadsMutation = (
  { __typename?: 'Mutation' }
  & { ImportLeads: (
    { __typename?: 'LeadTemplateReturnOutput' }
    & Pick<LeadTemplateReturnOutput, 'file' | 'file_name' | 'message'>
  ) }
);

export type GetLeadByContactIdQueryVariables = Exact<{
  contactId: Scalars['String'];
}>;


export type GetLeadByContactIdQuery = (
  { __typename?: 'Query' }
  & { getLeadByContactId: (
    { __typename?: 'leadContactEntity' }
    & Pick<LeadContactEntity, 'fullName' | 'email' | 'gender' | 'phoneNo' | 'icNo'>
    & { salutation?: Maybe<(
      { __typename?: 'salutationEntity' }
      & Pick<SalutationEntity, 'name'>
    )>, nationality?: Maybe<(
      { __typename?: 'sNationalityEntity' }
      & Pick<SNationalityEntity, 'name'>
    )>, race?: Maybe<(
      { __typename?: 'raceEntity' }
      & Pick<RaceEntity, 'name'>
    )>, incomeRange?: Maybe<(
      { __typename?: 'incomeRangeEntity' }
      & Pick<IncomeRangeEntity, 'range'>
    )>, maritalStatus?: Maybe<(
      { __typename?: 'maritalStatusEntity' }
      & Pick<MaritalStatusEntity, 'name'>
    )> }
  ) }
);

export type GetInvitationTemplateQueryVariables = Exact<{
  invitationTemplateId: Scalars['String'];
}>;


export type GetInvitationTemplateQuery = (
  { __typename?: 'Query' }
  & { getInvitationTemplateById: (
    { __typename?: 'eLaunchInvitationTemplateEntity' }
    & Pick<ELaunchInvitationTemplateEntity, 'subject' | 'salesDocId' | 'content'>
  ) }
);

export type AlterInvitationTemplateMutationVariables = Exact<{
  salesDocIds: Array<Scalars['String']> | Scalars['String'];
  invitationTemplateId?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  bodyContent?: Maybe<Scalars['String']>;
  eLaunchId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type AlterInvitationTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'alterInvitationTemplate'>
);

export type GetWhatsAppContentQueryVariables = Exact<{
  projectId: Scalars['String'];
  eLaunchId: Scalars['String'];
}>;


export type GetWhatsAppContentQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getWhatsAppContent'>
);

export type SendEmailInvitationTemplateMutationVariables = Exact<{
  projectId: Scalars['String'];
  eLaunchId: Scalars['String'];
  eLaunchLeadBatchId: Scalars['String'];
}>;


export type SendEmailInvitationTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendEmailInvitation'>
);

export type FinancierListQueryVariables = Exact<{ [key: string]: never; }>;


export type FinancierListQuery = (
  { __typename?: 'Query' }
  & { getFinancierList: Array<(
    { __typename?: 'financierEntity' }
    & Pick<FinancierEntity, 'id' | 'name' | 'assignedProjectCount' | 'loanCount' | 'commonStatus'>
  )> }
);

export type FinancierDetailQueryVariables = Exact<{
  financierId: Scalars['String'];
}>;


export type FinancierDetailQuery = (
  { __typename?: 'Query' }
  & { getFinancierDetail: (
    { __typename?: 'financierEntity' }
    & Pick<FinancierEntity, 'id' | 'name' | 'officeTel'>
    & { address?: Maybe<(
      { __typename?: 'AddressJson' }
      & Pick<AddressJson, 'address' | 'city' | 'state' | 'country' | 'postCode'>
    )>, financierContact: Array<(
      { __typename?: 'financierContactEntity' }
      & Pick<FinancierContactEntity, 'id' | 'name' | 'phoneNo' | 'email'>
    )> }
  ) }
);

export type FinancierAddMutationVariables = Exact<{
  input: FinancierInput;
}>;


export type FinancierAddMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'createFinancier'>
);

export type FinancierAddContactMutationVariables = Exact<{
  financierId: Scalars['String'];
  input: FinancierContact;
}>;


export type FinancierAddContactMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addFinancierContact'>
);

export type FinancierEditMutationVariables = Exact<{
  input: FinancierInput;
}>;


export type FinancierEditMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editFinancier'>
);

export type FinancierDeleteMutationVariables = Exact<{
  financierId: Scalars['String'];
}>;


export type FinancierDeleteMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteFinancier'>
);

export type FinancierPanelListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type FinancierPanelListQuery = (
  { __typename?: 'Query' }
  & { panelByProject: Array<(
    { __typename?: 'endfinProjectFinancierEntity' }
    & Pick<EndfinProjectFinancierEntity, 'financierStatus' | 'id' | 'assignedDate' | 'financialLimit' | 'interestRate' | 'financierCommonStatus'>
    & { financierInfo: (
      { __typename?: 'financierEntity' }
      & Pick<FinancierEntity, 'id' | 'name' | 'financierId'>
    ) }
  )> }
);

export type FinancierAssignListQueryVariables = Exact<{
  projectId: Scalars['String'];
  financierId?: Maybe<Scalars['String']>;
}>;


export type FinancierAssignListQuery = (
  { __typename?: 'Query' }
  & { panelFinancierList: Array<(
    { __typename?: 'financierEntity' }
    & Pick<FinancierEntity, 'id' | 'name' | 'financialLimit'>
    & { financierContact: Array<(
      { __typename?: 'financierContactEntity' }
      & Pick<FinancierContactEntity, 'id' | 'name'>
    )>, projectInvitation?: Maybe<Array<(
      { __typename?: 'FinancierProject' }
      & Pick<FinancierProject, 'projectId'>
      & { invitation: Array<(
        { __typename?: 'Contact' }
        & { contactInfo?: Maybe<(
          { __typename?: 'financierContactEntity' }
          & Pick<FinancierContactEntity, 'id' | 'name'>
        )> }
      )> }
    )>> }
  )> }
);

export type FinancierPanelDetailQueryVariables = Exact<{
  financierId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type FinancierPanelDetailQuery = (
  { __typename?: 'Query' }
  & { panelDetails: (
    { __typename?: 'financierPanelDetails' }
    & Pick<FinancierPanelDetails, 'id' | 'name' | 'endfinFinancierId' | 'officeTel'>
    & { address?: Maybe<(
      { __typename?: 'AddressJson' }
      & Pick<AddressJson, 'address' | 'city' | 'state' | 'country' | 'postCode'>
    )>, financierContact: Array<(
      { __typename?: 'financierContacts' }
      & Pick<FinancierContacts, 'id' | 'name' | 'phoneNo' | 'email' | 'invitationDate' | 'default'>
    )> }
  ) }
);

export type SetDefaultFinancierContactMutationVariables = Exact<{
  contactId: Scalars['String'];
  project_id: Scalars['String'];
  financier_id: Scalars['String'];
}>;


export type SetDefaultFinancierContactMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultFinancierContact'>
);

export type FinancierAssignPanelMutationVariables = Exact<{
  input: AdminFinancierPanelInput;
}>;


export type FinancierAssignPanelMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'assignPanel'>
);

export type FinancierUnassignPanelMutationVariables = Exact<{
  financierId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type FinancierUnassignPanelMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unassignPanel'>
);

export type FinancierResendInvitationMutationVariables = Exact<{
  input: AdminFinancierPanelInput;
}>;


export type FinancierResendInvitationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'sendProjectInvitation'>
);

export type FinancierRemoveContactMutationVariables = Exact<{
  input: AdminFinancierPanelInput;
}>;


export type FinancierRemoveContactMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeInvitationContact'>
);

export type EditFinancierLimitMutationVariables = Exact<{
  id: Scalars['String'];
  financialLimit: Scalars['Float'];
  interestRate?: Maybe<Scalars['Float']>;
}>;


export type EditFinancierLimitMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editFinancialLimit'>
);

export type SuspendFinancierMutationVariables = Exact<{
  financierId: Scalars['String'];
}>;


export type SuspendFinancierMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'suspendEndFinancier'>
);

export type IsEndFinEmailExistQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type IsEndFinEmailExistQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isEndFinEmailExist'>
);

export type GetGalleryByProjectQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetGalleryByProjectQuery = (
  { __typename?: 'Query' }
  & { GetGalleryByProject: Array<(
    { __typename?: 'projectEntity' }
    & Pick<ProjectEntity, 'distinctBlock'>
    & { galleryImage?: Maybe<Array<(
      { __typename?: 'ProjectGalleryMediaOuput' }
      & Pick<ProjectGalleryMediaOuput, 'resourceid' | 'url' | 'pictureid' | 'seqno' | 'caption'>
    )>>, blockGalleryImage?: Maybe<Array<(
      { __typename?: 'ProjectBlockMediaOuput' }
      & Pick<ProjectBlockMediaOuput, 'resourceid' | 'url' | 'caption' | 'pictureid' | 'block'>
    )>>, floorGalleryImage?: Maybe<Array<(
      { __typename?: 'ProjectFloorMediaOuput' }
      & Pick<ProjectFloorMediaOuput, 'resourceid' | 'url' | 'caption' | 'block' | 'floor' | 'pictureid' | 'floorlabel'>
    )>>, unitLayoutGalleryImage?: Maybe<Array<(
      { __typename?: 'ProjectUnitLayoutMediaOuput' }
      & Pick<ProjectUnitLayoutMediaOuput, 'resourceid' | 'url' | 'pictureid' | 'seqno' | 'caption' | 'unitlayoutid' | 'desc'>
    )>>, videoLink?: Maybe<Array<(
      { __typename?: 'MediaSource' }
      & Pick<MediaSource, 'videoType' | 'url' | 'caption'>
    )>>, virtualModel?: Maybe<Array<(
      { __typename?: 'ProjectResourceOuput' }
      & Pick<ProjectResourceOuput, 'url' | 'caption'>
    )>>, distinctBlockFloor?: Maybe<Array<(
      { __typename?: 'ProjectUnitBlockFloorOuput' }
      & Pick<ProjectUnitBlockFloorOuput, 'block' | 'floor' | 'floorlabel'>
    )>>, unitLayouts: Array<(
      { __typename?: 'unitLayoutEntity' }
      & Pick<UnitLayoutEntity, 'id' | 'desc'>
    )> }
  )> }
);

export type EditGalleryMutationVariables = Exact<{
  input: Array<AdminEditGalleryInput> | AdminEditGalleryInput;
}>;


export type EditGalleryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'EditGallery'>
);

export type CompanyListingQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyListingQuery = (
  { __typename?: 'Query' }
  & { CompanyListing: Array<(
    { __typename?: 'companyEntity' }
    & Pick<CompanyEntity, 'id' | 'name' | 'description' | 'companyRegNo' | 'officeTel' | 'websiteUrl' | 'imageUrl' | 'email' | 'isDeletable'>
  )> }
);

export type CompanyDetailQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type CompanyDetailQuery = (
  { __typename?: 'Query' }
  & { CompanyDetail: (
    { __typename?: 'companyEntity' }
    & Pick<CompanyEntity, 'id' | 'name' | 'imageUrl' | 'companyRegNo' | 'description' | 'email' | 'websiteUrl' | 'officeTel' | 'code' | 'regionId'>
    & { region?: Maybe<(
      { __typename?: 'regionEntity' }
      & Pick<RegionEntity, 'name'>
    )>, address?: Maybe<(
      { __typename?: 'AddressJson' }
      & Pick<AddressJson, 'address' | 'city' | 'state' | 'country' | 'postCode'>
    )> }
  ) }
);

export type RegionMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type RegionMasterDataQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & { Region: Array<(
      { __typename?: 'regionEntity' }
      & Pick<RegionEntity, 'id' | 'name'>
    )> }
  ) }
);

export type AddCompanyMutationVariables = Exact<{
  input: AdminCompanyInput;
}>;


export type AddCompanyMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'AddCompany'>
);

export type EditCompanyMutationVariables = Exact<{
  input: AdminCompanyInput;
}>;


export type EditCompanyMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'EditCompany'>
);

export type DeleteCompanyMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteCompanyMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'DeleteCompany'>
);

export type GetCountryStateCityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountryStateCityQuery = (
  { __typename?: 'Query' }
  & { getCountryStateCity: Array<(
    { __typename?: 'sCountryEntity' }
    & Pick<SCountryEntity, 'id' | 'name'>
    & { sStates: Array<(
      { __typename?: 'sStateEntity' }
      & Pick<SStateEntity, 'id' | 'name'>
      & { sCities?: Maybe<Array<(
        { __typename?: 'sCityEntity' }
        & Pick<SCityEntity, 'id' | 'name'>
      )>> }
    )> }
  )> }
);

export type GetSalesChartBlockQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesChartBlockQuery = (
  { __typename?: 'Query' }
  & { getProjectById: (
    { __typename?: 'projectEntity' }
    & { blockGalleryImage?: Maybe<Array<(
      { __typename?: 'ProjectBlockMediaOuput' }
      & Pick<ProjectBlockMediaOuput, 'block' | 'resourceid' | 'url'>
    )>> }
  ) }
);

export type GetSalesChartQueryVariables = Exact<{
  projectId: Scalars['String'];
  block: Scalars['String'];
}>;


export type GetSalesChartQuery = (
  { __typename?: 'Query' }
  & { GetActiveFloorAndUnitByProjectBlock: Array<(
    { __typename?: 'FloorOutput' }
    & Pick<FloorOutput, 'floor' | 'floorlabel'>
    & { ActiveUnit?: Maybe<Array<(
      { __typename?: 'unitEntity' }
      & Pick<UnitEntity, 'id' | 'unitNo' | 'unitStatus'>
      & { salesCharts?: Maybe<(
        { __typename?: 'salesChartEntity' }
        & Pick<SalesChartEntity, 'coordinates'>
      )> }
    )>> }
  )> }
);

export type UpdateSalesChartQueryVariables = Exact<{
  models: Array<AdminUnitSalesChartInput> | AdminUnitSalesChartInput;
}>;


export type UpdateSalesChartQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'UpdateSalesChart'>
);

export type UploadResourceProductMutationVariables = Exact<{
  file: Scalars['Upload'];
  isPrivate: Scalars['Boolean'];
}>;


export type UploadResourceProductMutation = (
  { __typename?: 'Mutation' }
  & { UploadResourceProduct: (
    { __typename?: 'CloudStorageOutput' }
    & Pick<CloudStorageOutput, 'BucketFileName' | 'FileName' | 'Url' | 'MediaType' | 'IsPrivate' | 'PrivateUrl'>
  ) }
);

export type DeleteResourceProductQueryVariables = Exact<{
  fileUrl: Scalars['String'];
  isPrivate: Scalars['Boolean'];
}>;


export type DeleteResourceProductQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'DeleteResourceProduct'>
);

export type DeleteResourceProductsQueryVariables = Exact<{
  fileUrls: Array<Scalars['String']> | Scalars['String'];
  isPrivate: Scalars['Boolean'];
}>;


export type DeleteResourceProductsQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'DeleteResourceProducts'>
);

export type GetAllIncomeRangeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllIncomeRangeQuery = (
  { __typename?: 'Query' }
  & { getAllIncomeRange?: Maybe<Array<(
    { __typename?: 'incomeRangeEntity' }
    & Pick<IncomeRangeEntity, 'id' | 'range' | 'commonStatus' | 'seqNo' | 'defaulted' | 'isDeletable'>
  )>> }
);

export type EditIncomeRangeMutationVariables = Exact<{
  input: EditIncomeRangeInput;
}>;


export type EditIncomeRangeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editIncomeRange'>
);

export type AddIncomeRangeMutationVariables = Exact<{
  input: IncomeRangeInput;
}>;


export type AddIncomeRangeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addIncomeRange'>
);

export type DeleteIncomeRangeByIdMutationVariables = Exact<{
  incomeRangeId: Scalars['String'];
}>;


export type DeleteIncomeRangeByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteIncomeRangeById'>
);

export type SetDefaultIncomeRangeMutationVariables = Exact<{
  incomeRangeId: Scalars['String'];
}>;


export type SetDefaultIncomeRangeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultIncomeRange'>
);

export type RemoveDefaultIncomeRangeMutationVariables = Exact<{
  incomeRangeId: Scalars['String'];
}>;


export type RemoveDefaultIncomeRangeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultIncomeRange'>
);

export type OrganizeIncomeRangeMutationVariables = Exact<{
  incomeRangeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeIncomeRangeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeIncomeRange'>
);

export type GetIntegrationAccountSpecQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationAccountSpecQuery = (
  { __typename?: 'Query' }
  & { getIntegrationAccountSpec: (
    { __typename?: 'accountSpecEntity' }
    & Pick<AccountSpecEntity, 'integrationAutoCapitalize'>
  ) }
);

export type AutoCapitalizationMutationVariables = Exact<{ [key: string]: never; }>;


export type AutoCapitalizationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'autoCapitalization'>
);

export type GetLeadIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadIntegrationQuery = (
  { __typename?: 'Query' }
  & { getLeadIntegration: Array<(
    { __typename?: 'lead3rdpartyIntegrationEntity' }
    & Pick<Lead3rdpartyIntegrationEntity, 'id' | 'integrationType' | 'title' | 'key' | 'token' | 'projectId' | 'accountId' | 'commonStatus'>
  )> }
);

export type GetLeadIntegrationByIdQueryVariables = Exact<{
  leadIntegrationId: Scalars['String'];
}>;


export type GetLeadIntegrationByIdQuery = (
  { __typename?: 'Query' }
  & { getLeadIntegrationById: (
    { __typename?: 'lead3rdpartyIntegrationEntity' }
    & Pick<Lead3rdpartyIntegrationEntity, 'id' | 'integrationType' | 'title' | 'key' | 'token' | 'integrationUrl' | 'accountId'>
    & { project?: Maybe<(
      { __typename?: 'projectEntity' }
      & Pick<ProjectEntity, 'id' | 'name'>
    )> }
  ) }
);

export type GetIntegrationSettingFormDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationSettingFormDataQuery = (
  { __typename?: 'Query' }
  & { getIntegrationSettingFormData: (
    { __typename?: 'IntegrationTypeGetFormOutput' }
    & Pick<IntegrationTypeGetFormOutput, 'integrationType'>
    & { projectDetails: Array<(
      { __typename?: 'ProjectDetailsOutput' }
      & Pick<ProjectDetailsOutput, 'projectId' | 'projectName'>
    )> }
  ) }
);

export type NewLeadIntegrationMutationVariables = Exact<{
  input: LeadIntegrationInput;
}>;


export type NewLeadIntegrationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'newLeadIntegration'>
);

export type EditLeadIntegrationMutationVariables = Exact<{
  input: LeadIntegrationInput;
}>;


export type EditLeadIntegrationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editLeadIntegration'>
);

export type AlterLeadIntegrationCommonStatusMutationVariables = Exact<{
  leadIntegrationId: Scalars['String'];
}>;


export type AlterLeadIntegrationCommonStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'alterLeadIntegrationCommonStatus'>
);

export type MissMatchSaleProjectListingQueryVariables = Exact<{ [key: string]: never; }>;


export type MissMatchSaleProjectListingQuery = (
  { __typename?: 'Query' }
  & { missMatchSaleProjectListing: Array<(
    { __typename?: 'getMissMatchSaleProjectListing' }
    & Pick<GetMissMatchSaleProjectListing, 'projectId' | 'projectName' | 'projectImageUrl' | 'missMatchSalesCount'>
  )> }
);

export type NotMatchSaleQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type NotMatchSaleQuery = (
  { __typename?: 'Query' }
  & { notMatchSale: Array<(
    { __typename?: 'NotMatchSaleOutput' }
    & Pick<NotMatchSaleOutput, 'UnitNo' | 'PurchaserName' | 'SaleDate' | 'SNPDate' | 'SellingPrice' | 'MissMatchType'>
  )> }
);

export type SyncMissMatchSalesMutationVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type SyncMissMatchSalesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'syncMissMatchSales'>
);

export type GetLayoutImagesByProjectQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetLayoutImagesByProjectQuery = (
  { __typename?: 'Query' }
  & { GetGalleryByProject: Array<(
    { __typename?: 'projectEntity' }
    & Pick<ProjectEntity, 'distinctBlock'>
    & { blockGalleryImage?: Maybe<Array<(
      { __typename?: 'ProjectBlockMediaOuput' }
      & Pick<ProjectBlockMediaOuput, 'resourceid' | 'url' | 'caption' | 'pictureid' | 'block'>
    )>>, floorGalleryImage?: Maybe<Array<(
      { __typename?: 'ProjectFloorMediaOuput' }
      & Pick<ProjectFloorMediaOuput, 'resourceid' | 'url' | 'caption' | 'block' | 'floor' | 'pictureid' | 'floorlabel'>
    )>>, unitLayoutGalleryImage?: Maybe<Array<(
      { __typename?: 'ProjectUnitLayoutMediaOuput' }
      & Pick<ProjectUnitLayoutMediaOuput, 'block' | 'resourceid' | 'url' | 'pictureid' | 'seqno' | 'caption' | 'unitlayoutid' | 'desc' | 'virtualModelLink' | 'unit_type_id' | 'unitLayout' | 'unit_type_desc'>
    )>>, videoLink?: Maybe<Array<(
      { __typename?: 'MediaSource' }
      & Pick<MediaSource, 'videoType' | 'url' | 'caption'>
    )>>, virtualModel?: Maybe<Array<(
      { __typename?: 'ProjectResourceOuput' }
      & Pick<ProjectResourceOuput, 'url' | 'caption'>
    )>>, distinctBlockFloor?: Maybe<Array<(
      { __typename?: 'ProjectUnitBlockFloorOuput' }
      & Pick<ProjectUnitBlockFloorOuput, 'block' | 'floor' | 'floorlabel'>
    )>>, unitLayouts: Array<(
      { __typename?: 'unitLayoutEntity' }
      & Pick<UnitLayoutEntity, 'id' | 'desc'>
    )>, unitTourVirtual?: Maybe<Array<(
      { __typename?: 'unitTourVirtualOutput' }
      & Pick<UnitTourVirtualOutput, 'tourId' | 'block' | 'unitLayoutId' | 'unitTypeId' | 'virtualModelLink' | 'unitLayoutName' | 'unitTypeName'>
    )>> }
  )> }
);

export type GetAllLeadSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllLeadSourceQuery = (
  { __typename?: 'Query' }
  & { getAllLeadSource?: Maybe<Array<(
    { __typename?: 'leadSourceEntity' }
    & Pick<LeadSourceEntity, 'id' | 'name' | 'commonStatus' | 'systemUse' | 'defaulted' | 'isDeletable'>
  )>> }
);

export type EditLeadSourceMutationVariables = Exact<{
  input: EditLeadSourceInput;
}>;


export type EditLeadSourceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editLeadSource'>
);

export type AddLeadSourceMutationVariables = Exact<{
  input: LeadSourceInput;
}>;


export type AddLeadSourceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addLeadSource'>
);

export type DeleteLeadSourceByIdMutationVariables = Exact<{
  sourceId: Scalars['String'];
}>;


export type DeleteLeadSourceByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteLeadSourceById'>
);

export type ChangeLeadStatusMutationVariables = Exact<{
  sourceId: Scalars['String'];
  status: Scalars['Boolean'];
}>;


export type ChangeLeadStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'changeLeadStatus'>
);

export type SetDefaultLeadSourceMutationVariables = Exact<{
  sourceId: Scalars['String'];
}>;


export type SetDefaultLeadSourceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultLeadSource'>
);

export type RemoveDefaultLeadSourceMutationVariables = Exact<{
  sourceId: Scalars['String'];
}>;


export type RemoveDefaultLeadSourceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultLeadSource'>
);

export type OrganizeLeadSourceMutationVariables = Exact<{
  sourceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeLeadSourceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeLeadSource'>
);

export type GetMasterELetteringQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterELetteringQuery = (
  { __typename?: 'Query' }
  & { getLetterTypeListing: Array<(
    { __typename?: 'standardLetterEntity' }
    & Pick<StandardLetterEntity, 'id' | 'name' | 'letterType' | 'count'>
  )> }
);

export type GetLetterTemplateListingQueryVariables = Exact<{
  standardLetterId: Scalars['String'];
}>;


export type GetLetterTemplateListingQuery = (
  { __typename?: 'Query' }
  & { getStandardLetter: (
    { __typename?: 'standardLetterEntity' }
    & Pick<StandardLetterEntity, 'name'>
  ), getLetterTemplateListing: Array<(
    { __typename?: 'letterTemplateEntity' }
    & Pick<LetterTemplateEntity, 'id' | 'name' | 'commonStatus' | 'allowToDelete' | 'modTs'>
  )> }
);

export type GetLetterTemplateDetailsQueryVariables = Exact<{
  letterTemplateId: Scalars['String'];
  standardLetterId: Scalars['String'];
}>;


export type GetLetterTemplateDetailsQuery = (
  { __typename?: 'Query' }
  & { getStandardLetter: (
    { __typename?: 'standardLetterEntity' }
    & Pick<StandardLetterEntity, 'name'>
  ), getLetterTemplateDetails: (
    { __typename?: 'EditLetterTemplate' }
    & Pick<EditLetterTemplate, 'id' | 'name' | 'templateBody' | 'jointBuyerSignRequired'>
    & { letterParameter: Array<(
      { __typename?: 'LetterParameter' }
      & Pick<LetterParameter, 'displayName' | 'columnName'>
    )> }
  ) }
);

export type GetStandardLetterParametersQueryVariables = Exact<{
  standardLetterId: Scalars['String'];
}>;


export type GetStandardLetterParametersQuery = (
  { __typename?: 'Query' }
  & { getStandardLetter: (
    { __typename?: 'standardLetterEntity' }
    & Pick<StandardLetterEntity, 'name'>
  ), getStandardLetterParameters: Array<(
    { __typename?: 'LetterParameter' }
    & Pick<LetterParameter, 'displayName' | 'columnName'>
  )> }
);

export type GetLetterPreviewQueryVariables = Exact<{
  letterTemplateId: Scalars['String'];
}>;


export type GetLetterPreviewQuery = (
  { __typename?: 'Query' }
  & { getLetterPreview: (
    { __typename?: 'letterTemplateEntity' }
    & Pick<LetterTemplateEntity, 'templateBody'>
  ) }
);

export type AddLetterTemplateMutationVariables = Exact<{
  input: LetterTemplateInput;
}>;


export type AddLetterTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addLetterTemplate'>
);

export type EditLetterTemplateMutationVariables = Exact<{
  input: EditLetterTemplateInput;
}>;


export type EditLetterTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editLetterTemplate'>
);

export type DeleteLetterTemplateMutationVariables = Exact<{
  letterTemplateId: Scalars['String'];
}>;


export type DeleteLetterTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteLetterTemplate'>
);

export type GetLetterTemplateListingByProjectQueryVariables = Exact<{
  standardLetterId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetLetterTemplateListingByProjectQuery = (
  { __typename?: 'Query' }
  & { getStandardLetter: (
    { __typename?: 'standardLetterEntity' }
    & Pick<StandardLetterEntity, 'name'>
  ), getLetterTemplateListingByProject: Array<(
    { __typename?: 'LetterTemplateByProject' }
    & Pick<LetterTemplateByProject, 'id' | 'letterTemplateId' | 'name' | 'commonStatus' | 'lastUpdated' | 'defaulted'>
  )> }
);

export type GetESignLetterTemplateToAssignQueryVariables = Exact<{
  standardLetterId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type GetESignLetterTemplateToAssignQuery = (
  { __typename?: 'Query' }
  & { getESignLetterTemplateToAssign: Array<(
    { __typename?: 'ESignLetterTemplateAssignmenttOutput' }
    & Pick<ESignLetterTemplateAssignmenttOutput, 'id' | 'name'>
  )> }
);

export type AssignProjectLetterTemplateMutationVariables = Exact<{
  letterTemplateIds: Array<Scalars['String']> | Scalars['String'];
  projectId: Scalars['String'];
  standardLetterId: Scalars['String'];
}>;


export type AssignProjectLetterTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'assignProjectLetterTemplate'>
);

export type SetDefaultProjectLetterTemplateMutationVariables = Exact<{
  standardLetterId: Scalars['String'];
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type SetDefaultProjectLetterTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultProjectLetterTemplate'>
);

export type RemoveDefaultProjectLetterTemplateMutationVariables = Exact<{
  standardLetterId: Scalars['String'];
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type RemoveDefaultProjectLetterTemplateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultProjectLetterTemplate'>
);

export type UnassignProjectLetterMutationVariables = Exact<{
  standardLetterId: Scalars['String'];
  projectId: Scalars['String'];
  id: Scalars['String'];
}>;


export type UnassignProjectLetterMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unassignProjectLetter'>
);

export type GetELetteringByProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetELetteringByProjectQuery = (
  { __typename?: 'Query' }
  & { getLetterTypeListing: Array<(
    { __typename?: 'standardLetterEntity' }
    & Pick<StandardLetterEntity, 'id' | 'name' | 'letterType' | 'countByProject'>
  )> }
);

export type GetAccountSpecQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountSpecQuery = (
  { __typename?: 'Query' }
  & { getAccountSpec?: Maybe<(
    { __typename?: 'LoanScreenAccountSpecOutput' }
    & Pick<LoanScreenAccountSpecOutput, 'loanPlusProjectId' | 'modifiedDate'>
  )> }
);

export type UpdateAccountSpecMutationVariables = Exact<{
  loanPlusProjectId: Scalars['Float'];
}>;


export type UpdateAccountSpecMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateAccountSpec'>
);

export type GetAllMaritalStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllMaritalStatusQuery = (
  { __typename?: 'Query' }
  & { getAllMaritalStatus?: Maybe<Array<(
    { __typename?: 'maritalStatusEntity' }
    & Pick<MaritalStatusEntity, 'id' | 'name' | 'commonStatus' | 'defaulted' | 'isDeletable' | 'systemUse'>
  )>> }
);

export type EditMaritalStatusMutationVariables = Exact<{
  input: EditMaritalStatusInput;
}>;


export type EditMaritalStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editMaritalStatus'>
);

export type AddMaritalStatusMutationVariables = Exact<{
  input: MaritalStatusInput;
}>;


export type AddMaritalStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addMaritalStatus'>
);

export type DeleteMaritalStatusByIdMutationVariables = Exact<{
  maritalStatusId: Scalars['String'];
}>;


export type DeleteMaritalStatusByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteMaritalStatusById'>
);

export type SetDefaultMaritalStatusMutationVariables = Exact<{
  maritalStatusId: Scalars['String'];
}>;


export type SetDefaultMaritalStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultMaritalStatus'>
);

export type RemoveDefaultMaritalStatusMutationVariables = Exact<{
  maritalStatusId: Scalars['String'];
}>;


export type RemoveDefaultMaritalStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultMaritalStatus'>
);

export type OrganizeMaritalStatusMutationVariables = Exact<{
  maritalStatusIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeMaritalStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeMaritalStatus'>
);

export type LeadInfoSetupCountQueryVariables = Exact<{ [key: string]: never; }>;


export type LeadInfoSetupCountQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'getLeadSourceCount'>
  ) }
);

export type ReasonCategorySetupCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ReasonCategorySetupCountQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'bookingCancellationCount'>
  ) }
);

export type PurchaserProfileSetupCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PurchaserProfileSetupCountQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'getRaceCount' | 'getMaritalCount' | 'getSalutationCount' | 'getIncomeRangeCount'>
  ) }
);

export type PropertyInfoSetupCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertyInfoSetupCountQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'getProjectTypeCount' | 'getPropertyTypeCount'>
  ) }
);

export type UnitInfoSetupCountQueryVariables = Exact<{ [key: string]: never; }>;


export type UnitInfoSetupCountQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'getUnitCount' | 'getDirectionCount'>
  ) }
);

export type GetLatestUpdateForSetupQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLatestUpdateForSetupQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'getLatestUpdateLeadInfo' | 'getLatestUpdateUnitInfo' | 'getLatestUpdatePropertyInfo' | 'getLatestUpdatePurchaserProfile' | 'getLatestUpdateELetter' | 'getLatestUpdateRoundRobin' | 'getLatestUpdateRegion' | 'getLatestUpdateReason'>
  ) }
);

export type GetAllNewsAnnouncementQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['Boolean']>;
}>;


export type GetAllNewsAnnouncementQuery = (
  { __typename?: 'Query' }
  & { getAllNewsAnnouncement: (
    { __typename?: 'NewsAnnouncementListOutput' }
    & Pick<NewsAnnouncementListOutput, 'total'>
    & { data: Array<(
      { __typename?: 'newsAnnouncementEntity' }
      & Pick<NewsAnnouncementEntity, 'id' | 'title' | 'description' | 'startDate' | 'endDate' | 'isPublish' | 'isExpired'>
      & { attachment?: Maybe<Array<(
        { __typename?: 'attachmentEntity' }
        & Pick<AttachmentEntity, 'id' | 'seqNo' | 'resourceUrl'>
      )>> }
    )> }
  ) }
);

export type GetNewsAnnouncementDetailsQueryVariables = Exact<{
  newsId: Scalars['String'];
}>;


export type GetNewsAnnouncementDetailsQuery = (
  { __typename?: 'Query' }
  & { getNewsAnnouncementDetails: (
    { __typename?: 'newsAnnouncementEntity' }
    & Pick<NewsAnnouncementEntity, 'id' | 'title' | 'startDate' | 'endDate' | 'description' | 'isPublish'>
    & { newsProjects: Array<(
      { __typename?: 'newsProjectEntity' }
      & Pick<NewsProjectEntity, 'projectId'>
    )>, attachment?: Maybe<Array<(
      { __typename?: 'attachmentEntity' }
      & Pick<AttachmentEntity, 'id' | 'fileName' | 'resourceUrl' | 'mediaType'>
    )>> }
  ), getAllProject: Array<(
    { __typename?: 'projectEntity' }
    & Pick<ProjectEntity, 'id' | 'name'>
  )> }
);

export type AddNewsAnnouncementMutationVariables = Exact<{
  input: NewsAnnouncementInput;
}>;


export type AddNewsAnnouncementMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addNewsAnnouncement'>
);

export type EditNewsAnnouncementMutationVariables = Exact<{
  input: NewsAnnouncementInput;
}>;


export type EditNewsAnnouncementMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editNewsAnnouncement'>
);

export type DeleteNewsAnnouncementMutationVariables = Exact<{
  newsId: Scalars['String'];
}>;


export type DeleteNewsAnnouncementMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteNewsAnnouncement'>
);

export type PublishNewsAnnouncementMutationVariables = Exact<{
  newsId: Scalars['String'];
}>;


export type PublishNewsAnnouncementMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'publishNewsAnnouncement'>
);

export type AddNupTypeMutationVariables = Exact<{
  input: NupTypeInput;
}>;


export type AddNupTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addNupType'>
);

export type GetNupTypeListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNupTypeListingQuery = (
  { __typename?: 'Query' }
  & { getNupTypeListing: Array<(
    { __typename?: 'nupTypeEntity' }
    & Pick<NupTypeEntity, 'id' | 'type' | 'description' | 'amount' | 'prefix' | 'commonStatus' | 'viaMobile' | 'viaAgent'>
  )> }
);

export type GetNupTypeDetailQueryVariables = Exact<{
  nupTypeId: Scalars['String'];
}>;


export type GetNupTypeDetailQuery = (
  { __typename?: 'Query' }
  & { getNupTypeDetail: (
    { __typename?: 'nupTypeEntity' }
    & Pick<NupTypeEntity, 'id' | 'type' | 'description' | 'amount' | 'prefix' | 'commonStatus' | 'viaMobile' | 'viaAgent'>
  ) }
);

export type EditNupTypeMutationVariables = Exact<{
  input: EditNupTypeInput;
}>;


export type EditNupTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editNupType'>
);

export type DeleteNupTypeMutationVariables = Exact<{
  nupTypeId: Scalars['String'];
}>;


export type DeleteNupTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteNupType'>
);

export type AddNupReasonMutationVariables = Exact<{
  input: NupReasonInput;
}>;


export type AddNupReasonMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addNupReason'>
);

export type GetNupReasonListingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNupReasonListingQuery = (
  { __typename?: 'Query' }
  & { getNupReasonListing: Array<(
    { __typename?: 'nupReasonEntity' }
    & Pick<NupReasonEntity, 'id' | 'code' | 'description' | 'commonStatus'>
  )> }
);

export type GetNupReasonDetailQueryVariables = Exact<{
  reasonId: Scalars['String'];
}>;


export type GetNupReasonDetailQuery = (
  { __typename?: 'Query' }
  & { getNupReasonDetail: (
    { __typename?: 'nupReasonEntity' }
    & Pick<NupReasonEntity, 'id' | 'code' | 'description' | 'commonStatus'>
  ) }
);

export type EditNupReasonMutationVariables = Exact<{
  input: EditNupReasonInput;
}>;


export type EditNupReasonMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editNupReason'>
);

export type DeleteNupReasonMutationVariables = Exact<{
  reasonId: Scalars['String'];
}>;


export type DeleteNupReasonMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteNupReason'>
);

export type GetAllOnlineUsersQueryVariables = Exact<{
  limit: Scalars['Float'];
  page: Scalars['Float'];
  accountId: Scalars['String'];
  search?: Maybe<Scalars['String']>;
  online?: Maybe<Scalars['Boolean']>;
}>;


export type GetAllOnlineUsersQuery = (
  { __typename?: 'Query' }
  & { getAllOnlineUsers: (
    { __typename?: 'OnlineUsersOutput' }
    & Pick<OnlineUsersOutput, 'total'>
    & { data: Array<(
      { __typename?: 'OnlineUsersModel' }
      & Pick<OnlineUsersModel, 'softwareCode' | 'accountId' | 'accountName' | 'name' | 'email' | 'ipAddress' | 'commonStatus' | 'lastLogin' | 'lastLogout'>
    )> }
  ) }
);

export type GetLeadAssignmentListByAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadAssignmentListByAccountQuery = (
  { __typename?: 'Query' }
  & { getLeadAssignmentListByAccount?: Maybe<Array<(
    { __typename?: 'openLeadAssignmentSettingOutput' }
    & Pick<OpenLeadAssignmentSettingOutput, 'leadAssignmentId' | 'staffName' | 'seqNo' | 'weightage'>
  )>> }
);

export type GetLeadAssignmentFormSourceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadAssignmentFormSourceQuery = (
  { __typename?: 'Query' }
  & { getLeadAssignmentFormSource: Array<(
    { __typename?: 'openLeadAssignmentSettingEntity' }
    & Pick<OpenLeadAssignmentSettingEntity, 'weight' | 'seq'>
  )> }
);

export type GetLeadAssigmentByIdQueryVariables = Exact<{
  leadAssigmentId: Scalars['String'];
}>;


export type GetLeadAssigmentByIdQuery = (
  { __typename?: 'Query' }
  & { getLeadAssigmentById: (
    { __typename?: 'openLeadAssignmentSettingOutput' }
    & Pick<OpenLeadAssignmentSettingOutput, 'seqNo' | 'leadAssignmentId' | 'weightage' | 'staffName' | 'staffId'>
  ) }
);

export type EditLeadAssignmentMutationVariables = Exact<{
  input: OpenLeadAssignmentSettingInput;
}>;


export type EditLeadAssignmentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editLeadAssignment'>
);

export type NewLeadAssignmentMutationVariables = Exact<{
  input: NewLeadAssignmentInput;
}>;


export type NewLeadAssignmentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'newLeadAssignment'>
);

export type DeleteLeadAssignmentMutationVariables = Exact<{
  leadAssigmentId: Scalars['String'];
}>;


export type DeleteLeadAssignmentMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteLeadAssignment'>
);

export type OrganizeLeadAssignmentSeqMutationVariables = Exact<{
  id: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeLeadAssignmentSeqMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeLeadAssignmentSeq'>
);

export type GetLeadAssignmentSalesStaffQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadAssignmentSalesStaffQuery = (
  { __typename?: 'Query' }
  & { getLeadAssignmentSalesStaff: Array<(
    { __typename?: 'ListOfSalesStaffByUserPermission' }
    & Pick<ListOfSalesStaffByUserPermission, 'staffId' | 'staffName'>
  )> }
);

export type GetLeadAssignmentNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLeadAssignmentNotificationQuery = (
  { __typename?: 'Query' }
  & { getLeadAssignmentNotification: (
    { __typename?: 'accountSpecEntity' }
    & Pick<AccountSpecEntity, 'leadAssignmentActivated'>
  ) }
);

export type UpdateLeadAssignmentNotificationStatusMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateLeadAssignmentNotificationStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateLeadAssignmentNotificationStatus'>
);

export type IsIntegratedProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type IsIntegratedProjectQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'isIntegratedProject'>
);

export type SyncIntegratePackageMutationVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type SyncIntegratePackageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'syncIntegratePackage'>
);

export type EditSalesPackageMutationVariables = Exact<{
  input: EditSalesPackageInput;
}>;


export type EditSalesPackageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editSalesPackage'>
);

export type AddSalesPackageMutationVariables = Exact<{
  input: AddSalesPackageInput;
}>;


export type AddSalesPackageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addSalesPackage'>
);

export type DeleteSalesPackageMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSalesPackageMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteSalesPackage'>
);

export type GetSalesPackagesListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesPackagesListQuery = (
  { __typename?: 'Query' }
  & { getSalesPackagesList: Array<(
    { __typename?: 'packageEntity' }
    & Pick<PackageEntity, 'id' | 'name' | 'desc' | 'projectId' | 'listPrice' | 'marketValue' | 'startDate' | 'endDate' | 'isIntegrated'>
  )> }
);

export type GetSalesPackageByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSalesPackageByIdQuery = (
  { __typename?: 'Query' }
  & { getSalesPackageById: (
    { __typename?: 'packageEntity' }
    & Pick<PackageEntity, 'id' | 'name' | 'desc' | 'projectId' | 'listPrice' | 'marketValue' | 'startDate' | 'endDate'>
  ) }
);

export type PaymentGatewayListQueryVariables = Exact<{ [key: string]: never; }>;


export type PaymentGatewayListQuery = (
  { __typename?: 'Query' }
  & { paymentGatewayListing: Array<(
    { __typename?: 'paymentGatewayEntity' }
    & Pick<PaymentGatewayEntity, 'id' | 'gatewayTypeDesc' | 'title' | 'lastUpdate' | 'assignedProjectCount' | 'isDeletable'>
  )> }
);

export type PaymentGatewayDetailsQueryVariables = Exact<{
  paymentGatewayId: Scalars['String'];
}>;


export type PaymentGatewayDetailsQuery = (
  { __typename?: 'Query' }
  & { paymentGatewayDetails: (
    { __typename?: 'paymentGatewayEntity' }
    & Pick<PaymentGatewayEntity, 'id' | 'gatewayType' | 'gatewayTypeDesc' | 'title' | 'gatewayInfo'>
  ) }
);

export type GetPaymentTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPaymentTypeQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getPaymentgatewayEnum'>
);

export type PaymentGatewayFormDataQueryVariables = Exact<{
  paymentGatewayId: Scalars['String'];
}>;


export type PaymentGatewayFormDataQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getPaymentgatewayEnum'>
  & { paymentGatewayDetails: (
    { __typename?: 'paymentGatewayEntity' }
    & Pick<PaymentGatewayEntity, 'id' | 'gatewayType' | 'gatewayTypeDesc' | 'title' | 'gatewayInfo' | 'assignedProjectCount'>
  ) }
);

export type DeletePaymentGatewayMutationVariables = Exact<{
  paymentGatewayId: Scalars['String'];
}>;


export type DeletePaymentGatewayMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deletePaymentGateway'>
);

export type AddPaymentGatewayMutationVariables = Exact<{
  input: PaymentGatewayInput;
}>;


export type AddPaymentGatewayMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addPaymentGateWay'>
);

export type EditPaymentGatewayMutationVariables = Exact<{
  input: PaymentGatewayInput;
}>;


export type EditPaymentGatewayMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editPaymentGateWay'>
);

export type ProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'allowAddProject'>
  & { getAllProject: Array<(
    { __typename?: 'projectEntity' }
    & Pick<ProjectEntity, 'id' | 'name' | 'currency' | 'unitMinPrice' | 'projectAddress' | 'minPrice' | 'state' | 'city'>
    & { firstGalleryImage?: Maybe<(
      { __typename?: 'ProjectResourceOuput' }
      & Pick<ProjectResourceOuput, 'url' | 'caption'>
    )> }
  )> }
);

export type ProjectDetailQueryVariables = Exact<{
  project_id: Scalars['String'];
}>;


export type ProjectDetailQuery = (
  { __typename?: 'Query' }
  & { projectDetail: (
    { __typename?: 'projectEntity' }
    & Pick<ProjectEntity, 'name' | 'projectCode' | 'desc' | 'isSaleMade' | 'currency' | 'country' | 'state' | 'city' | 'uom' | 'townshipName' | 'completionDate' | 'launchDate' | 'isIntegrated' | 'minPrice' | 'maxPrice' | 'unitMinBuiltUp' | 'unitMaxBuiltUp' | 'projectGps' | 'saleGalleryGps' | 'saleGalleryAddress' | 'projectAddress' | 'tenure' | 'tenureDesc' | 'landType' | 'landTypeDesc'>
    & { attachment?: Maybe<Array<(
      { __typename?: 'attachmentEntity' }
      & Pick<AttachmentEntity, 'fileName'>
    )>>, company?: Maybe<(
      { __typename?: 'companyEntity' }
      & Pick<CompanyEntity, 'id' | 'name' | 'companyRegNo' | 'description' | 'imageUrl'>
    )>, developmentCompany: (
      { __typename?: 'companyEntity' }
      & Pick<CompanyEntity, 'id' | 'name' | 'companyRegNo' | 'description' | 'imageUrl'>
    ), holdingCompany: (
      { __typename?: 'companyEntity' }
      & Pick<CompanyEntity, 'id' | 'name' | 'companyRegNo' | 'description' | 'imageUrl'>
    ), projectType: (
      { __typename?: 'projectTypeEntity' }
      & Pick<ProjectTypeEntity, 'id' | 'name'>
    ), virtualModel?: Maybe<Array<(
      { __typename?: 'ProjectResourceOuput' }
      & Pick<ProjectResourceOuput, 'url' | 'caption'>
    )>>, floorGalleryImage?: Maybe<Array<(
      { __typename?: 'ProjectFloorMediaOuput' }
      & Pick<ProjectFloorMediaOuput, 'block' | 'floor' | 'url' | 'caption' | 'floorlabel'>
    )>>, units: Array<(
      { __typename?: 'unitEntity' }
      & Pick<UnitEntity, 'block' | 'floor' | 'floorLabel' | 'builtUp'>
      & { unitLayout?: Maybe<(
        { __typename?: 'unitLayoutEntity' }
        & Pick<UnitLayoutEntity, 'desc'>
      )> }
    )>, unitLayoutGalleryImage?: Maybe<Array<(
      { __typename?: 'ProjectUnitLayoutMediaOuput' }
      & Pick<ProjectUnitLayoutMediaOuput, 'resourceid' | 'seqno' | 'caption' | 'url' | 'unitlayoutid' | 'unitLayout' | 'pictureid' | 'desc' | 'block' | 'unit_type_id' | 'virtualModelLink'>
    )>>, galleryImage?: Maybe<Array<(
      { __typename?: 'ProjectGalleryMediaOuput' }
      & Pick<ProjectGalleryMediaOuput, 'url' | 'caption'>
    )>>, amenities?: Maybe<Array<(
      { __typename?: 'Amenities' }
      & Pick<Amenities, 'items' | 'category'>
    )>>, embededYoutubeLink?: Maybe<Array<(
      { __typename?: 'ProjectYoutubeLinkOutput' }
      & Pick<ProjectYoutubeLinkOutput, 'videoType' | 'caption' | 'thumbnail' | 'url'>
    )>>, embededVimeoLink?: Maybe<Array<(
      { __typename?: 'ProjectYoutubeLinkOutput' }
      & Pick<ProjectYoutubeLinkOutput, 'videoType' | 'caption' | 'thumbnail' | 'url'>
    )>>, embededGoogleDriveLink?: Maybe<Array<(
      { __typename?: 'ProjectYoutubeLinkOutput' }
      & Pick<ProjectYoutubeLinkOutput, 'videoType' | 'caption' | 'thumbnail' | 'url'>
    )>>, virtualModelLink?: Maybe<Array<(
      { __typename?: 'MediaSource' }
      & Pick<MediaSource, 'url' | 'caption'>
    )>> }
  ) }
);

export type ProjectMasterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectMasterDataQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'LandType' | 'CurrencyCode' | 'Tenures' | 'UOM' | 'IntegrationTypes'>
    & { Nationalities: Array<(
      { __typename?: 'sNationalityEntity' }
      & Pick<SNationalityEntity, 'id' | 'name'>
    )>, Countries: Array<(
      { __typename?: 'CountryMasterDataOutput' }
      & Pick<CountryMasterDataOutput, 'name' | 'ID'>
    )>, ProjectTypes: Array<(
      { __typename?: 'projectTypeEntity' }
      & Pick<ProjectTypeEntity, 'id' | 'name' | 'defaulted'>
    )> }
  ) }
);

export type AllowAddProjectQueryVariables = Exact<{ [key: string]: never; }>;


export type AllowAddProjectQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'allowAddProject'>
);

export type AddProjectMutationVariables = Exact<{
  Input: AdminProjectInput;
}>;


export type AddProjectMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addProject'>
);

export type EditProjectMutationVariables = Exact<{
  Input: AdminProjectInput;
}>;


export type EditProjectMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editProject'>
);

export type GetProjectByIdForProjectSummaryQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetProjectByIdForProjectSummaryQuery = (
  { __typename?: 'Query' }
  & { getProjectById: (
    { __typename?: 'projectEntity' }
    & Pick<ProjectEntity, 'id' | 'projectLastUpdate' | 'galleryLastUpdate' | 'layoutImagesLastUpdate' | 'unitSetupLastUpdate' | 'carParkSetupLastUpdate' | 'unitAllocationLastUpdate' | 'salesChartLastUpdate' | 'salesDocLastUpdate' | 'siteProgressLastUpdate' | 'projectBrochureLastUpdate' | 'salesPackageLastUpdate' | 'discountLastUpdate' | 'efPanelLastUpdate' | 'solicitorLastUpdate' | 'policySettingLastUpdate' | 'roleAuthorizationLastUpdate' | 'teamAssignmentLastUpdate' | 'countUnitTotal' | 'isIntegrated' | 'standardLetterLastUpdate' | 'IsSubscribed' | 'eLaunchLastUpdate' | 'appointmentSchedulingLastUpdate'>
  ) }
);

export type ProjectGetAllQueryVariables = Exact<{ [key: string]: never; }>;


export type ProjectGetAllQuery = (
  { __typename?: 'Query' }
  & { getAllProject: Array<(
    { __typename?: 'projectEntity' }
    & Pick<ProjectEntity, 'id' | 'name' | 'currency' | 'projectAddress' | 'minPrice' | 'unitMinPrice' | 'state' | 'city'>
    & { firstGalleryImage?: Maybe<(
      { __typename?: 'ProjectResourceOuput' }
      & Pick<ProjectResourceOuput, 'url' | 'caption'>
    )>, company?: Maybe<(
      { __typename?: 'companyEntity' }
      & Pick<CompanyEntity, 'name'>
    )> }
  )> }
);

export type GetLangListQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLangListQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'Language' | 'SoftwareCode' | 'PurchaserAppSetting'>
  ) }
);

export type ProjectSpecDetailQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ProjectSpecDetailQuery = (
  { __typename?: 'Query' }
  & { GetProjectSpecByProjectId: (
    { __typename?: 'projectSpecEntity' }
    & Pick<ProjectSpecEntity, 'minBookingfeeAmount' | 'formLang' | 'purchaserAppSettings' | 'bookingFeeMandatory' | 'bookingfeeAmountRequired' | 'bookingSignRequired' | 'minAgeRequired' | 'minAge' | 'nricAttachmentRequired' | 'ccrAttachmentRequired' | 'bookingPDPAconsentRequired' | 'bookingRefundPolicyconsentRequired' | 'statementRefundPolicy' | 'templatePackagesShow' | 'templateDiscountsShow' | 'templateAddressShow' | 'templateRemarksShow' | 'templateMaritalStatusShow' | 'templateCompanyShow' | 'loanconsentRequired' | 'loanScreening' | 'expectedSnpRequired' | 'expectedSnpDuration' | 'getSoftwareCode' | 'trGeneration' | 'ELetteringSMSRequired' | 'paymentGatewayRefundPolicy' | 'autoAssignLeadActivated' | 'assignStartTime' | 'assignEndTime' | 'autoReassignLeadActivated' | 'autoReassignLeadDuration' | 'reassignStartTime' | 'reassignEndTime' | 'notifyUnattendedLeadActivated' | 'notifyUnattendedLeadDuration' | 'unattendedLeadNotificationMethod' | 'unattendedLeadManagerHandled' | 'leadAgingActivated' | 'leadAgingNotificationMethod' | 'leadIdleOne' | 'leadIdleTwo' | 'leadIdleThree' | 'leadAgingManagerHandled' | 'leadAssignNotificationActivated' | 'leadAssignNotificationMethod' | 'reservationSales' | 'reservationAgency' | 'autoReleaseReservationDay' | 'unitSort' | 'alertAgingActivated' | 'display2DChart'>
    & { autoReleaseNotificationReminder?: Maybe<(
      { __typename?: 'autoReleaseNotificationReminderOutput' }
      & Pick<AutoReleaseNotificationReminderOutput, 'reminderDay' | 'salesUserReceive' | 'agencyUserReceive'>
    )>, paymentGateway?: Maybe<(
      { __typename?: 'paymentGatewayEntity' }
      & Pick<PaymentGatewayEntity, 'title'>
    )>, saleLeadNotification?: Maybe<(
      { __typename?: 'SaleLeadNotificationOutput' }
      & Pick<SaleLeadNotificationOutput, 'leadAssignment'>
      & { loanAssignment?: Maybe<(
        { __typename?: 'loanAssignmentOutput' }
        & Pick<LoanAssignmentOutput, 'salesUserReceive' | 'agencyUserReceive' | 'endFinUserReceive'>
      )>, solicitorCaseAssignment?: Maybe<(
        { __typename?: 'solicitorCaseAssignmentOutput' }
        & Pick<SolicitorCaseAssignmentOutput, 'salesUserReceive' | 'agencyUserReceive' | 'solicitorUserReceive'>
      )>, booking?: Maybe<(
        { __typename?: 'BookingNotificationOutput' }
        & Pick<BookingNotificationOutput, 'assignmentSalesUserReceive' | 'assignmentAgencyUserReceive' | 'assignmentPurchaserReceive' | 'attachTr' | 'attachBookingAttachment'>
      )>, bookingCancellation?: Maybe<(
        { __typename?: 'BookingCancellationNotificationOutput' }
        & Pick<BookingCancellationNotificationOutput, 'salesUserReceive' | 'agencyUserReceive' | 'purchaserReceive'>
      )>, snpSigningReminder?: Maybe<(
        { __typename?: 'SNPSigningReminderOutput' }
        & Pick<SnpSigningReminderOutput, 'salesUserReceive' | 'agencyUserReceive' | 'purchaserReceive' | 'beforeDay' | 'afterDay'>
      )> }
    )>, agencyLeadNotification?: Maybe<(
      { __typename?: 'AgencyLeadNotificationOutput' }
      & { loanAssignment?: Maybe<(
        { __typename?: 'loanAssignmentOutput' }
        & Pick<LoanAssignmentOutput, 'salesUserReceive' | 'agencyUserReceive' | 'endFinUserReceive'>
      )> }
    )>, unattendedLeadManagerNames?: Maybe<Array<(
      { __typename?: 'ProjectSpecManagerOutput' }
      & Pick<ProjectSpecManagerOutput, 'name'>
    )>>, leadAgingManagerNames?: Maybe<Array<(
      { __typename?: 'ProjectSpecManagerOutput' }
      & Pick<ProjectSpecManagerOutput, 'name'>
    )>>, getAccountSpec?: Maybe<(
      { __typename?: 'accountSpecEntity' }
      & Pick<AccountSpecEntity, 'loanPlusProjectId'>
    )>, salesAlertAging?: Maybe<(
      { __typename?: 'SalesAlertAgingOutput' }
      & Pick<SalesAlertAgingOutput, 'isActive' | 'maxMinorSalesAlertAging' | 'maxMajorSalesAlertAging'>
    )>, loanAlertAging?: Maybe<(
      { __typename?: 'LoanAlertAgingOutput' }
      & Pick<LoanAlertAgingOutput, 'isActive' | 'maxMinorLoanAlertAging' | 'maxMajorLoanAlertAging'>
    )>, solicitorAlertAging?: Maybe<(
      { __typename?: 'SolicitorAlertAgingOutput' }
      & Pick<SolicitorAlertAgingOutput, 'isActive' | 'maxMinorSolicitorAlertAging' | 'maxMajorSolicitorAlertAging'>
    )> }
  ), getProjectById: (
    { __typename?: 'projectEntity' }
    & { developmentCompany: (
      { __typename?: 'companyEntity' }
      & Pick<CompanyEntity, 'id'>
    ), holdingCompany: (
      { __typename?: 'companyEntity' }
      & Pick<CompanyEntity, 'id'>
    ) }
  ) }
);

export type EditProjectSpecMutationVariables = Exact<{
  input: AdminSaveProjectSpecInput;
}>;


export type EditProjectSpecMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'EditProjectSpec'>
);

export type ProjectSpecDetailForEditFormQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ProjectSpecDetailForEditFormQuery = (
  { __typename?: 'Query' }
  & { GetProjectSpecByProjectId: (
    { __typename?: 'projectSpecEntity' }
    & Pick<ProjectSpecEntity, 'bookingFormLang' | 'purchaserAppSetting' | 'bookingFeeMandatory' | 'minBookingfeeAmount' | 'bookingfeeAmountRequired' | 'bookingSignRequired' | 'minAgeRequired' | 'minAge' | 'nricAttachmentRequired' | 'ccrAttachmentRequired' | 'bookingPDPAconsentRequired' | 'bookingRefundPolicyconsentRequired' | 'statementRefundPolicy' | 'templatePackagesShow' | 'templateDiscountsShow' | 'templateAddressShow' | 'templateRemarksShow' | 'templateMaritalStatusShow' | 'templateCompanyShow' | 'loanconsentRequired' | 'loanScreening' | 'expectedSnpRequired' | 'expectedSnpDuration' | 'paymentGatewayId' | 'paymentGatewayRefundPolicy' | 'autoAssignLeadActivated' | 'assignStartTime' | 'assignEndTime' | 'autoReassignLeadActivated' | 'autoReassignLeadDuration' | 'reassignStartTime' | 'reassignEndTime' | 'notifyUnattendedLeadActivated' | 'notifyUnattendedLeadDuration' | 'unattendedLeadNotificationMethod' | 'unattendedLeadManagerHandled' | 'leadAgingActivated' | 'leadAgingNotificationMethod' | 'leadIdleOne' | 'leadIdleTwo' | 'leadIdleThree' | 'leadAgingManagerHandled' | 'getSoftwareCode' | 'unitSort' | 'trGeneration' | 'ELetteringSMSRequired' | 'leadAssignNotificationActivated' | 'leadAssignNotificationMethod' | 'reservationAgency' | 'reservationSales' | 'autoReleaseReservationDay' | 'alertAgingActivated' | 'display2DChart'>
    & { autoReleaseNotificationReminder?: Maybe<(
      { __typename?: 'autoReleaseNotificationReminderOutput' }
      & Pick<AutoReleaseNotificationReminderOutput, 'reminderDay' | 'salesUserReceive' | 'agencyUserReceive'>
    )>, saleLeadNotification?: Maybe<(
      { __typename?: 'SaleLeadNotificationOutput' }
      & Pick<SaleLeadNotificationOutput, 'leadAssignment'>
      & { loanAssignment?: Maybe<(
        { __typename?: 'loanAssignmentOutput' }
        & Pick<LoanAssignmentOutput, 'salesUserReceive' | 'agencyUserReceive' | 'endFinUserReceive'>
      )>, solicitorCaseAssignment?: Maybe<(
        { __typename?: 'solicitorCaseAssignmentOutput' }
        & Pick<SolicitorCaseAssignmentOutput, 'salesUserReceive' | 'agencyUserReceive' | 'solicitorUserReceive'>
      )>, booking?: Maybe<(
        { __typename?: 'BookingNotificationOutput' }
        & Pick<BookingNotificationOutput, 'assignmentSalesUserReceive' | 'assignmentAgencyUserReceive' | 'assignmentPurchaserReceive' | 'attachTr' | 'attachBookingAttachment'>
      )>, bookingCancellation?: Maybe<(
        { __typename?: 'BookingCancellationNotificationOutput' }
        & Pick<BookingCancellationNotificationOutput, 'salesUserReceive' | 'agencyUserReceive' | 'purchaserReceive'>
      )>, snpSigningReminder?: Maybe<(
        { __typename?: 'SNPSigningReminderOutput' }
        & Pick<SnpSigningReminderOutput, 'salesUserReceive' | 'agencyUserReceive' | 'purchaserReceive' | 'beforeDay' | 'afterDay'>
      )> }
    )>, agencyLeadNotification?: Maybe<(
      { __typename?: 'AgencyLeadNotificationOutput' }
      & { loanAssignment?: Maybe<(
        { __typename?: 'loanAssignmentOutput' }
        & Pick<LoanAssignmentOutput, 'salesUserReceive' | 'agencyUserReceive' | 'endFinUserReceive'>
      )> }
    )>, getAccountSpec?: Maybe<(
      { __typename?: 'accountSpecEntity' }
      & Pick<AccountSpecEntity, 'loanPlusProjectId'>
    )>, salesAlertAging?: Maybe<(
      { __typename?: 'SalesAlertAgingOutput' }
      & Pick<SalesAlertAgingOutput, 'isActive' | 'maxMinorSalesAlertAging' | 'maxMajorSalesAlertAging'>
    )>, loanAlertAging?: Maybe<(
      { __typename?: 'LoanAlertAgingOutput' }
      & Pick<LoanAlertAgingOutput, 'isActive' | 'maxMinorLoanAlertAging' | 'maxMajorLoanAlertAging'>
    )>, solicitorAlertAging?: Maybe<(
      { __typename?: 'SolicitorAlertAgingOutput' }
      & Pick<SolicitorAlertAgingOutput, 'isActive' | 'maxMinorSolicitorAlertAging' | 'maxMajorSolicitorAlertAging'>
    )> }
  ), getProjectById: (
    { __typename?: 'projectEntity' }
    & { developmentCompany: (
      { __typename?: 'companyEntity' }
      & Pick<CompanyEntity, 'id'>
    ), holdingCompany: (
      { __typename?: 'companyEntity' }
      & Pick<CompanyEntity, 'id'>
    ) }
  ), getSuserListForProjectSpec: Array<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID' | 'name'>
  )>, paymentGatewayListing: Array<(
    { __typename?: 'paymentGatewayEntity' }
    & Pick<PaymentGatewayEntity, 'id' | 'title'>
  )> }
);

export type GetIntegrationDetailsByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetIntegrationDetailsByProjectIdQuery = (
  { __typename?: 'Query' }
  & { GetIntegrationDetailsByProjectId?: Maybe<(
    { __typename?: 'projectIntegrationEntity' }
    & Pick<ProjectIntegrationEntity, 'ifcaProjectId' | 'ifcaPhaseId' | 'integrationUrl' | 'gracePeriod' | 'paymentPlanId' | 'paymentPlanCode' | 'paymentPlanDesc'>
  )> }
);

export type UserAccessEntityMutationVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type UserAccessEntityMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateUserLatestEntity'>
);

export type GetGalleryVideoByProjectQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetGalleryVideoByProjectQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'GetVideoGalleryByProject'>
);

export type EditGalleryVideoMutationVariables = Exact<{
  input: Array<AdminEditGalleryVideoInput> | AdminEditGalleryVideoInput;
}>;


export type EditGalleryVideoMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'EditGalleryVideo'>
);

export type GetGalleryTourByProjectQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetGalleryTourByProjectQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'GetGalleryTourByProject'>
);

export type EditGalleryTourMutationVariables = Exact<{
  input: Array<AdminEditGalleryTourInput> | AdminEditGalleryTourInput;
}>;


export type EditGalleryTourMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'EditGalleryTour'>
);

export type GetProjectGalleryByProjectQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetProjectGalleryByProjectQuery = (
  { __typename?: 'Query' }
  & { GetProjectGalleryByProject: Array<(
    { __typename?: 'ProjectGalleryOutput' }
    & Pick<ProjectGalleryOutput, 'resourceid' | 'url' | 'pictureid' | 'seqno' | 'caption'>
  )> }
);

export type EditProjectGalleryMutationVariables = Exact<{
  input: Array<AdminEditProjectGalleryInput> | AdminEditProjectGalleryInput;
}>;


export type EditProjectGalleryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'EditProjectGallery'>
);

export type DeleteProjectGalleryMutationVariables = Exact<{
  input: Array<AdminEditProjectGalleryInput> | AdminEditProjectGalleryInput;
}>;


export type DeleteProjectGalleryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'DeleteProjectGallery'>
);

export type GetBlockGalleryByProjectQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetBlockGalleryByProjectQuery = (
  { __typename?: 'Query' }
  & { GetBlockGalleryByProject: Array<(
    { __typename?: 'BlockGalleryOutput' }
    & Pick<BlockGalleryOutput, 'resourceid' | 'url' | 'caption' | 'pictureid' | 'block'>
  )> }
);

export type GetDistinctBlockByProjectIdQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetDistinctBlockByProjectIdQuery = (
  { __typename?: 'Query' }
  & { GetDistinctBlockByProjectId: Array<(
    { __typename?: 'DistinctBlockByProjectOutput' }
    & Pick<DistinctBlockByProjectOutput, 'block'>
  )> }
);

export type EditBlockGalleryMutationVariables = Exact<{
  input: Array<AdminEditLayoutBlockInput> | AdminEditLayoutBlockInput;
}>;


export type EditBlockGalleryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'EditBlockGallery'>
);

export type DeleteBlockGalleryMutationVariables = Exact<{
  input: Array<AdminEditLayoutBlockInput> | AdminEditLayoutBlockInput;
}>;


export type DeleteBlockGalleryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'DeleteBlockGallery'>
);

export type GetFloorGalleryByProjectQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetFloorGalleryByProjectQuery = (
  { __typename?: 'Query' }
  & { GetFloorGalleryByProject: Array<(
    { __typename?: 'FloorGalleryOutput' }
    & Pick<FloorGalleryOutput, 'resourceid' | 'url' | 'pictureid' | 'seqno' | 'caption' | 'block' | 'floor' | 'blockFloor'>
  )> }
);

export type GetDistinctFloorByProjectIdQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetDistinctFloorByProjectIdQuery = (
  { __typename?: 'Query' }
  & { GetDistinctFloorByProjectId: Array<(
    { __typename?: 'DistinctFloorByProjectOutput' }
    & Pick<DistinctFloorByProjectOutput, 'block' | 'floor' | 'blockFloor'>
  )> }
);

export type GetUnitGalleryByProjectQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetUnitGalleryByProjectQuery = (
  { __typename?: 'Query' }
  & { GetUnitGalleryByProject: Array<(
    { __typename?: 'UnitGalleryOutput' }
    & Pick<UnitGalleryOutput, 'resourceid' | 'url' | 'pictureid' | 'seqno' | 'caption' | 'unit_layout_id' | 'unit_type_id' | 'virtualModelLink' | 'desc' | 'block' | 'unit_type_desc'>
  )> }
);

export type EditFloorGalleryMutationVariables = Exact<{
  input: Array<AdminEditLayoutFloorInput> | AdminEditLayoutFloorInput;
}>;


export type EditFloorGalleryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'EditFloorGallery'>
);

export type DeleteFloorGalleryMutationVariables = Exact<{
  input: Array<AdminEditLayoutFloorInput> | AdminEditLayoutFloorInput;
}>;


export type DeleteFloorGalleryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'DeleteFloorGallery'>
);

export type GetDistinctUnitByProjectIdQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetDistinctUnitByProjectIdQuery = (
  { __typename?: 'Query' }
  & { GetDistinctUnitByProjectId: Array<(
    { __typename?: 'DistinctUnitByProjectOutput' }
    & Pick<DistinctUnitByProjectOutput, 'unit_layout_id' | 'desc' | 'block'>
  )> }
);

export type GetDistinctUnitTypeByProjectIdQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetDistinctUnitTypeByProjectIdQuery = (
  { __typename?: 'Query' }
  & { GetDistinctUnitTypeByProjectId: Array<(
    { __typename?: 'DistinctUnitTypeByProjectOutput' }
    & Pick<DistinctUnitTypeByProjectOutput, 'unit_type_id' | 'unit_type_desc' | 'unit_block'>
  )> }
);

export type EditUnitGalleryMutationVariables = Exact<{
  input: Array<AdminEditLayoutUnitInput> | AdminEditLayoutUnitInput;
}>;


export type EditUnitGalleryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'EditUnitGallery'>
);

export type DeleteUnitGalleryMutationVariables = Exact<{
  input: Array<AdminEditLayoutUnitInput> | AdminEditLayoutUnitInput;
}>;


export type DeleteUnitGalleryMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'DeleteUnitGallery'>
);

export type ViewAppointmentScheduleQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type ViewAppointmentScheduleQuery = (
  { __typename?: 'Query' }
  & { viewAppointmentSchedule: (
    { __typename?: 'getAppoitmentSchedulingOutput' }
    & Pick<GetAppoitmentSchedulingOutput, 'id' | 'projectId' | 'startTime' | 'endTime' | 'maxPaxPerAppoitment'>
    & { closeDate?: Maybe<Array<(
      { __typename?: 'saleGalleryCloseDateTime' }
      & Pick<SaleGalleryCloseDateTime, 'closeId' | 'startDate' | 'endDate' | 'BlockstartTime' | 'BlockendTime'>
    )>> }
  ) }
);

export type UpdateAppointmentScheduleMutationVariables = Exact<{
  input: EditAppointmentScheduleInput;
}>;


export type UpdateAppointmentScheduleMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateAppointmentSchedule'>
);

export type AddSalesGalleryCloseDateMutationVariables = Exact<{
  input: AddBlockDateInput;
}>;


export type AddSalesGalleryCloseDateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addSalesGalleryCloseDate'>
);

export type ViewCloseDateByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ViewCloseDateByIdQuery = (
  { __typename?: 'Query' }
  & { viewCloseDateById: (
    { __typename?: 'salesGalleryCloseDateEntity' }
    & Pick<SalesGalleryCloseDateEntity, 'id' | 'accountId' | 'projectId' | 'startTime' | 'endTime' | 'startDate' | 'endDate' | 'appointmentSchedulingId'>
  ) }
);

export type EditSalesGalleryCloseDateMutationVariables = Exact<{
  input: EditBlockDateInput;
}>;


export type EditSalesGalleryCloseDateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editSalesGalleryCloseDate'>
);

export type DeleteSalesGalleryCloseDateMutationVariables = Exact<{
  input: CloseDateIdInput;
}>;


export type DeleteSalesGalleryCloseDateMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteSalesGalleryCloseDate'>
);

export type GetAllActiveProjectIntegrationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActiveProjectIntegrationQuery = (
  { __typename?: 'Query' }
  & { getAllActiveProjectIntegration: Array<(
    { __typename?: 'projectIntegrationEntity' }
    & Pick<ProjectIntegrationEntity, 'id' | 'accountId' | 'projectId' | 'ifcaCompanyName' | 'integrationUrl' | 'integrationType' | 'ifcaProjectName'>
  )> }
);

export type GetAllActiveProjectIntegrationWithUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllActiveProjectIntegrationWithUrlQuery = (
  { __typename?: 'Query' }
  & { getAllActiveProjectIntegrationWithUrl?: Maybe<Array<(
    { __typename?: 'getAllActiveProjectIntegrationWithUrlOutput' }
    & Pick<GetAllActiveProjectIntegrationWithUrlOutput, 'id' | 'accountId' | 'integrationType' | 'integrationUrl' | 'companyName' | 'message'>
  )>> }
);

export type GetAllGatewayUpdatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllGatewayUpdatesQuery = (
  { __typename?: 'Query' }
  & { getAllGatewayUpdates: Array<(
    { __typename?: 'SGatewayUpdates_A' }
    & Pick<SGatewayUpdates_A, 'ID' | 'IntegrationType' | 'version' | 'md5' | 'hasSqlUpdate' | 'url' | 'verifySql' | 'sql'>
  )> }
);

export type GetAllGatewayUpdatesByTypeQueryVariables = Exact<{
  IntType: Scalars['String'];
}>;


export type GetAllGatewayUpdatesByTypeQuery = (
  { __typename?: 'Query' }
  & { getAllGatewayUpdatesByType: Array<(
    { __typename?: 'SGatewayUpdates_A' }
    & Pick<SGatewayUpdates_A, 'ID' | 'IntegrationType' | 'version' | 'md5' | 'hasSqlUpdate' | 'url' | 'verifySql' | 'sql'>
  )> }
);

export type EditGatewayUpdatesMutationVariables = Exact<{
  input: SGatewayUpdateInput;
}>;


export type EditGatewayUpdatesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editGatewayUpdates'>
);

export type AddGatewayUpdatesMutationVariables = Exact<{
  input: SGatewayAddInput;
}>;


export type AddGatewayUpdatesMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addGatewayUpdates'>
);

export type GetGatewayUpdatesByIdQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetGatewayUpdatesByIdQuery = (
  { __typename?: 'Query' }
  & { getGatewayUpdatesById: (
    { __typename?: 'SGatewayUpdates_A' }
    & Pick<SGatewayUpdates_A, 'ID' | 'IntegrationType' | 'version' | 'md5' | 'hasSqlUpdate' | 'url' | 'verifySql' | 'sql' | 'releaseNote'>
  ) }
);

export type DeleteGatewayUpdatesByIdMutationVariables = Exact<{
  ID: Scalars['String'];
}>;


export type DeleteGatewayUpdatesByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteGatewayUpdatesById'>
);

export type GetAllOnPremApiVerQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOnPremApiVerQuery = (
  { __typename?: 'Query' }
  & { getAllOnPremApiVer: Array<(
    { __typename?: 'CheckOnPremApiModel' }
    & Pick<CheckOnPremApiModel, 'onPremVer' | 'onPremIntType' | 'apiUrl' | 'accountId' | 'softwareCode' | 'sApiGatewayId' | 'getSuccess' | 'errno' | 'errMsg'>
  )> }
);

export type UpdateAllOnPremApisQueryVariables = Exact<{ [key: string]: never; }>;


export type UpdateAllOnPremApisQuery = (
  { __typename?: 'Query' }
  & { updateAllOnPremApis: Array<(
    { __typename?: 'OnPremApiResModel' }
    & Pick<OnPremApiResModel, 'id' | 'apiUrl' | 'integrationType' | 'version' | 'errno' | 'errMsg' | 'updated' | 'apiMsg'>
  )> }
);

export type GetOnPremApiVerQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type GetOnPremApiVerQuery = (
  { __typename?: 'Query' }
  & { getOnPremApiVer: (
    { __typename?: 'CheckOnPremApiModel' }
    & Pick<CheckOnPremApiModel, 'onPremVer' | 'onPremIntType' | 'apiUrl' | 'softwareCode' | 'sApiGatewayId' | 'getSuccess' | 'errno' | 'errMsg'>
  ) }
);

export type UpdateOnPremApiQueryVariables = Exact<{
  ID: Scalars['String'];
}>;


export type UpdateOnPremApiQuery = (
  { __typename?: 'Query' }
  & { updateOnPremApi: (
    { __typename?: 'OnPremApiResModel' }
    & Pick<OnPremApiResModel, 'apiUrl' | 'integrationType' | 'version' | 'errno' | 'errMsg' | 'updated' | 'apiMsg'>
  ) }
);

export type UpdateOnPremApiByVerQueryVariables = Exact<{
  ID: Scalars['String'];
  updateApiID: Scalars['String'];
}>;


export type UpdateOnPremApiByVerQuery = (
  { __typename?: 'Query' }
  & { updateOnPremApiByVer: (
    { __typename?: 'OnPremApiResModel' }
    & Pick<OnPremApiResModel, 'id' | 'apiUrl' | 'integrationType' | 'version' | 'errno' | 'errMsg' | 'updated' | 'apiMsg'>
  ) }
);

export type GetAllProjectTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllProjectTypeQuery = (
  { __typename?: 'Query' }
  & { getAllProjectType?: Maybe<Array<(
    { __typename?: 'projectTypeEntity' }
    & Pick<ProjectTypeEntity, 'id' | 'name' | 'commonStatus' | 'defaulted' | 'seq_no' | 'isDeletable'>
  )>> }
);

export type EditProjectTypeMutationVariables = Exact<{
  input: EditProjectTypeInput;
}>;


export type EditProjectTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editProjectType'>
);

export type AddProjectTypeMutationVariables = Exact<{
  input: ProjectTypeInput;
}>;


export type AddProjectTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addProjectType'>
);

export type DeleteProjectTypeByIdMutationVariables = Exact<{
  projectTypeId: Scalars['String'];
}>;


export type DeleteProjectTypeByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteProjectTypeById'>
);

export type SetDefaultProjectTypeMutationVariables = Exact<{
  projectTypeId: Scalars['String'];
}>;


export type SetDefaultProjectTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultProjectType'>
);

export type RemoveDefaultProjectTypeMutationVariables = Exact<{
  projectTypeId: Scalars['String'];
}>;


export type RemoveDefaultProjectTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultProjectType'>
);

export type OrganizeProjectTypeMutationVariables = Exact<{
  projectTypeId: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeProjectTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeProjectType'>
);

export type GetAllPropertyTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllPropertyTypeQuery = (
  { __typename?: 'Query' }
  & { getAllPropertyType?: Maybe<Array<(
    { __typename?: 'propertyTypeEntity' }
    & Pick<PropertyTypeEntity, 'id' | 'name' | 'commercialPurpose' | 'commonStatus' | 'defaulted' | 'seq_no' | 'isDeletable'>
  )>> }
);

export type EditPropertyTypeMutationVariables = Exact<{
  input: EditPropertyTypeInput;
}>;


export type EditPropertyTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editPropertyType'>
);

export type AddPropertyTypeMutationVariables = Exact<{
  input: PropertyTypeInput;
}>;


export type AddPropertyTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addPropertyType'>
);

export type DeletePropertyTypeByIdMutationVariables = Exact<{
  propertyTypeId: Scalars['String'];
}>;


export type DeletePropertyTypeByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deletePropertyTypeById'>
);

export type SetDefaultPropertyTypeMutationVariables = Exact<{
  propertyTypeId: Scalars['String'];
}>;


export type SetDefaultPropertyTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultPropertyType'>
);

export type RemoveDefaultPropertyTypeMutationVariables = Exact<{
  propertyTypeId: Scalars['String'];
}>;


export type RemoveDefaultPropertyTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultPropertyType'>
);

export type OrganizePropertyTypeMutationVariables = Exact<{
  propertyTypeId: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizePropertyTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizePropertyType'>
);

export type GetMasterCommercialPurposeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMasterCommercialPurposeQuery = (
  { __typename?: 'Query' }
  & { GetAllMasterInfo: (
    { __typename?: 'MasterDataOutput' }
    & Pick<MasterDataOutput, 'CommercialPurposes'>
  ) }
);

export type GetAllRaceQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllRaceQuery = (
  { __typename?: 'Query' }
  & { getAllRace?: Maybe<Array<(
    { __typename?: 'raceEntity' }
    & Pick<RaceEntity, 'id' | 'name' | 'commonStatus' | 'defaulted' | 'isDeletable'>
  )>> }
);

export type EditRaceMutationVariables = Exact<{
  input: EditRaceInput;
}>;


export type EditRaceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editRace'>
);

export type AddRaceMutationVariables = Exact<{
  input: RaceInput;
}>;


export type AddRaceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addRace'>
);

export type DeleteRaceByIdMutationVariables = Exact<{
  raceId: Scalars['String'];
}>;


export type DeleteRaceByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteRaceById'>
);

export type SetDefaultRaceMutationVariables = Exact<{
  raceId: Scalars['String'];
}>;


export type SetDefaultRaceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultRace'>
);

export type RemoveDefaultRaceMutationVariables = Exact<{
  raceId: Scalars['String'];
}>;


export type RemoveDefaultRaceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultRace'>
);

export type OrganizeRaceMutationVariables = Exact<{
  raceIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeRaceMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeRace'>
);

export type GetAllReasonCodeQueryVariables = Exact<{
  type: Scalars['String'];
}>;


export type GetAllReasonCodeQuery = (
  { __typename?: 'Query' }
  & { getAllReasonCode?: Maybe<Array<(
    { __typename?: 'reasonCodeEntity' }
    & Pick<ReasonCodeEntity, 'id' | 'name' | 'commonStatus' | 'defaulted' | 'type' | 'systemUse' | 'isDeletable'>
  )>> }
);

export type AddReasonCodeMutationVariables = Exact<{
  input: ReasonCodeInput;
}>;


export type AddReasonCodeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addReasonCode'>
);

export type DeleteReasonCodeByIdMutationVariables = Exact<{
  reasonCodeId: Scalars['String'];
}>;


export type DeleteReasonCodeByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteReasonCodeById'>
);

export type EditReasonCodeMutationVariables = Exact<{
  input: EditReasonCodeInput;
}>;


export type EditReasonCodeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editReasonCode'>
);

export type SetDefaultReasonCodeMutationVariables = Exact<{
  reasonCodeId: Scalars['String'];
  type: Scalars['String'];
}>;


export type SetDefaultReasonCodeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultReasonCode'>
);

export type RemoveDefaultReasonCodeMutationVariables = Exact<{
  reasonCodeId: Scalars['String'];
  type: Scalars['String'];
}>;


export type RemoveDefaultReasonCodeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultReasonCode'>
);

export type OrganizeReasonCodeMutationVariables = Exact<{
  reasonCodeIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeReasonCodeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeReasonCode'>
);

export type GetListOfRegionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetListOfRegionQuery = (
  { __typename?: 'Query' }
  & { getListOfRegion?: Maybe<Array<(
    { __typename?: 'regionEntity' }
    & Pick<RegionEntity, 'id' | 'name' | 'commonStatus' | 'systemUse' | 'defaulted' | 'isDeletable'>
  )>> }
);

export type AddRegionMutationVariables = Exact<{
  input: RegionInput;
}>;


export type AddRegionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addRegion'>
);

export type EditRegionMutationVariables = Exact<{
  input: EditRegionInput;
}>;


export type EditRegionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editRegion'>
);

export type DeleteRegionByIdMutationVariables = Exact<{
  regionId: Scalars['String'];
}>;


export type DeleteRegionByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteRegionById'>
);

export type AlterRegionCommonStatusMutationVariables = Exact<{
  regionId: Scalars['String'];
}>;


export type AlterRegionCommonStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'alterRegionCommonStatus'>
);

export type SetDefaultRegionMutationVariables = Exact<{
  regionId: Scalars['String'];
}>;


export type SetDefaultRegionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultRegion'>
);

export type RemoveDefaultRegionMutationVariables = Exact<{
  regionId: Scalars['String'];
}>;


export type RemoveDefaultRegionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultRegion'>
);

export type OrganizeRegionMutationVariables = Exact<{
  regionIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeRegionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeRegion'>
);

export type GetSalesTeamByProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesTeamByProjectQuery = (
  { __typename?: 'Query' }
  & { getSalesTeamByProject: Array<(
    { __typename?: 'saleTeamEntity' }
    & Pick<SaleTeamEntity, 'id' | 'name' | 'memberCount'>
  )> }
);

export type AddSalesTeamsMutationVariables = Exact<{
  input: TeamInput;
}>;


export type AddSalesTeamsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addSalesTeams'>
);

export type EditSalesTeamsMutationVariables = Exact<{
  input: EditTeamInput;
}>;


export type EditSalesTeamsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editSalesTeams'>
);

export type DeleteSalesTeamMutationVariables = Exact<{
  teamId: Scalars['String'];
}>;


export type DeleteSalesTeamMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteSalesTeamById'>
);

export type GetAssignedMembersQueryVariables = Exact<{
  teamId: Scalars['String'];
}>;


export type GetAssignedMembersQuery = (
  { __typename?: 'Query' }
  & { getAssignedTeamMembers: Array<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID' | 'name' | 'contactNo' | 'email'>
  )> }
);

export type GetUnassignedMembersQueryVariables = Exact<{
  projectId: Scalars['String'];
  teamId: Scalars['String'];
}>;


export type GetUnassignedMembersQuery = (
  { __typename?: 'Query' }
  & { getUnassignedTeamMembers: Array<(
    { __typename?: 'UserEntity' }
    & Pick<UserEntity, 'ID' | 'name' | 'contactNo' | 'email'>
  )> }
);

export type AssignMemberMutationVariables = Exact<{
  projectId: Scalars['String'];
  teamId: Scalars['String'];
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type AssignMemberMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'assignTeamMember'>
);

export type UnassignMemberMutationVariables = Exact<{
  teamId: Scalars['String'];
  userIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type UnassignMemberMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unassignTeamMember'>
);

export type GetSalesTeamByProjectForAllocationQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesTeamByProjectForAllocationQuery = (
  { __typename?: 'Query' }
  & { getSalesTeamForAllocation: Array<(
    { __typename?: 'salesTeamByProjectOutput' }
    & Pick<SalesTeamByProjectOutput, 'id' | 'name' | 'enableAllocation' | 'allocatedUnits' | 'totalUnits'>
  )> }
);

export type AlterTeamAllocationPermissionMutationVariables = Exact<{
  teamId: Scalars['String'];
}>;


export type AlterTeamAllocationPermissionMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'alterTeamAllocationPermission'>
);

export type GetTeamBeenAllocatedWithUnitQueryVariables = Exact<{
  projectId: Scalars['String'];
  teamId: Scalars['String'];
}>;


export type GetTeamBeenAllocatedWithUnitQuery = (
  { __typename?: 'Query' }
  & { getTeamBeenAllocatedWithUnit?: Maybe<Array<(
    { __typename?: 'saleTeamEntity' }
    & Pick<SaleTeamEntity, 'id' | 'name'>
  )>> }
);

export type GetAllocatedUnitsByTeamQueryVariables = Exact<{
  projectId: Scalars['String'];
  teamId: Scalars['String'];
  block: Scalars['String'];
}>;


export type GetAllocatedUnitsByTeamQuery = (
  { __typename?: 'Query' }
  & { getAllocatedUnitsByTeam: Array<(
    { __typename?: 'SalesChartUnitOutput' }
    & Pick<SalesChartUnitOutput, 'unit_id' | 'unit_no' | 'unit_status' | 'unit_type' | 'price' | 'floor' | 'floor_label' | 'cell' | 'status' | 'isBumi'>
  )> }
);

export type AllocateUnitsForTeamMutationVariables = Exact<{
  selectUnitIds: Array<Scalars['String']> | Scalars['String'];
  teamId: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type AllocateUnitsForTeamMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'allocateUnitsForTeam'>
);

export type UploadSalesDocMutationVariables = Exact<{
  isPrivate?: Maybe<Scalars['Boolean']>;
  file: Scalars['Upload'];
  input: SalesDocInput;
}>;


export type UploadSalesDocMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'uploadSalesDoc'>
);

export type GetSalesDocTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSalesDocTypeQuery = (
  { __typename?: 'Query' }
  & Pick<Query, 'getSalesDocType'>
);

export type GetSalesDocByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetSalesDocByIdQuery = (
  { __typename?: 'Query' }
  & { getSalesDocById: (
    { __typename?: 'salesDocEntity' }
    & Pick<SalesDocEntity, 'id' | 'docName' | 'type' | 'allowSalesTeam' | 'allowAgency'>
    & { attachment: (
      { __typename?: 'attachmentEntity' }
      & Pick<AttachmentEntity, 'fileName'>
    ) }
  ) }
);

export type GetSalesDocTypeListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesDocTypeListQuery = (
  { __typename?: 'Query' }
  & { getSalesDocList: Array<(
    { __typename?: 'salesDocEntity' }
    & Pick<SalesDocEntity, 'id' | 'docName' | 'type' | 'allowSalesTeam' | 'allowAgency' | 'typeDescription'>
    & { attachment: (
      { __typename?: 'attachmentEntity' }
      & Pick<AttachmentEntity, 'resourceUrl' | 'fileName'>
    ) }
  )> }
);

export type DeleteSalesDocMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteSalesDocMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteSalesDoc'>
);

export type UpdateSalesDocMutationVariables = Exact<{
  input: EditSalesDocInput;
  file?: Maybe<Scalars['Upload']>;
}>;


export type UpdateSalesDocMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'updateSalesDoc'>
);

export type GetBrochureListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetBrochureListQuery = (
  { __typename?: 'Query' }
  & { getBrochureList: Array<(
    { __typename?: 'salesDocEntity' }
    & Pick<SalesDocEntity, 'id' | 'projectId' | 'modTs' | 'docName' | 'typeDescription' | 'type' | 'allowSalesTeam' | 'allowAgency'>
    & { attachment: (
      { __typename?: 'attachmentEntity' }
      & Pick<AttachmentEntity, 'fileName' | 'resourceUrl'>
    ) }
  )> }
);

export type GetAllSalutationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSalutationQuery = (
  { __typename?: 'Query' }
  & { getAllSalutation?: Maybe<Array<(
    { __typename?: 'salutationEntity' }
    & Pick<SalutationEntity, 'id' | 'name' | 'commonStatus' | 'defaulted' | 'isDeletable'>
  )>> }
);

export type EditSalutationMutationVariables = Exact<{
  input: EditSalutationInput;
}>;


export type EditSalutationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editSalutation'>
);

export type AddSalutationMutationVariables = Exact<{
  input: SalutationInput;
}>;


export type AddSalutationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addSalutation'>
);

export type DeleteSalutationByIdMutationVariables = Exact<{
  salutationId: Scalars['String'];
}>;


export type DeleteSalutationByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteSalutationById'>
);

export type SetDefaultSalutationMutationVariables = Exact<{
  salutationId: Scalars['String'];
}>;


export type SetDefaultSalutationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultSalutation'>
);

export type RemoveDefaultSalutationMutationVariables = Exact<{
  salutationId: Scalars['String'];
}>;


export type RemoveDefaultSalutationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultSalutation'>
);

export type OrganizeSalutationMutationVariables = Exact<{
  salutationIds: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeSalutationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeSalutation'>
);

export type SiteProgressDataQueryVariables = Exact<{
  project_id: Scalars['String'];
  limit: Scalars['Float'];
  page: Scalars['Float'];
  search?: Maybe<Scalars['String']>;
}>;


export type SiteProgressDataQuery = (
  { __typename?: 'Query' }
  & { getListSiteProgress: (
    { __typename?: 'siteProgressListingOutput' }
    & Pick<SiteProgressListingOutput, 'total'>
    & { data?: Maybe<Array<(
      { __typename?: 'siteProgressEntity' }
      & Pick<SiteProgressEntity, 'id' | 'title' | 'publishDate' | 'description'>
      & { attachment: Array<(
        { __typename?: 'attachmentEntity' }
        & Pick<AttachmentEntity, 'id' | 'resourceUrl'>
      )> }
    )>> }
  ) }
);

export type DeleteSiteProgressMutationVariables = Exact<{
  siteProgressId: Scalars['String'];
}>;


export type DeleteSiteProgressMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteSiteProgress'>
);

export type AddSiteProgressMutationVariables = Exact<{
  project_id: Scalars['String'];
  input: AddSiteProgressInput;
}>;


export type AddSiteProgressMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addSiteProgess'>
);

export type GetEditSiteProgressDetailsQueryVariables = Exact<{
  siteProgressId: Scalars['String'];
}>;


export type GetEditSiteProgressDetailsQuery = (
  { __typename?: 'Query' }
  & { getEditSource: (
    { __typename?: 'siteProgressEntity' }
    & Pick<SiteProgressEntity, 'title' | 'publishDate' | 'description'>
    & { attachment: Array<(
      { __typename?: 'attachmentEntity' }
      & Pick<AttachmentEntity, 'id' | 'resourceUrl' | 'fileName'>
    )> }
  ) }
);

export type EditSiteProgressMutationVariables = Exact<{
  input: EditSiteProgressInput;
}>;


export type EditSiteProgressMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editSiteProgress'>
);

export type SolicitorListQueryVariables = Exact<{ [key: string]: never; }>;


export type SolicitorListQuery = (
  { __typename?: 'Query' }
  & { solicitorList: Array<(
    { __typename?: 'solicitorAppointedEntity' }
    & Pick<SolicitorAppointedEntity, 'id' | 'name' | 'assignedProjectCount' | 'commonStatus' | 'logoUrl' | 'modTs'>
  )> }
);

export type SolicitorDetailsQueryVariables = Exact<{
  solicitorAppointedId: Scalars['String'];
}>;


export type SolicitorDetailsQuery = (
  { __typename?: 'Query' }
  & { solicitorDetails?: Maybe<(
    { __typename?: 'solicitorAppointedEntity' }
    & Pick<SolicitorAppointedEntity, 'id' | 'solicitorId' | 'name' | 'email' | 'officeTel' | 'contactName' | 'contactEmail' | 'contactPhoneNo' | 'logoUrl' | 'solicitorCode'>
    & { address?: Maybe<(
      { __typename?: 'AddressJson' }
      & Pick<AddressJson, 'address' | 'state' | 'country' | 'city' | 'postCode'>
    )> }
  )>, solicitorProjectList: Array<(
    { __typename?: 'solicitorProjectEntity' }
    & Pick<SolicitorProjectEntity, 'id' | 'createdTs'>
    & { project?: Maybe<(
      { __typename?: 'projectEntity' }
      & Pick<ProjectEntity, 'name'>
      & { solicitorLayoutList?: Maybe<Array<(
        { __typename?: 'solicitorLayoutList' }
        & Pick<SolicitorLayoutList, 'project_id' | 'desc' | 'allotted' | 'layout_id' | 'sold' | 'total_selling'>
      )>> }
    )> }
  )> }
);

export type AddSolicitorMutationVariables = Exact<{
  input: AdminSolicitorInput;
}>;


export type AddSolicitorMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addSolicitor'>
);

export type EditSolicitorMutationVariables = Exact<{
  solicitorAppointedId: Scalars['String'];
  input: AdminSolicitorInput;
}>;


export type EditSolicitorMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editSolicitor'>
);

export type SuspendSolicitorMutationVariables = Exact<{
  solicitorAppointedId: Scalars['String'];
}>;


export type SuspendSolicitorMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'suspendSolicitor'>
);

export type SyncIntegrateSolicitorMutationVariables = Exact<{ [key: string]: never; }>;


export type SyncIntegrateSolicitorMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'syncIntegrateSolicitor'>
);

export type SolicitorAppointedListQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type SolicitorAppointedListQuery = (
  { __typename?: 'Query' }
  & { solicitorAppointedList: Array<(
    { __typename?: 'solicitorAppointedEntity' }
    & Pick<SolicitorAppointedEntity, 'id' | 'solicitorId' | 'name' | 'logoUrl' | 'commonStatus' | 'default' | 'solicitorStatus'>
    & { solicitorUnitCount?: Maybe<(
      { __typename?: 'solicitorUnitCount' }
      & Pick<SolicitorUnitCount, 'allocated' | 'sold'>
    )> }
  )> }
);

export type SolicitorListForAssignmentQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type SolicitorListForAssignmentQuery = (
  { __typename?: 'Query' }
  & { solicitorListForAssignment: Array<(
    { __typename?: 'solicitorAppointedEntity' }
    & Pick<SolicitorAppointedEntity, 'id' | 'solicitorId' | 'name'>
  )> }
);

export type AssignSolicitorToProjectMutationVariables = Exact<{
  projectId: Scalars['String'];
  solicitor_appointed_id: Array<Scalars['String']> | Scalars['String'];
}>;


export type AssignSolicitorToProjectMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'assignSolicitorToProject'>
);

export type SolicitorAppointedDetailsQueryVariables = Exact<{
  solicitor_appointed_id: Scalars['String'];
}>;


export type SolicitorAppointedDetailsQuery = (
  { __typename?: 'Query' }
  & { solicitorAppointedDetails: (
    { __typename?: 'solicitorAppointedEntity' }
    & Pick<SolicitorAppointedEntity, 'id' | 'name' | 'email' | 'officeTel' | 'createdTs' | 'contactName' | 'contactEmail' | 'contactPhoneNo'>
    & { address?: Maybe<(
      { __typename?: 'AddressJson' }
      & Pick<AddressJson, 'address'>
    )> }
  ) }
);

export type UnassignSolicitorFromProjectMutationVariables = Exact<{
  project_id: Scalars['String'];
  solicitor_id: Scalars['String'];
}>;


export type UnassignSolicitorFromProjectMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'unassignSolicitorFromProject'>
);

export type ResendSolicitorAppointedInvitationMutationVariables = Exact<{
  solicitor_appointed_id: Scalars['String'];
  project_id: Scalars['String'];
}>;


export type ResendSolicitorAppointedInvitationMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resendSolicitorAppointedInvitation'>
);

export type SolicitorMarkAsDefaultMutationVariables = Exact<{
  projectId: Scalars['String'];
  solicitorId: Scalars['String'];
}>;


export type SolicitorMarkAsDefaultMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'markAsDefault'>
);

export type GetAllUnitTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllUnitTypeQuery = (
  { __typename?: 'Query' }
  & { getAllUnitType?: Maybe<Array<(
    { __typename?: 'unitTypeEntity' }
    & Pick<UnitTypeEntity, 'id' | 'name' | 'commonStatus' | 'defaulted' | 'seq_no' | 'isDeletable'>
  )>> }
);

export type EditUnitTypeMutationVariables = Exact<{
  input: EditUnitTypeInput;
}>;


export type EditUnitTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'editUnitType'>
);

export type AddUnitTypeMutationVariables = Exact<{
  input: UnitTypeInput;
}>;


export type AddUnitTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'addUnitType'>
);

export type DeleteUnitTypeByIdMutationVariables = Exact<{
  unitTypeId: Scalars['String'];
}>;


export type DeleteUnitTypeByIdMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'deleteUnitTypeById'>
);

export type SetDefaultUnitTypeMutationVariables = Exact<{
  unitTypeId: Scalars['String'];
}>;


export type SetDefaultUnitTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'setDefaultUnitType'>
);

export type RemoveDefaultUnitTypeMutationVariables = Exact<{
  unitTypeId: Scalars['String'];
}>;


export type RemoveDefaultUnitTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeDefaultUnitType'>
);

export type OrganizeUnitTypeMutationVariables = Exact<{
  unitTypeId: Array<Scalars['String']> | Scalars['String'];
}>;


export type OrganizeUnitTypeMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'organizeUnitType'>
);

export type GetBlockByProjectQueryVariables = Exact<{
  projectId: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
}>;


export type GetBlockByProjectQuery = (
  { __typename?: 'Query' }
  & { GetBlockByProject: (
    { __typename?: 'BlockByProjectOutput' }
    & Pick<BlockByProjectOutput, 'integrated' | 'blocks' | 'isSubProduct'>
  ) }
);

export type GetUnitFloorByBlockQueryVariables = Exact<{
  projectId: Scalars['String'];
  block: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
}>;


export type GetUnitFloorByBlockQuery = (
  { __typename?: 'Query' }
  & { GetFloorByProjectBlock?: Maybe<Array<(
    { __typename?: 'FloorOutput' }
    & Pick<FloorOutput, 'floor' | 'floorlabel' | 'isSubProduct'>
    & { Unit?: Maybe<Array<(
      { __typename?: 'unitEntity' }
      & { projectSpec: Array<(
        { __typename?: 'projectSpecEntity' }
        & Pick<ProjectSpecEntity, 'reservationSales' | 'reservationAgency'>
      )> }
    )>> }
  )>>, GetUnitByProjectBlock: Array<(
    { __typename?: 'unitEntity' }
    & Pick<UnitEntity, 'id' | 'unitNo' | 'floor' | 'floorLabel' | 'cell' | 'unitStatus' | 'commonStatus' | 'isBumi'>
  )> }
);

export type GetUnitForCarParkQueryVariables = Exact<{
  projectId: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
}>;


export type GetUnitForCarParkQuery = (
  { __typename?: 'Query' }
  & { GetUnitByProjectBlock: Array<(
    { __typename?: 'unitEntity' }
    & Pick<UnitEntity, 'id' | 'unitNo' | 'floor' | 'floorLabel' | 'cell' | 'unitStatus' | 'commonStatus' | 'isBumi'>
  )> }
);

export type UpdateUnitStatusMutationVariables = Exact<{
  models: Array<AdminUnitStatusInput> | AdminUnitStatusInput;
}>;


export type UpdateUnitStatusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'UpdateUnitStatus'>
);

export type ImportUnitOptionsQueryVariables = Exact<{
  projectId: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
}>;


export type ImportUnitOptionsQuery = (
  { __typename?: 'Query' }
  & { ImportUnitOptions: (
    { __typename?: 'ImportUnitOptionOutput' }
    & Pick<ImportUnitOptionOutput, 'displayImportMethods' | 'overwrite' | 'append' | 'integrated'>
  ) }
);

export type ImportUnitMutationVariables = Exact<{
  projectId: Scalars['String'];
  excel: Scalars['Upload'];
  method: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
}>;


export type ImportUnitMutation = (
  { __typename?: 'Mutation' }
  & { ImportUnit: (
    { __typename?: 'UnitExcelReturnOutput' }
    & Pick<UnitExcelReturnOutput, 'message' | 'file_name' | 'file'>
  ) }
);

export type ExportUnitQueryVariables = Exact<{
  projectId: Scalars['String'];
  isSubProduct: Scalars['Boolean'];
}>;


export type ExportUnitQuery = (
  { __typename?: 'Query' }
  & { ExportUnit: (
    { __typename?: 'UnitExcelOutput' }
    & Pick<UnitExcelOutput, 'base64' | 'projectname'>
  ) }
);

export type GetSalesChartDataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetSalesChartDataQuery = (
  { __typename?: 'Query' }
  & { GetSalesChartData?: Maybe<(
    { __typename?: 'projectEntity' }
    & Pick<ProjectEntity, 'saleschartBlock' | 'unitMinPrice' | 'unitMaxPrice'>
    & { unitTypes?: Maybe<Array<(
      { __typename?: 'unitTypeOutput' }
      & Pick<UnitTypeOutput, 'id' | 'name' | 'builtUp'>
    )>> }
  )> }
);

export type GetSalesChartByBlockQueryVariables = Exact<{
  projectId: Scalars['String'];
  block: Scalars['String'];
}>;


export type GetSalesChartByBlockQuery = (
  { __typename?: 'Query' }
  & { GetSalesChartByBlock: (
    { __typename?: 'SalesChartFloorUnitOutput' }
    & { floors: Array<(
      { __typename?: 'SalesChartFloorOutput' }
      & Pick<SalesChartFloorOutput, 'floor' | 'floor_label'>
    )>, units: Array<(
      { __typename?: 'SalesChartUnitOutput' }
      & Pick<SalesChartUnitOutput, 'unit_id' | 'unit_no' | 'unit_status' | 'unit_type' | 'price' | 'floor' | 'cell'>
    )> }
  ) }
);

export type ResetSalesChartByBlockMutationVariables = Exact<{
  block: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type ResetSalesChartByBlockMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'resetSalesChartByBlock'>
);

export type GetUnitLayoutBlockByProjectIdQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetUnitLayoutBlockByProjectIdQuery = (
  { __typename?: 'Query' }
  & { getUnitLayoutBlockByProjectId: Array<(
    { __typename?: 'UnitLayoutBlockOutput' }
    & Pick<UnitLayoutBlockOutput, 'unitLayoutId' | 'block' | 'unit_type_desc' | 'unit_type_id'>
  )> }
);

export type GetUnitMasterDataQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type GetUnitMasterDataQuery = (
  { __typename?: 'Query' }
  & { getUnitMasterData: (
    { __typename?: 'unitMasterDataOutput' }
    & { propertyType?: Maybe<Array<(
      { __typename?: 'dropDownDataOutput' }
      & Pick<DropDownDataOutput, 'id' | 'name'>
    )>>, direction?: Maybe<Array<(
      { __typename?: 'dropDownDataOutput' }
      & Pick<DropDownDataOutput, 'id' | 'name'>
    )>>, unitType?: Maybe<Array<(
      { __typename?: 'dropDownDataOutput' }
      & Pick<DropDownDataOutput, 'id' | 'name'>
    )>>, unitLayout?: Maybe<Array<(
      { __typename?: 'dropDownDataOutput' }
      & Pick<DropDownDataOutput, 'id' | 'name'>
    )>> }
  ) }
);

export type GenerateUnitMutationVariables = Exact<{
  input: GenerateUnitInput;
}>;


export type GenerateUnitMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'generateUnit'>
);

export type AssignCarParkToUnitMutationVariables = Exact<{
  input: AssignCarkParkInput;
}>;


export type AssignCarParkToUnitMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'AssignCarParkToUnit'>
);

export type IntegrationParamsQueryVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type IntegrationParamsQuery = (
  { __typename?: 'Query' }
  & { projectIntegrationById: (
    { __typename?: 'projectIntegrationEntity' }
    & Pick<ProjectIntegrationEntity, 'integrationUrl' | 'ifcaCompanyId' | 'ifcaCompanyName' | 'ifcaProjectId' | 'ifcaProjectName' | 'ifcaPhaseId' | 'ifcaPhaseName' | 'gracePeriod' | 'paymentPlanDesc'>
  ) }
);

export type IntegrationCompanyListQueryVariables = Exact<{
  baseUrl: Scalars['String'];
  projectId: Scalars['String'];
}>;


export type IntegrationCompanyListQuery = (
  { __typename?: 'Query' }
  & { getCompanyList?: Maybe<Array<(
    { __typename?: 'IntegrationCompanyOutput' }
    & Pick<IntegrationCompanyOutput, 'id' | 'name'>
  )>> }
);

export type IntegrationProjectListQueryVariables = Exact<{
  baseUrl: Scalars['String'];
  ifcaCompanyId: Scalars['String'];
}>;


export type IntegrationProjectListQuery = (
  { __typename?: 'Query' }
  & { getProjectList: Array<(
    { __typename?: 'IntegrationCompanyOutput' }
    & Pick<IntegrationCompanyOutput, 'id' | 'name'>
  )> }
);

export type IntegrationPhaseListQueryVariables = Exact<{
  baseUrl: Scalars['String'];
  ifcaProjectId: Scalars['String'];
}>;


export type IntegrationPhaseListQuery = (
  { __typename?: 'Query' }
  & { getPhaseList: Array<(
    { __typename?: 'IntegrationCompanyOutput' }
    & Pick<IntegrationCompanyOutput, 'id' | 'name'>
  )> }
);

export type IntegrationPaymentPlanQueryVariables = Exact<{
  baseUrl: Scalars['String'];
  projectId?: Maybe<Scalars['String']>;
}>;


export type IntegrationPaymentPlanQuery = (
  { __typename?: 'Query' }
  & { getPaymentPlan: Array<(
    { __typename?: 'IntegrationPaymentPlanInfoOutput' }
    & Pick<IntegrationPaymentPlanInfoOutput, 'PaymentPlanID' | 'PaymentPlanCode' | 'Description'>
  )> }
);

export type IntegrationUnitListQueryVariables = Exact<{
  input: AdminUnitIntegrationInput;
}>;


export type IntegrationUnitListQuery = (
  { __typename?: 'Query' }
  & { getUnitList: Array<(
    { __typename?: 'IntegrationUnitOutput' }
    & Pick<IntegrationUnitOutput, 'ifcaUnitId' | 'unitNo' | 'block' | 'floor' | 'floorLabel' | 'cell'>
  )> }
);

export type IntegrationDotNetPplusMutationVariables = Exact<{
  projectId: Scalars['String'];
  input: AdminUnitIntegrationInput;
}>;


export type IntegrationDotNetPplusMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'integrateUnitFromDotNetPplus'>
);

export type RepullIntegrateUnitsMutationVariables = Exact<{
  projectId: Scalars['String'];
  rePull: Scalars['Boolean'];
}>;


export type RepullIntegrateUnitsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'repullIntegrateUnits'>
);

export type IntegrationRemoveUnitsMutationVariables = Exact<{
  projectId: Scalars['String'];
}>;


export type IntegrationRemoveUnitsMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'removeAllUnits'>
);

export type Get360TourFormDataByProjectQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type Get360TourFormDataByProjectQuery = (
  { __typename?: 'Query' }
  & { Get360TourFormDataByProject: Array<(
    { __typename?: 'BlockOutput' }
    & Pick<BlockOutput, 'block'>
    & { unitTypes: Array<(
      { __typename?: 'UnitTypeLinkOutput' }
      & Pick<UnitTypeLinkOutput, 'unitTypeId' | 'unitTypeName'>
    )>, unitLayouts: Array<(
      { __typename?: 'UnitLayoutOutput' }
      & Pick<UnitLayoutOutput, 'unitLayoutId' | 'unitLayoutName'>
    )> }
  )> }
);

export type GetUnit360TourByProjectQueryVariables = Exact<{
  projectid: Scalars['String'];
}>;


export type GetUnit360TourByProjectQuery = (
  { __typename?: 'Query' }
  & { GetUnit360TourByProject: Array<(
    { __typename?: 'unitTourVirtualLinkEntity' }
    & Pick<UnitTourVirtualLinkEntity, 'id' | 'seqNo' | 'unitLayoutId' | 'unitTypeId' | 'virtualModelLink' | 'block'>
  )> }
);

export type AlterUnitTourMutationVariables = Exact<{
  input: Array<AdminUpdateUnitVirtualModelInput> | AdminUpdateUnitVirtualModelInput;
}>;


export type AlterUnitTourMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'AlterUnitTour'>
);

export type DeleteUnitTourLinkMutationVariables = Exact<{
  tourIds: Array<Scalars['String']> | Scalars['String'];
  projectId: Scalars['String'];
}>;


export type DeleteUnitTourLinkMutation = (
  { __typename?: 'Mutation' }
  & Pick<Mutation, 'DeleteUnitTourLink'>
);

export const AccessSecurityListingDocument = gql`
    query accessSecurityListing {
  accessSecurityListing {
    totalUser
    activeUser
    rolesCount
    availableUser
    platformUserCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccessSecurityListingGQL extends Apollo.Query<AccessSecurityListingQuery, AccessSecurityListingQueryVariables> {
    document = AccessSecurityListingDocument;
    
  }
export const UserListingDocument = gql`
    query userListing($activeStatus: String) {
  userListing(activeStatus: $activeStatus) {
    ID
    name
    contactNo
    email
    superUser
    commonStatus
    userFeaturePermission {
      allowOpenlead
      allowPropertyAgency
    }
    isActivated
    isSuspendible
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserListingGQL extends Apollo.Query<UserListingQuery, UserListingQueryVariables> {
    document = UserListingDocument;
    
  }
export const GetUserDetailsDocument = gql`
    query getUserDetails($userId: String!) {
  getUserDetails(userId: $userId) {
    ID
    name
    email
    contactNo
    superUser
    commonStatus
    userFeaturePermission {
      allowOpenlead
      allowPropertyAgency
      allowGlobalBI
      allowRoundRobin
      allowOpenLeadRoundRobin
    }
    isActivated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserDetailsGQL extends Apollo.Query<GetUserDetailsQuery, GetUserDetailsQueryVariables> {
    document = GetUserDetailsDocument;
    
  }
export const GetUserByIdDocument = gql`
    query getUserById($userId: String!) {
  getEditUser(userId: $userId) {
    ID
    name
    userName
    email
    contactNo
    superUser
    userFeaturePermission {
      allowOpenlead
      allowPropertyAgency
      allowGlobalBI
      allowRoundRobin
      allowOpenLeadRoundRobin
    }
    isActivated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserByIdGQL extends Apollo.Query<GetUserByIdQuery, GetUserByIdQueryVariables> {
    document = GetUserByIdDocument;
    
  }
export const EditUserDocument = gql`
    mutation editUser($input: EditUserInput!) {
  editUser(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditUserGQL extends Apollo.Mutation<EditUserMutation, EditUserMutationVariables> {
    document = EditUserDocument;
    
  }
export const AddUserDocument = gql`
    mutation addUser($input: NewUserInput!) {
  addUser(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUserGQL extends Apollo.Mutation<AddUserMutation, AddUserMutationVariables> {
    document = AddUserDocument;
    
  }
export const SuspendUserDocument = gql`
    mutation suspendUser($userId: String!) {
  suspendUser(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuspendUserGQL extends Apollo.Mutation<SuspendUserMutation, SuspendUserMutationVariables> {
    document = SuspendUserDocument;
    
  }
export const UnSuspendUserDocument = gql`
    mutation unSuspendUser($userId: String!) {
  unSuspendUser(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnSuspendUserGQL extends Apollo.Mutation<UnSuspendUserMutation, UnSuspendUserMutationVariables> {
    document = UnSuspendUserDocument;
    
  }
export const GetPermissionDocument = gql`
    query getPermission {
  getPermission
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPermissionGQL extends Apollo.Query<GetPermissionQuery, GetPermissionQueryVariables> {
    document = GetPermissionDocument;
    
  }
export const RoleListDocument = gql`
    query roleList {
  getRoles {
    id
    name
    permissions
    isDeletable
    userCountByRole
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleListGQL extends Apollo.Query<RoleListQuery, RoleListQueryVariables> {
    document = RoleListDocument;
    
  }
export const GetRolesByIdDocument = gql`
    query getRolesById($roleId: String!) {
  getRoleById(roleId: $roleId) {
    id
    name
    permissions
    permissionIds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRolesByIdGQL extends Apollo.Query<GetRolesByIdQuery, GetRolesByIdQueryVariables> {
    document = GetRolesByIdDocument;
    
  }
export const NewRoleDocument = gql`
    mutation newRole($roleName: String!, $permissionList: [String!]!) {
  newRole(roleName: $roleName, permissionList: $permissionList)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NewRoleGQL extends Apollo.Mutation<NewRoleMutation, NewRoleMutationVariables> {
    document = NewRoleDocument;
    
  }
export const DeleteRoleDocument = gql`
    mutation deleteRole($roleId: String!) {
  deleteRole(roleId: $roleId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRoleGQL extends Apollo.Mutation<DeleteRoleMutation, DeleteRoleMutationVariables> {
    document = DeleteRoleDocument;
    
  }
export const EditRoleDocument = gql`
    mutation editRole($roleId: String!, $roleName: String!, $permissionList: [PermissionInput!]!) {
  editRole(roleId: $roleId, roleName: $roleName, permissionList: $permissionList)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditRoleGQL extends Apollo.Mutation<EditRoleMutation, EditRoleMutationVariables> {
    document = EditRoleDocument;
    
  }
export const NonSuperUserListingDocument = gql`
    query nonSuperUserListing {
  userListing(isSuperUser: false, activeUserOnly: true) {
    ID
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NonSuperUserListingGQL extends Apollo.Query<NonSuperUserListingQuery, NonSuperUserListingQueryVariables> {
    document = NonSuperUserListingDocument;
    
  }
export const RoleListByProjectDocument = gql`
    query roleListByProject($projectId: String!) {
  getRoles {
    id
    name
    permissions
    users(projectId: $projectId) {
      ID
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleListByProjectGQL extends Apollo.Query<RoleListByProjectQuery, RoleListByProjectQueryVariables> {
    document = RoleListByProjectDocument;
    
  }
export const RoleAssignmentDocument = gql`
    mutation roleAssignment($input: ProjectUserRoleAssignmentInput!) {
  roleAssignment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RoleAssignmentGQL extends Apollo.Mutation<RoleAssignmentMutation, RoleAssignmentMutationVariables> {
    document = RoleAssignmentDocument;
    
  }
export const GetUserCountByProjectDocument = gql`
    query getUserCountByProject($roleId: String!) {
  getUserCountByProject(roleId: $roleId) {
    projectName
    userCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserCountByProjectGQL extends Apollo.Query<GetUserCountByProjectQuery, GetUserCountByProjectQueryVariables> {
    document = GetUserCountByProjectDocument;
    
  }
export const IsAllowAddUserDocument = gql`
    query isAllowAddUser {
  isAllowAddUser
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsAllowAddUserGQL extends Apollo.Query<IsAllowAddUserQuery, IsAllowAddUserQueryVariables> {
    document = IsAllowAddUserDocument;
    
  }
export const ResendEmailInvitationDocument = gql`
    mutation resendEmailInvitation($userId: String!) {
  resendInvitation(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendEmailInvitationGQL extends Apollo.Mutation<ResendEmailInvitationMutation, ResendEmailInvitationMutationVariables> {
    document = ResendEmailInvitationDocument;
    
  }
export const IsEmailExistDocument = gql`
    query isEmailExist($email: String!, $userId: String) {
  isEmailExist(email: $email, userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsEmailExistGQL extends Apollo.Query<IsEmailExistQuery, IsEmailExistQueryVariables> {
    document = IsEmailExistDocument;
    
  }
export const IsUserNameExistDocument = gql`
    query isUserNameExist($userName: String!, $userId: String) {
  isUserNameExist(userName: $userName, userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsUserNameExistGQL extends Apollo.Query<IsUserNameExistQuery, IsUserNameExistQueryVariables> {
    document = IsUserNameExistDocument;
    
  }
export const GetPlatformUsersDocument = gql`
    query getPlatformUsers {
  getPlatformUsers {
    ID
    name
    email
    commonStatus
    role
    commonStatus
    isActivated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlatformUsersGQL extends Apollo.Query<GetPlatformUsersQuery, GetPlatformUsersQueryVariables> {
    document = GetPlatformUsersDocument;
    
  }
export const SuspendPlatformUserDocument = gql`
    mutation suspendPlatformUser($userId: String!) {
  suspendPlatformUser(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuspendPlatformUserGQL extends Apollo.Mutation<SuspendPlatformUserMutation, SuspendPlatformUserMutationVariables> {
    document = SuspendPlatformUserDocument;
    
  }
export const UnsuspendPlatformUserDocument = gql`
    mutation unsuspendPlatformUser($userId: String!) {
  unsuspendPlatformUser(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnsuspendPlatformUserGQL extends Apollo.Mutation<UnsuspendPlatformUserMutation, UnsuspendPlatformUserMutationVariables> {
    document = UnsuspendPlatformUserDocument;
    
  }
export const ChangePlatformUserPasswordDocument = gql`
    mutation changePlatformUserPassword($userId: String!, $newPassword: String!, $confirmPassword: String!) {
  changePlatformUserPassword(
    userId: $userId
    newPassword: $newPassword
    confirmPassword: $confirmPassword
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePlatformUserPasswordGQL extends Apollo.Mutation<ChangePlatformUserPasswordMutation, ChangePlatformUserPasswordMutationVariables> {
    document = ChangePlatformUserPasswordDocument;
    
  }
export const GetPlatformUserByIdDocument = gql`
    query getPlatformUserById($userId: String!) {
  getPlatformUserById(userId: $userId) {
    ID
    name
    username
    email
    contactNo
    role
    isActivated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlatformUserByIdGQL extends Apollo.Query<GetPlatformUserByIdQuery, GetPlatformUserByIdQueryVariables> {
    document = GetPlatformUserByIdDocument;
    
  }
export const EditPlatformUserDocument = gql`
    mutation editPlatformUser($input: EditPlatformUserInput!) {
  editPlatformUser(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditPlatformUserGQL extends Apollo.Mutation<EditPlatformUserMutation, EditPlatformUserMutationVariables> {
    document = EditPlatformUserDocument;
    
  }
export const AddNewPlatformUserDocument = gql`
    mutation addNewPlatformUser($input: NewPlatformUserInput!) {
  addNewPlatformUser(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNewPlatformUserGQL extends Apollo.Mutation<AddNewPlatformUserMutation, AddNewPlatformUserMutationVariables> {
    document = AddNewPlatformUserDocument;
    
  }
export const IsPlatformUserEmailExistDocument = gql`
    query isPlatformUserEmailExist($email: String!, $userId: String) {
  isPlatformUserEmailExist(email: $email, userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsPlatformUserEmailExistGQL extends Apollo.Query<IsPlatformUserEmailExistQuery, IsPlatformUserEmailExistQueryVariables> {
    document = IsPlatformUserEmailExistDocument;
    
  }
export const IsPlatformUserNameExistDocument = gql`
    query isPlatformUserNameExist($userName: String!, $userId: String) {
  isPlatformUserNameExist(userName: $userName, userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsPlatformUserNameExistGQL extends Apollo.Query<IsPlatformUserNameExistQuery, IsPlatformUserNameExistQueryVariables> {
    document = IsPlatformUserNameExistDocument;
    
  }
export const GetAssignedAccoutListDocument = gql`
    query getAssignedAccoutList($userId: String!) {
  getAssignedAccoutList(userId: $userId) {
    id
    accountId
    platformUserId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssignedAccoutListGQL extends Apollo.Query<GetAssignedAccoutListQuery, GetAssignedAccoutListQueryVariables> {
    document = GetAssignedAccoutListDocument;
    
  }
export const AssignPlatformUserAccountDocument = gql`
    mutation assignPlatformUserAccount($platformUserId: String!, $accountId: String!) {
  assignPlatformUserAccount(
    platformUserId: $platformUserId
    accountId: $accountId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignPlatformUserAccountGQL extends Apollo.Mutation<AssignPlatformUserAccountMutation, AssignPlatformUserAccountMutationVariables> {
    document = AssignPlatformUserAccountDocument;
    
  }
export const UnassignPlatformUserAccountDocument = gql`
    mutation unassignPlatformUserAccount($platformUserId: String!, $accountId: String!) {
  unassignPlatformUserAccount(
    platformUserId: $platformUserId
    accountId: $accountId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnassignPlatformUserAccountGQL extends Apollo.Mutation<UnassignPlatformUserAccountMutation, UnassignPlatformUserAccountMutationVariables> {
    document = UnassignPlatformUserAccountDocument;
    
  }
export const GetNonAdminAccountListDocument = gql`
    query getNonAdminAccountList($userId: String!) {
  getNonAdminAccountList(userId: $userId) {
    ID
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNonAdminAccountListGQL extends Apollo.Query<GetNonAdminAccountListQuery, GetNonAdminAccountListQueryVariables> {
    document = GetNonAdminAccountListDocument;
    
  }
export const AssignPlatformUserAccountsDocument = gql`
    mutation assignPlatformUserAccounts($platformUserId: String!, $accountIds: [String!]!) {
  assignPlatformUserAccounts(
    platformUserId: $platformUserId
    accountIds: $accountIds
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignPlatformUserAccountsGQL extends Apollo.Mutation<AssignPlatformUserAccountsMutation, AssignPlatformUserAccountsMutationVariables> {
    document = AssignPlatformUserAccountsDocument;
    
  }
export const UnassignPlatformUserAccountsDocument = gql`
    mutation unassignPlatformUserAccounts($platformUserId: String!, $accountIds: [String!]!) {
  unassignPlatformUserAccounts(
    platformUserId: $platformUserId
    accountIds: $accountIds
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnassignPlatformUserAccountsGQL extends Apollo.Mutation<UnassignPlatformUserAccountsMutation, UnassignPlatformUserAccountsMutationVariables> {
    document = UnassignPlatformUserAccountsDocument;
    
  }
export const CheckPlatformUserIsAdminDocument = gql`
    query checkPlatformUserIsAdmin($userId: String!) {
  checkPlatformUserIsAdmin(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckPlatformUserIsAdminGQL extends Apollo.Query<CheckPlatformUserIsAdminQuery, CheckPlatformUserIsAdminQueryVariables> {
    document = CheckPlatformUserIsAdminDocument;
    
  }
export const ResendPlatformUserInvitationDocument = gql`
    mutation resendPlatformUserInvitation($userId: String!) {
  resendPlatformUserInvitation(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendPlatformUserInvitationGQL extends Apollo.Mutation<ResendPlatformUserInvitationMutation, ResendPlatformUserInvitationMutationVariables> {
    document = ResendPlatformUserInvitationDocument;
    
  }
export const LoginDocument = gql`
    query login($LoginId: String!, $Password: String!) {
  login(LoginId: $LoginId, Password: $Password)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Query<LoginQuery, LoginQueryVariables> {
    document = LoginDocument;
    
  }
export const LogoutDocument = gql`
    query logout {
  logout
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogoutGQL extends Apollo.Query<LogoutQuery, LogoutQueryVariables> {
    document = LogoutDocument;
    
  }
export const AccountNameDocument = gql`
    query accountName {
  getAccountName
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AccountNameGQL extends Apollo.Query<AccountNameQuery, AccountNameQueryVariables> {
    document = AccountNameDocument;
    
  }
export const GetAccountListDocument = gql`
    query getAccountList {
  getAccountList {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccountListGQL extends Apollo.Query<GetAccountListQuery, GetAccountListQueryVariables> {
    document = GetAccountListDocument;
    
  }
export const PasswordPolicyDocument = gql`
    query passwordPolicy {
  passswordPolicy {
    RequiredLength
    RequiredUniqueChars
    RequireNonAlphanumeric
    RequireLowercase
    RequireUppercase
    RequireDigit
    ErrorMsg {
      RequiredLength
      RequiredUniqueChars
      RequireNonAlphanumeric
      RequireLowercase
      RequireUppercase
      RequireDigit
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PasswordPolicyGQL extends Apollo.Query<PasswordPolicyQuery, PasswordPolicyQueryVariables> {
    document = PasswordPolicyDocument;
    
  }
export const UnblockUserDocument = gql`
    mutation unblockUser($userId: String!, $newPassword: String!, $confirmPassword: String!) {
  unblockUser(
    userId: $userId
    newPassword: $newPassword
    confirmPassword: $confirmPassword
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnblockUserGQL extends Apollo.Mutation<UnblockUserMutation, UnblockUserMutationVariables> {
    document = UnblockUserDocument;
    
  }
export const SwitchAccountDocument = gql`
    query switchAccount($accountID: String!) {
  refreshToken(accountID: $accountID)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SwitchAccountGQL extends Apollo.Query<SwitchAccountQuery, SwitchAccountQueryVariables> {
    document = SwitchAccountDocument;
    
  }
export const GetPlatformUserProfileDocument = gql`
    query getPlatformUserProfile {
  getPlatformUserProfile {
    ID
    name
    username
    email
    contactNo
    role
    avatar
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPlatformUserProfileGQL extends Apollo.Query<GetPlatformUserProfileQuery, GetPlatformUserProfileQueryVariables> {
    document = GetPlatformUserProfileDocument;
    
  }
export const ChangePlatformUserPasswordInProfileDocument = gql`
    mutation changePlatformUserPasswordInProfile($currentPassword: String!, $newPassword: String!, $confirmPassword: String!) {
  changePlatformUserPasswordInProfile(
    currentPassword: $currentPassword
    newPassword: $newPassword
    confirmPassword: $confirmPassword
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangePlatformUserPasswordInProfileGQL extends Apollo.Mutation<ChangePlatformUserPasswordInProfileMutation, ChangePlatformUserPasswordInProfileMutationVariables> {
    document = ChangePlatformUserPasswordInProfileDocument;
    
  }
export const UpdatePlatformUserProfileDocument = gql`
    mutation updatePlatformUserProfile($input: UpdatePlatformUserProfileInput!) {
  updatePlatformUserProfile(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePlatformUserProfileGQL extends Apollo.Mutation<UpdatePlatformUserProfileMutation, UpdatePlatformUserProfileMutationVariables> {
    document = UpdatePlatformUserProfileDocument;
    
  }
export const CountryDocument = gql`
    query country {
  GetAllMasterInfo {
    Countries {
      ID
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CountryGQL extends Apollo.Query<CountryQuery, CountryQueryVariables> {
    document = CountryDocument;
    
  }
export const StateDocument = gql`
    query state($countryId: String!) {
  GetStatesByCountry(countryId: $countryId) {
    ID
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StateGQL extends Apollo.Query<StateQuery, StateQueryVariables> {
    document = StateDocument;
    
  }
export const CityDocument = gql`
    query city($stateId: String!) {
  GetCitiesByState(stateId: $stateId) {
    ID
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CityGQL extends Apollo.Query<CityQuery, CityQueryVariables> {
    document = CityDocument;
    
  }
export const PostcodeDocument = gql`
    query postcode($cityId: String!) {
  GetPostcodeByCity(cityId: $cityId) {
    ID
    postcode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PostcodeGQL extends Apollo.Query<PostcodeQuery, PostcodeQueryVariables> {
    document = PostcodeDocument;
    
  }
export const GetAllAppointmentTypeDocument = gql`
    query getAllAppointmentType {
  getAllAppointmentType {
    id
    name
    seqNo
    defaulted
    systemUse
    commonStatus
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllAppointmentTypeGQL extends Apollo.Query<GetAllAppointmentTypeQuery, GetAllAppointmentTypeQueryVariables> {
    document = GetAllAppointmentTypeDocument;
    
  }
export const AddAppointmentTypeDocument = gql`
    mutation addAppointmentType($appointmentName: String!) {
  addAppointmentType(appointmentName: $appointmentName)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddAppointmentTypeGQL extends Apollo.Mutation<AddAppointmentTypeMutation, AddAppointmentTypeMutationVariables> {
    document = AddAppointmentTypeDocument;
    
  }
export const EditAppointmentTypeDocument = gql`
    mutation editAppointmentType($appointmentName: String!, $appointmentId: String!) {
  editAppointmentType(
    appointmentId: $appointmentId
    appointmentName: $appointmentName
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditAppointmentTypeGQL extends Apollo.Mutation<EditAppointmentTypeMutation, EditAppointmentTypeMutationVariables> {
    document = EditAppointmentTypeDocument;
    
  }
export const SetDefaultAppointmentTypeDocument = gql`
    mutation setDefaultAppointmentType($appointmentId: String!) {
  setDefaultAppointmentType(appointmentId: $appointmentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultAppointmentTypeGQL extends Apollo.Mutation<SetDefaultAppointmentTypeMutation, SetDefaultAppointmentTypeMutationVariables> {
    document = SetDefaultAppointmentTypeDocument;
    
  }
export const DeleteAppointmentTypeDocument = gql`
    mutation deleteAppointmentType($appointmentId: String!) {
  deleteAppointmentType(appointmentId: $appointmentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAppointmentTypeGQL extends Apollo.Mutation<DeleteAppointmentTypeMutation, DeleteAppointmentTypeMutationVariables> {
    document = DeleteAppointmentTypeDocument;
    
  }
export const DeactivateAppointmentTypeDocument = gql`
    mutation deactivateAppointmentType($appointmentId: String!) {
  deactivateAppointmentType(appointmentId: $appointmentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateAppointmentTypeGQL extends Apollo.Mutation<DeactivateAppointmentTypeMutation, DeactivateAppointmentTypeMutationVariables> {
    document = DeactivateAppointmentTypeDocument;
    
  }
export const OrganizeAppointmentTypeDocument = gql`
    mutation organizeAppointmentType($appointmentId: [String!]!) {
  organizeAppointmentType(appointmentId: $appointmentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeAppointmentTypeGQL extends Apollo.Mutation<OrganizeAppointmentTypeMutation, OrganizeAppointmentTypeMutationVariables> {
    document = OrganizeAppointmentTypeDocument;
    
  }
export const RemoveDefaultAppointmentTypeDocument = gql`
    mutation removeDefaultAppointmentType($appointmentId: String!) {
  removeDefaultAppointmentType(appointmentId: $appointmentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultAppointmentTypeGQL extends Apollo.Mutation<RemoveDefaultAppointmentTypeMutation, RemoveDefaultAppointmentTypeMutationVariables> {
    document = RemoveDefaultAppointmentTypeDocument;
    
  }
export const CampaignDataDocument = gql`
    query campaignData {
  getCampaignList {
    name
    id
    startDate
    endDate
    getCampaignEventsCount
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CampaignDataGQL extends Apollo.Query<CampaignDataQuery, CampaignDataQueryVariables> {
    document = CampaignDataDocument;
    
  }
export const CampaignDataByIdDocument = gql`
    query campaignDataById($campaign_id: String!) {
  getCampaignById(campaignId: $campaign_id) {
    name
    id
    startDate
    endDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CampaignDataByIdGQL extends Apollo.Query<CampaignDataByIdQuery, CampaignDataByIdQueryVariables> {
    document = CampaignDataByIdDocument;
    
  }
export const GetEventsbyCampaignDocument = gql`
    query getEventsbyCampaign($campaign_id: String!) {
  getEventsListByCampaign(campaignId: $campaign_id) {
    events {
      id
      name
      desc
      startDate
      endDate
      budget
      isDeletable
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventsbyCampaignGQL extends Apollo.Query<GetEventsbyCampaignQuery, GetEventsbyCampaignQueryVariables> {
    document = GetEventsbyCampaignDocument;
    
  }
export const GetEventsDetailsDocument = gql`
    query getEventsDetails($events_id: String!) {
  getEventsDetails(eventsId: $events_id) {
    name
    desc
    website
    location
    startDate
    endDate
    budget
    campaignId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventsDetailsGQL extends Apollo.Query<GetEventsDetailsQuery, GetEventsDetailsQueryVariables> {
    document = GetEventsDetailsDocument;
    
  }
export const GetEventsEditDetailsDocument = gql`
    query getEventsEditDetails($events_id: String!, $campaign_id: String!) {
  getEventsDetails(eventsId: $events_id) {
    name
    desc
    website
    location
    startDate
    endDate
    budget
  }
  getCampaignById(campaignId: $campaign_id) {
    startDate
    endDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventsEditDetailsGQL extends Apollo.Query<GetEventsEditDetailsQuery, GetEventsEditDetailsQueryVariables> {
    document = GetEventsEditDetailsDocument;
    
  }
export const AddEventsDocument = gql`
    mutation addEvents($input: AdminEventsInput!) {
  addEvents(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddEventsGQL extends Apollo.Mutation<AddEventsMutation, AddEventsMutationVariables> {
    document = AddEventsDocument;
    
  }
export const EditEventsDocument = gql`
    mutation editEvents($input: AdminEventsInput!) {
  editEvents(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditEventsGQL extends Apollo.Mutation<EditEventsMutation, EditEventsMutationVariables> {
    document = EditEventsDocument;
    
  }
export const AddCampaignDocument = gql`
    mutation addCampaign($input: AdminCampaignInput!) {
  addCampaign(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCampaignGQL extends Apollo.Mutation<AddCampaignMutation, AddCampaignMutationVariables> {
    document = AddCampaignDocument;
    
  }
export const EditCampaignDocument = gql`
    mutation editCampaign($input: AdminCampaignInput!) {
  editCampaign(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditCampaignGQL extends Apollo.Mutation<EditCampaignMutation, EditCampaignMutationVariables> {
    document = EditCampaignDocument;
    
  }
export const DeleteCampaignDocument = gql`
    mutation deleteCampaign($campaignID: String!) {
  deleteCampaignById(campaignId: $campaignID)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCampaignGQL extends Apollo.Mutation<DeleteCampaignMutation, DeleteCampaignMutationVariables> {
    document = DeleteCampaignDocument;
    
  }
export const DeleteEventsDocument = gql`
    mutation deleteEvents($eventsID: String!) {
  deleteEventsById(eventsId: $eventsID)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEventsGQL extends Apollo.Mutation<DeleteEventsMutation, DeleteEventsMutationVariables> {
    document = DeleteEventsDocument;
    
  }
export const GetAllDirectionDocument = gql`
    query getAllDirection {
  getAllDirection {
    id
    name
    commonStatus
    defaulted
    seq_no
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDirectionGQL extends Apollo.Query<GetAllDirectionQuery, GetAllDirectionQueryVariables> {
    document = GetAllDirectionDocument;
    
  }
export const EditDirectionDocument = gql`
    mutation editDirection($input: EditDirectionInput!) {
  editDirection(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditDirectionGQL extends Apollo.Mutation<EditDirectionMutation, EditDirectionMutationVariables> {
    document = EditDirectionDocument;
    
  }
export const AddDirectionDocument = gql`
    mutation addDirection($input: DirectionInput!) {
  addDirection(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddDirectionGQL extends Apollo.Mutation<AddDirectionMutation, AddDirectionMutationVariables> {
    document = AddDirectionDocument;
    
  }
export const DeleteDirectionByIdDocument = gql`
    mutation deleteDirectionById($directionId: String!) {
  deleteDirectionById(directionId: $directionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDirectionByIdGQL extends Apollo.Mutation<DeleteDirectionByIdMutation, DeleteDirectionByIdMutationVariables> {
    document = DeleteDirectionByIdDocument;
    
  }
export const SetDefaultDirectionDocument = gql`
    mutation setDefaultDirection($directionId: String!) {
  setDefaultDirection(directionId: $directionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultDirectionGQL extends Apollo.Mutation<SetDefaultDirectionMutation, SetDefaultDirectionMutationVariables> {
    document = SetDefaultDirectionDocument;
    
  }
export const RemoveDefaultDirectionDocument = gql`
    mutation removeDefaultDirection($directionId: String!) {
  removeDefaultDirection(directionId: $directionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultDirectionGQL extends Apollo.Mutation<RemoveDefaultDirectionMutation, RemoveDefaultDirectionMutationVariables> {
    document = RemoveDefaultDirectionDocument;
    
  }
export const OrganizeDirectionDocument = gql`
    mutation organizeDirection($directionId: [String!]!) {
  organizeDirection(directionId: $directionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeDirectionGQL extends Apollo.Mutation<OrganizeDirectionMutation, OrganizeDirectionMutationVariables> {
    document = OrganizeDirectionDocument;
    
  }
export const GetAllDiscountDocument = gql`
    query getAllDiscount {
  getAllDiscount {
    id
    discountTypeId
    title
    description
    formula
    prefix
    isIntegrated
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllDiscountGQL extends Apollo.Query<GetAllDiscountQuery, GetAllDiscountQueryVariables> {
    document = GetAllDiscountDocument;
    
  }
export const GetDiscountByIdDocument = gql`
    query getDiscountById($discountId: String!) {
  getDiscountById(discountId: $discountId) {
    title
    formula
    id
    discountTypeId
    prefix
    description
    discountVal
    isIntegrated
  }
  GetAllMasterInfo {
    DiscountType {
      id
      name
    }
    DiscountPrefix
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDiscountByIdGQL extends Apollo.Query<GetDiscountByIdQuery, GetDiscountByIdQueryVariables> {
    document = GetDiscountByIdDocument;
    
  }
export const EditDiscountDocument = gql`
    mutation editDiscount($input: EditDiscountInput!) {
  editDiscount(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditDiscountGQL extends Apollo.Mutation<EditDiscountMutation, EditDiscountMutationVariables> {
    document = EditDiscountDocument;
    
  }
export const GetDiscountMasterInfoDocument = gql`
    query getDiscountMasterInfo {
  GetAllMasterInfo {
    DiscountType {
      id
      name
    }
    DiscountPrefix
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDiscountMasterInfoGQL extends Apollo.Query<GetDiscountMasterInfoQuery, GetDiscountMasterInfoQueryVariables> {
    document = GetDiscountMasterInfoDocument;
    
  }
export const DeleteDiscountDocument = gql`
    mutation deleteDiscount($discountId: String!) {
  deleteDiscount(discountId: $discountId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDiscountGQL extends Apollo.Mutation<DeleteDiscountMutation, DeleteDiscountMutationVariables> {
    document = DeleteDiscountDocument;
    
  }
export const SyncIntegrateDiscountDocument = gql`
    mutation syncIntegrateDiscount {
  syncIntegrateDiscount
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncIntegrateDiscountGQL extends Apollo.Mutation<SyncIntegrateDiscountMutation, SyncIntegrateDiscountMutationVariables> {
    document = SyncIntegrateDiscountDocument;
    
  }
export const AddDiscountDocument = gql`
    mutation addDiscount($input: DiscountInput!) {
  addDiscount(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddDiscountGQL extends Apollo.Mutation<AddDiscountMutation, AddDiscountMutationVariables> {
    document = AddDiscountDocument;
    
  }
export const GetDiscountAssignedByProjectIdDocument = gql`
    query getDiscountAssignedByProjectId($projectId: String!) {
  getDiscountAssignedByProjectId(projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDiscountAssignedByProjectIdGQL extends Apollo.Query<GetDiscountAssignedByProjectIdQuery, GetDiscountAssignedByProjectIdQueryVariables> {
    document = GetDiscountAssignedByProjectIdDocument;
    
  }
export const AssignDiscountDocument = gql`
    mutation assignDiscount($input: assignDiscountInput!) {
  assignDiscount(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignDiscountGQL extends Apollo.Mutation<AssignDiscountMutation, AssignDiscountMutationVariables> {
    document = AssignDiscountDocument;
    
  }
export const EditAssignDiscountDocument = gql`
    mutation editAssignDiscount($input: assignDiscountInput!) {
  editAssignDiscount(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditAssignDiscountGQL extends Apollo.Mutation<EditAssignDiscountMutation, EditAssignDiscountMutationVariables> {
    document = EditAssignDiscountDocument;
    
  }
export const UnassignDiscountDocument = gql`
    mutation unassignDiscount($projectId: String!, $discountId: String!) {
  unassignDiscount(projectId: $projectId, discountId: $discountId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnassignDiscountGQL extends Apollo.Mutation<UnassignDiscountMutation, UnassignDiscountMutationVariables> {
    document = UnassignDiscountDocument;
    
  }
export const GetAssignedDiscountByIdDocument = gql`
    query getAssignedDiscountById($discountId: String!, $projectId: String!) {
  getAssignedDiscountById(discountId: $discountId, projectId: $projectId) {
    id
    effectiveDate
    expired_date
    projectId
    discountId
    discount {
      id
      title
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssignedDiscountByIdGQL extends Apollo.Query<GetAssignedDiscountByIdQuery, GetAssignedDiscountByIdQueryVariables> {
    document = GetAssignedDiscountByIdDocument;
    
  }
export const GetAssignDiscountFormSourceDocument = gql`
    query getAssignDiscountFormSource($projectId: String!) {
  getAssignDiscountFormSource(projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssignDiscountFormSourceGQL extends Apollo.Query<GetAssignDiscountFormSourceQuery, GetAssignDiscountFormSourceQueryVariables> {
    document = GetAssignDiscountFormSourceDocument;
    
  }
export const SetDefaultDiscountForProjectDocument = gql`
    mutation setDefaultDiscountForProject($discountId: String!, $projectId: String!) {
  setDefaultDiscountForProject(discountId: $discountId, projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultDiscountForProjectGQL extends Apollo.Mutation<SetDefaultDiscountForProjectMutation, SetDefaultDiscountForProjectMutationVariables> {
    document = SetDefaultDiscountForProjectDocument;
    
  }
export const UnmarkDefaultDiscountForProjectDocument = gql`
    mutation unmarkDefaultDiscountForProject($discountId: String!, $projectId: String!) {
  unmarkDefaultDiscountForProject(discountId: $discountId, projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnmarkDefaultDiscountForProjectGQL extends Apollo.Mutation<UnmarkDefaultDiscountForProjectMutation, UnmarkDefaultDiscountForProjectMutationVariables> {
    document = UnmarkDefaultDiscountForProjectDocument;
    
  }
export const GetELaunchListingDocument = gql`
    query getELaunchListing($projectId: String!) {
  getELaunchListing(projectId: $projectId) {
    id
    name
    publishDate
    startDate
    endDate
    terminationDate
    totalUnitAllocationCount
    totalBookedUnitAllocationCount
    totalInvitedPurchaserCount
    invitationTemplateId
    eLaunchLeadBatch {
      totalRegisteredLeadCount
      recordCount
    }
    hasEnded
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetELaunchListingGQL extends Apollo.Query<GetELaunchListingQuery, GetELaunchListingQueryVariables> {
    document = GetELaunchListingDocument;
    
  }
export const GetELaunchByIdDocument = gql`
    query getELaunchById($eLaunchId: String!) {
  getELaunchById(eLaunchId: $eLaunchId) {
    id
    name
    startDate
    endDate
    publishDate
    code
    terminationDate
    totalUnitAllocationCount
    totalBookedUnitAllocationCount
    totalInvitedPurchaserCount
    totalBookedUnit
    eLaunchLeadBatch {
      totalRegisteredLeadCount
      recordCount
    }
    hasEnded
    hasPublished
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetELaunchByIdGQL extends Apollo.Query<GetELaunchByIdQuery, GetELaunchByIdQueryVariables> {
    document = GetELaunchByIdDocument;
    
  }
export const GetELaunchLinkDocument = gql`
    query getELaunchLink($eLaunchId: String!) {
  getELaunchLink(eLaunchId: $eLaunchId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetELaunchLinkGQL extends Apollo.Query<GetELaunchLinkQuery, GetELaunchLinkQueryVariables> {
    document = GetELaunchLinkDocument;
    
  }
export const AddELaunchDocument = gql`
    mutation addELaunch($input: ELaunchInput!) {
  addELaunch(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddELaunchGQL extends Apollo.Mutation<AddELaunchMutation, AddELaunchMutationVariables> {
    document = AddELaunchDocument;
    
  }
export const EditELaunchDocument = gql`
    mutation editELaunch($input: ELaunchInput!) {
  editELaunch(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditELaunchGQL extends Apollo.Mutation<EditELaunchMutation, EditELaunchMutationVariables> {
    document = EditELaunchDocument;
    
  }
export const IsELaunchCodeExistDocument = gql`
    query isELaunchCodeExist($code: String!, $eLaunchID: String) {
  isELaunchCodeExist(code: $code, eLaunchID: $eLaunchID)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsELaunchCodeExistGQL extends Apollo.Query<IsELaunchCodeExistQuery, IsELaunchCodeExistQueryVariables> {
    document = IsELaunchCodeExistDocument;
    
  }
export const DeleteELaunchDocument = gql`
    mutation deleteELaunch($eLaunchId: String!) {
  deleteELaunch(eLaunchId: $eLaunchId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteELaunchGQL extends Apollo.Mutation<DeleteELaunchMutation, DeleteELaunchMutationVariables> {
    document = DeleteELaunchDocument;
    
  }
export const GetAllocatedUnitsByELaunchIdDocument = gql`
    query getAllocatedUnitsByELaunchId($projectId: String!, $eLaunchId: String!, $block: String!) {
  getELaunchById(eLaunchId: $eLaunchId) {
    name
    startDate
    endDate
  }
  getAllocatedUnitsByELaunchId(
    projectId: $projectId
    eLaunchId: $eLaunchId
    block: $block
  ) {
    unit_id
    unit_no
    unit_status
    unit_type
    price
    floor
    floor_label
    cell
    status
    favouriteCount(eLaunchId: $eLaunchId)
    unitType
    isBumi
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllocatedUnitsByELaunchIdGQL extends Apollo.Query<GetAllocatedUnitsByELaunchIdQuery, GetAllocatedUnitsByELaunchIdQueryVariables> {
    document = GetAllocatedUnitsByELaunchIdDocument;
    
  }
export const GetELaunchUnitAllocationSummaryDocument = gql`
    query getELaunchUnitAllocationSummary($elaunchId: String!) {
  getELaunchById(eLaunchId: $elaunchId) {
    name
    startDate
    endDate
  }
  getELaunchUnitAllocationSummary(elaunchId: $elaunchId) {
    block
    count
    unitType
    favouriteCount
    bookedCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetELaunchUnitAllocationSummaryGQL extends Apollo.Query<GetELaunchUnitAllocationSummaryQuery, GetELaunchUnitAllocationSummaryQueryVariables> {
    document = GetELaunchUnitAllocationSummaryDocument;
    
  }
export const GetELaunchUnitAllocationDocument = gql`
    query getELaunchUnitAllocation($block: String!, $eLaunchId: String!) {
  getELaunchById(eLaunchId: $eLaunchId) {
    name
  }
  getAllocatedUnitsByBlock(block: $block, elaunchId: $eLaunchId) {
    unit {
      id
      unitNo
      unitStatus
    }
    totalFavouriteCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetELaunchUnitAllocationGQL extends Apollo.Query<GetELaunchUnitAllocationQuery, GetELaunchUnitAllocationQueryVariables> {
    document = GetELaunchUnitAllocationDocument;
    
  }
export const UpdateELaunchAllocationDocument = gql`
    mutation updateELaunchAllocation($input: ELaunchAllocationInput!) {
  updateELaunchAllocation(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateELaunchAllocationGQL extends Apollo.Mutation<UpdateELaunchAllocationMutation, UpdateELaunchAllocationMutationVariables> {
    document = UpdateELaunchAllocationDocument;
    
  }
export const GetELaunchRegisteredPurchaserDocument = gql`
    query getELaunchRegisteredPurchaser($search: String, $eLaunchId: String!) {
  getRegisteredPurchaserListing(search: $search, eLaunchId: $eLaunchId) {
    userId
    name
    email
    phone
    unitFavouriteAndBookedCount(eLaunchId: $eLaunchId)
    isLead
    favouriteAndBookedUnits(eLaunchId: $eLaunchId) {
      favouriteUnits
      bookedUnits
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetELaunchRegisteredPurchaserGQL extends Apollo.Query<GetELaunchRegisteredPurchaserQuery, GetELaunchRegisteredPurchaserQueryVariables> {
    document = GetELaunchRegisteredPurchaserDocument;
    
  }
export const GetRegisteredPurchaserDetailsByIdDocument = gql`
    query getRegisteredPurchaserDetailsById($userId: String!, $eLaunchId: String!) {
  getRegisteredPurchaserDetailsById(userId: $userId, eLaunchId: $eLaunchId) {
    purchaserDetail {
      name
      email
      phone
      isLead
    }
    favouriteUnits
    bookedUnits {
      unitNo
      saleId
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegisteredPurchaserDetailsByIdGQL extends Apollo.Query<GetRegisteredPurchaserDetailsByIdQuery, GetRegisteredPurchaserDetailsByIdQueryVariables> {
    document = GetRegisteredPurchaserDetailsByIdDocument;
    
  }
export const GetBusinessInsightSummaryDataDocument = gql`
    query getBusinessInsightSummaryData {
  getMostFavouriteUnit {
    totalFavourite
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBusinessInsightSummaryDataGQL extends Apollo.Query<GetBusinessInsightSummaryDataQuery, GetBusinessInsightSummaryDataQueryVariables> {
    document = GetBusinessInsightSummaryDataDocument;
    
  }
export const GetMostFavouriteUnitDocument = gql`
    query getMostFavouriteUnit {
  getMostFavouriteUnit {
    favouriteUnit {
      unitNo
      count
    }
    favouriteUnitType {
      unitType
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMostFavouriteUnitGQL extends Apollo.Query<GetMostFavouriteUnitQuery, GetMostFavouriteUnitQueryVariables> {
    document = GetMostFavouriteUnitDocument;
    
  }
export const GetPurchaserDemoFilterDocument = gql`
    query getPurchaserDemoFilter {
  getPurchaserDemoFilter {
    propertyType
    unitLayout {
      propertyType
      unitLayout {
        propertyTypeId
        unitLayoutId
        unitLayoutDesc
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPurchaserDemoFilterGQL extends Apollo.Query<GetPurchaserDemoFilterQuery, GetPurchaserDemoFilterQueryVariables> {
    document = GetPurchaserDemoFilterDocument;
    
  }
export const GetPurchaserDemographicDataDocument = gql`
    query getPurchaserDemographicData($unitLayoutId: String, $propertyTypeId: String) {
  getRaceBI(unitLayoutId: $unitLayoutId, propertyTypeId: $propertyTypeId) {
    name
    value
  }
  getNationalityBI(unitLayoutId: $unitLayoutId, propertyTypeId: $propertyTypeId) {
    name
    value
  }
  getAgeBI(unitLayoutId: $unitLayoutId, propertyTypeId: $propertyTypeId) {
    name
    value
  }
  getLocationBI(unitLayoutId: $unitLayoutId, propertyTypeId: $propertyTypeId) {
    name
    value
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPurchaserDemographicDataGQL extends Apollo.Query<GetPurchaserDemographicDataQuery, GetPurchaserDemographicDataQueryVariables> {
    document = GetPurchaserDemographicDataDocument;
    
  }
export const ExportPurchaserDocument = gql`
    query exportPurchaser($startDate: DateTime!, $endDate: DateTime!) {
  exportPurchaser(startDate: $startDate, endDate: $endDate) {
    base64
    projectName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportPurchaserGQL extends Apollo.Query<ExportPurchaserQuery, ExportPurchaserQueryVariables> {
    document = ExportPurchaserDocument;
    
  }
export const GetBookingDetailDataDocument = gql`
    query getBookingDetailData($saleId: String!, $projectId: String!) {
  getBookingDetailData(saleId: $saleId, projectId: $projectId) {
    cancelledDate
    cancelledReason
    cancelledByName
    buyerCompanyName
    buyerCompanyRegNo
    buyerName
    buyerNric
    salesId
    salesStatus
    attachmentCount {
      isAttachmentComplete
      requiredDocCount
      completedDocCount
    }
    salePaymentId
    isjointBuyerComplete
    isPurchaserInfoComplete
    buyerPhoneNo
    buyerEmail
    salesNo
    unitNo
    unitLayout
    unitLayoutDes
    landArea
    extraLandArea
    builtUp
    isCompany
    buyerCompanyName
    sellingPrice
    listPrice
    paymentMethod
    buyerId
    unitId
    joinBuyer {
      contact {
        fullName
      }
    }
    bookingRemark
    personName
    teamName
    agencyName
    agencyUserName
  }
  GetBookingDetail(sale_id: $saleId) {
    loanScreening {
      caseCode
      status
      CCRIS
      CTOS
      createdDate
      modifiedDate
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBookingDetailDataGQL extends Apollo.Query<GetBookingDetailDataQuery, GetBookingDetailDataQueryVariables> {
    document = GetBookingDetailDataDocument;
    
  }
export const BookingAttachmentsDocument = gql`
    query bookingAttachments($saleId: String!) {
  GetBookingDetail(sale_id: $saleId) {
    id
    salesStatus
    sellingPrice
    salesPerson
    bookDate
    contact {
      id
      fullName
      companyName
      nationality {
        name
      }
    }
    unit {
      id
      unitNo
      price
      projectSpec {
        bookingPDPAconsentRequired
      }
    }
    bookingAttachments {
      bookingCcrAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
      bookingNricAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
      bookingFeeAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
      bookingPdpaAttachments {
        id
        accountId
        refTable
        refId
        refType
        mediaType
        resourceUrl
        fileName
        bucketFileName
        isPrivate
        seqNo
        allowDelete
      }
    }
    loanScreeningReports {
      refType
      mediaType
      resourceUrl
      fileName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BookingAttachmentsGQL extends Apollo.Query<BookingAttachmentsQuery, BookingAttachmentsQueryVariables> {
    document = BookingAttachmentsDocument;
    
  }
export const JointBuyerDetailsDocument = gql`
    query jointBuyerDetails($sale_id: String!) {
  GetBookingDetail(sale_id: $sale_id) {
    id
    bookDate
    salesStatus
    sellingPrice
    unit {
      id
      unitNo
      price
    }
    contact {
      id
      fullName
      companyName
    }
    salesPerson
    joinBuyer {
      id
      commonStatus
      contact {
        id
        fullName
        phoneNo
        email
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JointBuyerDetailsGQL extends Apollo.Query<JointBuyerDetailsQuery, JointBuyerDetailsQueryVariables> {
    document = JointBuyerDetailsDocument;
    
  }
export const DownloadAttachmentDocument = gql`
    mutation downloadAttachment($input: SalesDownloadAttachmentInput!) {
  downloadAttachment(input: $input) {
    content
    fileName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DownloadAttachmentGQL extends Apollo.Mutation<DownloadAttachmentMutation, DownloadAttachmentMutationVariables> {
    document = DownloadAttachmentDocument;
    
  }
export const SendDocEmailToELaunchLeadDocument = gql`
    mutation sendDocEmailToELaunchLead($recipients: [String!]!, $contactIds: [String!]!, $projectId: String!, $message: String!, $subject: String!) {
  sendDocEmailToELaunchLead(
    recipients: $recipients
    contactIds: $contactIds
    projectId: $projectId
    message: $message
    subject: $subject
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendDocEmailToELaunchLeadGQL extends Apollo.Mutation<SendDocEmailToELaunchLeadMutation, SendDocEmailToELaunchLeadMutationVariables> {
    document = SendDocEmailToELaunchLeadDocument;
    
  }
export const OpenLeadDownloadTemplateDocument = gql`
    query openLeadDownloadTemplate {
  downloadLeadTemplate {
    file_name
    file
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OpenLeadDownloadTemplateGQL extends Apollo.Query<OpenLeadDownloadTemplateQuery, OpenLeadDownloadTemplateQueryVariables> {
    document = OpenLeadDownloadTemplateDocument;
    
  }
export const ExtractImportedLeadToExcelDocument = gql`
    query extractImportedLeadToExcel($eLaunchBatchId: String!) {
  extractImportedLeadToExcel(eLaunchBatchId: $eLaunchBatchId) {
    file_name
    file
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExtractImportedLeadToExcelGQL extends Apollo.Query<ExtractImportedLeadToExcelQuery, ExtractImportedLeadToExcelQueryVariables> {
    document = ExtractImportedLeadToExcelDocument;
    
  }
export const GetLeadByELauchIdDocument = gql`
    query getLeadByELauchId($eLaunchId: String!) {
  getLeadByELaunchId(eLaunchId: $eLaunchId) {
    contactId
    fullName
    email
    phoneNo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeadByELauchIdGQL extends Apollo.Query<GetLeadByELauchIdQuery, GetLeadByELauchIdQueryVariables> {
    document = GetLeadByELauchIdDocument;
    
  }
export const GetELaunchLeadBatchListDocument = gql`
    query getELaunchLeadBatchList($eLaunchId: String!) {
  getELaunchLeadBatchList(eLaunchId: $eLaunchId) {
    eLaunchId
    eLaunchName
    totalImportedLead
    totalRegisteredLead
    leadBatchs
    endDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetELaunchLeadBatchListGQL extends Apollo.Query<GetELaunchLeadBatchListQuery, GetELaunchLeadBatchListQueryVariables> {
    document = GetELaunchLeadBatchListDocument;
    
  }
export const LeadsByBatchDocument = gql`
    query LeadsByBatch($batchId: String!, $page: Float!, $limit: Float!, $search: String) {
  LeadsByBatch(batch_id: $batchId, limit: $limit, page: $page, search: $search) {
    id
    batchTitle
    createdTs
    isExpired
    recordCount
    leadData {
      full_name
      gender
      phone_no
      email
      lead_source
      isRegistered
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LeadsByBatchGQL extends Apollo.Query<LeadsByBatchQuery, LeadsByBatchQueryVariables> {
    document = LeadsByBatchDocument;
    
  }
export const GetExistingLeadsDocument = gql`
    query getExistingLeads($projectId: String!, $eLaunchId: String!, $leadStatusFilter: String, $salesPersonFilter: String, $limitFilter: [String!]) {
  getExistingLeads(
    projectId: $projectId
    eLaunchId: $eLaunchId
    leadStatusFilter: $leadStatusFilter
    salesPersonFilter: $salesPersonFilter
    limitFilter: $limitFilter
  ) {
    total
    openTotal
    hotTotal
    coldTotal
    dropTotal
    waitingListTotal
    soldTotal
    signTotal
    reservedTotal
    data {
      id
      sales_person_id
      sales_person_name
      contact_id
      full_name
      lead_status
      lead_source
      event_name
      activity_date
      activity_desc
      follow_up_remark
      follow_up_date
      email
      phone_no
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExistingLeadsGQL extends Apollo.Query<GetExistingLeadsQuery, GetExistingLeadsQueryVariables> {
    document = GetExistingLeadsDocument;
    
  }
export const ImportExistingLeadsDocument = gql`
    mutation importExistingLeads($contactIds: [String!]!, $eLaunchId: String!, $batchTitle: String!, $projectId: String!) {
  importExistingLeads(
    contactIds: $contactIds
    eLaunchId: $eLaunchId
    batchTitle: $batchTitle
    projectId: $projectId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportExistingLeadsGQL extends Apollo.Mutation<ImportExistingLeadsMutation, ImportExistingLeadsMutationVariables> {
    document = ImportExistingLeadsDocument;
    
  }
export const OpenLeadImportLeadsDocument = gql`
    mutation openLeadImportLeads($batchTitle: String!, $projectId: String!, $eLaunchId: String!, $file: Upload!) {
  ImportLeads(
    batchTitle: $batchTitle
    projectId: $projectId
    eLaunchId: $eLaunchId
    file: $file
  ) {
    file
    file_name
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OpenLeadImportLeadsGQL extends Apollo.Mutation<OpenLeadImportLeadsMutation, OpenLeadImportLeadsMutationVariables> {
    document = OpenLeadImportLeadsDocument;
    
  }
export const GetLeadByContactIdDocument = gql`
    query getLeadByContactId($contactId: String!) {
  getLeadByContactId(contactId: $contactId) {
    fullName
    email
    gender
    phoneNo
    icNo
    salutation {
      name
    }
    nationality {
      name
    }
    race {
      name
    }
    incomeRange {
      range
    }
    maritalStatus {
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeadByContactIdGQL extends Apollo.Query<GetLeadByContactIdQuery, GetLeadByContactIdQueryVariables> {
    document = GetLeadByContactIdDocument;
    
  }
export const GetInvitationTemplateDocument = gql`
    query getInvitationTemplate($invitationTemplateId: String!) {
  getInvitationTemplateById(invitationTemplateId: $invitationTemplateId) {
    subject
    salesDocId
    content
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvitationTemplateGQL extends Apollo.Query<GetInvitationTemplateQuery, GetInvitationTemplateQueryVariables> {
    document = GetInvitationTemplateDocument;
    
  }
export const AlterInvitationTemplateDocument = gql`
    mutation alterInvitationTemplate($salesDocIds: [String!]!, $invitationTemplateId: String, $subject: String, $bodyContent: String, $eLaunchId: String!, $projectId: String!) {
  alterInvitationTemplate(
    salesDocIds: $salesDocIds
    invitationTemplateId: $invitationTemplateId
    subject: $subject
    bodyContent: $bodyContent
    eLaunchId: $eLaunchId
    projectId: $projectId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlterInvitationTemplateGQL extends Apollo.Mutation<AlterInvitationTemplateMutation, AlterInvitationTemplateMutationVariables> {
    document = AlterInvitationTemplateDocument;
    
  }
export const GetWhatsAppContentDocument = gql`
    query getWhatsAppContent($projectId: String!, $eLaunchId: String!) {
  getWhatsAppContent(projectId: $projectId, eLaunchId: $eLaunchId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWhatsAppContentGQL extends Apollo.Query<GetWhatsAppContentQuery, GetWhatsAppContentQueryVariables> {
    document = GetWhatsAppContentDocument;
    
  }
export const SendEmailInvitationTemplateDocument = gql`
    mutation sendEmailInvitationTemplate($projectId: String!, $eLaunchId: String!, $eLaunchLeadBatchId: String!) {
  sendEmailInvitation(
    projectId: $projectId
    eLaunchId: $eLaunchId
    eLaunchLeadBatchId: $eLaunchLeadBatchId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendEmailInvitationTemplateGQL extends Apollo.Mutation<SendEmailInvitationTemplateMutation, SendEmailInvitationTemplateMutationVariables> {
    document = SendEmailInvitationTemplateDocument;
    
  }
export const FinancierListDocument = gql`
    query financierList {
  getFinancierList {
    id
    name
    assignedProjectCount
    loanCount
    commonStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierListGQL extends Apollo.Query<FinancierListQuery, FinancierListQueryVariables> {
    document = FinancierListDocument;
    
  }
export const FinancierDetailDocument = gql`
    query financierDetail($financierId: String!) {
  getFinancierDetail(financier_id: $financierId) {
    id
    name
    officeTel
    address {
      address
      city
      state
      country
      postCode
    }
    financierContact {
      id
      name
      phoneNo
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierDetailGQL extends Apollo.Query<FinancierDetailQuery, FinancierDetailQueryVariables> {
    document = FinancierDetailDocument;
    
  }
export const FinancierAddDocument = gql`
    mutation financierAdd($input: FinancierInput!) {
  createFinancier(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierAddGQL extends Apollo.Mutation<FinancierAddMutation, FinancierAddMutationVariables> {
    document = FinancierAddDocument;
    
  }
export const FinancierAddContactDocument = gql`
    mutation financierAddContact($financierId: String!, $input: FinancierContact!) {
  addFinancierContact(financier_id: $financierId, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierAddContactGQL extends Apollo.Mutation<FinancierAddContactMutation, FinancierAddContactMutationVariables> {
    document = FinancierAddContactDocument;
    
  }
export const FinancierEditDocument = gql`
    mutation financierEdit($input: FinancierInput!) {
  editFinancier(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierEditGQL extends Apollo.Mutation<FinancierEditMutation, FinancierEditMutationVariables> {
    document = FinancierEditDocument;
    
  }
export const FinancierDeleteDocument = gql`
    mutation financierDelete($financierId: String!) {
  deleteFinancier(financier_id: $financierId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierDeleteGQL extends Apollo.Mutation<FinancierDeleteMutation, FinancierDeleteMutationVariables> {
    document = FinancierDeleteDocument;
    
  }
export const FinancierPanelListDocument = gql`
    query financierPanelList($projectId: String!) {
  panelByProject(projectId: $projectId) {
    financierStatus
    id
    assignedDate
    financialLimit
    interestRate
    financierInfo {
      id
      name
      financierId
    }
    financierCommonStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierPanelListGQL extends Apollo.Query<FinancierPanelListQuery, FinancierPanelListQueryVariables> {
    document = FinancierPanelListDocument;
    
  }
export const FinancierAssignListDocument = gql`
    query financierAssignList($projectId: String!, $financierId: String) {
  panelFinancierList(project_id: $projectId, financier_id: $financierId) {
    id
    name
    financialLimit
    financierContact {
      id
      name
    }
    projectInvitation {
      projectId
      invitation {
        contactInfo {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierAssignListGQL extends Apollo.Query<FinancierAssignListQuery, FinancierAssignListQueryVariables> {
    document = FinancierAssignListDocument;
    
  }
export const FinancierPanelDetailDocument = gql`
    query financierPanelDetail($financierId: String!, $projectId: String!) {
  panelDetails(financier_id: $financierId, project_id: $projectId) {
    id
    name
    endfinFinancierId
    officeTel
    address {
      address
      city
      state
      country
      postCode
    }
    financierContact {
      id
      name
      phoneNo
      email
      invitationDate
      default
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierPanelDetailGQL extends Apollo.Query<FinancierPanelDetailQuery, FinancierPanelDetailQueryVariables> {
    document = FinancierPanelDetailDocument;
    
  }
export const SetDefaultFinancierContactDocument = gql`
    mutation setDefaultFinancierContact($contactId: String!, $project_id: String!, $financier_id: String!) {
  setDefaultFinancierContact(
    contactId: $contactId
    project_id: $project_id
    financier_id: $financier_id
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultFinancierContactGQL extends Apollo.Mutation<SetDefaultFinancierContactMutation, SetDefaultFinancierContactMutationVariables> {
    document = SetDefaultFinancierContactDocument;
    
  }
export const FinancierAssignPanelDocument = gql`
    mutation financierAssignPanel($input: AdminFinancierPanelInput!) {
  assignPanel(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierAssignPanelGQL extends Apollo.Mutation<FinancierAssignPanelMutation, FinancierAssignPanelMutationVariables> {
    document = FinancierAssignPanelDocument;
    
  }
export const FinancierUnassignPanelDocument = gql`
    mutation financierUnassignPanel($financierId: String!, $projectId: String!) {
  unassignPanel(financier_id: $financierId, project_id: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierUnassignPanelGQL extends Apollo.Mutation<FinancierUnassignPanelMutation, FinancierUnassignPanelMutationVariables> {
    document = FinancierUnassignPanelDocument;
    
  }
export const FinancierResendInvitationDocument = gql`
    mutation financierResendInvitation($input: AdminFinancierPanelInput!) {
  sendProjectInvitation(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierResendInvitationGQL extends Apollo.Mutation<FinancierResendInvitationMutation, FinancierResendInvitationMutationVariables> {
    document = FinancierResendInvitationDocument;
    
  }
export const FinancierRemoveContactDocument = gql`
    mutation financierRemoveContact($input: AdminFinancierPanelInput!) {
  removeInvitationContact(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FinancierRemoveContactGQL extends Apollo.Mutation<FinancierRemoveContactMutation, FinancierRemoveContactMutationVariables> {
    document = FinancierRemoveContactDocument;
    
  }
export const EditFinancierLimitDocument = gql`
    mutation editFinancierLimit($id: String!, $financialLimit: Float!, $interestRate: Float) {
  editFinancialLimit(
    id: $id
    financialLimit: $financialLimit
    interestRate: $interestRate
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditFinancierLimitGQL extends Apollo.Mutation<EditFinancierLimitMutation, EditFinancierLimitMutationVariables> {
    document = EditFinancierLimitDocument;
    
  }
export const SuspendFinancierDocument = gql`
    mutation suspendFinancier($financierId: String!) {
  suspendEndFinancier(financierId: $financierId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuspendFinancierGQL extends Apollo.Mutation<SuspendFinancierMutation, SuspendFinancierMutationVariables> {
    document = SuspendFinancierDocument;
    
  }
export const IsEndFinEmailExistDocument = gql`
    query isEndFinEmailExist($email: String!) {
  isEndFinEmailExist(email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsEndFinEmailExistGQL extends Apollo.Query<IsEndFinEmailExistQuery, IsEndFinEmailExistQueryVariables> {
    document = IsEndFinEmailExistDocument;
    
  }
export const GetGalleryByProjectDocument = gql`
    query getGalleryByProject($projectid: String!) {
  GetGalleryByProject(projectId: $projectid) {
    galleryImage {
      resourceid
      url
      pictureid
      seqno
      caption
    }
    blockGalleryImage {
      resourceid
      url
      caption
      pictureid
      block
    }
    floorGalleryImage {
      resourceid
      url
      caption
      block
      floor
      pictureid
      floorlabel
    }
    unitLayoutGalleryImage {
      resourceid
      url
      pictureid
      seqno
      caption
      unitlayoutid
      desc
    }
    videoLink {
      videoType
      url
      caption
    }
    virtualModel {
      url
      caption
    }
    distinctBlock
    distinctBlockFloor {
      block
      floor
      floorlabel
    }
    unitLayouts {
      id
      desc
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGalleryByProjectGQL extends Apollo.Query<GetGalleryByProjectQuery, GetGalleryByProjectQueryVariables> {
    document = GetGalleryByProjectDocument;
    
  }
export const EditGalleryDocument = gql`
    mutation editGallery($input: [AdminEditGalleryInput!]!) {
  EditGallery(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditGalleryGQL extends Apollo.Mutation<EditGalleryMutation, EditGalleryMutationVariables> {
    document = EditGalleryDocument;
    
  }
export const CompanyListingDocument = gql`
    query companyListing {
  CompanyListing {
    id
    name
    description
    companyRegNo
    officeTel
    websiteUrl
    imageUrl
    email
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyListingGQL extends Apollo.Query<CompanyListingQuery, CompanyListingQueryVariables> {
    document = CompanyListingDocument;
    
  }
export const CompanyDetailDocument = gql`
    query companyDetail($id: String!) {
  CompanyDetail(id: $id) {
    id
    name
    imageUrl
    companyRegNo
    description
    email
    websiteUrl
    officeTel
    code
    regionId
    region {
      name
    }
    address {
      address
      city
      state
      country
      postCode
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyDetailGQL extends Apollo.Query<CompanyDetailQuery, CompanyDetailQueryVariables> {
    document = CompanyDetailDocument;
    
  }
export const RegionMasterDataDocument = gql`
    query regionMasterData {
  GetAllMasterInfo {
    Region {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegionMasterDataGQL extends Apollo.Query<RegionMasterDataQuery, RegionMasterDataQueryVariables> {
    document = RegionMasterDataDocument;
    
  }
export const AddCompanyDocument = gql`
    mutation addCompany($input: AdminCompanyInput!) {
  AddCompany(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCompanyGQL extends Apollo.Mutation<AddCompanyMutation, AddCompanyMutationVariables> {
    document = AddCompanyDocument;
    
  }
export const EditCompanyDocument = gql`
    mutation editCompany($input: AdminCompanyInput!) {
  EditCompany(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditCompanyGQL extends Apollo.Mutation<EditCompanyMutation, EditCompanyMutationVariables> {
    document = EditCompanyDocument;
    
  }
export const DeleteCompanyDocument = gql`
    mutation deleteCompany($id: String!) {
  DeleteCompany(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCompanyGQL extends Apollo.Mutation<DeleteCompanyMutation, DeleteCompanyMutationVariables> {
    document = DeleteCompanyDocument;
    
  }
export const GetCountryStateCityDocument = gql`
    query getCountryStateCity {
  getCountryStateCity {
    id
    name
    sStates {
      id
      name
      sCities {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountryStateCityGQL extends Apollo.Query<GetCountryStateCityQuery, GetCountryStateCityQueryVariables> {
    document = GetCountryStateCityDocument;
    
  }
export const GetSalesChartBlockDocument = gql`
    query getSalesChartBlock($projectId: String!) {
  getProjectById(projectId: $projectId) {
    blockGalleryImage {
      block
      resourceid
      url
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesChartBlockGQL extends Apollo.Query<GetSalesChartBlockQuery, GetSalesChartBlockQueryVariables> {
    document = GetSalesChartBlockDocument;
    
  }
export const GetSalesChartDocument = gql`
    query getSalesChart($projectId: String!, $block: String!) {
  GetActiveFloorAndUnitByProjectBlock(ProjectId: $projectId, Block: $block) {
    floor
    floorlabel
    ActiveUnit {
      id
      unitNo
      unitStatus
      salesCharts {
        coordinates
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesChartGQL extends Apollo.Query<GetSalesChartQuery, GetSalesChartQueryVariables> {
    document = GetSalesChartDocument;
    
  }
export const UpdateSalesChartDocument = gql`
    query updateSalesChart($models: [AdminUnitSalesChartInput!]!) {
  UpdateSalesChart(models: $models)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSalesChartGQL extends Apollo.Query<UpdateSalesChartQuery, UpdateSalesChartQueryVariables> {
    document = UpdateSalesChartDocument;
    
  }
export const UploadResourceProductDocument = gql`
    mutation uploadResourceProduct($file: Upload!, $isPrivate: Boolean!) {
  UploadResourceProduct(file: $file, isPrivate: $isPrivate) {
    BucketFileName
    FileName
    Url
    MediaType
    IsPrivate
    PrivateUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadResourceProductGQL extends Apollo.Mutation<UploadResourceProductMutation, UploadResourceProductMutationVariables> {
    document = UploadResourceProductDocument;
    
  }
export const DeleteResourceProductDocument = gql`
    query deleteResourceProduct($fileUrl: String!, $isPrivate: Boolean!) {
  DeleteResourceProduct(fileUrl: $fileUrl, isPrivate: $isPrivate)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteResourceProductGQL extends Apollo.Query<DeleteResourceProductQuery, DeleteResourceProductQueryVariables> {
    document = DeleteResourceProductDocument;
    
  }
export const DeleteResourceProductsDocument = gql`
    query deleteResourceProducts($fileUrls: [String!]!, $isPrivate: Boolean!) {
  DeleteResourceProducts(fileUrls: $fileUrls, isPrivate: $isPrivate)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteResourceProductsGQL extends Apollo.Query<DeleteResourceProductsQuery, DeleteResourceProductsQueryVariables> {
    document = DeleteResourceProductsDocument;
    
  }
export const GetAllIncomeRangeDocument = gql`
    query getAllIncomeRange {
  getAllIncomeRange {
    id
    range
    commonStatus
    seqNo
    defaulted
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllIncomeRangeGQL extends Apollo.Query<GetAllIncomeRangeQuery, GetAllIncomeRangeQueryVariables> {
    document = GetAllIncomeRangeDocument;
    
  }
export const EditIncomeRangeDocument = gql`
    mutation editIncomeRange($input: EditIncomeRangeInput!) {
  editIncomeRange(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditIncomeRangeGQL extends Apollo.Mutation<EditIncomeRangeMutation, EditIncomeRangeMutationVariables> {
    document = EditIncomeRangeDocument;
    
  }
export const AddIncomeRangeDocument = gql`
    mutation addIncomeRange($input: IncomeRangeInput!) {
  addIncomeRange(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddIncomeRangeGQL extends Apollo.Mutation<AddIncomeRangeMutation, AddIncomeRangeMutationVariables> {
    document = AddIncomeRangeDocument;
    
  }
export const DeleteIncomeRangeByIdDocument = gql`
    mutation deleteIncomeRangeById($incomeRangeId: String!) {
  deleteIncomeRangeById(incomeRangeId: $incomeRangeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteIncomeRangeByIdGQL extends Apollo.Mutation<DeleteIncomeRangeByIdMutation, DeleteIncomeRangeByIdMutationVariables> {
    document = DeleteIncomeRangeByIdDocument;
    
  }
export const SetDefaultIncomeRangeDocument = gql`
    mutation setDefaultIncomeRange($incomeRangeId: String!) {
  setDefaultIncomeRange(incomeRangeId: $incomeRangeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultIncomeRangeGQL extends Apollo.Mutation<SetDefaultIncomeRangeMutation, SetDefaultIncomeRangeMutationVariables> {
    document = SetDefaultIncomeRangeDocument;
    
  }
export const RemoveDefaultIncomeRangeDocument = gql`
    mutation removeDefaultIncomeRange($incomeRangeId: String!) {
  removeDefaultIncomeRange(incomeRangeId: $incomeRangeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultIncomeRangeGQL extends Apollo.Mutation<RemoveDefaultIncomeRangeMutation, RemoveDefaultIncomeRangeMutationVariables> {
    document = RemoveDefaultIncomeRangeDocument;
    
  }
export const OrganizeIncomeRangeDocument = gql`
    mutation organizeIncomeRange($incomeRangeIds: [String!]!) {
  organizeIncomeRange(incomeRangeIds: $incomeRangeIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeIncomeRangeGQL extends Apollo.Mutation<OrganizeIncomeRangeMutation, OrganizeIncomeRangeMutationVariables> {
    document = OrganizeIncomeRangeDocument;
    
  }
export const GetIntegrationAccountSpecDocument = gql`
    query getIntegrationAccountSpec {
  getIntegrationAccountSpec {
    integrationAutoCapitalize
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIntegrationAccountSpecGQL extends Apollo.Query<GetIntegrationAccountSpecQuery, GetIntegrationAccountSpecQueryVariables> {
    document = GetIntegrationAccountSpecDocument;
    
  }
export const AutoCapitalizationDocument = gql`
    mutation autoCapitalization {
  autoCapitalization
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AutoCapitalizationGQL extends Apollo.Mutation<AutoCapitalizationMutation, AutoCapitalizationMutationVariables> {
    document = AutoCapitalizationDocument;
    
  }
export const GetLeadIntegrationDocument = gql`
    query getLeadIntegration {
  getLeadIntegration {
    id
    integrationType
    title
    key
    token
    projectId
    accountId
    commonStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeadIntegrationGQL extends Apollo.Query<GetLeadIntegrationQuery, GetLeadIntegrationQueryVariables> {
    document = GetLeadIntegrationDocument;
    
  }
export const GetLeadIntegrationByIdDocument = gql`
    query getLeadIntegrationById($leadIntegrationId: String!) {
  getLeadIntegrationById(leadIntegrationId: $leadIntegrationId) {
    id
    integrationType
    title
    key
    token
    integrationUrl
    project {
      id
      name
    }
    accountId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeadIntegrationByIdGQL extends Apollo.Query<GetLeadIntegrationByIdQuery, GetLeadIntegrationByIdQueryVariables> {
    document = GetLeadIntegrationByIdDocument;
    
  }
export const GetIntegrationSettingFormDataDocument = gql`
    query getIntegrationSettingFormData {
  getIntegrationSettingFormData {
    projectDetails {
      projectId
      projectName
    }
    integrationType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIntegrationSettingFormDataGQL extends Apollo.Query<GetIntegrationSettingFormDataQuery, GetIntegrationSettingFormDataQueryVariables> {
    document = GetIntegrationSettingFormDataDocument;
    
  }
export const NewLeadIntegrationDocument = gql`
    mutation newLeadIntegration($input: LeadIntegrationInput!) {
  newLeadIntegration(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NewLeadIntegrationGQL extends Apollo.Mutation<NewLeadIntegrationMutation, NewLeadIntegrationMutationVariables> {
    document = NewLeadIntegrationDocument;
    
  }
export const EditLeadIntegrationDocument = gql`
    mutation editLeadIntegration($input: LeadIntegrationInput!) {
  editLeadIntegration(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditLeadIntegrationGQL extends Apollo.Mutation<EditLeadIntegrationMutation, EditLeadIntegrationMutationVariables> {
    document = EditLeadIntegrationDocument;
    
  }
export const AlterLeadIntegrationCommonStatusDocument = gql`
    mutation alterLeadIntegrationCommonStatus($leadIntegrationId: String!) {
  alterLeadIntegrationCommonStatus(leadIntegrationId: $leadIntegrationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlterLeadIntegrationCommonStatusGQL extends Apollo.Mutation<AlterLeadIntegrationCommonStatusMutation, AlterLeadIntegrationCommonStatusMutationVariables> {
    document = AlterLeadIntegrationCommonStatusDocument;
    
  }
export const MissMatchSaleProjectListingDocument = gql`
    query missMatchSaleProjectListing {
  missMatchSaleProjectListing {
    projectId
    projectName
    projectImageUrl
    missMatchSalesCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MissMatchSaleProjectListingGQL extends Apollo.Query<MissMatchSaleProjectListingQuery, MissMatchSaleProjectListingQueryVariables> {
    document = MissMatchSaleProjectListingDocument;
    
  }
export const NotMatchSaleDocument = gql`
    query notMatchSale($projectId: String!) {
  notMatchSale(projectId: $projectId) {
    UnitNo
    PurchaserName
    SaleDate
    SNPDate
    SellingPrice
    MissMatchType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotMatchSaleGQL extends Apollo.Query<NotMatchSaleQuery, NotMatchSaleQueryVariables> {
    document = NotMatchSaleDocument;
    
  }
export const SyncMissMatchSalesDocument = gql`
    mutation syncMissMatchSales($projectId: String!) {
  syncMissMatchSales(projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncMissMatchSalesGQL extends Apollo.Mutation<SyncMissMatchSalesMutation, SyncMissMatchSalesMutationVariables> {
    document = SyncMissMatchSalesDocument;
    
  }
export const GetLayoutImagesByProjectDocument = gql`
    query getLayoutImagesByProject($projectid: String!) {
  GetGalleryByProject(projectId: $projectid) {
    blockGalleryImage {
      resourceid
      url
      caption
      pictureid
      block
    }
    floorGalleryImage {
      resourceid
      url
      caption
      block
      floor
      pictureid
      floorlabel
    }
    unitLayoutGalleryImage {
      block
      resourceid
      url
      pictureid
      seqno
      caption
      unitlayoutid
      desc
      virtualModelLink
      unit_type_id
      unitLayout
      unit_type_desc
    }
    videoLink {
      videoType
      url
      caption
    }
    virtualModel {
      url
      caption
    }
    distinctBlock
    distinctBlockFloor {
      block
      floor
      floorlabel
    }
    unitLayouts {
      id
      desc
    }
    unitTourVirtual {
      tourId
      block
      unitLayoutId
      unitTypeId
      virtualModelLink
      unitLayoutName
      unitTypeName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLayoutImagesByProjectGQL extends Apollo.Query<GetLayoutImagesByProjectQuery, GetLayoutImagesByProjectQueryVariables> {
    document = GetLayoutImagesByProjectDocument;
    
  }
export const GetAllLeadSourceDocument = gql`
    query getAllLeadSource {
  getAllLeadSource {
    id
    name
    commonStatus
    systemUse
    defaulted
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllLeadSourceGQL extends Apollo.Query<GetAllLeadSourceQuery, GetAllLeadSourceQueryVariables> {
    document = GetAllLeadSourceDocument;
    
  }
export const EditLeadSourceDocument = gql`
    mutation editLeadSource($input: EditLeadSourceInput!) {
  editLeadSource(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditLeadSourceGQL extends Apollo.Mutation<EditLeadSourceMutation, EditLeadSourceMutationVariables> {
    document = EditLeadSourceDocument;
    
  }
export const AddLeadSourceDocument = gql`
    mutation addLeadSource($input: LeadSourceInput!) {
  addLeadSource(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddLeadSourceGQL extends Apollo.Mutation<AddLeadSourceMutation, AddLeadSourceMutationVariables> {
    document = AddLeadSourceDocument;
    
  }
export const DeleteLeadSourceByIdDocument = gql`
    mutation deleteLeadSourceById($sourceId: String!) {
  deleteLeadSourceById(sourceId: $sourceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLeadSourceByIdGQL extends Apollo.Mutation<DeleteLeadSourceByIdMutation, DeleteLeadSourceByIdMutationVariables> {
    document = DeleteLeadSourceByIdDocument;
    
  }
export const ChangeLeadStatusDocument = gql`
    mutation changeLeadStatus($sourceId: String!, $status: Boolean!) {
  changeLeadStatus(sourceId: $sourceId, status: $status)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeLeadStatusGQL extends Apollo.Mutation<ChangeLeadStatusMutation, ChangeLeadStatusMutationVariables> {
    document = ChangeLeadStatusDocument;
    
  }
export const SetDefaultLeadSourceDocument = gql`
    mutation setDefaultLeadSource($sourceId: String!) {
  setDefaultLeadSource(sourceId: $sourceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultLeadSourceGQL extends Apollo.Mutation<SetDefaultLeadSourceMutation, SetDefaultLeadSourceMutationVariables> {
    document = SetDefaultLeadSourceDocument;
    
  }
export const RemoveDefaultLeadSourceDocument = gql`
    mutation removeDefaultLeadSource($sourceId: String!) {
  removeDefaultLeadSource(sourceId: $sourceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultLeadSourceGQL extends Apollo.Mutation<RemoveDefaultLeadSourceMutation, RemoveDefaultLeadSourceMutationVariables> {
    document = RemoveDefaultLeadSourceDocument;
    
  }
export const OrganizeLeadSourceDocument = gql`
    mutation organizeLeadSource($sourceIds: [String!]!) {
  organizeLeadSource(sourceIds: $sourceIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeLeadSourceGQL extends Apollo.Mutation<OrganizeLeadSourceMutation, OrganizeLeadSourceMutationVariables> {
    document = OrganizeLeadSourceDocument;
    
  }
export const GetMasterELetteringDocument = gql`
    query getMasterELettering {
  getLetterTypeListing {
    id
    name
    letterType
    count
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMasterELetteringGQL extends Apollo.Query<GetMasterELetteringQuery, GetMasterELetteringQueryVariables> {
    document = GetMasterELetteringDocument;
    
  }
export const GetLetterTemplateListingDocument = gql`
    query getLetterTemplateListing($standardLetterId: String!) {
  getStandardLetter(id: $standardLetterId) {
    name
  }
  getLetterTemplateListing(standardLetterId: $standardLetterId) {
    id
    name
    commonStatus
    allowToDelete
    modTs
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLetterTemplateListingGQL extends Apollo.Query<GetLetterTemplateListingQuery, GetLetterTemplateListingQueryVariables> {
    document = GetLetterTemplateListingDocument;
    
  }
export const GetLetterTemplateDetailsDocument = gql`
    query getLetterTemplateDetails($letterTemplateId: String!, $standardLetterId: String!) {
  getStandardLetter(id: $standardLetterId) {
    name
  }
  getLetterTemplateDetails(letterTemplateId: $letterTemplateId) {
    id
    name
    templateBody
    jointBuyerSignRequired
    letterParameter {
      displayName
      columnName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLetterTemplateDetailsGQL extends Apollo.Query<GetLetterTemplateDetailsQuery, GetLetterTemplateDetailsQueryVariables> {
    document = GetLetterTemplateDetailsDocument;
    
  }
export const GetStandardLetterParametersDocument = gql`
    query getStandardLetterParameters($standardLetterId: String!) {
  getStandardLetter(id: $standardLetterId) {
    name
  }
  getStandardLetterParameters(standardLetterId: $standardLetterId) {
    displayName
    columnName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStandardLetterParametersGQL extends Apollo.Query<GetStandardLetterParametersQuery, GetStandardLetterParametersQueryVariables> {
    document = GetStandardLetterParametersDocument;
    
  }
export const GetLetterPreviewDocument = gql`
    query getLetterPreview($letterTemplateId: String!) {
  getLetterPreview(letterTemplateId: $letterTemplateId) {
    templateBody
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLetterPreviewGQL extends Apollo.Query<GetLetterPreviewQuery, GetLetterPreviewQueryVariables> {
    document = GetLetterPreviewDocument;
    
  }
export const AddLetterTemplateDocument = gql`
    mutation addLetterTemplate($input: LetterTemplateInput!) {
  addLetterTemplate(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddLetterTemplateGQL extends Apollo.Mutation<AddLetterTemplateMutation, AddLetterTemplateMutationVariables> {
    document = AddLetterTemplateDocument;
    
  }
export const EditLetterTemplateDocument = gql`
    mutation editLetterTemplate($input: EditLetterTemplateInput!) {
  editLetterTemplate(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditLetterTemplateGQL extends Apollo.Mutation<EditLetterTemplateMutation, EditLetterTemplateMutationVariables> {
    document = EditLetterTemplateDocument;
    
  }
export const DeleteLetterTemplateDocument = gql`
    mutation deleteLetterTemplate($letterTemplateId: String!) {
  deleteLetterTemplate(letterTemplateId: $letterTemplateId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLetterTemplateGQL extends Apollo.Mutation<DeleteLetterTemplateMutation, DeleteLetterTemplateMutationVariables> {
    document = DeleteLetterTemplateDocument;
    
  }
export const GetLetterTemplateListingByProjectDocument = gql`
    query getLetterTemplateListingByProject($standardLetterId: String!, $projectId: String!) {
  getStandardLetter(id: $standardLetterId) {
    name
  }
  getLetterTemplateListingByProject(
    standardLetterId: $standardLetterId
    projectId: $projectId
  ) {
    id
    letterTemplateId
    name
    commonStatus
    lastUpdated
    defaulted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLetterTemplateListingByProjectGQL extends Apollo.Query<GetLetterTemplateListingByProjectQuery, GetLetterTemplateListingByProjectQueryVariables> {
    document = GetLetterTemplateListingByProjectDocument;
    
  }
export const GetESignLetterTemplateToAssignDocument = gql`
    query getESignLetterTemplateToAssign($standardLetterId: String!, $projectId: String!) {
  getESignLetterTemplateToAssign(
    standardLetterId: $standardLetterId
    projectId: $projectId
  ) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetESignLetterTemplateToAssignGQL extends Apollo.Query<GetESignLetterTemplateToAssignQuery, GetESignLetterTemplateToAssignQueryVariables> {
    document = GetESignLetterTemplateToAssignDocument;
    
  }
export const AssignProjectLetterTemplateDocument = gql`
    mutation assignProjectLetterTemplate($letterTemplateIds: [String!]!, $projectId: String!, $standardLetterId: String!) {
  assignProjectLetterTemplate(
    letterTemplateIds: $letterTemplateIds
    projectId: $projectId
    standardLetterId: $standardLetterId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignProjectLetterTemplateGQL extends Apollo.Mutation<AssignProjectLetterTemplateMutation, AssignProjectLetterTemplateMutationVariables> {
    document = AssignProjectLetterTemplateDocument;
    
  }
export const SetDefaultProjectLetterTemplateDocument = gql`
    mutation setDefaultProjectLetterTemplate($standardLetterId: String!, $projectId: String!, $id: String!) {
  setDefaultProjectLetterTemplate(
    standardLetterId: $standardLetterId
    projectId: $projectId
    id: $id
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultProjectLetterTemplateGQL extends Apollo.Mutation<SetDefaultProjectLetterTemplateMutation, SetDefaultProjectLetterTemplateMutationVariables> {
    document = SetDefaultProjectLetterTemplateDocument;
    
  }
export const RemoveDefaultProjectLetterTemplateDocument = gql`
    mutation removeDefaultProjectLetterTemplate($standardLetterId: String!, $projectId: String!, $id: String!) {
  removeDefaultProjectLetterTemplate(
    standardLetterId: $standardLetterId
    projectId: $projectId
    id: $id
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultProjectLetterTemplateGQL extends Apollo.Mutation<RemoveDefaultProjectLetterTemplateMutation, RemoveDefaultProjectLetterTemplateMutationVariables> {
    document = RemoveDefaultProjectLetterTemplateDocument;
    
  }
export const UnassignProjectLetterDocument = gql`
    mutation unassignProjectLetter($standardLetterId: String!, $projectId: String!, $id: String!) {
  unassignProjectLetter(
    standardLetterId: $standardLetterId
    projectId: $projectId
    id: $id
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnassignProjectLetterGQL extends Apollo.Mutation<UnassignProjectLetterMutation, UnassignProjectLetterMutationVariables> {
    document = UnassignProjectLetterDocument;
    
  }
export const GetELetteringByProjectDocument = gql`
    query getELetteringByProject($projectId: String!) {
  getLetterTypeListing {
    id
    name
    letterType
    countByProject(projectId: $projectId)
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetELetteringByProjectGQL extends Apollo.Query<GetELetteringByProjectQuery, GetELetteringByProjectQueryVariables> {
    document = GetELetteringByProjectDocument;
    
  }
export const GetAccountSpecDocument = gql`
    query getAccountSpec {
  getAccountSpec {
    loanPlusProjectId
    modifiedDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAccountSpecGQL extends Apollo.Query<GetAccountSpecQuery, GetAccountSpecQueryVariables> {
    document = GetAccountSpecDocument;
    
  }
export const UpdateAccountSpecDocument = gql`
    mutation updateAccountSpec($loanPlusProjectId: Float!) {
  updateAccountSpec(loanPlusProjectId: $loanPlusProjectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAccountSpecGQL extends Apollo.Mutation<UpdateAccountSpecMutation, UpdateAccountSpecMutationVariables> {
    document = UpdateAccountSpecDocument;
    
  }
export const GetAllMaritalStatusDocument = gql`
    query getAllMaritalStatus {
  getAllMaritalStatus {
    id
    name
    commonStatus
    defaulted
    isDeletable
    systemUse
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllMaritalStatusGQL extends Apollo.Query<GetAllMaritalStatusQuery, GetAllMaritalStatusQueryVariables> {
    document = GetAllMaritalStatusDocument;
    
  }
export const EditMaritalStatusDocument = gql`
    mutation editMaritalStatus($input: EditMaritalStatusInput!) {
  editMaritalStatus(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditMaritalStatusGQL extends Apollo.Mutation<EditMaritalStatusMutation, EditMaritalStatusMutationVariables> {
    document = EditMaritalStatusDocument;
    
  }
export const AddMaritalStatusDocument = gql`
    mutation addMaritalStatus($input: MaritalStatusInput!) {
  addMaritalStatus(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddMaritalStatusGQL extends Apollo.Mutation<AddMaritalStatusMutation, AddMaritalStatusMutationVariables> {
    document = AddMaritalStatusDocument;
    
  }
export const DeleteMaritalStatusByIdDocument = gql`
    mutation deleteMaritalStatusById($maritalStatusId: String!) {
  deleteMaritalStatusById(maritalStatusId: $maritalStatusId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMaritalStatusByIdGQL extends Apollo.Mutation<DeleteMaritalStatusByIdMutation, DeleteMaritalStatusByIdMutationVariables> {
    document = DeleteMaritalStatusByIdDocument;
    
  }
export const SetDefaultMaritalStatusDocument = gql`
    mutation setDefaultMaritalStatus($maritalStatusId: String!) {
  setDefaultMaritalStatus(maritalStatusId: $maritalStatusId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultMaritalStatusGQL extends Apollo.Mutation<SetDefaultMaritalStatusMutation, SetDefaultMaritalStatusMutationVariables> {
    document = SetDefaultMaritalStatusDocument;
    
  }
export const RemoveDefaultMaritalStatusDocument = gql`
    mutation removeDefaultMaritalStatus($maritalStatusId: String!) {
  removeDefaultMaritalStatus(maritalStatusId: $maritalStatusId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultMaritalStatusGQL extends Apollo.Mutation<RemoveDefaultMaritalStatusMutation, RemoveDefaultMaritalStatusMutationVariables> {
    document = RemoveDefaultMaritalStatusDocument;
    
  }
export const OrganizeMaritalStatusDocument = gql`
    mutation organizeMaritalStatus($maritalStatusIds: [String!]!) {
  organizeMaritalStatus(maritalStatusIds: $maritalStatusIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeMaritalStatusGQL extends Apollo.Mutation<OrganizeMaritalStatusMutation, OrganizeMaritalStatusMutationVariables> {
    document = OrganizeMaritalStatusDocument;
    
  }
export const LeadInfoSetupCountDocument = gql`
    query leadInfoSetupCount {
  GetAllMasterInfo {
    getLeadSourceCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LeadInfoSetupCountGQL extends Apollo.Query<LeadInfoSetupCountQuery, LeadInfoSetupCountQueryVariables> {
    document = LeadInfoSetupCountDocument;
    
  }
export const ReasonCategorySetupCountDocument = gql`
    query reasonCategorySetupCount {
  GetAllMasterInfo {
    bookingCancellationCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReasonCategorySetupCountGQL extends Apollo.Query<ReasonCategorySetupCountQuery, ReasonCategorySetupCountQueryVariables> {
    document = ReasonCategorySetupCountDocument;
    
  }
export const PurchaserProfileSetupCountDocument = gql`
    query purchaserProfileSetupCount {
  GetAllMasterInfo {
    getRaceCount
    getMaritalCount
    getSalutationCount
    getIncomeRangeCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PurchaserProfileSetupCountGQL extends Apollo.Query<PurchaserProfileSetupCountQuery, PurchaserProfileSetupCountQueryVariables> {
    document = PurchaserProfileSetupCountDocument;
    
  }
export const PropertyInfoSetupCountDocument = gql`
    query propertyInfoSetupCount {
  GetAllMasterInfo {
    getProjectTypeCount
    getPropertyTypeCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PropertyInfoSetupCountGQL extends Apollo.Query<PropertyInfoSetupCountQuery, PropertyInfoSetupCountQueryVariables> {
    document = PropertyInfoSetupCountDocument;
    
  }
export const UnitInfoSetupCountDocument = gql`
    query unitInfoSetupCount {
  GetAllMasterInfo {
    getUnitCount
    getDirectionCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnitInfoSetupCountGQL extends Apollo.Query<UnitInfoSetupCountQuery, UnitInfoSetupCountQueryVariables> {
    document = UnitInfoSetupCountDocument;
    
  }
export const GetLatestUpdateForSetupDocument = gql`
    query getLatestUpdateForSetup {
  GetAllMasterInfo {
    getLatestUpdateLeadInfo
    getLatestUpdateUnitInfo
    getLatestUpdatePropertyInfo
    getLatestUpdatePurchaserProfile
    getLatestUpdateELetter
    getLatestUpdateRoundRobin
    getLatestUpdateRegion
    getLatestUpdateReason
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLatestUpdateForSetupGQL extends Apollo.Query<GetLatestUpdateForSetupQuery, GetLatestUpdateForSetupQueryVariables> {
    document = GetLatestUpdateForSetupDocument;
    
  }
export const GetAllNewsAnnouncementDocument = gql`
    query getAllNewsAnnouncement($limit: Float!, $page: Float!, $search: String, $published: Boolean) {
  getAllNewsAnnouncement(
    limit: $limit
    page: $page
    search: $search
    published: $published
  ) {
    data {
      id
      title
      description
      startDate
      endDate
      isPublish
      attachment {
        id
        seqNo
        resourceUrl
      }
      isExpired
    }
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllNewsAnnouncementGQL extends Apollo.Query<GetAllNewsAnnouncementQuery, GetAllNewsAnnouncementQueryVariables> {
    document = GetAllNewsAnnouncementDocument;
    
  }
export const GetNewsAnnouncementDetailsDocument = gql`
    query getNewsAnnouncementDetails($newsId: String!) {
  getNewsAnnouncementDetails(newsId: $newsId) {
    id
    title
    startDate
    endDate
    description
    isPublish
    newsProjects {
      projectId
    }
    attachment {
      id
      fileName
      resourceUrl
      mediaType
    }
  }
  getAllProject {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNewsAnnouncementDetailsGQL extends Apollo.Query<GetNewsAnnouncementDetailsQuery, GetNewsAnnouncementDetailsQueryVariables> {
    document = GetNewsAnnouncementDetailsDocument;
    
  }
export const AddNewsAnnouncementDocument = gql`
    mutation addNewsAnnouncement($input: NewsAnnouncementInput!) {
  addNewsAnnouncement(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNewsAnnouncementGQL extends Apollo.Mutation<AddNewsAnnouncementMutation, AddNewsAnnouncementMutationVariables> {
    document = AddNewsAnnouncementDocument;
    
  }
export const EditNewsAnnouncementDocument = gql`
    mutation editNewsAnnouncement($input: NewsAnnouncementInput!) {
  editNewsAnnouncement(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditNewsAnnouncementGQL extends Apollo.Mutation<EditNewsAnnouncementMutation, EditNewsAnnouncementMutationVariables> {
    document = EditNewsAnnouncementDocument;
    
  }
export const DeleteNewsAnnouncementDocument = gql`
    mutation deleteNewsAnnouncement($newsId: String!) {
  deleteNewsAnnouncement(newsId: $newsId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteNewsAnnouncementGQL extends Apollo.Mutation<DeleteNewsAnnouncementMutation, DeleteNewsAnnouncementMutationVariables> {
    document = DeleteNewsAnnouncementDocument;
    
  }
export const PublishNewsAnnouncementDocument = gql`
    mutation publishNewsAnnouncement($newsId: String!) {
  publishNewsAnnouncement(newsId: $newsId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PublishNewsAnnouncementGQL extends Apollo.Mutation<PublishNewsAnnouncementMutation, PublishNewsAnnouncementMutationVariables> {
    document = PublishNewsAnnouncementDocument;
    
  }
export const AddNupTypeDocument = gql`
    mutation addNupType($input: NupTypeInput!) {
  addNupType(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNupTypeGQL extends Apollo.Mutation<AddNupTypeMutation, AddNupTypeMutationVariables> {
    document = AddNupTypeDocument;
    
  }
export const GetNupTypeListingDocument = gql`
    query getNupTypeListing {
  getNupTypeListing {
    id
    type
    description
    amount
    prefix
    commonStatus
    viaMobile
    viaAgent
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNupTypeListingGQL extends Apollo.Query<GetNupTypeListingQuery, GetNupTypeListingQueryVariables> {
    document = GetNupTypeListingDocument;
    
  }
export const GetNupTypeDetailDocument = gql`
    query getNupTypeDetail($nupTypeId: String!) {
  getNupTypeDetail(nupTypeId: $nupTypeId) {
    id
    type
    description
    amount
    prefix
    commonStatus
    viaMobile
    viaAgent
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNupTypeDetailGQL extends Apollo.Query<GetNupTypeDetailQuery, GetNupTypeDetailQueryVariables> {
    document = GetNupTypeDetailDocument;
    
  }
export const EditNupTypeDocument = gql`
    mutation editNupType($input: EditNupTypeInput!) {
  editNupType(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditNupTypeGQL extends Apollo.Mutation<EditNupTypeMutation, EditNupTypeMutationVariables> {
    document = EditNupTypeDocument;
    
  }
export const DeleteNupTypeDocument = gql`
    mutation deleteNupType($nupTypeId: String!) {
  deleteNupType(nupTypeId: $nupTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteNupTypeGQL extends Apollo.Mutation<DeleteNupTypeMutation, DeleteNupTypeMutationVariables> {
    document = DeleteNupTypeDocument;
    
  }
export const AddNupReasonDocument = gql`
    mutation addNupReason($input: NupReasonInput!) {
  addNupReason(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddNupReasonGQL extends Apollo.Mutation<AddNupReasonMutation, AddNupReasonMutationVariables> {
    document = AddNupReasonDocument;
    
  }
export const GetNupReasonListingDocument = gql`
    query getNupReasonListing {
  getNupReasonListing {
    id
    code
    description
    commonStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNupReasonListingGQL extends Apollo.Query<GetNupReasonListingQuery, GetNupReasonListingQueryVariables> {
    document = GetNupReasonListingDocument;
    
  }
export const GetNupReasonDetailDocument = gql`
    query getNupReasonDetail($reasonId: String!) {
  getNupReasonDetail(reasonId: $reasonId) {
    id
    code
    description
    commonStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNupReasonDetailGQL extends Apollo.Query<GetNupReasonDetailQuery, GetNupReasonDetailQueryVariables> {
    document = GetNupReasonDetailDocument;
    
  }
export const EditNupReasonDocument = gql`
    mutation editNupReason($input: EditNupReasonInput!) {
  editNupReason(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditNupReasonGQL extends Apollo.Mutation<EditNupReasonMutation, EditNupReasonMutationVariables> {
    document = EditNupReasonDocument;
    
  }
export const DeleteNupReasonDocument = gql`
    mutation deleteNupReason($reasonId: String!) {
  deleteNupReason(reasonId: $reasonId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteNupReasonGQL extends Apollo.Mutation<DeleteNupReasonMutation, DeleteNupReasonMutationVariables> {
    document = DeleteNupReasonDocument;
    
  }
export const GetAllOnlineUsersDocument = gql`
    query getAllOnlineUsers($limit: Float!, $page: Float!, $accountId: String!, $search: String, $online: Boolean) {
  getAllOnlineUsers(
    limit: $limit
    page: $page
    accountId: $accountId
    search: $search
    online: $online
  ) {
    data {
      softwareCode
      accountId
      accountName
      name
      email
      ipAddress
      commonStatus
      lastLogin
      lastLogout
    }
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllOnlineUsersGQL extends Apollo.Query<GetAllOnlineUsersQuery, GetAllOnlineUsersQueryVariables> {
    document = GetAllOnlineUsersDocument;
    
  }
export const GetLeadAssignmentListByAccountDocument = gql`
    query getLeadAssignmentListByAccount {
  getLeadAssignmentListByAccount {
    leadAssignmentId
    staffName
    seqNo
    weightage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeadAssignmentListByAccountGQL extends Apollo.Query<GetLeadAssignmentListByAccountQuery, GetLeadAssignmentListByAccountQueryVariables> {
    document = GetLeadAssignmentListByAccountDocument;
    
  }
export const GetLeadAssignmentFormSourceDocument = gql`
    query getLeadAssignmentFormSource {
  getLeadAssignmentFormSource {
    weight
    seq
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeadAssignmentFormSourceGQL extends Apollo.Query<GetLeadAssignmentFormSourceQuery, GetLeadAssignmentFormSourceQueryVariables> {
    document = GetLeadAssignmentFormSourceDocument;
    
  }
export const GetLeadAssigmentByIdDocument = gql`
    query getLeadAssigmentById($leadAssigmentId: String!) {
  getLeadAssigmentById(leadAssigmentId: $leadAssigmentId) {
    seqNo
    leadAssignmentId
    weightage
    staffName
    staffId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeadAssigmentByIdGQL extends Apollo.Query<GetLeadAssigmentByIdQuery, GetLeadAssigmentByIdQueryVariables> {
    document = GetLeadAssigmentByIdDocument;
    
  }
export const EditLeadAssignmentDocument = gql`
    mutation editLeadAssignment($input: OpenLeadAssignmentSettingInput!) {
  editLeadAssignment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditLeadAssignmentGQL extends Apollo.Mutation<EditLeadAssignmentMutation, EditLeadAssignmentMutationVariables> {
    document = EditLeadAssignmentDocument;
    
  }
export const NewLeadAssignmentDocument = gql`
    mutation newLeadAssignment($input: NewLeadAssignmentInput!) {
  newLeadAssignment(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NewLeadAssignmentGQL extends Apollo.Mutation<NewLeadAssignmentMutation, NewLeadAssignmentMutationVariables> {
    document = NewLeadAssignmentDocument;
    
  }
export const DeleteLeadAssignmentDocument = gql`
    mutation deleteLeadAssignment($leadAssigmentId: String!) {
  deleteLeadAssignment(leadAssigmentId: $leadAssigmentId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLeadAssignmentGQL extends Apollo.Mutation<DeleteLeadAssignmentMutation, DeleteLeadAssignmentMutationVariables> {
    document = DeleteLeadAssignmentDocument;
    
  }
export const OrganizeLeadAssignmentSeqDocument = gql`
    mutation organizeLeadAssignmentSeq($id: [String!]!) {
  organizeLeadAssignmentSeq(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeLeadAssignmentSeqGQL extends Apollo.Mutation<OrganizeLeadAssignmentSeqMutation, OrganizeLeadAssignmentSeqMutationVariables> {
    document = OrganizeLeadAssignmentSeqDocument;
    
  }
export const GetLeadAssignmentSalesStaffDocument = gql`
    query getLeadAssignmentSalesStaff {
  getLeadAssignmentSalesStaff {
    staffId
    staffName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeadAssignmentSalesStaffGQL extends Apollo.Query<GetLeadAssignmentSalesStaffQuery, GetLeadAssignmentSalesStaffQueryVariables> {
    document = GetLeadAssignmentSalesStaffDocument;
    
  }
export const GetLeadAssignmentNotificationDocument = gql`
    query getLeadAssignmentNotification {
  getLeadAssignmentNotification {
    leadAssignmentActivated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLeadAssignmentNotificationGQL extends Apollo.Query<GetLeadAssignmentNotificationQuery, GetLeadAssignmentNotificationQueryVariables> {
    document = GetLeadAssignmentNotificationDocument;
    
  }
export const UpdateLeadAssignmentNotificationStatusDocument = gql`
    mutation updateLeadAssignmentNotificationStatus {
  updateLeadAssignmentNotificationStatus
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLeadAssignmentNotificationStatusGQL extends Apollo.Mutation<UpdateLeadAssignmentNotificationStatusMutation, UpdateLeadAssignmentNotificationStatusMutationVariables> {
    document = UpdateLeadAssignmentNotificationStatusDocument;
    
  }
export const IsIntegratedProjectDocument = gql`
    query isIntegratedProject($projectId: String!) {
  isIntegratedProject(projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsIntegratedProjectGQL extends Apollo.Query<IsIntegratedProjectQuery, IsIntegratedProjectQueryVariables> {
    document = IsIntegratedProjectDocument;
    
  }
export const SyncIntegratePackageDocument = gql`
    mutation syncIntegratePackage($projectId: String!) {
  syncIntegratePackage(projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncIntegratePackageGQL extends Apollo.Mutation<SyncIntegratePackageMutation, SyncIntegratePackageMutationVariables> {
    document = SyncIntegratePackageDocument;
    
  }
export const EditSalesPackageDocument = gql`
    mutation editSalesPackage($input: EditSalesPackageInput!) {
  editSalesPackage(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditSalesPackageGQL extends Apollo.Mutation<EditSalesPackageMutation, EditSalesPackageMutationVariables> {
    document = EditSalesPackageDocument;
    
  }
export const AddSalesPackageDocument = gql`
    mutation addSalesPackage($input: AddSalesPackageInput!) {
  addSalesPackage(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddSalesPackageGQL extends Apollo.Mutation<AddSalesPackageMutation, AddSalesPackageMutationVariables> {
    document = AddSalesPackageDocument;
    
  }
export const DeleteSalesPackageDocument = gql`
    mutation deleteSalesPackage($id: String!) {
  deleteSalesPackage(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSalesPackageGQL extends Apollo.Mutation<DeleteSalesPackageMutation, DeleteSalesPackageMutationVariables> {
    document = DeleteSalesPackageDocument;
    
  }
export const GetSalesPackagesListDocument = gql`
    query getSalesPackagesList($projectId: String!) {
  getSalesPackagesList(projectId: $projectId) {
    id
    name
    desc
    projectId
    listPrice
    marketValue
    startDate
    endDate
    isIntegrated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesPackagesListGQL extends Apollo.Query<GetSalesPackagesListQuery, GetSalesPackagesListQueryVariables> {
    document = GetSalesPackagesListDocument;
    
  }
export const GetSalesPackageByIdDocument = gql`
    query getSalesPackageById($id: String!) {
  getSalesPackageById(id: $id) {
    id
    name
    desc
    projectId
    listPrice
    marketValue
    startDate
    endDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesPackageByIdGQL extends Apollo.Query<GetSalesPackageByIdQuery, GetSalesPackageByIdQueryVariables> {
    document = GetSalesPackageByIdDocument;
    
  }
export const PaymentGatewayListDocument = gql`
    query paymentGatewayList {
  paymentGatewayListing {
    id
    gatewayTypeDesc
    title
    lastUpdate
    assignedProjectCount
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentGatewayListGQL extends Apollo.Query<PaymentGatewayListQuery, PaymentGatewayListQueryVariables> {
    document = PaymentGatewayListDocument;
    
  }
export const PaymentGatewayDetailsDocument = gql`
    query paymentGatewayDetails($paymentGatewayId: String!) {
  paymentGatewayDetails(payment_gateway_id: $paymentGatewayId) {
    id
    gatewayType
    gatewayTypeDesc
    title
    gatewayInfo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentGatewayDetailsGQL extends Apollo.Query<PaymentGatewayDetailsQuery, PaymentGatewayDetailsQueryVariables> {
    document = PaymentGatewayDetailsDocument;
    
  }
export const GetPaymentTypeDocument = gql`
    query getPaymentType {
  getPaymentgatewayEnum
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPaymentTypeGQL extends Apollo.Query<GetPaymentTypeQuery, GetPaymentTypeQueryVariables> {
    document = GetPaymentTypeDocument;
    
  }
export const PaymentGatewayFormDataDocument = gql`
    query paymentGatewayFormData($paymentGatewayId: String!) {
  paymentGatewayDetails(payment_gateway_id: $paymentGatewayId) {
    id
    gatewayType
    gatewayTypeDesc
    title
    gatewayInfo
    assignedProjectCount
  }
  getPaymentgatewayEnum
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PaymentGatewayFormDataGQL extends Apollo.Query<PaymentGatewayFormDataQuery, PaymentGatewayFormDataQueryVariables> {
    document = PaymentGatewayFormDataDocument;
    
  }
export const DeletePaymentGatewayDocument = gql`
    mutation deletePaymentGateway($paymentGatewayId: String!) {
  deletePaymentGateway(payment_gateway_id: $paymentGatewayId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePaymentGatewayGQL extends Apollo.Mutation<DeletePaymentGatewayMutation, DeletePaymentGatewayMutationVariables> {
    document = DeletePaymentGatewayDocument;
    
  }
export const AddPaymentGatewayDocument = gql`
    mutation addPaymentGateway($input: PaymentGatewayInput!) {
  addPaymentGateWay(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddPaymentGatewayGQL extends Apollo.Mutation<AddPaymentGatewayMutation, AddPaymentGatewayMutationVariables> {
    document = AddPaymentGatewayDocument;
    
  }
export const EditPaymentGatewayDocument = gql`
    mutation editPaymentGateway($input: PaymentGatewayInput!) {
  editPaymentGateWay(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditPaymentGatewayGQL extends Apollo.Mutation<EditPaymentGatewayMutation, EditPaymentGatewayMutationVariables> {
    document = EditPaymentGatewayDocument;
    
  }
export const ProjectDocument = gql`
    query project {
  getAllProject {
    id
    name
    currency
    firstGalleryImage {
      url
      caption
    }
    unitMinPrice
    projectAddress
    minPrice
    state
    city
  }
  allowAddProject
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectGQL extends Apollo.Query<ProjectQuery, ProjectQueryVariables> {
    document = ProjectDocument;
    
  }
export const ProjectDetailDocument = gql`
    query projectDetail($project_id: String!) {
  projectDetail(id: $project_id) {
    name
    projectCode
    desc
    isSaleMade
    currency
    country
    state
    city
    uom
    townshipName
    completionDate
    launchDate
    isIntegrated
    minPrice
    maxPrice
    unitMinBuiltUp
    unitMaxBuiltUp
    projectGps
    saleGalleryGps
    saleGalleryAddress
    projectAddress
    attachment {
      fileName
    }
    company {
      id
      name
      companyRegNo
      description
      imageUrl
    }
    developmentCompany {
      id
      name
      companyRegNo
      description
      imageUrl
    }
    holdingCompany {
      id
      name
      companyRegNo
      description
      imageUrl
    }
    projectType {
      id
      name
    }
    tenure
    tenureDesc
    landType
    landTypeDesc
    virtualModel {
      url
      caption
    }
    floorGalleryImage {
      block
      floor
      url
      caption
      floorlabel
    }
    units {
      block
      floor
      floorLabel
      builtUp
      unitLayout {
        desc
      }
    }
    unitLayoutGalleryImage {
      resourceid
      seqno
      caption
      url
      unitlayoutid
      unitLayout
      pictureid
      desc
      block
      unit_type_id
      virtualModelLink
    }
    galleryImage {
      url
      caption
    }
    amenities {
      items
      category
    }
    embededYoutubeLink {
      videoType
      caption
      thumbnail
      url
    }
    embededVimeoLink {
      videoType
      caption
      thumbnail
      url
    }
    embededGoogleDriveLink {
      videoType
      caption
      thumbnail
      url
    }
    virtualModelLink {
      url
      caption
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectDetailGQL extends Apollo.Query<ProjectDetailQuery, ProjectDetailQueryVariables> {
    document = ProjectDetailDocument;
    
  }
export const ProjectMasterDataDocument = gql`
    query projectMasterData {
  GetAllMasterInfo {
    LandType
    CurrencyCode
    Tenures
    Nationalities {
      id
      name
    }
    Countries {
      name
      ID
    }
    UOM
    IntegrationTypes
    ProjectTypes {
      id
      name
      defaulted
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectMasterDataGQL extends Apollo.Query<ProjectMasterDataQuery, ProjectMasterDataQueryVariables> {
    document = ProjectMasterDataDocument;
    
  }
export const AllowAddProjectDocument = gql`
    query allowAddProject {
  allowAddProject
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllowAddProjectGQL extends Apollo.Query<AllowAddProjectQuery, AllowAddProjectQueryVariables> {
    document = AllowAddProjectDocument;
    
  }
export const AddProjectDocument = gql`
    mutation addProject($Input: AdminProjectInput!) {
  addProject(input: $Input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddProjectGQL extends Apollo.Mutation<AddProjectMutation, AddProjectMutationVariables> {
    document = AddProjectDocument;
    
  }
export const EditProjectDocument = gql`
    mutation editProject($Input: AdminProjectInput!) {
  editProject(input: $Input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditProjectGQL extends Apollo.Mutation<EditProjectMutation, EditProjectMutationVariables> {
    document = EditProjectDocument;
    
  }
export const GetProjectByIdForProjectSummaryDocument = gql`
    query getProjectByIdForProjectSummary($projectId: String!) {
  getProjectById(projectId: $projectId) {
    id
    projectLastUpdate
    galleryLastUpdate
    layoutImagesLastUpdate
    unitSetupLastUpdate
    carParkSetupLastUpdate
    unitAllocationLastUpdate
    salesChartLastUpdate
    salesDocLastUpdate
    siteProgressLastUpdate
    projectBrochureLastUpdate
    salesPackageLastUpdate
    discountLastUpdate
    efPanelLastUpdate
    solicitorLastUpdate
    policySettingLastUpdate
    roleAuthorizationLastUpdate
    teamAssignmentLastUpdate
    countUnitTotal
    isIntegrated
    standardLetterLastUpdate
    IsSubscribed
    eLaunchLastUpdate
    appointmentSchedulingLastUpdate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProjectByIdForProjectSummaryGQL extends Apollo.Query<GetProjectByIdForProjectSummaryQuery, GetProjectByIdForProjectSummaryQueryVariables> {
    document = GetProjectByIdForProjectSummaryDocument;
    
  }
export const ProjectGetAllDocument = gql`
    query projectGetAll {
  getAllProject {
    id
    name
    currency
    firstGalleryImage {
      url
      caption
    }
    projectAddress
    company {
      name
    }
    minPrice
    unitMinPrice
    state
    city
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectGetAllGQL extends Apollo.Query<ProjectGetAllQuery, ProjectGetAllQueryVariables> {
    document = ProjectGetAllDocument;
    
  }
export const GetLangListDocument = gql`
    query getLangList {
  GetAllMasterInfo {
    Language
    SoftwareCode
    PurchaserAppSetting
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLangListGQL extends Apollo.Query<GetLangListQuery, GetLangListQueryVariables> {
    document = GetLangListDocument;
    
  }
export const ProjectSpecDetailDocument = gql`
    query projectSpecDetail($projectId: String!) {
  GetProjectSpecByProjectId(project_id: $projectId) {
    minBookingfeeAmount
    formLang
    purchaserAppSettings
    bookingFeeMandatory
    bookingfeeAmountRequired
    bookingSignRequired
    minAgeRequired
    minAge
    nricAttachmentRequired
    ccrAttachmentRequired
    bookingPDPAconsentRequired
    bookingRefundPolicyconsentRequired
    statementRefundPolicy
    templatePackagesShow
    templateDiscountsShow
    templateAddressShow
    templateRemarksShow
    templateMaritalStatusShow
    templateCompanyShow
    loanconsentRequired
    loanScreening
    expectedSnpRequired
    expectedSnpDuration
    getSoftwareCode
    trGeneration
    ELetteringSMSRequired
    autoReleaseNotificationReminder {
      reminderDay
      salesUserReceive
      agencyUserReceive
    }
    paymentGateway {
      title
    }
    paymentGatewayRefundPolicy
    autoAssignLeadActivated
    assignStartTime
    assignEndTime
    autoReassignLeadActivated
    autoReassignLeadDuration
    reassignStartTime
    reassignEndTime
    notifyUnattendedLeadActivated
    notifyUnattendedLeadDuration
    unattendedLeadNotificationMethod
    unattendedLeadManagerHandled
    leadAgingActivated
    leadAgingNotificationMethod
    leadIdleOne
    leadIdleTwo
    leadIdleThree
    leadAgingManagerHandled
    leadAssignNotificationActivated
    leadAssignNotificationMethod
    reservationSales
    reservationAgency
    autoReleaseReservationDay
    saleLeadNotification {
      leadAssignment
      loanAssignment {
        salesUserReceive
        agencyUserReceive
        endFinUserReceive
      }
      solicitorCaseAssignment {
        salesUserReceive
        agencyUserReceive
        solicitorUserReceive
      }
      booking {
        assignmentSalesUserReceive
        assignmentAgencyUserReceive
        assignmentPurchaserReceive
        attachTr
        attachBookingAttachment
      }
      bookingCancellation {
        salesUserReceive
        agencyUserReceive
        purchaserReceive
      }
      snpSigningReminder {
        salesUserReceive
        agencyUserReceive
        purchaserReceive
        beforeDay
        afterDay
      }
    }
    agencyLeadNotification {
      loanAssignment {
        salesUserReceive
        agencyUserReceive
        endFinUserReceive
      }
    }
    unattendedLeadManagerNames {
      name
    }
    leadAgingManagerNames {
      name
    }
    getAccountSpec {
      loanPlusProjectId
    }
    unitSort
    alertAgingActivated
    salesAlertAging {
      isActive
      maxMinorSalesAlertAging
      maxMajorSalesAlertAging
    }
    loanAlertAging {
      isActive
      maxMinorLoanAlertAging
      maxMajorLoanAlertAging
    }
    solicitorAlertAging {
      isActive
      maxMinorSolicitorAlertAging
      maxMajorSolicitorAlertAging
    }
    display2DChart
  }
  getProjectById(projectId: $projectId) {
    developmentCompany {
      id
    }
    holdingCompany {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectSpecDetailGQL extends Apollo.Query<ProjectSpecDetailQuery, ProjectSpecDetailQueryVariables> {
    document = ProjectSpecDetailDocument;
    
  }
export const EditProjectSpecDocument = gql`
    mutation editProjectSpec($input: AdminSaveProjectSpecInput!) {
  EditProjectSpec(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditProjectSpecGQL extends Apollo.Mutation<EditProjectSpecMutation, EditProjectSpecMutationVariables> {
    document = EditProjectSpecDocument;
    
  }
export const ProjectSpecDetailForEditFormDocument = gql`
    query ProjectSpecDetailForEditForm($projectId: String!) {
  GetProjectSpecByProjectId(project_id: $projectId) {
    bookingFormLang
    purchaserAppSetting
    bookingFeeMandatory
    minBookingfeeAmount
    bookingfeeAmountRequired
    bookingSignRequired
    minAgeRequired
    minAge
    nricAttachmentRequired
    ccrAttachmentRequired
    bookingPDPAconsentRequired
    bookingRefundPolicyconsentRequired
    statementRefundPolicy
    templatePackagesShow
    templateDiscountsShow
    templateAddressShow
    templateRemarksShow
    templateMaritalStatusShow
    templateCompanyShow
    loanconsentRequired
    loanScreening
    expectedSnpRequired
    expectedSnpDuration
    paymentGatewayId
    paymentGatewayRefundPolicy
    autoAssignLeadActivated
    assignStartTime
    assignEndTime
    autoReleaseNotificationReminder {
      reminderDay
      salesUserReceive
      agencyUserReceive
    }
    autoReassignLeadActivated
    autoReassignLeadDuration
    reassignStartTime
    reassignEndTime
    notifyUnattendedLeadActivated
    notifyUnattendedLeadDuration
    unattendedLeadNotificationMethod
    unattendedLeadManagerHandled
    leadAgingActivated
    leadAgingNotificationMethod
    leadIdleOne
    leadIdleTwo
    leadIdleThree
    leadAgingManagerHandled
    getSoftwareCode
    unitSort
    trGeneration
    ELetteringSMSRequired
    leadAssignNotificationActivated
    leadAssignNotificationMethod
    reservationAgency
    reservationSales
    autoReleaseReservationDay
    saleLeadNotification {
      leadAssignment
      loanAssignment {
        salesUserReceive
        agencyUserReceive
        endFinUserReceive
      }
      solicitorCaseAssignment {
        salesUserReceive
        agencyUserReceive
        solicitorUserReceive
      }
      booking {
        assignmentSalesUserReceive
        assignmentAgencyUserReceive
        assignmentPurchaserReceive
        attachTr
        attachBookingAttachment
      }
      bookingCancellation {
        salesUserReceive
        agencyUserReceive
        purchaserReceive
      }
      snpSigningReminder {
        salesUserReceive
        agencyUserReceive
        purchaserReceive
        beforeDay
        afterDay
      }
    }
    agencyLeadNotification {
      loanAssignment {
        salesUserReceive
        agencyUserReceive
        endFinUserReceive
      }
    }
    getAccountSpec {
      loanPlusProjectId
    }
    alertAgingActivated
    salesAlertAging {
      isActive
      maxMinorSalesAlertAging
      maxMajorSalesAlertAging
    }
    loanAlertAging {
      isActive
      maxMinorLoanAlertAging
      maxMajorLoanAlertAging
    }
    solicitorAlertAging {
      isActive
      maxMinorSolicitorAlertAging
      maxMajorSolicitorAlertAging
    }
    display2DChart
  }
  getProjectById(projectId: $projectId) {
    developmentCompany {
      id
    }
    holdingCompany {
      id
    }
  }
  getSuserListForProjectSpec {
    ID
    name
  }
  paymentGatewayListing {
    id
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ProjectSpecDetailForEditFormGQL extends Apollo.Query<ProjectSpecDetailForEditFormQuery, ProjectSpecDetailForEditFormQueryVariables> {
    document = ProjectSpecDetailForEditFormDocument;
    
  }
export const GetIntegrationDetailsByProjectIdDocument = gql`
    query GetIntegrationDetailsByProjectId($projectId: String!) {
  GetIntegrationDetailsByProjectId(projectId: $projectId) {
    ifcaProjectId
    ifcaPhaseId
    integrationUrl
    gracePeriod
    paymentPlanId
    paymentPlanCode
    paymentPlanDesc
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetIntegrationDetailsByProjectIdGQL extends Apollo.Query<GetIntegrationDetailsByProjectIdQuery, GetIntegrationDetailsByProjectIdQueryVariables> {
    document = GetIntegrationDetailsByProjectIdDocument;
    
  }
export const UserAccessEntityDocument = gql`
    mutation UserAccessEntity($projectId: String!) {
  updateUserLatestEntity(project_id: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserAccessEntityGQL extends Apollo.Mutation<UserAccessEntityMutation, UserAccessEntityMutationVariables> {
    document = UserAccessEntityDocument;
    
  }
export const GetGalleryVideoByProjectDocument = gql`
    query getGalleryVideoByProject($projectid: String!) {
  GetVideoGalleryByProject(projectId: $projectid)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGalleryVideoByProjectGQL extends Apollo.Query<GetGalleryVideoByProjectQuery, GetGalleryVideoByProjectQueryVariables> {
    document = GetGalleryVideoByProjectDocument;
    
  }
export const EditGalleryVideoDocument = gql`
    mutation editGalleryVideo($input: [AdminEditGalleryVideoInput!]!) {
  EditGalleryVideo(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditGalleryVideoGQL extends Apollo.Mutation<EditGalleryVideoMutation, EditGalleryVideoMutationVariables> {
    document = EditGalleryVideoDocument;
    
  }
export const GetGalleryTourByProjectDocument = gql`
    query getGalleryTourByProject($projectid: String!) {
  GetGalleryTourByProject(projectId: $projectid)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGalleryTourByProjectGQL extends Apollo.Query<GetGalleryTourByProjectQuery, GetGalleryTourByProjectQueryVariables> {
    document = GetGalleryTourByProjectDocument;
    
  }
export const EditGalleryTourDocument = gql`
    mutation editGalleryTour($input: [AdminEditGalleryTourInput!]!) {
  EditGalleryTour(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditGalleryTourGQL extends Apollo.Mutation<EditGalleryTourMutation, EditGalleryTourMutationVariables> {
    document = EditGalleryTourDocument;
    
  }
export const GetProjectGalleryByProjectDocument = gql`
    query getProjectGalleryByProject($projectid: String!) {
  GetProjectGalleryByProject(projectId: $projectid) {
    resourceid
    url
    pictureid
    seqno
    caption
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetProjectGalleryByProjectGQL extends Apollo.Query<GetProjectGalleryByProjectQuery, GetProjectGalleryByProjectQueryVariables> {
    document = GetProjectGalleryByProjectDocument;
    
  }
export const EditProjectGalleryDocument = gql`
    mutation editProjectGallery($input: [AdminEditProjectGalleryInput!]!) {
  EditProjectGallery(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditProjectGalleryGQL extends Apollo.Mutation<EditProjectGalleryMutation, EditProjectGalleryMutationVariables> {
    document = EditProjectGalleryDocument;
    
  }
export const DeleteProjectGalleryDocument = gql`
    mutation deleteProjectGallery($input: [AdminEditProjectGalleryInput!]!) {
  DeleteProjectGallery(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProjectGalleryGQL extends Apollo.Mutation<DeleteProjectGalleryMutation, DeleteProjectGalleryMutationVariables> {
    document = DeleteProjectGalleryDocument;
    
  }
export const GetBlockGalleryByProjectDocument = gql`
    query getBlockGalleryByProject($projectid: String!) {
  GetBlockGalleryByProject(projectId: $projectid) {
    resourceid
    url
    caption
    pictureid
    block
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBlockGalleryByProjectGQL extends Apollo.Query<GetBlockGalleryByProjectQuery, GetBlockGalleryByProjectQueryVariables> {
    document = GetBlockGalleryByProjectDocument;
    
  }
export const GetDistinctBlockByProjectIdDocument = gql`
    query getDistinctBlockByProjectId($projectid: String!) {
  GetDistinctBlockByProjectId(projectId: $projectid) {
    block
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDistinctBlockByProjectIdGQL extends Apollo.Query<GetDistinctBlockByProjectIdQuery, GetDistinctBlockByProjectIdQueryVariables> {
    document = GetDistinctBlockByProjectIdDocument;
    
  }
export const EditBlockGalleryDocument = gql`
    mutation editBlockGallery($input: [AdminEditLayoutBlockInput!]!) {
  EditBlockGallery(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditBlockGalleryGQL extends Apollo.Mutation<EditBlockGalleryMutation, EditBlockGalleryMutationVariables> {
    document = EditBlockGalleryDocument;
    
  }
export const DeleteBlockGalleryDocument = gql`
    mutation deleteBlockGallery($input: [AdminEditLayoutBlockInput!]!) {
  DeleteBlockGallery(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBlockGalleryGQL extends Apollo.Mutation<DeleteBlockGalleryMutation, DeleteBlockGalleryMutationVariables> {
    document = DeleteBlockGalleryDocument;
    
  }
export const GetFloorGalleryByProjectDocument = gql`
    query getFloorGalleryByProject($projectid: String!) {
  GetFloorGalleryByProject(projectId: $projectid) {
    resourceid
    url
    pictureid
    seqno
    caption
    block
    floor
    blockFloor
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFloorGalleryByProjectGQL extends Apollo.Query<GetFloorGalleryByProjectQuery, GetFloorGalleryByProjectQueryVariables> {
    document = GetFloorGalleryByProjectDocument;
    
  }
export const GetDistinctFloorByProjectIdDocument = gql`
    query getDistinctFloorByProjectId($projectid: String!) {
  GetDistinctFloorByProjectId(projectId: $projectid) {
    block
    floor
    blockFloor
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDistinctFloorByProjectIdGQL extends Apollo.Query<GetDistinctFloorByProjectIdQuery, GetDistinctFloorByProjectIdQueryVariables> {
    document = GetDistinctFloorByProjectIdDocument;
    
  }
export const GetUnitGalleryByProjectDocument = gql`
    query getUnitGalleryByProject($projectid: String!) {
  GetUnitGalleryByProject(projectId: $projectid) {
    resourceid
    url
    pictureid
    seqno
    caption
    unit_layout_id
    unit_type_id
    virtualModelLink
    desc
    block
    unit_type_desc
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitGalleryByProjectGQL extends Apollo.Query<GetUnitGalleryByProjectQuery, GetUnitGalleryByProjectQueryVariables> {
    document = GetUnitGalleryByProjectDocument;
    
  }
export const EditFloorGalleryDocument = gql`
    mutation editFloorGallery($input: [AdminEditLayoutFloorInput!]!) {
  EditFloorGallery(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditFloorGalleryGQL extends Apollo.Mutation<EditFloorGalleryMutation, EditFloorGalleryMutationVariables> {
    document = EditFloorGalleryDocument;
    
  }
export const DeleteFloorGalleryDocument = gql`
    mutation deleteFloorGallery($input: [AdminEditLayoutFloorInput!]!) {
  DeleteFloorGallery(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFloorGalleryGQL extends Apollo.Mutation<DeleteFloorGalleryMutation, DeleteFloorGalleryMutationVariables> {
    document = DeleteFloorGalleryDocument;
    
  }
export const GetDistinctUnitByProjectIdDocument = gql`
    query getDistinctUnitByProjectId($projectid: String!) {
  GetDistinctUnitByProjectId(projectId: $projectid) {
    unit_layout_id
    desc
    block
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDistinctUnitByProjectIdGQL extends Apollo.Query<GetDistinctUnitByProjectIdQuery, GetDistinctUnitByProjectIdQueryVariables> {
    document = GetDistinctUnitByProjectIdDocument;
    
  }
export const GetDistinctUnitTypeByProjectIdDocument = gql`
    query getDistinctUnitTypeByProjectId($projectid: String!) {
  GetDistinctUnitTypeByProjectId(projectId: $projectid) {
    unit_type_id
    unit_type_desc
    unit_block
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDistinctUnitTypeByProjectIdGQL extends Apollo.Query<GetDistinctUnitTypeByProjectIdQuery, GetDistinctUnitTypeByProjectIdQueryVariables> {
    document = GetDistinctUnitTypeByProjectIdDocument;
    
  }
export const EditUnitGalleryDocument = gql`
    mutation editUnitGallery($input: [AdminEditLayoutUnitInput!]!) {
  EditUnitGallery(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditUnitGalleryGQL extends Apollo.Mutation<EditUnitGalleryMutation, EditUnitGalleryMutationVariables> {
    document = EditUnitGalleryDocument;
    
  }
export const DeleteUnitGalleryDocument = gql`
    mutation deleteUnitGallery($input: [AdminEditLayoutUnitInput!]!) {
  DeleteUnitGallery(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUnitGalleryGQL extends Apollo.Mutation<DeleteUnitGalleryMutation, DeleteUnitGalleryMutationVariables> {
    document = DeleteUnitGalleryDocument;
    
  }
export const ViewAppointmentScheduleDocument = gql`
    query viewAppointmentSchedule($projectId: String!) {
  viewAppointmentSchedule(projectId: $projectId) {
    id
    projectId
    startTime
    endTime
    maxPaxPerAppoitment
    closeDate {
      closeId
      startDate
      endDate
      BlockstartTime
      BlockendTime
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ViewAppointmentScheduleGQL extends Apollo.Query<ViewAppointmentScheduleQuery, ViewAppointmentScheduleQueryVariables> {
    document = ViewAppointmentScheduleDocument;
    
  }
export const UpdateAppointmentScheduleDocument = gql`
    mutation updateAppointmentSchedule($input: EditAppointmentScheduleInput!) {
  updateAppointmentSchedule(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAppointmentScheduleGQL extends Apollo.Mutation<UpdateAppointmentScheduleMutation, UpdateAppointmentScheduleMutationVariables> {
    document = UpdateAppointmentScheduleDocument;
    
  }
export const AddSalesGalleryCloseDateDocument = gql`
    mutation addSalesGalleryCloseDate($input: addBlockDateInput!) {
  addSalesGalleryCloseDate(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddSalesGalleryCloseDateGQL extends Apollo.Mutation<AddSalesGalleryCloseDateMutation, AddSalesGalleryCloseDateMutationVariables> {
    document = AddSalesGalleryCloseDateDocument;
    
  }
export const ViewCloseDateByIdDocument = gql`
    query viewCloseDateById($id: String!) {
  viewCloseDateById(id: $id) {
    id
    accountId
    projectId
    startTime
    endTime
    startDate
    endDate
    appointmentSchedulingId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ViewCloseDateByIdGQL extends Apollo.Query<ViewCloseDateByIdQuery, ViewCloseDateByIdQueryVariables> {
    document = ViewCloseDateByIdDocument;
    
  }
export const EditSalesGalleryCloseDateDocument = gql`
    mutation editSalesGalleryCloseDate($input: editBlockDateInput!) {
  editSalesGalleryCloseDate(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditSalesGalleryCloseDateGQL extends Apollo.Mutation<EditSalesGalleryCloseDateMutation, EditSalesGalleryCloseDateMutationVariables> {
    document = EditSalesGalleryCloseDateDocument;
    
  }
export const DeleteSalesGalleryCloseDateDocument = gql`
    mutation deleteSalesGalleryCloseDate($input: CloseDateIdInput!) {
  deleteSalesGalleryCloseDate(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSalesGalleryCloseDateGQL extends Apollo.Mutation<DeleteSalesGalleryCloseDateMutation, DeleteSalesGalleryCloseDateMutationVariables> {
    document = DeleteSalesGalleryCloseDateDocument;
    
  }
export const GetAllActiveProjectIntegrationDocument = gql`
    query getAllActiveProjectIntegration {
  getAllActiveProjectIntegration {
    id
    accountId
    projectId
    ifcaCompanyName
    integrationUrl
    integrationType
    ifcaProjectName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActiveProjectIntegrationGQL extends Apollo.Query<GetAllActiveProjectIntegrationQuery, GetAllActiveProjectIntegrationQueryVariables> {
    document = GetAllActiveProjectIntegrationDocument;
    
  }
export const GetAllActiveProjectIntegrationWithUrlDocument = gql`
    query getAllActiveProjectIntegrationWithUrl {
  getAllActiveProjectIntegrationWithUrl {
    id
    accountId
    integrationType
    integrationUrl
    companyName
    message
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllActiveProjectIntegrationWithUrlGQL extends Apollo.Query<GetAllActiveProjectIntegrationWithUrlQuery, GetAllActiveProjectIntegrationWithUrlQueryVariables> {
    document = GetAllActiveProjectIntegrationWithUrlDocument;
    
  }
export const GetAllGatewayUpdatesDocument = gql`
    query getAllGatewayUpdates {
  getAllGatewayUpdates {
    ID
    IntegrationType
    version
    md5
    hasSqlUpdate
    url
    verifySql
    sql
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllGatewayUpdatesGQL extends Apollo.Query<GetAllGatewayUpdatesQuery, GetAllGatewayUpdatesQueryVariables> {
    document = GetAllGatewayUpdatesDocument;
    
  }
export const GetAllGatewayUpdatesByTypeDocument = gql`
    query getAllGatewayUpdatesByType($IntType: String!) {
  getAllGatewayUpdatesByType(IntType: $IntType) {
    ID
    IntegrationType
    version
    md5
    hasSqlUpdate
    url
    verifySql
    sql
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllGatewayUpdatesByTypeGQL extends Apollo.Query<GetAllGatewayUpdatesByTypeQuery, GetAllGatewayUpdatesByTypeQueryVariables> {
    document = GetAllGatewayUpdatesByTypeDocument;
    
  }
export const EditGatewayUpdatesDocument = gql`
    mutation editGatewayUpdates($input: sGatewayUpdateInput!) {
  editGatewayUpdates(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditGatewayUpdatesGQL extends Apollo.Mutation<EditGatewayUpdatesMutation, EditGatewayUpdatesMutationVariables> {
    document = EditGatewayUpdatesDocument;
    
  }
export const AddGatewayUpdatesDocument = gql`
    mutation addGatewayUpdates($input: sGatewayAddInput!) {
  addGatewayUpdates(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddGatewayUpdatesGQL extends Apollo.Mutation<AddGatewayUpdatesMutation, AddGatewayUpdatesMutationVariables> {
    document = AddGatewayUpdatesDocument;
    
  }
export const GetGatewayUpdatesByIdDocument = gql`
    query getGatewayUpdatesById($ID: String!) {
  getGatewayUpdatesById(ID: $ID) {
    ID
    IntegrationType
    version
    md5
    hasSqlUpdate
    url
    verifySql
    sql
    releaseNote
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGatewayUpdatesByIdGQL extends Apollo.Query<GetGatewayUpdatesByIdQuery, GetGatewayUpdatesByIdQueryVariables> {
    document = GetGatewayUpdatesByIdDocument;
    
  }
export const DeleteGatewayUpdatesByIdDocument = gql`
    mutation deleteGatewayUpdatesById($ID: String!) {
  deleteGatewayUpdatesById(ID: $ID)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteGatewayUpdatesByIdGQL extends Apollo.Mutation<DeleteGatewayUpdatesByIdMutation, DeleteGatewayUpdatesByIdMutationVariables> {
    document = DeleteGatewayUpdatesByIdDocument;
    
  }
export const GetAllOnPremApiVerDocument = gql`
    query getAllOnPremApiVer {
  getAllOnPremApiVer {
    onPremVer
    onPremIntType
    apiUrl
    accountId
    softwareCode
    sApiGatewayId
    getSuccess
    errno
    errMsg
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllOnPremApiVerGQL extends Apollo.Query<GetAllOnPremApiVerQuery, GetAllOnPremApiVerQueryVariables> {
    document = GetAllOnPremApiVerDocument;
    
  }
export const UpdateAllOnPremApisDocument = gql`
    query updateAllOnPremApis {
  updateAllOnPremApis {
    id
    apiUrl
    integrationType
    version
    errno
    errMsg
    updated
    apiMsg
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAllOnPremApisGQL extends Apollo.Query<UpdateAllOnPremApisQuery, UpdateAllOnPremApisQueryVariables> {
    document = UpdateAllOnPremApisDocument;
    
  }
export const GetOnPremApiVerDocument = gql`
    query getOnPremApiVer($ID: String!) {
  getOnPremApiVer(ID: $ID) {
    onPremVer
    onPremIntType
    apiUrl
    softwareCode
    sApiGatewayId
    getSuccess
    errno
    errMsg
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOnPremApiVerGQL extends Apollo.Query<GetOnPremApiVerQuery, GetOnPremApiVerQueryVariables> {
    document = GetOnPremApiVerDocument;
    
  }
export const UpdateOnPremApiDocument = gql`
    query updateOnPremApi($ID: String!) {
  updateOnPremApi(ID: $ID) {
    apiUrl
    integrationType
    version
    errno
    errMsg
    updated
    apiMsg
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOnPremApiGQL extends Apollo.Query<UpdateOnPremApiQuery, UpdateOnPremApiQueryVariables> {
    document = UpdateOnPremApiDocument;
    
  }
export const UpdateOnPremApiByVerDocument = gql`
    query updateOnPremApiByVer($ID: String!, $updateApiID: String!) {
  updateOnPremApiByVer(ID: $ID, updateApiID: $updateApiID) {
    id
    apiUrl
    integrationType
    version
    errno
    errMsg
    updated
    apiMsg
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateOnPremApiByVerGQL extends Apollo.Query<UpdateOnPremApiByVerQuery, UpdateOnPremApiByVerQueryVariables> {
    document = UpdateOnPremApiByVerDocument;
    
  }
export const GetAllProjectTypeDocument = gql`
    query getAllProjectType {
  getAllProjectType {
    id
    name
    commonStatus
    defaulted
    seq_no
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllProjectTypeGQL extends Apollo.Query<GetAllProjectTypeQuery, GetAllProjectTypeQueryVariables> {
    document = GetAllProjectTypeDocument;
    
  }
export const EditProjectTypeDocument = gql`
    mutation editProjectType($input: EditProjectTypeInput!) {
  editProjectType(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditProjectTypeGQL extends Apollo.Mutation<EditProjectTypeMutation, EditProjectTypeMutationVariables> {
    document = EditProjectTypeDocument;
    
  }
export const AddProjectTypeDocument = gql`
    mutation addProjectType($input: ProjectTypeInput!) {
  addProjectType(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddProjectTypeGQL extends Apollo.Mutation<AddProjectTypeMutation, AddProjectTypeMutationVariables> {
    document = AddProjectTypeDocument;
    
  }
export const DeleteProjectTypeByIdDocument = gql`
    mutation deleteProjectTypeById($projectTypeId: String!) {
  deleteProjectTypeById(projectTypeId: $projectTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProjectTypeByIdGQL extends Apollo.Mutation<DeleteProjectTypeByIdMutation, DeleteProjectTypeByIdMutationVariables> {
    document = DeleteProjectTypeByIdDocument;
    
  }
export const SetDefaultProjectTypeDocument = gql`
    mutation setDefaultProjectType($projectTypeId: String!) {
  setDefaultProjectType(projectTypeId: $projectTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultProjectTypeGQL extends Apollo.Mutation<SetDefaultProjectTypeMutation, SetDefaultProjectTypeMutationVariables> {
    document = SetDefaultProjectTypeDocument;
    
  }
export const RemoveDefaultProjectTypeDocument = gql`
    mutation removeDefaultProjectType($projectTypeId: String!) {
  removeDefaultProjectType(projectTypeId: $projectTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultProjectTypeGQL extends Apollo.Mutation<RemoveDefaultProjectTypeMutation, RemoveDefaultProjectTypeMutationVariables> {
    document = RemoveDefaultProjectTypeDocument;
    
  }
export const OrganizeProjectTypeDocument = gql`
    mutation organizeProjectType($projectTypeId: [String!]!) {
  organizeProjectType(projectTypeId: $projectTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeProjectTypeGQL extends Apollo.Mutation<OrganizeProjectTypeMutation, OrganizeProjectTypeMutationVariables> {
    document = OrganizeProjectTypeDocument;
    
  }
export const GetAllPropertyTypeDocument = gql`
    query getAllPropertyType {
  getAllPropertyType {
    id
    name
    commercialPurpose
    commonStatus
    defaulted
    seq_no
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllPropertyTypeGQL extends Apollo.Query<GetAllPropertyTypeQuery, GetAllPropertyTypeQueryVariables> {
    document = GetAllPropertyTypeDocument;
    
  }
export const EditPropertyTypeDocument = gql`
    mutation editPropertyType($input: EditPropertyTypeInput!) {
  editPropertyType(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditPropertyTypeGQL extends Apollo.Mutation<EditPropertyTypeMutation, EditPropertyTypeMutationVariables> {
    document = EditPropertyTypeDocument;
    
  }
export const AddPropertyTypeDocument = gql`
    mutation addPropertyType($input: PropertyTypeInput!) {
  addPropertyType(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddPropertyTypeGQL extends Apollo.Mutation<AddPropertyTypeMutation, AddPropertyTypeMutationVariables> {
    document = AddPropertyTypeDocument;
    
  }
export const DeletePropertyTypeByIdDocument = gql`
    mutation deletePropertyTypeById($propertyTypeId: String!) {
  deletePropertyTypeById(propertyTypeId: $propertyTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePropertyTypeByIdGQL extends Apollo.Mutation<DeletePropertyTypeByIdMutation, DeletePropertyTypeByIdMutationVariables> {
    document = DeletePropertyTypeByIdDocument;
    
  }
export const SetDefaultPropertyTypeDocument = gql`
    mutation setDefaultPropertyType($propertyTypeId: String!) {
  setDefaultPropertyType(propertyTypeId: $propertyTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultPropertyTypeGQL extends Apollo.Mutation<SetDefaultPropertyTypeMutation, SetDefaultPropertyTypeMutationVariables> {
    document = SetDefaultPropertyTypeDocument;
    
  }
export const RemoveDefaultPropertyTypeDocument = gql`
    mutation removeDefaultPropertyType($propertyTypeId: String!) {
  removeDefaultPropertyType(propertyTypeId: $propertyTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultPropertyTypeGQL extends Apollo.Mutation<RemoveDefaultPropertyTypeMutation, RemoveDefaultPropertyTypeMutationVariables> {
    document = RemoveDefaultPropertyTypeDocument;
    
  }
export const OrganizePropertyTypeDocument = gql`
    mutation organizePropertyType($propertyTypeId: [String!]!) {
  organizePropertyType(propertyTypeId: $propertyTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizePropertyTypeGQL extends Apollo.Mutation<OrganizePropertyTypeMutation, OrganizePropertyTypeMutationVariables> {
    document = OrganizePropertyTypeDocument;
    
  }
export const GetMasterCommercialPurposeDocument = gql`
    query getMasterCommercialPurpose {
  GetAllMasterInfo {
    CommercialPurposes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMasterCommercialPurposeGQL extends Apollo.Query<GetMasterCommercialPurposeQuery, GetMasterCommercialPurposeQueryVariables> {
    document = GetMasterCommercialPurposeDocument;
    
  }
export const GetAllRaceDocument = gql`
    query getAllRace {
  getAllRace {
    id
    name
    commonStatus
    defaulted
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllRaceGQL extends Apollo.Query<GetAllRaceQuery, GetAllRaceQueryVariables> {
    document = GetAllRaceDocument;
    
  }
export const EditRaceDocument = gql`
    mutation editRace($input: EditRaceInput!) {
  editRace(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditRaceGQL extends Apollo.Mutation<EditRaceMutation, EditRaceMutationVariables> {
    document = EditRaceDocument;
    
  }
export const AddRaceDocument = gql`
    mutation addRace($input: RaceInput!) {
  addRace(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddRaceGQL extends Apollo.Mutation<AddRaceMutation, AddRaceMutationVariables> {
    document = AddRaceDocument;
    
  }
export const DeleteRaceByIdDocument = gql`
    mutation deleteRaceById($raceId: String!) {
  deleteRaceById(raceId: $raceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRaceByIdGQL extends Apollo.Mutation<DeleteRaceByIdMutation, DeleteRaceByIdMutationVariables> {
    document = DeleteRaceByIdDocument;
    
  }
export const SetDefaultRaceDocument = gql`
    mutation setDefaultRace($raceId: String!) {
  setDefaultRace(raceId: $raceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultRaceGQL extends Apollo.Mutation<SetDefaultRaceMutation, SetDefaultRaceMutationVariables> {
    document = SetDefaultRaceDocument;
    
  }
export const RemoveDefaultRaceDocument = gql`
    mutation removeDefaultRace($raceId: String!) {
  removeDefaultRace(raceId: $raceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultRaceGQL extends Apollo.Mutation<RemoveDefaultRaceMutation, RemoveDefaultRaceMutationVariables> {
    document = RemoveDefaultRaceDocument;
    
  }
export const OrganizeRaceDocument = gql`
    mutation organizeRace($raceIds: [String!]!) {
  organizeRace(raceIds: $raceIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeRaceGQL extends Apollo.Mutation<OrganizeRaceMutation, OrganizeRaceMutationVariables> {
    document = OrganizeRaceDocument;
    
  }
export const GetAllReasonCodeDocument = gql`
    query getAllReasonCode($type: String!) {
  getAllReasonCode(type: $type) {
    id
    name
    commonStatus
    defaulted
    type
    systemUse
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllReasonCodeGQL extends Apollo.Query<GetAllReasonCodeQuery, GetAllReasonCodeQueryVariables> {
    document = GetAllReasonCodeDocument;
    
  }
export const AddReasonCodeDocument = gql`
    mutation addReasonCode($input: ReasonCodeInput!) {
  addReasonCode(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddReasonCodeGQL extends Apollo.Mutation<AddReasonCodeMutation, AddReasonCodeMutationVariables> {
    document = AddReasonCodeDocument;
    
  }
export const DeleteReasonCodeByIdDocument = gql`
    mutation deleteReasonCodeById($reasonCodeId: String!) {
  deleteReasonCodeById(reasonCodeId: $reasonCodeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteReasonCodeByIdGQL extends Apollo.Mutation<DeleteReasonCodeByIdMutation, DeleteReasonCodeByIdMutationVariables> {
    document = DeleteReasonCodeByIdDocument;
    
  }
export const EditReasonCodeDocument = gql`
    mutation editReasonCode($input: EditReasonCodeInput!) {
  editReasonCode(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditReasonCodeGQL extends Apollo.Mutation<EditReasonCodeMutation, EditReasonCodeMutationVariables> {
    document = EditReasonCodeDocument;
    
  }
export const SetDefaultReasonCodeDocument = gql`
    mutation setDefaultReasonCode($reasonCodeId: String!, $type: String!) {
  setDefaultReasonCode(reasonCodeId: $reasonCodeId, type: $type)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultReasonCodeGQL extends Apollo.Mutation<SetDefaultReasonCodeMutation, SetDefaultReasonCodeMutationVariables> {
    document = SetDefaultReasonCodeDocument;
    
  }
export const RemoveDefaultReasonCodeDocument = gql`
    mutation removeDefaultReasonCode($reasonCodeId: String!, $type: String!) {
  removeDefaultReasonCode(reasonCodeId: $reasonCodeId, type: $type)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultReasonCodeGQL extends Apollo.Mutation<RemoveDefaultReasonCodeMutation, RemoveDefaultReasonCodeMutationVariables> {
    document = RemoveDefaultReasonCodeDocument;
    
  }
export const OrganizeReasonCodeDocument = gql`
    mutation organizeReasonCode($reasonCodeIds: [String!]!) {
  organizeReasonCode(reasonCodeIds: $reasonCodeIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeReasonCodeGQL extends Apollo.Mutation<OrganizeReasonCodeMutation, OrganizeReasonCodeMutationVariables> {
    document = OrganizeReasonCodeDocument;
    
  }
export const GetListOfRegionDocument = gql`
    query getListOfRegion {
  getListOfRegion {
    id
    name
    commonStatus
    systemUse
    defaulted
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetListOfRegionGQL extends Apollo.Query<GetListOfRegionQuery, GetListOfRegionQueryVariables> {
    document = GetListOfRegionDocument;
    
  }
export const AddRegionDocument = gql`
    mutation addRegion($input: RegionInput!) {
  addRegion(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddRegionGQL extends Apollo.Mutation<AddRegionMutation, AddRegionMutationVariables> {
    document = AddRegionDocument;
    
  }
export const EditRegionDocument = gql`
    mutation editRegion($input: EditRegionInput!) {
  editRegion(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditRegionGQL extends Apollo.Mutation<EditRegionMutation, EditRegionMutationVariables> {
    document = EditRegionDocument;
    
  }
export const DeleteRegionByIdDocument = gql`
    mutation deleteRegionById($regionId: String!) {
  deleteRegionById(regionId: $regionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRegionByIdGQL extends Apollo.Mutation<DeleteRegionByIdMutation, DeleteRegionByIdMutationVariables> {
    document = DeleteRegionByIdDocument;
    
  }
export const AlterRegionCommonStatusDocument = gql`
    mutation alterRegionCommonStatus($regionId: String!) {
  alterRegionCommonStatus(regionId: $regionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlterRegionCommonStatusGQL extends Apollo.Mutation<AlterRegionCommonStatusMutation, AlterRegionCommonStatusMutationVariables> {
    document = AlterRegionCommonStatusDocument;
    
  }
export const SetDefaultRegionDocument = gql`
    mutation setDefaultRegion($regionId: String!) {
  setDefaultRegion(regionId: $regionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultRegionGQL extends Apollo.Mutation<SetDefaultRegionMutation, SetDefaultRegionMutationVariables> {
    document = SetDefaultRegionDocument;
    
  }
export const RemoveDefaultRegionDocument = gql`
    mutation removeDefaultRegion($regionId: String!) {
  removeDefaultRegion(regionId: $regionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultRegionGQL extends Apollo.Mutation<RemoveDefaultRegionMutation, RemoveDefaultRegionMutationVariables> {
    document = RemoveDefaultRegionDocument;
    
  }
export const OrganizeRegionDocument = gql`
    mutation organizeRegion($regionIds: [String!]!) {
  organizeRegion(regionIds: $regionIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeRegionGQL extends Apollo.Mutation<OrganizeRegionMutation, OrganizeRegionMutationVariables> {
    document = OrganizeRegionDocument;
    
  }
export const GetSalesTeamByProjectDocument = gql`
    query getSalesTeamByProject($projectId: String!) {
  getSalesTeamByProject(projectId: $projectId) {
    id
    name
    memberCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesTeamByProjectGQL extends Apollo.Query<GetSalesTeamByProjectQuery, GetSalesTeamByProjectQueryVariables> {
    document = GetSalesTeamByProjectDocument;
    
  }
export const AddSalesTeamsDocument = gql`
    mutation addSalesTeams($input: TeamInput!) {
  addSalesTeams(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddSalesTeamsGQL extends Apollo.Mutation<AddSalesTeamsMutation, AddSalesTeamsMutationVariables> {
    document = AddSalesTeamsDocument;
    
  }
export const EditSalesTeamsDocument = gql`
    mutation editSalesTeams($input: EditTeamInput!) {
  editSalesTeams(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditSalesTeamsGQL extends Apollo.Mutation<EditSalesTeamsMutation, EditSalesTeamsMutationVariables> {
    document = EditSalesTeamsDocument;
    
  }
export const DeleteSalesTeamDocument = gql`
    mutation deleteSalesTeam($teamId: String!) {
  deleteSalesTeamById(teamId: $teamId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSalesTeamGQL extends Apollo.Mutation<DeleteSalesTeamMutation, DeleteSalesTeamMutationVariables> {
    document = DeleteSalesTeamDocument;
    
  }
export const GetAssignedMembersDocument = gql`
    query getAssignedMembers($teamId: String!) {
  getAssignedTeamMembers(teamId: $teamId) {
    ID
    name
    contactNo
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAssignedMembersGQL extends Apollo.Query<GetAssignedMembersQuery, GetAssignedMembersQueryVariables> {
    document = GetAssignedMembersDocument;
    
  }
export const GetUnassignedMembersDocument = gql`
    query getUnassignedMembers($projectId: String!, $teamId: String!) {
  getUnassignedTeamMembers(projectId: $projectId, teamId: $teamId) {
    ID
    name
    contactNo
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnassignedMembersGQL extends Apollo.Query<GetUnassignedMembersQuery, GetUnassignedMembersQueryVariables> {
    document = GetUnassignedMembersDocument;
    
  }
export const AssignMemberDocument = gql`
    mutation assignMember($projectId: String!, $teamId: String!, $userIds: [String!]!) {
  assignTeamMember(projectId: $projectId, teamId: $teamId, userIds: $userIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignMemberGQL extends Apollo.Mutation<AssignMemberMutation, AssignMemberMutationVariables> {
    document = AssignMemberDocument;
    
  }
export const UnassignMemberDocument = gql`
    mutation unassignMember($teamId: String!, $userIds: [String!]!) {
  unassignTeamMember(teamId: $teamId, userIds: $userIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnassignMemberGQL extends Apollo.Mutation<UnassignMemberMutation, UnassignMemberMutationVariables> {
    document = UnassignMemberDocument;
    
  }
export const GetSalesTeamByProjectForAllocationDocument = gql`
    query getSalesTeamByProjectForAllocation($projectId: String!) {
  getSalesTeamForAllocation(projectId: $projectId) {
    id
    name
    enableAllocation
    allocatedUnits
    totalUnits
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesTeamByProjectForAllocationGQL extends Apollo.Query<GetSalesTeamByProjectForAllocationQuery, GetSalesTeamByProjectForAllocationQueryVariables> {
    document = GetSalesTeamByProjectForAllocationDocument;
    
  }
export const AlterTeamAllocationPermissionDocument = gql`
    mutation alterTeamAllocationPermission($teamId: String!) {
  alterTeamAllocationPermission(teamId: $teamId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlterTeamAllocationPermissionGQL extends Apollo.Mutation<AlterTeamAllocationPermissionMutation, AlterTeamAllocationPermissionMutationVariables> {
    document = AlterTeamAllocationPermissionDocument;
    
  }
export const GetTeamBeenAllocatedWithUnitDocument = gql`
    query getTeamBeenAllocatedWithUnit($projectId: String!, $teamId: String!) {
  getTeamBeenAllocatedWithUnit(projectId: $projectId, teamId: $teamId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTeamBeenAllocatedWithUnitGQL extends Apollo.Query<GetTeamBeenAllocatedWithUnitQuery, GetTeamBeenAllocatedWithUnitQueryVariables> {
    document = GetTeamBeenAllocatedWithUnitDocument;
    
  }
export const GetAllocatedUnitsByTeamDocument = gql`
    query getAllocatedUnitsByTeam($projectId: String!, $teamId: String!, $block: String!) {
  getAllocatedUnitsByTeam(projectId: $projectId, teamId: $teamId, block: $block) {
    unit_id
    unit_no
    unit_status
    unit_type
    price
    floor
    floor_label
    cell
    status
    isBumi
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllocatedUnitsByTeamGQL extends Apollo.Query<GetAllocatedUnitsByTeamQuery, GetAllocatedUnitsByTeamQueryVariables> {
    document = GetAllocatedUnitsByTeamDocument;
    
  }
export const AllocateUnitsForTeamDocument = gql`
    mutation allocateUnitsForTeam($selectUnitIds: [String!]!, $teamId: String!, $projectId: String!) {
  allocateUnitsForTeam(
    selectUnitIds: $selectUnitIds
    teamId: $teamId
    projectId: $projectId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AllocateUnitsForTeamGQL extends Apollo.Mutation<AllocateUnitsForTeamMutation, AllocateUnitsForTeamMutationVariables> {
    document = AllocateUnitsForTeamDocument;
    
  }
export const UploadSalesDocDocument = gql`
    mutation uploadSalesDoc($isPrivate: Boolean, $file: Upload!, $input: SalesDocInput!) {
  uploadSalesDoc(isPrivate: $isPrivate, file: $file, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UploadSalesDocGQL extends Apollo.Mutation<UploadSalesDocMutation, UploadSalesDocMutationVariables> {
    document = UploadSalesDocDocument;
    
  }
export const GetSalesDocTypeDocument = gql`
    query getSalesDocType {
  getSalesDocType
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesDocTypeGQL extends Apollo.Query<GetSalesDocTypeQuery, GetSalesDocTypeQueryVariables> {
    document = GetSalesDocTypeDocument;
    
  }
export const GetSalesDocByIdDocument = gql`
    query getSalesDocById($id: String!) {
  getSalesDocById(salesDocId: $id) {
    id
    docName
    type
    allowSalesTeam
    allowAgency
    attachment {
      fileName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesDocByIdGQL extends Apollo.Query<GetSalesDocByIdQuery, GetSalesDocByIdQueryVariables> {
    document = GetSalesDocByIdDocument;
    
  }
export const GetSalesDocTypeListDocument = gql`
    query getSalesDocTypeList($projectId: String!) {
  getSalesDocList(projectId: $projectId) {
    id
    docName
    type
    allowSalesTeam
    allowAgency
    typeDescription
    attachment {
      resourceUrl
      fileName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesDocTypeListGQL extends Apollo.Query<GetSalesDocTypeListQuery, GetSalesDocTypeListQueryVariables> {
    document = GetSalesDocTypeListDocument;
    
  }
export const DeleteSalesDocDocument = gql`
    mutation deleteSalesDoc($id: String!) {
  deleteSalesDoc(salesDocId: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSalesDocGQL extends Apollo.Mutation<DeleteSalesDocMutation, DeleteSalesDocMutationVariables> {
    document = DeleteSalesDocDocument;
    
  }
export const UpdateSalesDocDocument = gql`
    mutation updateSalesDoc($input: EditSalesDocInput!, $file: Upload) {
  updateSalesDoc(input: $input, file: $file)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateSalesDocGQL extends Apollo.Mutation<UpdateSalesDocMutation, UpdateSalesDocMutationVariables> {
    document = UpdateSalesDocDocument;
    
  }
export const GetBrochureListDocument = gql`
    query getBrochureList($projectId: String!) {
  getBrochureList(projectId: $projectId) {
    id
    projectId
    modTs
    docName
    typeDescription
    type
    allowSalesTeam
    allowAgency
    attachment {
      fileName
      resourceUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBrochureListGQL extends Apollo.Query<GetBrochureListQuery, GetBrochureListQueryVariables> {
    document = GetBrochureListDocument;
    
  }
export const GetAllSalutationDocument = gql`
    query getAllSalutation {
  getAllSalutation {
    id
    name
    commonStatus
    defaulted
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllSalutationGQL extends Apollo.Query<GetAllSalutationQuery, GetAllSalutationQueryVariables> {
    document = GetAllSalutationDocument;
    
  }
export const EditSalutationDocument = gql`
    mutation editSalutation($input: EditSalutationInput!) {
  editSalutation(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditSalutationGQL extends Apollo.Mutation<EditSalutationMutation, EditSalutationMutationVariables> {
    document = EditSalutationDocument;
    
  }
export const AddSalutationDocument = gql`
    mutation addSalutation($input: SalutationInput!) {
  addSalutation(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddSalutationGQL extends Apollo.Mutation<AddSalutationMutation, AddSalutationMutationVariables> {
    document = AddSalutationDocument;
    
  }
export const DeleteSalutationByIdDocument = gql`
    mutation deleteSalutationById($salutationId: String!) {
  deleteSalutationById(salutationId: $salutationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSalutationByIdGQL extends Apollo.Mutation<DeleteSalutationByIdMutation, DeleteSalutationByIdMutationVariables> {
    document = DeleteSalutationByIdDocument;
    
  }
export const SetDefaultSalutationDocument = gql`
    mutation setDefaultSalutation($salutationId: String!) {
  setDefaultSalutation(salutationId: $salutationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultSalutationGQL extends Apollo.Mutation<SetDefaultSalutationMutation, SetDefaultSalutationMutationVariables> {
    document = SetDefaultSalutationDocument;
    
  }
export const RemoveDefaultSalutationDocument = gql`
    mutation removeDefaultSalutation($salutationId: String!) {
  removeDefaultSalutation(salutationId: $salutationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultSalutationGQL extends Apollo.Mutation<RemoveDefaultSalutationMutation, RemoveDefaultSalutationMutationVariables> {
    document = RemoveDefaultSalutationDocument;
    
  }
export const OrganizeSalutationDocument = gql`
    mutation organizeSalutation($salutationIds: [String!]!) {
  organizeSalutation(salutationIds: $salutationIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeSalutationGQL extends Apollo.Mutation<OrganizeSalutationMutation, OrganizeSalutationMutationVariables> {
    document = OrganizeSalutationDocument;
    
  }
export const SiteProgressDataDocument = gql`
    query siteProgressData($project_id: String!, $limit: Float!, $page: Float!, $search: String) {
  getListSiteProgress(
    project_id: $project_id
    limit: $limit
    page: $page
    search: $search
  ) {
    total
    data {
      id
      title
      publishDate
      description
      attachment {
        id
        resourceUrl
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SiteProgressDataGQL extends Apollo.Query<SiteProgressDataQuery, SiteProgressDataQueryVariables> {
    document = SiteProgressDataDocument;
    
  }
export const DeleteSiteProgressDocument = gql`
    mutation deleteSiteProgress($siteProgressId: String!) {
  deleteSiteProgress(siteProgressId: $siteProgressId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteSiteProgressGQL extends Apollo.Mutation<DeleteSiteProgressMutation, DeleteSiteProgressMutationVariables> {
    document = DeleteSiteProgressDocument;
    
  }
export const AddSiteProgressDocument = gql`
    mutation addSiteProgress($project_id: String!, $input: AddSiteProgressInput!) {
  addSiteProgess(project_id: $project_id, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddSiteProgressGQL extends Apollo.Mutation<AddSiteProgressMutation, AddSiteProgressMutationVariables> {
    document = AddSiteProgressDocument;
    
  }
export const GetEditSiteProgressDetailsDocument = gql`
    query getEditSiteProgressDetails($siteProgressId: String!) {
  getEditSource(siteProgressId: $siteProgressId) {
    title
    publishDate
    description
    attachment {
      id
      resourceUrl
      fileName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEditSiteProgressDetailsGQL extends Apollo.Query<GetEditSiteProgressDetailsQuery, GetEditSiteProgressDetailsQueryVariables> {
    document = GetEditSiteProgressDetailsDocument;
    
  }
export const EditSiteProgressDocument = gql`
    mutation editSiteProgress($input: editSiteProgressInput!) {
  editSiteProgress(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditSiteProgressGQL extends Apollo.Mutation<EditSiteProgressMutation, EditSiteProgressMutationVariables> {
    document = EditSiteProgressDocument;
    
  }
export const SolicitorListDocument = gql`
    query solicitorList {
  solicitorList {
    id
    name
    assignedProjectCount
    commonStatus
    logoUrl
    modTs
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SolicitorListGQL extends Apollo.Query<SolicitorListQuery, SolicitorListQueryVariables> {
    document = SolicitorListDocument;
    
  }
export const SolicitorDetailsDocument = gql`
    query solicitorDetails($solicitorAppointedId: String!) {
  solicitorDetails(solicitor_appointed_id: $solicitorAppointedId) {
    id
    solicitorId
    name
    email
    officeTel
    contactName
    contactEmail
    contactPhoneNo
    logoUrl
    solicitorCode
    address {
      address
      state
      country
      city
      postCode
    }
  }
  solicitorProjectList(solicitor_appointed_id: $solicitorAppointedId) {
    id
    createdTs
    project {
      name
      solicitorLayoutList(solicitorAppointedId: $solicitorAppointedId) {
        project_id
        desc
        allotted
        layout_id
        sold
        total_selling
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SolicitorDetailsGQL extends Apollo.Query<SolicitorDetailsQuery, SolicitorDetailsQueryVariables> {
    document = SolicitorDetailsDocument;
    
  }
export const AddSolicitorDocument = gql`
    mutation addSolicitor($input: AdminSolicitorInput!) {
  addSolicitor(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddSolicitorGQL extends Apollo.Mutation<AddSolicitorMutation, AddSolicitorMutationVariables> {
    document = AddSolicitorDocument;
    
  }
export const EditSolicitorDocument = gql`
    mutation editSolicitor($solicitorAppointedId: String!, $input: AdminSolicitorInput!) {
  editSolicitor(solicitor_appointed_id: $solicitorAppointedId, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditSolicitorGQL extends Apollo.Mutation<EditSolicitorMutation, EditSolicitorMutationVariables> {
    document = EditSolicitorDocument;
    
  }
export const SuspendSolicitorDocument = gql`
    mutation suspendSolicitor($solicitorAppointedId: String!) {
  suspendSolicitor(solicitor_appointed_id: $solicitorAppointedId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SuspendSolicitorGQL extends Apollo.Mutation<SuspendSolicitorMutation, SuspendSolicitorMutationVariables> {
    document = SuspendSolicitorDocument;
    
  }
export const SyncIntegrateSolicitorDocument = gql`
    mutation syncIntegrateSolicitor {
  syncIntegrateSolicitor
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SyncIntegrateSolicitorGQL extends Apollo.Mutation<SyncIntegrateSolicitorMutation, SyncIntegrateSolicitorMutationVariables> {
    document = SyncIntegrateSolicitorDocument;
    
  }
export const SolicitorAppointedListDocument = gql`
    query solicitorAppointedList($projectId: String!) {
  solicitorAppointedList(project_id: $projectId) {
    id
    solicitorId
    name
    logoUrl
    commonStatus
    default(projectId: $projectId)
    solicitorStatus(project_id: $projectId)
    solicitorUnitCount(project_id: $projectId) {
      allocated
      sold
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SolicitorAppointedListGQL extends Apollo.Query<SolicitorAppointedListQuery, SolicitorAppointedListQueryVariables> {
    document = SolicitorAppointedListDocument;
    
  }
export const SolicitorListForAssignmentDocument = gql`
    query solicitorListForAssignment($projectId: String!) {
  solicitorListForAssignment(project_id: $projectId) {
    id
    solicitorId
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SolicitorListForAssignmentGQL extends Apollo.Query<SolicitorListForAssignmentQuery, SolicitorListForAssignmentQueryVariables> {
    document = SolicitorListForAssignmentDocument;
    
  }
export const AssignSolicitorToProjectDocument = gql`
    mutation assignSolicitorToProject($projectId: String!, $solicitor_appointed_id: [String!]!) {
  assignSolicitorToProject(
    project_id: $projectId
    solicitor_appointed_id: $solicitor_appointed_id
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignSolicitorToProjectGQL extends Apollo.Mutation<AssignSolicitorToProjectMutation, AssignSolicitorToProjectMutationVariables> {
    document = AssignSolicitorToProjectDocument;
    
  }
export const SolicitorAppointedDetailsDocument = gql`
    query solicitorAppointedDetails($solicitor_appointed_id: String!) {
  solicitorAppointedDetails(solicitor_appointed_id: $solicitor_appointed_id) {
    id
    name
    email
    officeTel
    address {
      address
    }
    createdTs
    contactName
    contactEmail
    contactPhoneNo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SolicitorAppointedDetailsGQL extends Apollo.Query<SolicitorAppointedDetailsQuery, SolicitorAppointedDetailsQueryVariables> {
    document = SolicitorAppointedDetailsDocument;
    
  }
export const UnassignSolicitorFromProjectDocument = gql`
    mutation unassignSolicitorFromProject($project_id: String!, $solicitor_id: String!) {
  unassignSolicitorFromProject(
    project_id: $project_id
    solicitor_id: $solicitor_id
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UnassignSolicitorFromProjectGQL extends Apollo.Mutation<UnassignSolicitorFromProjectMutation, UnassignSolicitorFromProjectMutationVariables> {
    document = UnassignSolicitorFromProjectDocument;
    
  }
export const ResendSolicitorAppointedInvitationDocument = gql`
    mutation resendSolicitorAppointedInvitation($solicitor_appointed_id: String!, $project_id: String!) {
  resendSolicitorAppointedInvitation(
    solicitor_appointed_id: $solicitor_appointed_id
    project_id: $project_id
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendSolicitorAppointedInvitationGQL extends Apollo.Mutation<ResendSolicitorAppointedInvitationMutation, ResendSolicitorAppointedInvitationMutationVariables> {
    document = ResendSolicitorAppointedInvitationDocument;
    
  }
export const SolicitorMarkAsDefaultDocument = gql`
    mutation solicitorMarkAsDefault($projectId: String!, $solicitorId: String!) {
  markAsDefault(projectId: $projectId, solicitorId: $solicitorId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SolicitorMarkAsDefaultGQL extends Apollo.Mutation<SolicitorMarkAsDefaultMutation, SolicitorMarkAsDefaultMutationVariables> {
    document = SolicitorMarkAsDefaultDocument;
    
  }
export const GetAllUnitTypeDocument = gql`
    query getAllUnitType {
  getAllUnitType {
    id
    name
    commonStatus
    defaulted
    seq_no
    isDeletable
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllUnitTypeGQL extends Apollo.Query<GetAllUnitTypeQuery, GetAllUnitTypeQueryVariables> {
    document = GetAllUnitTypeDocument;
    
  }
export const EditUnitTypeDocument = gql`
    mutation editUnitType($input: EditUnitTypeInput!) {
  editUnitType(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditUnitTypeGQL extends Apollo.Mutation<EditUnitTypeMutation, EditUnitTypeMutationVariables> {
    document = EditUnitTypeDocument;
    
  }
export const AddUnitTypeDocument = gql`
    mutation addUnitType($input: UnitTypeInput!) {
  addUnitType(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddUnitTypeGQL extends Apollo.Mutation<AddUnitTypeMutation, AddUnitTypeMutationVariables> {
    document = AddUnitTypeDocument;
    
  }
export const DeleteUnitTypeByIdDocument = gql`
    mutation deleteUnitTypeById($unitTypeId: String!) {
  deleteUnitTypeById(unitTypeId: $unitTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUnitTypeByIdGQL extends Apollo.Mutation<DeleteUnitTypeByIdMutation, DeleteUnitTypeByIdMutationVariables> {
    document = DeleteUnitTypeByIdDocument;
    
  }
export const SetDefaultUnitTypeDocument = gql`
    mutation setDefaultUnitType($unitTypeId: String!) {
  setDefaultUnitType(unitTypeId: $unitTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetDefaultUnitTypeGQL extends Apollo.Mutation<SetDefaultUnitTypeMutation, SetDefaultUnitTypeMutationVariables> {
    document = SetDefaultUnitTypeDocument;
    
  }
export const RemoveDefaultUnitTypeDocument = gql`
    mutation removeDefaultUnitType($unitTypeId: String!) {
  removeDefaultUnitType(unitTypeId: $unitTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveDefaultUnitTypeGQL extends Apollo.Mutation<RemoveDefaultUnitTypeMutation, RemoveDefaultUnitTypeMutationVariables> {
    document = RemoveDefaultUnitTypeDocument;
    
  }
export const OrganizeUnitTypeDocument = gql`
    mutation organizeUnitType($unitTypeId: [String!]!) {
  organizeUnitType(unitTypeId: $unitTypeId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class OrganizeUnitTypeGQL extends Apollo.Mutation<OrganizeUnitTypeMutation, OrganizeUnitTypeMutationVariables> {
    document = OrganizeUnitTypeDocument;
    
  }
export const GetBlockByProjectDocument = gql`
    query getBlockByProject($projectId: String!, $isSubProduct: Boolean!) {
  GetBlockByProject(projectId: $projectId, isSubProduct: $isSubProduct) {
    integrated
    blocks
    isSubProduct
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBlockByProjectGQL extends Apollo.Query<GetBlockByProjectQuery, GetBlockByProjectQueryVariables> {
    document = GetBlockByProjectDocument;
    
  }
export const GetUnitFloorByBlockDocument = gql`
    query getUnitFloorByBlock($projectId: String!, $block: String!, $isSubProduct: Boolean!) {
  GetFloorByProjectBlock(
    projectId: $projectId
    block: $block
    isSubProduct: $isSubProduct
  ) {
    floor
    floorlabel
    isSubProduct
    Unit {
      projectSpec {
        reservationSales
        reservationAgency
      }
    }
  }
  GetUnitByProjectBlock(
    projectId: $projectId
    block: $block
    isSubProduct: $isSubProduct
  ) {
    id
    unitNo
    floor
    floorLabel
    cell
    unitStatus
    commonStatus
    isBumi
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitFloorByBlockGQL extends Apollo.Query<GetUnitFloorByBlockQuery, GetUnitFloorByBlockQueryVariables> {
    document = GetUnitFloorByBlockDocument;
    
  }
export const GetUnitForCarParkDocument = gql`
    query getUnitForCarPark($projectId: String!, $isSubProduct: Boolean!) {
  GetUnitByProjectBlock(projectId: $projectId, isSubProduct: $isSubProduct) {
    id
    unitNo
    floor
    floorLabel
    cell
    unitStatus
    commonStatus
    isBumi
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitForCarParkGQL extends Apollo.Query<GetUnitForCarParkQuery, GetUnitForCarParkQueryVariables> {
    document = GetUnitForCarParkDocument;
    
  }
export const UpdateUnitStatusDocument = gql`
    mutation updateUnitStatus($models: [AdminUnitStatusInput!]!) {
  UpdateUnitStatus(models: $models)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateUnitStatusGQL extends Apollo.Mutation<UpdateUnitStatusMutation, UpdateUnitStatusMutationVariables> {
    document = UpdateUnitStatusDocument;
    
  }
export const ImportUnitOptionsDocument = gql`
    query importUnitOptions($projectId: String!, $isSubProduct: Boolean!) {
  ImportUnitOptions(project_id: $projectId, isSubProduct: $isSubProduct) {
    displayImportMethods
    overwrite
    append
    integrated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportUnitOptionsGQL extends Apollo.Query<ImportUnitOptionsQuery, ImportUnitOptionsQueryVariables> {
    document = ImportUnitOptionsDocument;
    
  }
export const ImportUnitDocument = gql`
    mutation importUnit($projectId: String!, $excel: Upload!, $method: String!, $isSubProduct: Boolean!) {
  ImportUnit(
    project_id: $projectId
    file: $excel
    method: $method
    isSubProduct: $isSubProduct
  ) {
    message
    file_name
    file
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImportUnitGQL extends Apollo.Mutation<ImportUnitMutation, ImportUnitMutationVariables> {
    document = ImportUnitDocument;
    
  }
export const ExportUnitDocument = gql`
    query exportUnit($projectId: String!, $isSubProduct: Boolean!) {
  ExportUnit(project_id: $projectId, isSubProduct: $isSubProduct) {
    base64
    projectname
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportUnitGQL extends Apollo.Query<ExportUnitQuery, ExportUnitQueryVariables> {
    document = ExportUnitDocument;
    
  }
export const GetSalesChartDataDocument = gql`
    query GetSalesChartData($projectId: String!) {
  GetSalesChartData(projectId: $projectId) {
    saleschartBlock
    unitMinPrice
    unitMaxPrice
    unitTypes {
      id
      name
      builtUp
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesChartDataGQL extends Apollo.Query<GetSalesChartDataQuery, GetSalesChartDataQueryVariables> {
    document = GetSalesChartDataDocument;
    
  }
export const GetSalesChartByBlockDocument = gql`
    query GetSalesChartByBlock($projectId: String!, $block: String!) {
  GetSalesChartByBlock(project_id: $projectId, block: $block) {
    floors {
      floor
      floor_label
    }
    units {
      unit_id
      unit_no
      unit_status
      unit_type
      price
      floor
      cell
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSalesChartByBlockGQL extends Apollo.Query<GetSalesChartByBlockQuery, GetSalesChartByBlockQueryVariables> {
    document = GetSalesChartByBlockDocument;
    
  }
export const ResetSalesChartByBlockDocument = gql`
    mutation resetSalesChartByBlock($block: String!, $projectId: String!) {
  resetSalesChartByBlock(block: $block, projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetSalesChartByBlockGQL extends Apollo.Mutation<ResetSalesChartByBlockMutation, ResetSalesChartByBlockMutationVariables> {
    document = ResetSalesChartByBlockDocument;
    
  }
export const GetUnitLayoutBlockByProjectIdDocument = gql`
    query getUnitLayoutBlockByProjectId($projectId: String!) {
  getUnitLayoutBlockByProjectId(ProjectId: $projectId) {
    unitLayoutId
    block
    unit_type_desc
    unit_type_id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitLayoutBlockByProjectIdGQL extends Apollo.Query<GetUnitLayoutBlockByProjectIdQuery, GetUnitLayoutBlockByProjectIdQueryVariables> {
    document = GetUnitLayoutBlockByProjectIdDocument;
    
  }
export const GetUnitMasterDataDocument = gql`
    query getUnitMasterData($projectId: String!) {
  getUnitMasterData(projectId: $projectId) {
    propertyType {
      id
      name
    }
    direction {
      id
      name
    }
    unitType {
      id
      name
    }
    unitLayout {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnitMasterDataGQL extends Apollo.Query<GetUnitMasterDataQuery, GetUnitMasterDataQueryVariables> {
    document = GetUnitMasterDataDocument;
    
  }
export const GenerateUnitDocument = gql`
    mutation generateUnit($input: generateUnitInput!) {
  generateUnit(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateUnitGQL extends Apollo.Mutation<GenerateUnitMutation, GenerateUnitMutationVariables> {
    document = GenerateUnitDocument;
    
  }
export const AssignCarParkToUnitDocument = gql`
    mutation AssignCarParkToUnit($input: assignCarkParkInput!) {
  AssignCarParkToUnit(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignCarParkToUnitGQL extends Apollo.Mutation<AssignCarParkToUnitMutation, AssignCarParkToUnitMutationVariables> {
    document = AssignCarParkToUnitDocument;
    
  }
export const IntegrationParamsDocument = gql`
    query integrationParams($projectId: String!) {
  projectIntegrationById(projectId: $projectId) {
    integrationUrl
    ifcaCompanyId
    ifcaCompanyName
    ifcaProjectId
    ifcaProjectName
    ifcaPhaseId
    ifcaPhaseName
    gracePeriod
    paymentPlanDesc
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntegrationParamsGQL extends Apollo.Query<IntegrationParamsQuery, IntegrationParamsQueryVariables> {
    document = IntegrationParamsDocument;
    
  }
export const IntegrationCompanyListDocument = gql`
    query integrationCompanyList($baseUrl: String!, $projectId: String!) {
  getCompanyList(baseUrl: $baseUrl, projectId: $projectId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntegrationCompanyListGQL extends Apollo.Query<IntegrationCompanyListQuery, IntegrationCompanyListQueryVariables> {
    document = IntegrationCompanyListDocument;
    
  }
export const IntegrationProjectListDocument = gql`
    query integrationProjectList($baseUrl: String!, $ifcaCompanyId: String!) {
  getProjectList(baseUrl: $baseUrl, ifcaCompanyID: $ifcaCompanyId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntegrationProjectListGQL extends Apollo.Query<IntegrationProjectListQuery, IntegrationProjectListQueryVariables> {
    document = IntegrationProjectListDocument;
    
  }
export const IntegrationPhaseListDocument = gql`
    query integrationPhaseList($baseUrl: String!, $ifcaProjectId: String!) {
  getPhaseList(baseUrl: $baseUrl, ifcaProjectID: $ifcaProjectId) {
    id
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntegrationPhaseListGQL extends Apollo.Query<IntegrationPhaseListQuery, IntegrationPhaseListQueryVariables> {
    document = IntegrationPhaseListDocument;
    
  }
export const IntegrationPaymentPlanDocument = gql`
    query integrationPaymentPlan($baseUrl: String!, $projectId: String) {
  getPaymentPlan(baseUrl: $baseUrl, projectId: $projectId) {
    PaymentPlanID
    PaymentPlanCode
    Description
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntegrationPaymentPlanGQL extends Apollo.Query<IntegrationPaymentPlanQuery, IntegrationPaymentPlanQueryVariables> {
    document = IntegrationPaymentPlanDocument;
    
  }
export const IntegrationUnitListDocument = gql`
    query integrationUnitList($input: AdminUnitIntegrationInput!) {
  getUnitList(input: $input) {
    ifcaUnitId
    unitNo
    block
    floor
    floorLabel
    cell
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntegrationUnitListGQL extends Apollo.Query<IntegrationUnitListQuery, IntegrationUnitListQueryVariables> {
    document = IntegrationUnitListDocument;
    
  }
export const IntegrationDotNetPplusDocument = gql`
    mutation integrationDotNetPplus($projectId: String!, $input: AdminUnitIntegrationInput!) {
  integrateUnitFromDotNetPplus(projectID: $projectId, input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntegrationDotNetPplusGQL extends Apollo.Mutation<IntegrationDotNetPplusMutation, IntegrationDotNetPplusMutationVariables> {
    document = IntegrationDotNetPplusDocument;
    
  }
export const RepullIntegrateUnitsDocument = gql`
    mutation repullIntegrateUnits($projectId: String!, $rePull: Boolean!) {
  repullIntegrateUnits(projectId: $projectId, rePull: $rePull)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RepullIntegrateUnitsGQL extends Apollo.Mutation<RepullIntegrateUnitsMutation, RepullIntegrateUnitsMutationVariables> {
    document = RepullIntegrateUnitsDocument;
    
  }
export const IntegrationRemoveUnitsDocument = gql`
    mutation integrationRemoveUnits($projectId: String!) {
  removeAllUnits(projectID: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntegrationRemoveUnitsGQL extends Apollo.Mutation<IntegrationRemoveUnitsMutation, IntegrationRemoveUnitsMutationVariables> {
    document = IntegrationRemoveUnitsDocument;
    
  }
export const Get360TourFormDataByProjectDocument = gql`
    query get360TourFormDataByProject($projectid: String!) {
  Get360TourFormDataByProject(projectId: $projectid) {
    block
    unitTypes {
      unitTypeId
      unitTypeName
    }
    unitLayouts {
      unitLayoutId
      unitLayoutName
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Get360TourFormDataByProjectGQL extends Apollo.Query<Get360TourFormDataByProjectQuery, Get360TourFormDataByProjectQueryVariables> {
    document = Get360TourFormDataByProjectDocument;
    
  }
export const GetUnit360TourByProjectDocument = gql`
    query getUnit360TourByProject($projectid: String!) {
  GetUnit360TourByProject(projectId: $projectid) {
    id
    seqNo
    unitLayoutId
    unitTypeId
    virtualModelLink
    block
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUnit360TourByProjectGQL extends Apollo.Query<GetUnit360TourByProjectQuery, GetUnit360TourByProjectQueryVariables> {
    document = GetUnit360TourByProjectDocument;
    
  }
export const AlterUnitTourDocument = gql`
    mutation AlterUnitTour($input: [AdminUpdateUnitVirtualModelInput!]!) {
  AlterUnitTour(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AlterUnitTourGQL extends Apollo.Mutation<AlterUnitTourMutation, AlterUnitTourMutationVariables> {
    document = AlterUnitTourDocument;
    
  }
export const DeleteUnitTourLinkDocument = gql`
    mutation DeleteUnitTourLink($tourIds: [String!]!, $projectId: String!) {
  DeleteUnitTourLink(tourIds: $tourIds, projectId: $projectId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUnitTourLinkGQL extends Apollo.Mutation<DeleteUnitTourLinkMutation, DeleteUnitTourLinkMutationVariables> {
    document = DeleteUnitTourLinkDocument;
    
  }